var _assertThisInitialized = require("/opt/build/repo/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _get = require("/opt/build/repo/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

require("core-js/modules/es.string.trim-start.js");

require("core-js/modules/es.string.trim-end.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e107) { throw _e107; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e108) { didErr = true; err = _e108; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

!function (t, e) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : ((t = "undefined" != typeof globalThis ? globalThis : t || self).prettierPlugins = t.prettierPlugins || {}, t.prettierPlugins.babel = e());
}(this, function () {
  "use strict";

  var t = function t(_t2, e) {
    var s = new SyntaxError(_t2 + " (" + e.start.line + ":" + e.start.column + ")");
    return s.loc = e, s;
  },
      e = function e(t) {
    return "string" == typeof t ? t.replace(function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$onlyFirst = _ref.onlyFirst,
          t = _ref$onlyFirst === void 0 ? !1 : _ref$onlyFirst;

      var e = ["[\\u001B\\u009B][[\\]()#;?]*(?:(?:(?:[a-zA-Z\\d]*(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]*)*)?\\u0007)", "(?:(?:\\d{1,4}(?:;\\d{0,4})*)?[\\dA-PR-TZcf-ntqry=><~]))"].join("|");
      return new RegExp(e, t ? void 0 : "g");
    }(), "") : t;
  };

  var s = function s(t) {
    return !Number.isNaN(t) && t >= 4352 && (t <= 4447 || 9001 === t || 9002 === t || 11904 <= t && t <= 12871 && 12351 !== t || 12880 <= t && t <= 19903 || 19968 <= t && t <= 42182 || 43360 <= t && t <= 43388 || 44032 <= t && t <= 55203 || 63744 <= t && t <= 64255 || 65040 <= t && t <= 65049 || 65072 <= t && t <= 65131 || 65281 <= t && t <= 65376 || 65504 <= t && t <= 65510 || 110592 <= t && t <= 110593 || 127488 <= t && t <= 127569 || 131072 <= t && t <= 262141);
  };

  var r = s,
      i = s;
  r.default = i;

  var n = function n(t) {
    if ("string" != typeof (t = t.replace(/\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73)\uDB40\uDC7F|\uD83D\uDC68(?:\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFB|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFE])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|[\u2695\u2696\u2708]\uFE0F|\uD83D[\uDC66\uDC67]|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|(?:\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708])\uFE0F|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C[\uDFFB-\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC69)\uD83C\uDFFB|\uD83E\uDDD1(?:\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])|\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1)|(?:\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFE])|(?:\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC69)(?:\uD83C[\uDFFB\uDFFC])|\uD83D\uDC69(?:\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFC-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|(?:\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC69)(?:\uD83C[\uDFFB-\uDFFD])|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83D\uDC69(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|(?:(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)\uFE0F|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDD])(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\u200D[\u2640\u2642])|\uD83C\uDFF4\u200D\u2620)\uFE0F|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC15\u200D\uD83E\uDDBA|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF4\uD83C\uDDF2|\uD83C\uDDF6\uD83C\uDDE6|[#\*0-9]\uFE0F\u20E3|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270A-\u270D]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC70\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDCAA\uDD74\uDD7A\uDD90\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD36\uDDB5\uDDB6\uDDBB\uDDD2-\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDED5\uDEEB\uDEEC\uDEF4-\uDEFA\uDFE0-\uDFEB]|\uD83E[\uDD0D-\uDD3A\uDD3C-\uDD45\uDD47-\uDD71\uDD73-\uDD76\uDD7A-\uDDA2\uDDA5-\uDDAA\uDDAE-\uDDCA\uDDCD-\uDDFF\uDE70-\uDE73\uDE78-\uDE7A\uDE80-\uDE82\uDE90-\uDE95])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDED5\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEFA\uDFE0-\uDFEB]|\uD83E[\uDD0D-\uDD3A\uDD3C-\uDD45\uDD47-\uDD71\uDD73-\uDD76\uDD7A-\uDDA2\uDDA5-\uDDAA\uDDAE-\uDDCA\uDDCD-\uDDFF\uDE70-\uDE73\uDE78-\uDE7A\uDE80-\uDE82\uDE90-\uDE95])\uFE0F|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDC8F\uDC91\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD0F\uDD18-\uDD1F\uDD26\uDD30-\uDD39\uDD3C-\uDD3E\uDDB5\uDDB6\uDDB8\uDDB9\uDDBB\uDDCD-\uDDCF\uDDD1-\uDDDD])/g, "  ")) || 0 === t.length) return 0;
    t = e(t);
    var s = 0;

    for (var _e2 = 0; _e2 < t.length; _e2++) {
      var _i = t.codePointAt(_e2);

      _i <= 31 || _i >= 127 && _i <= 159 || _i >= 768 && _i <= 879 || (_i > 65535 && _e2++, s += r(_i) ? 2 : 1);
    }

    return s;
  };

  var a = n,
      o = n;
  a.default = o;

  var u = function u(t) {
    if ("string" != typeof t) throw new TypeError("Expected a string");
    return t.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
  };

  function h(t, e) {
    return e || (e = t.slice(0)), Object.freeze(Object.defineProperties(t, {
      raw: {
        value: Object.freeze(e)
      }
    }));
  }

  var c = "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {};

  function p() {
    throw new Error("setTimeout has not been defined");
  }

  function l() {
    throw new Error("clearTimeout has not been defined");
  }

  var d = p,
      D = l;

  function m(t) {
    if (d === setTimeout) return setTimeout(t, 0);
    if ((d === p || !d) && setTimeout) return d = setTimeout, setTimeout(t, 0);

    try {
      return d(t, 0);
    } catch (e) {
      try {
        return d.call(null, t, 0);
      } catch (e) {
        return d.call(this, t, 0);
      }
    }
  }

  "function" == typeof c.setTimeout && (d = setTimeout), "function" == typeof c.clearTimeout && (D = clearTimeout);
  var f,
      y = [],
      E = !1,
      A = -1;

  function C() {
    E && f && (E = !1, f.length ? y = f.concat(y) : A = -1, y.length && x());
  }

  function x() {
    if (!E) {
      var t = m(C);
      E = !0;

      for (var e = y.length; e;) {
        for (f = y, y = []; ++A < e;) {
          f && f[A].run();
        }

        A = -1, e = y.length;
      }

      f = null, E = !1, function (t) {
        if (D === clearTimeout) return clearTimeout(t);
        if ((D === l || !D) && clearTimeout) return D = clearTimeout, clearTimeout(t);

        try {
          D(t);
        } catch (e) {
          try {
            return D.call(null, t);
          } catch (e) {
            return D.call(this, t);
          }
        }
      }(t);
    }
  }

  function F(t, e) {
    this.fun = t, this.array = e;
  }

  F.prototype.run = function () {
    this.fun.apply(null, this.array);
  };

  function g() {}

  var b = g,
      P = g,
      T = g,
      w = g,
      B = g,
      S = g,
      N = g;

  var I = c.performance || {},
      v = I.now || I.mozNow || I.msNow || I.oNow || I.webkitNow || function () {
    return new Date().getTime();
  };

  var k = new Date();
  var L = {
    nextTick: function nextTick(t) {
      var e = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var s = 1; s < arguments.length; s++) {
        e[s - 1] = arguments[s];
      }
      y.push(new F(t, e)), 1 !== y.length || E || m(x);
    },
    title: "browser",
    browser: !0,
    env: {},
    argv: [],
    version: "",
    versions: {},
    on: b,
    addListener: P,
    once: T,
    off: w,
    removeListener: B,
    removeAllListeners: S,
    emit: N,
    binding: function binding(t) {
      throw new Error("process.binding is not supported");
    },
    cwd: function cwd() {
      return "/";
    },
    chdir: function chdir(t) {
      throw new Error("process.chdir is not supported");
    },
    umask: function umask() {
      return 0;
    },
    hrtime: function hrtime(t) {
      var e = .001 * v.call(I),
          s = Math.floor(e),
          r = Math.floor(e % 1 * 1e9);
      return t && (s -= t[0], (r -= t[1]) < 0 && (s--, r += 1e9)), [s, r];
    },
    platform: "browser",
    release: {},
    config: {},
    uptime: function uptime() {
      return (new Date() - k) / 1e3;
    }
  };
  var O = "object" == typeof L && L.env && L.env.NODE_DEBUG && /\bsemver\b/i.test(L.env.NODE_DEBUG) ? function () {
    var _console;

    for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
      t[_key] = arguments[_key];
    }

    return (_console = console).error.apply(_console, ["SEMVER"].concat(t));
  } : function () {};
  var M = {
    SEMVER_SPEC_VERSION: "2.0.0",
    MAX_LENGTH: 256,
    MAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER || 9007199254740991,
    MAX_SAFE_COMPONENT_LENGTH: 16
  };

  function R(t, e, s) {
    return t(s = {
      path: e,
      exports: {},
      require: function require(t, e) {
        return function () {
          throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
        }(null == e && s.path);
      }
    }, s.exports), s.exports;
  }

  function _(t) {
    return t && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
  }

  var j = R(function (t, e) {
    var s = M.MAX_SAFE_COMPONENT_LENGTH,
        r = (e = t.exports = {}).re = [],
        i = e.src = [],
        n = e.t = {};
    var a = 0;

    var o = function o(t, e, s) {
      var o = a++;
      O(o, e), n[t] = o, i[o] = e, r[o] = new RegExp(e, s ? "g" : void 0);
    };

    o("NUMERICIDENTIFIER", "0|[1-9]\\d*"), o("NUMERICIDENTIFIERLOOSE", "[0-9]+"), o("NONNUMERICIDENTIFIER", "\\d*[a-zA-Z-][a-zA-Z0-9-]*"), o("MAINVERSION", "(".concat(i[n.NUMERICIDENTIFIER], ")\\.") + "(".concat(i[n.NUMERICIDENTIFIER], ")\\.") + "(".concat(i[n.NUMERICIDENTIFIER], ")")), o("MAINVERSIONLOOSE", "(".concat(i[n.NUMERICIDENTIFIERLOOSE], ")\\.") + "(".concat(i[n.NUMERICIDENTIFIERLOOSE], ")\\.") + "(".concat(i[n.NUMERICIDENTIFIERLOOSE], ")")), o("PRERELEASEIDENTIFIER", "(?:".concat(i[n.NUMERICIDENTIFIER], "|").concat(i[n.NONNUMERICIDENTIFIER], ")")), o("PRERELEASEIDENTIFIERLOOSE", "(?:".concat(i[n.NUMERICIDENTIFIERLOOSE], "|").concat(i[n.NONNUMERICIDENTIFIER], ")")), o("PRERELEASE", "(?:-(".concat(i[n.PRERELEASEIDENTIFIER], "(?:\\.").concat(i[n.PRERELEASEIDENTIFIER], ")*))")), o("PRERELEASELOOSE", "(?:-?(".concat(i[n.PRERELEASEIDENTIFIERLOOSE], "(?:\\.").concat(i[n.PRERELEASEIDENTIFIERLOOSE], ")*))")), o("BUILDIDENTIFIER", "[0-9A-Za-z-]+"), o("BUILD", "(?:\\+(".concat(i[n.BUILDIDENTIFIER], "(?:\\.").concat(i[n.BUILDIDENTIFIER], ")*))")), o("FULLPLAIN", "v?".concat(i[n.MAINVERSION]).concat(i[n.PRERELEASE], "?").concat(i[n.BUILD], "?")), o("FULL", "^".concat(i[n.FULLPLAIN], "$")), o("LOOSEPLAIN", "[v=\\s]*".concat(i[n.MAINVERSIONLOOSE]).concat(i[n.PRERELEASELOOSE], "?").concat(i[n.BUILD], "?")), o("LOOSE", "^".concat(i[n.LOOSEPLAIN], "$")), o("GTLT", "((?:<|>)?=?)"), o("XRANGEIDENTIFIERLOOSE", "".concat(i[n.NUMERICIDENTIFIERLOOSE], "|x|X|\\*")), o("XRANGEIDENTIFIER", "".concat(i[n.NUMERICIDENTIFIER], "|x|X|\\*")), o("XRANGEPLAIN", "[v=\\s]*(".concat(i[n.XRANGEIDENTIFIER], ")") + "(?:\\.(".concat(i[n.XRANGEIDENTIFIER], ")") + "(?:\\.(".concat(i[n.XRANGEIDENTIFIER], ")") + "(?:".concat(i[n.PRERELEASE], ")?").concat(i[n.BUILD], "?") + ")?)?"), o("XRANGEPLAINLOOSE", "[v=\\s]*(".concat(i[n.XRANGEIDENTIFIERLOOSE], ")") + "(?:\\.(".concat(i[n.XRANGEIDENTIFIERLOOSE], ")") + "(?:\\.(".concat(i[n.XRANGEIDENTIFIERLOOSE], ")") + "(?:".concat(i[n.PRERELEASELOOSE], ")?").concat(i[n.BUILD], "?") + ")?)?"), o("XRANGE", "^".concat(i[n.GTLT], "\\s*").concat(i[n.XRANGEPLAIN], "$")), o("XRANGELOOSE", "^".concat(i[n.GTLT], "\\s*").concat(i[n.XRANGEPLAINLOOSE], "$")), o("COERCE", "".concat("(^|[^\\d])(\\d{1,").concat(s, "})") + "(?:\\.(\\d{1,".concat(s, "}))?") + "(?:\\.(\\d{1,".concat(s, "}))?") + "(?:$|[^\\d])"), o("COERCERTL", i[n.COERCE], !0), o("LONETILDE", "(?:~>?)"), o("TILDETRIM", "(\\s*)".concat(i[n.LONETILDE], "\\s+"), !0), e.tildeTrimReplace = "$1~", o("TILDE", "^".concat(i[n.LONETILDE]).concat(i[n.XRANGEPLAIN], "$")), o("TILDELOOSE", "^".concat(i[n.LONETILDE]).concat(i[n.XRANGEPLAINLOOSE], "$")), o("LONECARET", "(?:\\^)"), o("CARETTRIM", "(\\s*)".concat(i[n.LONECARET], "\\s+"), !0), e.caretTrimReplace = "$1^", o("CARET", "^".concat(i[n.LONECARET]).concat(i[n.XRANGEPLAIN], "$")), o("CARETLOOSE", "^".concat(i[n.LONECARET]).concat(i[n.XRANGEPLAINLOOSE], "$")), o("COMPARATORLOOSE", "^".concat(i[n.GTLT], "\\s*(").concat(i[n.LOOSEPLAIN], ")$|^$")), o("COMPARATOR", "^".concat(i[n.GTLT], "\\s*(").concat(i[n.FULLPLAIN], ")$|^$")), o("COMPARATORTRIM", "(\\s*)".concat(i[n.GTLT], "\\s*(").concat(i[n.LOOSEPLAIN], "|").concat(i[n.XRANGEPLAIN], ")"), !0), e.comparatorTrimReplace = "$1$2$3", o("HYPHENRANGE", "^\\s*(".concat(i[n.XRANGEPLAIN], ")") + "\\s+-\\s+" + "(".concat(i[n.XRANGEPLAIN], ")") + "\\s*$"), o("HYPHENRANGELOOSE", "^\\s*(".concat(i[n.XRANGEPLAINLOOSE], ")") + "\\s+-\\s+" + "(".concat(i[n.XRANGEPLAINLOOSE], ")") + "\\s*$"), o("STAR", "(<|>)?=?\\s*\\*"), o("GTE0", "^\\s*>=\\s*0.0.0\\s*$"), o("GTE0PRE", "^\\s*>=\\s*0.0.0-0\\s*$");
  });

  var U = /^[0-9]+$/,
      q = function q(t, e) {
    var s = U.test(t),
        r = U.test(e);
    return s && r && (t = +t, e = +e), t === e ? 0 : s && !r ? -1 : r && !s ? 1 : t < e ? -1 : 1;
  };

  var V = {
    compareIdentifiers: q,
    rcompareIdentifiers: function rcompareIdentifiers(t, e) {
      return q(e, t);
    }
  };
  var z = M.MAX_LENGTH,
      H = M.MAX_SAFE_INTEGER,
      W = j.re,
      X = j.t,
      G = V.compareIdentifiers;

  var K = /*#__PURE__*/function () {
    function K(t, e) {
      _classCallCheck(this, K);

      if (e && "object" == typeof e || (e = {
        loose: !!e,
        includePrerelease: !1
      }), t instanceof K) {
        if (t.loose === !!e.loose && t.includePrerelease === !!e.includePrerelease) return t;
        t = t.version;
      } else if ("string" != typeof t) throw new TypeError("Invalid Version: ".concat(t));

      if (t.length > z) throw new TypeError("version is longer than ".concat(z, " characters"));
      O("SemVer", t, e), this.options = e, this.loose = !!e.loose, this.includePrerelease = !!e.includePrerelease;
      var s = t.trim().match(e.loose ? W[X.LOOSE] : W[X.FULL]);
      if (!s) throw new TypeError("Invalid Version: ".concat(t));
      if (this.raw = t, this.major = +s[1], this.minor = +s[2], this.patch = +s[3], this.major > H || this.major < 0) throw new TypeError("Invalid major version");
      if (this.minor > H || this.minor < 0) throw new TypeError("Invalid minor version");
      if (this.patch > H || this.patch < 0) throw new TypeError("Invalid patch version");
      s[4] ? this.prerelease = s[4].split(".").map(function (t) {
        if (/^[0-9]+$/.test(t)) {
          var _e3 = +t;

          if (_e3 >= 0 && _e3 < H) return _e3;
        }

        return t;
      }) : this.prerelease = [], this.build = s[5] ? s[5].split(".") : [], this.format();
    }

    _createClass(K, [{
      key: "format",
      value: function format() {
        return this.version = "".concat(this.major, ".").concat(this.minor, ".").concat(this.patch), this.prerelease.length && (this.version += "-".concat(this.prerelease.join("."))), this.version;
      }
    }, {
      key: "toString",
      value: function toString() {
        return this.version;
      }
    }, {
      key: "compare",
      value: function compare(t) {
        if (O("SemVer.compare", this.version, this.options, t), !(t instanceof K)) {
          if ("string" == typeof t && t === this.version) return 0;
          t = new K(t, this.options);
        }

        return t.version === this.version ? 0 : this.compareMain(t) || this.comparePre(t);
      }
    }, {
      key: "compareMain",
      value: function compareMain(t) {
        return t instanceof K || (t = new K(t, this.options)), G(this.major, t.major) || G(this.minor, t.minor) || G(this.patch, t.patch);
      }
    }, {
      key: "comparePre",
      value: function comparePre(t) {
        if (t instanceof K || (t = new K(t, this.options)), this.prerelease.length && !t.prerelease.length) return -1;
        if (!this.prerelease.length && t.prerelease.length) return 1;
        if (!this.prerelease.length && !t.prerelease.length) return 0;
        var e = 0;

        do {
          var _s2 = this.prerelease[e],
              _r = t.prerelease[e];
          if (O("prerelease compare", e, _s2, _r), void 0 === _s2 && void 0 === _r) return 0;
          if (void 0 === _r) return 1;
          if (void 0 === _s2) return -1;
          if (_s2 !== _r) return G(_s2, _r);
        } while (++e);
      }
    }, {
      key: "compareBuild",
      value: function compareBuild(t) {
        t instanceof K || (t = new K(t, this.options));
        var e = 0;

        do {
          var _s3 = this.build[e],
              _r2 = t.build[e];
          if (O("prerelease compare", e, _s3, _r2), void 0 === _s3 && void 0 === _r2) return 0;
          if (void 0 === _r2) return 1;
          if (void 0 === _s3) return -1;
          if (_s3 !== _r2) return G(_s3, _r2);
        } while (++e);
      }
    }, {
      key: "inc",
      value: function inc(t, e) {
        switch (t) {
          case "premajor":
            this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", e);
            break;

          case "preminor":
            this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", e);
            break;

          case "prepatch":
            this.prerelease.length = 0, this.inc("patch", e), this.inc("pre", e);
            break;

          case "prerelease":
            0 === this.prerelease.length && this.inc("patch", e), this.inc("pre", e);
            break;

          case "major":
            0 === this.minor && 0 === this.patch && 0 !== this.prerelease.length || this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
            break;

          case "minor":
            0 === this.patch && 0 !== this.prerelease.length || this.minor++, this.patch = 0, this.prerelease = [];
            break;

          case "patch":
            0 === this.prerelease.length && this.patch++, this.prerelease = [];
            break;

          case "pre":
            if (0 === this.prerelease.length) this.prerelease = [0];else {
              var _t3 = this.prerelease.length;

              for (; --_t3 >= 0;) {
                "number" == typeof this.prerelease[_t3] && (this.prerelease[_t3]++, _t3 = -2);
              }

              -1 === _t3 && this.prerelease.push(0);
            }
            e && (this.prerelease[0] === e ? isNaN(this.prerelease[1]) && (this.prerelease = [e, 0]) : this.prerelease = [e, 0]);
            break;

          default:
            throw new Error("invalid increment argument: ".concat(t));
        }

        return this.format(), this.raw = this.version, this;
      }
    }]);

    return K;
  }();

  var J = K;

  var $ = function $(t, e, s) {
    return new J(t, s).compare(new J(e, s));
  };

  var Y = function Y(t, e, s) {
    return $(t, e, s) < 0;
  };

  var Q = function Q(t, e, s) {
    return $(t, e, s) >= 0;
  },
      Z = "2.2.1",
      tt = R(function (t, e) {
    function s() {
      for (var t = [], e = 0; e < arguments.length; e++) {
        t[e] = arguments[e];
      }
    }

    function r() {
      return "undefined" != typeof WeakMap ? new WeakMap() : {
        add: s,
        delete: s,
        get: s,
        set: s,
        has: function has(t) {
          return !1;
        }
      };
    }

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var i = Object.prototype.hasOwnProperty,
        n = function n(t, e) {
      return i.call(t, e);
    };

    function a(t, e) {
      for (var s in e) {
        n(e, s) && (t[s] = e[s]);
      }

      return t;
    }

    var o = /^[ \t]*(?:\r\n|\r|\n)/,
        u = /(?:\r\n|\r|\n)[ \t]*$/,
        h = /^(?:[\r\n]|$)/,
        c = /(?:\r\n|\r|\n)([ \t]*)(?:[^ \t\r\n]|$)/,
        p = /^[ \t]*[\r\n][ \t\r\n]*$/;

    function l(t, e, s) {
      var r = 0,
          i = t[0].match(c);
      i && (r = i[1].length);
      var n = new RegExp("(\\r\\n|\\r|\\n).{0," + r + "}", "g");
      e && (t = t.slice(1));
      var a = s.newline,
          h = s.trimLeadingNewline,
          p = s.trimTrailingNewline,
          l = "string" == typeof a,
          d = t.length;
      return t.map(function (t, e) {
        return t = t.replace(n, "$1"), 0 === e && h && (t = t.replace(o, "")), e === d - 1 && p && (t = t.replace(u, "")), l && (t = t.replace(/\r\n|\n|\r/g, function (t) {
          return a;
        })), t;
      });
    }

    function d(t, e) {
      for (var s = "", r = 0, i = t.length; r < i; r++) {
        s += t[r], r < i - 1 && (s += e[r]);
      }

      return s;
    }

    function D(t) {
      return n(t, "raw") && n(t, "length");
    }

    var m = function t(e) {
      var s = r(),
          i = r();
      return a(function r(n) {
        for (var o = [], u = 1; u < arguments.length; u++) {
          o[u - 1] = arguments[u];
        }

        if (D(n)) {
          var c = n,
              f = (o[0] === r || o[0] === m) && p.test(c[0]) && h.test(c[1]),
              y = f ? i : s,
              E = y.get(c);
          if (E || (E = l(c, f, e), y.set(c, E)), 0 === o.length) return E[0];
          var A = d(E, f ? o.slice(1) : o);
          return A;
        }

        return t(a(a({}, e), n || {}));
      }, {
        string: function string(t) {
          return l([t], !1, e)[0];
        }
      });
    }({
      trimLeadingNewline: !0,
      trimTrailingNewline: !0
    });

    e.outdent = m, e.default = m;

    try {
      t.exports = m, Object.defineProperty(m, "__esModule", {
        value: !0
      }), m.default = m, m.outdent = m;
    } catch (t) {}
  });

  function et() {
    var t = h(["\n      Require either '@prettier' or '@format' to be present in the file's first docblock comment\n      in order for it to be formatted.\n    "]);
    return et = function et() {
      return t;
    }, t;
  }

  function st() {
    var t = h(["\n      Format code starting at a given character offset.\n      The range will extend backwards to the start of the first line containing the selected statement.\n      This option cannot be used with --cursor-offset.\n    "]);
    return st = function st() {
      return t;
    }, t;
  }

  function rt() {
    var t = h(["\n      Format code ending at a given character offset (exclusive).\n      The range will extend forwards to the end of the selected statement.\n      This option cannot be used with --cursor-offset.\n    "]);
    return rt = function rt() {
      return t;
    }, t;
  }

  function it() {
    var t = h(["\n      Custom directory that contains prettier plugins in node_modules subdirectory.\n      Overrides default behavior when plugins are searched relatively to the location of Prettier.\n      Multiple values are accepted.\n    "]);
    return it = function it() {
      return t;
    }, t;
  }

  function nt() {
    var t = h(["\n          Maintain existing\n          (mixed values within one file are normalised by looking at what's used after the first line)\n        "]);
    return nt = function nt() {
      return t;
    }, t;
  }

  function at() {
    var t = h(["\n      Print (to stderr) where a cursor at the given position would move to after formatting.\n      This option cannot be used with --range-start and --range-end.\n    "]);
    return at = function at() {
      return t;
    }, t;
  }

  var ot = tt.outdent,
      ut = "Config",
      ht = "Editor",
      ct = "Other",
      pt = "Global",
      lt = "Special",
      dt = {
    cursorOffset: {
      since: "1.4.0",
      category: lt,
      type: "int",
      default: -1,
      range: {
        start: -1,
        end: 1 / 0,
        step: 1
      },
      description: ot(at()),
      cliCategory: ht
    },
    endOfLine: {
      since: "1.15.0",
      category: pt,
      type: "choice",
      default: [{
        since: "1.15.0",
        value: "auto"
      }, {
        since: "2.0.0",
        value: "lf"
      }],
      description: "Which end of line characters to apply.",
      choices: [{
        value: "lf",
        description: "Line Feed only (\\n), common on Linux and macOS as well as inside git repos"
      }, {
        value: "crlf",
        description: "Carriage Return + Line Feed characters (\\r\\n), common on Windows"
      }, {
        value: "cr",
        description: "Carriage Return character only (\\r), used very rarely"
      }, {
        value: "auto",
        description: ot(nt())
      }]
    },
    filepath: {
      since: "1.4.0",
      category: lt,
      type: "path",
      description: "Specify the input filepath. This will be used to do parser inference.",
      cliName: "stdin-filepath",
      cliCategory: ct,
      cliDescription: "Path to the file to pretend that stdin comes from."
    },
    insertPragma: {
      since: "1.8.0",
      category: lt,
      type: "boolean",
      default: !1,
      description: "Insert @format pragma into file's first docblock comment.",
      cliCategory: ct
    },
    parser: {
      since: "0.0.10",
      category: pt,
      type: "choice",
      default: [{
        since: "0.0.10",
        value: "babylon"
      }, {
        since: "1.13.0",
        value: void 0
      }],
      description: "Which parser to use.",
      exception: function exception(t) {
        return "string" == typeof t || "function" == typeof t;
      },
      choices: [{
        value: "flow",
        description: "Flow"
      }, {
        value: "babel",
        since: "1.16.0",
        description: "JavaScript"
      }, {
        value: "babel-flow",
        since: "1.16.0",
        description: "Flow"
      }, {
        value: "babel-ts",
        since: "2.0.0",
        description: "TypeScript"
      }, {
        value: "typescript",
        since: "1.4.0",
        description: "TypeScript"
      }, {
        value: "espree",
        since: "2.2.0",
        description: "JavaScript"
      }, {
        value: "meriyah",
        since: "2.2.0",
        description: "JavaScript"
      }, {
        value: "css",
        since: "1.7.1",
        description: "CSS"
      }, {
        value: "less",
        since: "1.7.1",
        description: "Less"
      }, {
        value: "scss",
        since: "1.7.1",
        description: "SCSS"
      }, {
        value: "json",
        since: "1.5.0",
        description: "JSON"
      }, {
        value: "json5",
        since: "1.13.0",
        description: "JSON5"
      }, {
        value: "json-stringify",
        since: "1.13.0",
        description: "JSON.stringify"
      }, {
        value: "graphql",
        since: "1.5.0",
        description: "GraphQL"
      }, {
        value: "markdown",
        since: "1.8.0",
        description: "Markdown"
      }, {
        value: "mdx",
        since: "1.15.0",
        description: "MDX"
      }, {
        value: "vue",
        since: "1.10.0",
        description: "Vue"
      }, {
        value: "yaml",
        since: "1.14.0",
        description: "YAML"
      }, {
        value: "glimmer",
        since: null,
        description: "Handlebars"
      }, {
        value: "html",
        since: "1.15.0",
        description: "HTML"
      }, {
        value: "angular",
        since: "1.15.0",
        description: "Angular"
      }, {
        value: "lwc",
        since: "1.17.0",
        description: "Lightning Web Components"
      }]
    },
    plugins: {
      since: "1.10.0",
      type: "path",
      array: !0,
      default: [{
        value: []
      }],
      category: pt,
      description: "Add a plugin. Multiple plugins can be passed as separate `--plugin`s.",
      exception: function exception(t) {
        return "string" == typeof t || "object" == typeof t;
      },
      cliName: "plugin",
      cliCategory: ut
    },
    pluginSearchDirs: {
      since: "1.13.0",
      type: "path",
      array: !0,
      default: [{
        value: []
      }],
      category: pt,
      description: ot(it()),
      exception: function exception(t) {
        return "string" == typeof t || "object" == typeof t;
      },
      cliName: "plugin-search-dir",
      cliCategory: ut
    },
    printWidth: {
      since: "0.0.0",
      category: pt,
      type: "int",
      default: 80,
      description: "The line length where Prettier will try wrap.",
      range: {
        start: 0,
        end: 1 / 0,
        step: 1
      }
    },
    rangeEnd: {
      since: "1.4.0",
      category: lt,
      type: "int",
      default: 1 / 0,
      range: {
        start: 0,
        end: 1 / 0,
        step: 1
      },
      description: ot(rt()),
      cliCategory: ht
    },
    rangeStart: {
      since: "1.4.0",
      category: lt,
      type: "int",
      default: 0,
      range: {
        start: 0,
        end: 1 / 0,
        step: 1
      },
      description: ot(st()),
      cliCategory: ht
    },
    requirePragma: {
      since: "1.7.0",
      category: lt,
      type: "boolean",
      default: !1,
      description: ot(et()),
      cliCategory: ct
    },
    tabWidth: {
      type: "int",
      category: pt,
      default: 2,
      description: "Number of spaces per indentation level.",
      range: {
        start: 0,
        end: 1 / 0,
        step: 1
      }
    },
    useTabs: {
      since: "1.0.0",
      category: pt,
      type: "boolean",
      default: !1,
      description: "Indent with tabs instead of spaces."
    },
    embeddedLanguageFormatting: {
      since: "2.1.0",
      category: pt,
      type: "choice",
      default: [{
        since: "2.1.0",
        value: "auto"
      }],
      description: "Control how Prettier formats quoted code embedded in the file.",
      choices: [{
        value: "auto",
        description: "Format embedded code if Prettier can automatically identify it."
      }, {
        value: "off",
        description: "Never automatically format embedded code."
      }]
    }
  };
  var Dt = {
    compare: $,
    lt: Y,
    gte: Q
  },
      mt = Z,
      ft = {
    CATEGORY_CONFIG: ut,
    CATEGORY_EDITOR: ht,
    CATEGORY_FORMAT: "Format",
    CATEGORY_OTHER: ct,
    CATEGORY_OUTPUT: "Output",
    CATEGORY_GLOBAL: pt,
    CATEGORY_SPECIAL: lt,
    options: dt
  }.options;
  var yt = {
    getSupportInfo: function getSupportInfo() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$plugins = _ref2.plugins,
          t = _ref2$plugins === void 0 ? [] : _ref2$plugins,
          _ref2$showUnreleased = _ref2.showUnreleased,
          e = _ref2$showUnreleased === void 0 ? !1 : _ref2$showUnreleased,
          _ref2$showDeprecated = _ref2.showDeprecated,
          s = _ref2$showDeprecated === void 0 ? !1 : _ref2$showDeprecated,
          _ref2$showInternal = _ref2.showInternal,
          r = _ref2$showInternal === void 0 ? !1 : _ref2$showInternal;

      var i = mt.split("-", 1)[0],
          n = t.reduce(function (t, e) {
        return t.concat(e.languages || []);
      }, []).filter(h),
          a = (o = Object.assign.apply(Object, [{}].concat(_toConsumableArray(t.map(function (_ref3) {
        var t = _ref3.options;
        return t;
      })), [ft])), u = "name", Object.entries(o).map(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
            t = _ref5[0],
            e = _ref5[1];

        return Object.assign(_defineProperty({}, u, t), e);
      })).filter(function (t) {
        return h(t) && c(t);
      }).sort(function (t, e) {
        return t.name === e.name ? 0 : t.name < e.name ? -1 : 1;
      }).map(function (t) {
        if (r) return t;
        return function (t, e) {
          if (null == t) return {};
          var s,
              r,
              i = {},
              n = Object.keys(t);

          for (r = 0; r < n.length; r++) {
            s = n[r], e.indexOf(s) >= 0 || (i[s] = t[s]);
          }

          return i;
        }(t, ["cliName", "cliCategory", "cliDescription"]);
      }).map(function (e) {
        e = Object.assign({}, e), Array.isArray(e.default) && (e.default = 1 === e.default.length ? e.default[0].value : e.default.filter(h).sort(function (t, e) {
          return Dt.compare(e.since, t.since);
        })[0].value), Array.isArray(e.choices) && (e.choices = e.choices.filter(function (t) {
          return h(t) && c(t);
        }), "parser" === e.name && function (t, e, s) {
          var r = new Set(t.choices.map(function (t) {
            return t.value;
          }));

          var _iterator = _createForOfIteratorHelper(e),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _i2 = _step.value;

              if (_i2.parsers) {
                var _iterator2 = _createForOfIteratorHelper(_i2.parsers),
                    _step2;

                try {
                  var _loop = function _loop() {
                    var e = _step2.value;

                    if (!r.has(e)) {
                      r.add(e);

                      var _n = s.find(function (t) {
                        return t.parsers && t.parsers[e];
                      });

                      var _a = _i2.name;
                      _n && _n.name && (_a += " (plugin: ".concat(_n.name, ")")), t.choices.push({
                        value: e,
                        description: _a
                      });
                    }
                  };

                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    _loop();
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }(e, n, t));
        var s = t.filter(function (t) {
          return t.defaultOptions && void 0 !== t.defaultOptions[e.name];
        }).reduce(function (t, s) {
          return t[s.name] = s.defaultOptions[e.name], t;
        }, {});
        return Object.assign({}, e, {
          pluginDefaults: s
        });
      });
      var o, u;
      return {
        languages: n,
        options: a
      };

      function h(t) {
        return e || !("since" in t) || t.since && Dt.gte(i, t.since);
      }

      function c(t) {
        return s || !("deprecated" in t) || t.deprecated && Dt.lt(i, t.deprecated);
      }
    }
  };
  var Et = yt.getSupportInfo,
      At = /[^\x20-\x7F]/;

  function Ct(t) {
    return function (e, s, r) {
      var i = r && r.backwards;
      if (!1 === s) return !1;
      var n = e.length;
      var a = s;

      for (; a >= 0 && a < n;) {
        var _s4 = e.charAt(a);

        if (t instanceof RegExp) {
          if (!t.test(_s4)) return a;
        } else if (!t.includes(_s4)) return a;

        i ? a-- : a++;
      }

      return (-1 === a || a === n) && a;
    };
  }

  var xt = Ct(/\s/),
      Ft = Ct(" \t"),
      gt = Ct(",; \t"),
      bt = Ct(/[^\n\r]/);

  function Pt(t, e) {
    if (!1 === e) return !1;
    if ("/" === t.charAt(e) && "*" === t.charAt(e + 1)) for (var _s5 = e + 2; _s5 < t.length; ++_s5) {
      if ("*" === t.charAt(_s5) && "/" === t.charAt(_s5 + 1)) return _s5 + 2;
    }
    return e;
  }

  function Tt(t, e) {
    return !1 !== e && ("/" === t.charAt(e) && "/" === t.charAt(e + 1) ? bt(t, e) : e);
  }

  function wt(t, e, s) {
    var r = s && s.backwards;
    if (!1 === e) return !1;
    var i = t.charAt(e);

    if (r) {
      if ("\r" === t.charAt(e - 1) && "\n" === i) return e - 2;
      if ("\n" === i || "\r" === i || "\u2028" === i || "\u2029" === i) return e - 1;
    } else {
      if ("\r" === i && "\n" === t.charAt(e + 1)) return e + 2;
      if ("\n" === i || "\r" === i || "\u2028" === i || "\u2029" === i) return e + 1;
    }

    return e;
  }

  function Bt(t, e, s) {
    var r = Ft(t, (s = s || {}).backwards ? e - 1 : e, s);
    return r !== wt(t, r, s);
  }

  function St(t, e) {
    var s = null,
        r = e;

    for (; r !== s;) {
      s = r, r = gt(t, r), r = Pt(t, r), r = Ft(t, r);
    }

    return r = Tt(t, r), r = wt(t, r), !1 !== r && Bt(t, r);
  }

  function Nt(t, e) {
    var s = null,
        r = e;

    for (; r !== s;) {
      s = r, r = Ft(t, r), r = Pt(t, r), r = Tt(t, r), r = wt(t, r);
    }

    return r;
  }

  function It(t, e, s) {
    return Nt(t, s(e));
  }

  function vt(t, e, s) {
    var r = 0;

    for (var _i3 = s = s || 0; _i3 < t.length; ++_i3) {
      "\t" === t[_i3] ? r = r + e - r % e : r++;
    }

    return r;
  }

  function kt(t, e) {
    var s = t.slice(1, -1),
        r = {
      quote: '"',
      regex: /"/g
    },
        i = {
      quote: "'",
      regex: /'/g
    },
        n = "'" === e ? i : r,
        a = n === i ? r : i;
    var o = n.quote;

    if (s.includes(n.quote) || s.includes(a.quote)) {
      o = (s.match(n.regex) || []).length > (s.match(a.regex) || []).length ? a.quote : n.quote;
    }

    return o;
  }

  function Lt(t, e, s) {
    var r = '"' === e ? "'" : '"',
        i = t.replace(/\\([\S\s])|(["'])/g, function (t, i, n) {
      return i === r ? i : n === e ? "\\" + n : n || (s && /^[^\n\r"'0-7\\bfnrt-vx\u2028\u2029]$/.test(i) ? i : "\\" + i);
    });
    return e + i + e;
  }

  function Ot(t, e) {
    (t.comments || (t.comments = [])).push(e), e.printed = !1, "JSXText" === t.type && (e.printed = !0);
  }

  var Mt = {
    inferParserByLanguage: function inferParserByLanguage(t, e) {
      var _Et = Et({
        plugins: e.plugins
      }),
          s = _Et.languages,
          r = s.find(function (_ref6) {
        var e = _ref6.name;
        return e.toLowerCase() === t;
      }) || s.find(function (_ref7) {
        var e = _ref7.aliases;
        return Array.isArray(e) && e.includes(t);
      }) || s.find(function (_ref8) {
        var e = _ref8.extensions;
        return Array.isArray(e) && e.includes(".".concat(t));
      });

      return r && r.parsers[0];
    },
    replaceEndOfLineWith: function replaceEndOfLineWith(t, e) {
      var s = [];

      var _iterator3 = _createForOfIteratorHelper(t.split("\n")),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _r3 = _step3.value;
          0 !== s.length && s.push(e), s.push(_r3);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return s;
    },
    getStringWidth: function getStringWidth(t) {
      return t ? At.test(t) ? a(t) : t.length : 0;
    },
    getMaxContinuousCount: function getMaxContinuousCount(t, e) {
      var s = t.match(new RegExp("(".concat(u(e), ")+"), "g"));
      return null === s ? 0 : s.reduce(function (t, s) {
        return Math.max(t, s.length / e.length);
      }, 0);
    },
    getMinNotPresentContinuousCount: function getMinNotPresentContinuousCount(t, e) {
      var s = t.match(new RegExp("(".concat(u(e), ")+"), "g"));
      if (null === s) return 0;
      var r = new Map();
      var i = 0;

      var _iterator4 = _createForOfIteratorHelper(s),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _t5 = _step4.value;

          var _s6 = _t5.length / e.length;

          r.set(_s6, !0), _s6 > i && (i = _s6);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      for (var _t4 = 1; _t4 < i; _t4++) {
        if (!r.get(_t4)) return _t4;
      }

      return i + 1;
    },
    getPenultimate: function getPenultimate(t) {
      return t[t.length - 2];
    },
    getLast: function getLast(t) {
      return t[t.length - 1];
    },
    getNextNonSpaceNonCommentCharacterIndexWithStartIndex: Nt,
    getNextNonSpaceNonCommentCharacterIndex: It,
    getNextNonSpaceNonCommentCharacter: function getNextNonSpaceNonCommentCharacter(t, e, s) {
      return t.charAt(It(t, e, s));
    },
    skip: Ct,
    skipWhitespace: xt,
    skipSpaces: Ft,
    skipToLineEnd: gt,
    skipEverythingButNewLine: bt,
    skipInlineComment: Pt,
    skipTrailingComment: Tt,
    skipNewline: wt,
    isNextLineEmptyAfterIndex: St,
    isNextLineEmpty: function isNextLineEmpty(t, e, s) {
      return St(t, s(e));
    },
    isPreviousLineEmpty: function isPreviousLineEmpty(t, e, s) {
      var r = s(e) - 1;
      return r = Ft(t, r, {
        backwards: !0
      }), r = wt(t, r, {
        backwards: !0
      }), r = Ft(t, r, {
        backwards: !0
      }), r !== wt(t, r, {
        backwards: !0
      });
    },
    hasNewline: Bt,
    hasNewlineInRange: function hasNewlineInRange(t, e, s) {
      for (var _r4 = e; _r4 < s; ++_r4) {
        if ("\n" === t.charAt(_r4)) return !0;
      }

      return !1;
    },
    hasSpaces: function hasSpaces(t, e, s) {
      return Ft(t, (s = s || {}).backwards ? e - 1 : e, s) !== e;
    },
    getAlignmentSize: vt,
    getIndentSize: function getIndentSize(t, e) {
      var s = t.lastIndexOf("\n");
      return -1 === s ? 0 : vt(t.slice(s + 1).match(/^[\t ]*/)[0], e);
    },
    getPreferredQuote: kt,
    printString: function printString(t, e, s) {
      var r = t.slice(1, -1),
          i = !r.includes('"') && !r.includes("'"),
          n = "json" === e.parser ? '"' : e.__isInHtmlAttribute ? "'" : kt(t, e.singleQuote ? "'" : '"');
      return s ? i ? n + r + n : t : Lt(r, n, !("css" === e.parser || "less" === e.parser || "scss" === e.parser || e.embeddedInHtml));
    },
    printNumber: function printNumber(t) {
      return t.toLowerCase().replace(/^([+-]?[\d.]+e)(?:\+|(-))?0*(\d)/, "$1$2$3").replace(/^([+-]?[\d.]+)e[+-]?0+$/, "$1").replace(/^([+-])?\./, "$10.").replace(/(\.\d+?)0+(?=e|$)/, "$1").replace(/\.(?=e|$)/, "");
    },
    isNodeIgnoreComment: function isNodeIgnoreComment(t) {
      return "prettier-ignore" === t.value.trim();
    },
    makeString: Lt,
    addLeadingComment: function addLeadingComment(t, e) {
      e.leading = !0, e.trailing = !1, Ot(t, e);
    },
    addDanglingComment: function addDanglingComment(t, e, s) {
      e.leading = !1, e.trailing = !1, s && (e.marker = s), Ot(t, e);
    },
    addTrailingComment: function addTrailingComment(t, e) {
      e.leading = !1, e.trailing = !0, Ot(t, e);
    },
    isFrontMatterNode: function isFrontMatterNode(t) {
      return t && "front-matter" === t.type;
    },
    getShebang: function getShebang(t) {
      if (!t.startsWith("#!")) return "";
      var e = t.indexOf("\n");
      return -1 === e ? t : t.slice(0, e);
    }
  },
      Rt = Object.freeze({
    __proto__: null,
    default: {
      EOL: "\n",
      platform: function platform() {
        return "browser";
      },
      cpus: function cpus() {
        return [{
          model: "Prettier"
        }];
      }
    }
  });

  var _t = function _t(t) {
    if ("string" != typeof t) throw new TypeError("Expected a string");
    var e = t.match(/(?:\r?\n)/g) || [];
    if (0 === e.length) return;
    var s = e.filter(function (t) {
      return "\r\n" === t;
    }).length;
    return s > e.length - s ? "\r\n" : "\n";
  };

  var jt = _t;

  jt.graceful = function (t) {
    return "string" == typeof t && _t(t) || "\n";
  };

  var Ut = _(Rt),
      qt = R(function (t, e) {
    function s() {
      var t = Ut;
      return s = function s() {
        return t;
      }, t;
    }

    function r() {
      var t = (e = jt) && e.__esModule ? e : {
        default: e
      };
      var e;
      return r = function r() {
        return t;
      }, t;
    }

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.extract = function (t) {
      var e = t.match(a);
      return e ? e[0].trimLeft() : "";
    }, e.strip = function (t) {
      var e = t.match(a);
      return e && e[0] ? t.substring(e[0].length) : t;
    }, e.parse = function (t) {
      return d(t).pragmas;
    }, e.parseWithComments = d, e.print = function (_ref9) {
      var _ref9$comments = _ref9.comments,
          t = _ref9$comments === void 0 ? "" : _ref9$comments,
          _ref9$pragmas = _ref9.pragmas,
          e = _ref9$pragmas === void 0 ? {} : _ref9$pragmas;
      var i = (0, r().default)(t) || s().EOL,
          n = " *",
          a = Object.keys(e),
          o = a.map(function (t) {
        return D(t, e[t]);
      }).reduce(function (t, e) {
        return t.concat(e);
      }, []).map(function (t) {
        return " * " + t + i;
      }).join("");

      if (!t) {
        if (0 === a.length) return "";

        if (1 === a.length && !Array.isArray(e[a[0]])) {
          var _t6 = e[a[0]];
          return "".concat("/**", " ").concat(D(a[0], _t6)[0]).concat(" */");
        }
      }

      var u = t.split(i).map(function (t) {
        return "".concat(n, " ").concat(t);
      }).join(i) + i;
      return "/**" + i + (t ? u : "") + (t && a.length ? n + i : "") + o + " */";
    };
    var i = /\*\/$/,
        n = /^\/\*\*/,
        a = /^\s*(\/\*\*?(.|\r?\n)*?\*\/)/,
        o = /(^|\s+)\/\/([^\r\n]*)/g,
        u = /^(\r?\n)+/,
        h = /(?:^|\r?\n) *(@[^\r\n]*?) *\r?\n *(?![^@\r\n]*\/\/[^]*)([^@\r\n\s][^@\r\n]+?) *\r?\n/g,
        c = /(?:^|\r?\n) *@(\S+) *([^\r\n]*)/g,
        p = /(\r?\n|^) *\* ?/g,
        l = [];

    function d(t) {
      var e = (0, r().default)(t) || s().EOL;
      t = t.replace(n, "").replace(i, "").replace(p, "$1");
      var a = "";

      for (; a !== t;) {
        a = t, t = t.replace(h, "".concat(e, "$1 $2").concat(e));
      }

      t = t.replace(u, "").trimRight();
      var d = Object.create(null),
          D = t.replace(c, "").replace(u, "").trimRight();
      var m;

      for (; m = c.exec(t);) {
        var _t7 = m[2].replace(o, "");

        "string" == typeof d[m[1]] || Array.isArray(d[m[1]]) ? d[m[1]] = l.concat(d[m[1]], _t7) : d[m[1]] = _t7;
      }

      return {
        comments: D,
        pragmas: d
      };
    }

    function D(t, e) {
      return l.concat(e).map(function (e) {
        return "@".concat(t, " ").concat(e).trim();
      });
    }
  });

  var Vt = {
    guessEndOfLine: function guessEndOfLine(t) {
      var e = t.indexOf("\r");
      return e >= 0 ? "\n" === t.charAt(e + 1) ? "crlf" : "cr" : "lf";
    },
    convertEndOfLineToChars: function convertEndOfLineToChars(t) {
      switch (t) {
        case "cr":
          return "\r";

        case "crlf":
          return "\r\n";

        default:
          return "\n";
      }
    },
    countEndOfLineChars: function countEndOfLineChars(t, e) {
      var s;
      if ("\n" === e) s = /\n/g;else if ("\r" === e) s = /\r/g;else {
        if ("\r\n" !== e) throw new Error('Unexpected "eol" '.concat(JSON.stringify(e), "."));
        s = /\r\n/g;
      }
      var r = t.match(s);
      return r ? r.length : 0;
    },
    normalizeEndOfLine: function normalizeEndOfLine(t) {
      return t.replace(/\r\n?/g, "\n");
    }
  };
  var zt = qt.parseWithComments,
      Ht = qt.strip,
      Wt = qt.extract,
      Xt = qt.print,
      Gt = Mt.getShebang,
      Kt = Vt.normalizeEndOfLine;

  function Jt(t) {
    var e = Gt(t);
    e && (t = t.slice(e.length + 1));

    var s = Wt(t),
        _zt = zt(s),
        r = _zt.pragmas,
        i = _zt.comments;

    return {
      shebang: e,
      text: t,
      pragmas: r,
      comments: i
    };
  }

  var $t = {
    hasPragma: function hasPragma(t) {
      var e = Object.keys(Jt(t).pragmas);
      return e.includes("prettier") || e.includes("format");
    },
    insertPragma: function insertPragma(t) {
      var _Jt = Jt(t),
          e = _Jt.shebang,
          s = _Jt.text,
          r = _Jt.pragmas,
          i = _Jt.comments,
          n = Ht(s),
          a = Xt({
        pragmas: Object.assign({
          format: ""
        }, r),
        comments: i.trimStart()
      });

      return (e ? "".concat(e, "\n") : "") + Kt(a) + (n.startsWith("\n") ? "\n" : "\n\n") + n;
    }
  };

  function Yt(t, e) {
    var _ref10 = e || {},
        s = _ref10.ignoreDecorators;

    if (!s) {
      var _e4 = t.declaration && t.declaration.decorators || t.decorators;

      if (_e4 && _e4.length > 0) return Yt(_e4[0]);
    }

    return t.range ? t.range[0] : t.start;
  }

  function Qt(t) {
    var e = t.range ? t.range[1] : t.end;
    return t.typeAnnotation ? Math.max(e, Qt(t.typeAnnotation)) : e;
  }

  function Zt(t, e) {
    return Yt(t) === Yt(e);
  }

  var te = {
    locStart: Yt,
    locEnd: Qt,
    composeLoc: function composeLoc(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : t;
      var s = Yt(t);
      return [s, "number" == typeof e ? s + e : Qt(e)];
    },
    hasSameLocStart: Zt,
    hasSameLoc: function hasSameLoc(t, e) {
      return Zt(t, e) && function (t, e) {
        return Qt(t) === Qt(e);
      }(t, e);
    }
  },
      ee = R(function (t) {
    !function () {
      function e(t) {
        if (null == t) return !1;

        switch (t.type) {
          case "BlockStatement":
          case "BreakStatement":
          case "ContinueStatement":
          case "DebuggerStatement":
          case "DoWhileStatement":
          case "EmptyStatement":
          case "ExpressionStatement":
          case "ForInStatement":
          case "ForStatement":
          case "IfStatement":
          case "LabeledStatement":
          case "ReturnStatement":
          case "SwitchStatement":
          case "ThrowStatement":
          case "TryStatement":
          case "VariableDeclaration":
          case "WhileStatement":
          case "WithStatement":
            return !0;
        }

        return !1;
      }

      function s(t) {
        switch (t.type) {
          case "IfStatement":
            return null != t.alternate ? t.alternate : t.consequent;

          case "LabeledStatement":
          case "ForStatement":
          case "ForInStatement":
          case "WhileStatement":
          case "WithStatement":
            return t.body;
        }

        return null;
      }

      t.exports = {
        isExpression: function isExpression(t) {
          if (null == t) return !1;

          switch (t.type) {
            case "ArrayExpression":
            case "AssignmentExpression":
            case "BinaryExpression":
            case "CallExpression":
            case "ConditionalExpression":
            case "FunctionExpression":
            case "Identifier":
            case "Literal":
            case "LogicalExpression":
            case "MemberExpression":
            case "NewExpression":
            case "ObjectExpression":
            case "SequenceExpression":
            case "ThisExpression":
            case "UnaryExpression":
            case "UpdateExpression":
              return !0;
          }

          return !1;
        },
        isStatement: e,
        isIterationStatement: function isIterationStatement(t) {
          if (null == t) return !1;

          switch (t.type) {
            case "DoWhileStatement":
            case "ForInStatement":
            case "ForStatement":
            case "WhileStatement":
              return !0;
          }

          return !1;
        },
        isSourceElement: function isSourceElement(t) {
          return e(t) || null != t && "FunctionDeclaration" === t.type;
        },
        isProblematicIfStatement: function isProblematicIfStatement(t) {
          var e;
          if ("IfStatement" !== t.type) return !1;
          if (null == t.alternate) return !1;
          e = t.consequent;

          do {
            if ("IfStatement" === e.type && null == e.alternate) return !0;
            e = s(e);
          } while (e);

          return !1;
        },
        trailingStatement: s
      };
    }();
  }),
      se = R(function (t) {
    !function () {
      var e, s, r, i, n, a;

      function o(t) {
        return t <= 65535 ? String.fromCharCode(t) : String.fromCharCode(Math.floor((t - 65536) / 1024) + 55296) + String.fromCharCode((t - 65536) % 1024 + 56320);
      }

      for (s = {
        NonAsciiIdentifierStart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
        NonAsciiIdentifierPart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19D9\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099\u309A\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/
      }, e = {
        NonAsciiIdentifierStart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCA0-\uDCDF\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F\uDFE0]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]/,
        NonAsciiIdentifierPart: /[\xAA\xB5\xB7\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1369-\u1371\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDDFD\uDE80-\uDE9C\uDEA0-\uDED0\uDEE0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE38-\uDE3A\uDE3F\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE6\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC00-\uDC46\uDC66-\uDC6F\uDC7F-\uDCBA\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD00-\uDD34\uDD36-\uDD3F\uDD50-\uDD73\uDD76\uDD80-\uDDC4\uDDCA-\uDDCC\uDDD0-\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE37\uDE3E\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEEA\uDEF0-\uDEF9\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC00-\uDC4A\uDC50-\uDC59\uDC80-\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDB5\uDDB8-\uDDC0\uDDD8-\uDDDD\uDE00-\uDE40\uDE44\uDE50-\uDE59\uDE80-\uDEB7\uDEC0-\uDEC9\uDF00-\uDF19\uDF1D-\uDF2B\uDF30-\uDF39]|\uD806[\uDCA0-\uDCE9\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC40\uDC50-\uDC59\uDC72-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDED0-\uDEED\uDEF0-\uDEF4\uDF00-\uDF36\uDF40-\uDF43\uDF50-\uDF59\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F\uDFE0]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9D\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]|\uD83A[\uDC00-\uDCC4\uDCD0-\uDCD6\uDD00-\uDD4A\uDD50-\uDD59]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]|\uDB40[\uDD00-\uDDEF]/
      }, r = [5760, 8192, 8193, 8194, 8195, 8196, 8197, 8198, 8199, 8200, 8201, 8202, 8239, 8287, 12288, 65279], i = new Array(128), a = 0; a < 128; ++a) {
        i[a] = a >= 97 && a <= 122 || a >= 65 && a <= 90 || 36 === a || 95 === a;
      }

      for (n = new Array(128), a = 0; a < 128; ++a) {
        n[a] = a >= 97 && a <= 122 || a >= 65 && a <= 90 || a >= 48 && a <= 57 || 36 === a || 95 === a;
      }

      t.exports = {
        isDecimalDigit: function isDecimalDigit(t) {
          return 48 <= t && t <= 57;
        },
        isHexDigit: function isHexDigit(t) {
          return 48 <= t && t <= 57 || 97 <= t && t <= 102 || 65 <= t && t <= 70;
        },
        isOctalDigit: function isOctalDigit(t) {
          return t >= 48 && t <= 55;
        },
        isWhiteSpace: function isWhiteSpace(t) {
          return 32 === t || 9 === t || 11 === t || 12 === t || 160 === t || t >= 5760 && r.indexOf(t) >= 0;
        },
        isLineTerminator: function isLineTerminator(t) {
          return 10 === t || 13 === t || 8232 === t || 8233 === t;
        },
        isIdentifierStartES5: function isIdentifierStartES5(t) {
          return t < 128 ? i[t] : s.NonAsciiIdentifierStart.test(o(t));
        },
        isIdentifierPartES5: function isIdentifierPartES5(t) {
          return t < 128 ? n[t] : s.NonAsciiIdentifierPart.test(o(t));
        },
        isIdentifierStartES6: function isIdentifierStartES6(t) {
          return t < 128 ? i[t] : e.NonAsciiIdentifierStart.test(o(t));
        },
        isIdentifierPartES6: function isIdentifierPartES6(t) {
          return t < 128 ? n[t] : e.NonAsciiIdentifierPart.test(o(t));
        }
      };
    }();
  }),
      re = R(function (t) {
    !function () {
      var e = se;

      function s(t, e) {
        return !(!e && "yield" === t) && r(t, e);
      }

      function r(t, e) {
        if (e && function (t) {
          switch (t) {
            case "implements":
            case "interface":
            case "package":
            case "private":
            case "protected":
            case "public":
            case "static":
            case "let":
              return !0;

            default:
              return !1;
          }
        }(t)) return !0;

        switch (t.length) {
          case 2:
            return "if" === t || "in" === t || "do" === t;

          case 3:
            return "var" === t || "for" === t || "new" === t || "try" === t;

          case 4:
            return "this" === t || "else" === t || "case" === t || "void" === t || "with" === t || "enum" === t;

          case 5:
            return "while" === t || "break" === t || "catch" === t || "throw" === t || "const" === t || "yield" === t || "class" === t || "super" === t;

          case 6:
            return "return" === t || "typeof" === t || "delete" === t || "switch" === t || "export" === t || "import" === t;

          case 7:
            return "default" === t || "finally" === t || "extends" === t;

          case 8:
            return "function" === t || "continue" === t || "debugger" === t;

          case 10:
            return "instanceof" === t;

          default:
            return !1;
        }
      }

      function i(t, e) {
        return "null" === t || "true" === t || "false" === t || s(t, e);
      }

      function n(t, e) {
        return "null" === t || "true" === t || "false" === t || r(t, e);
      }

      function a(t) {
        var s, r, i;
        if (0 === t.length) return !1;
        if (i = t.charCodeAt(0), !e.isIdentifierStartES5(i)) return !1;

        for (s = 1, r = t.length; s < r; ++s) {
          if (i = t.charCodeAt(s), !e.isIdentifierPartES5(i)) return !1;
        }

        return !0;
      }

      function o(t) {
        var s, r, i, n, a;
        if (0 === t.length) return !1;

        for (a = e.isIdentifierStartES6, s = 0, r = t.length; s < r; ++s) {
          if (55296 <= (i = t.charCodeAt(s)) && i <= 56319) {
            if (++s >= r) return !1;
            if (!(56320 <= (n = t.charCodeAt(s)) && n <= 57343)) return !1;
            i = 1024 * (i - 55296) + (n - 56320) + 65536;
          }

          if (!a(i)) return !1;
          a = e.isIdentifierPartES6;
        }

        return !0;
      }

      t.exports = {
        isKeywordES5: s,
        isKeywordES6: r,
        isReservedWordES5: i,
        isReservedWordES6: n,
        isRestrictedWord: function isRestrictedWord(t) {
          return "eval" === t || "arguments" === t;
        },
        isIdentifierNameES5: a,
        isIdentifierNameES6: o,
        isIdentifierES5: function isIdentifierES5(t, e) {
          return a(t) && !i(t, e);
        },
        isIdentifierES6: function isIdentifierES6(t, e) {
          return o(t) && !n(t, e);
        }
      };
    }();
  });
  var ie = R(function (t, e) {
    e.ast = ee, e.code = se, e.keyword = re;
  }).keyword.isIdentifierNameES5,
      ne = Mt.getLast,
      ae = Mt.hasNewline,
      oe = Mt.hasNewlineInRange,
      ue = Mt.skipWhitespace,
      he = te.locStart,
      ce = te.locEnd,
      pe = te.hasSameLocStart,
      le = "(?:(?=.)\\s)",
      de = new RegExp("^".concat(le, "*:")),
      De = new RegExp("^".concat(le, "*::"));

  function me(t, e) {
    if (!t || "object" != typeof t) return !1;
    if (Array.isArray(t)) return t.some(function (t) {
      return me(t, e);
    });
    var s = e(t);
    return "boolean" == typeof s ? s : Object.keys(t).some(function (s) {
      return me(t[s], e);
    });
  }

  function fe(t) {
    return "AssignmentExpression" === t.type || "BinaryExpression" === t.type || "LogicalExpression" === t.type || "NGPipeExpression" === t.type || "ConditionalExpression" === t.type || "CallExpression" === t.type || "OptionalCallExpression" === t.type || "MemberExpression" === t.type || "OptionalMemberExpression" === t.type || "SequenceExpression" === t.type || "TaggedTemplateExpression" === t.type || "BindExpression" === t.type || "UpdateExpression" === t.type && !t.prefix || "TSAsExpression" === t.type || "TSNonNullExpression" === t.type;
  }

  function ye(t) {
    return "Block" === t.type || "CommentBlock" === t.type || "MultiLine" === t.type;
  }

  var Ee = new Set(["ExportDefaultDeclaration", "ExportDefaultSpecifier", "DeclareExportDeclaration", "ExportNamedDeclaration", "ExportAllDeclaration"]);

  function Ae(t) {
    return t && Ee.has(t.type);
  }

  function Ce(t) {
    return "BooleanLiteral" === t.type || "DirectiveLiteral" === t.type || "Literal" === t.type || "NullLiteral" === t.type || "NumericLiteral" === t.type || "BigIntLiteral" === t.type || "DecimalLiteral" === t.type || "RegExpLiteral" === t.type || "StringLiteral" === t.type || "TemplateLiteral" === t.type || "TSTypeLiteral" === t.type || "JSXText" === t.type;
  }

  function xe(t) {
    return "NumericLiteral" === t.type || "Literal" === t.type && "number" == typeof t.value;
  }

  function Fe(t) {
    return "StringLiteral" === t.type || "Literal" === t.type && "string" == typeof t.value;
  }

  function ge(t) {
    return "FunctionExpression" === t.type || "ArrowFunctionExpression" === t.type;
  }

  function be(t) {
    return !("CallExpression" !== t.type && "OptionalCallExpression" !== t.type || "Identifier" !== t.callee.type || "async" !== t.callee.name && "inject" !== t.callee.name && "fakeAsync" !== t.callee.name);
  }

  function Pe(t) {
    return "JSXElement" === t.type || "JSXFragment" === t.type;
  }

  function Te(t) {
    return "get" === t.kind || "set" === t.kind;
  }

  function we(t) {
    return Te(t) || pe(t, t.value);
  }

  var Be = new Set(["BinaryExpression", "LogicalExpression", "NGPipeExpression"]);
  var Se = new Set(["AnyTypeAnnotation", "TSAnyKeyword", "NullLiteralTypeAnnotation", "TSNullKeyword", "ThisTypeAnnotation", "TSThisType", "NumberTypeAnnotation", "TSNumberKeyword", "VoidTypeAnnotation", "TSVoidKeyword", "BooleanTypeAnnotation", "TSBooleanKeyword", "BigIntTypeAnnotation", "TSBigIntKeyword", "SymbolTypeAnnotation", "TSSymbolKeyword", "StringTypeAnnotation", "TSStringKeyword", "BooleanLiteralTypeAnnotation", "StringLiteralTypeAnnotation", "BigIntLiteralTypeAnnotation", "NumberLiteralTypeAnnotation", "TSLiteralType", "TSTemplateLiteralType", "EmptyTypeAnnotation", "MixedTypeAnnotation", "TSNeverKeyword", "TSObjectKeyword", "TSUndefinedKeyword", "TSUnknownKeyword"]);
  var Ne = /^(skip|[fx]?(it|describe|test))$/;

  function Ie(t) {
    return "CallExpression" === t.type || "OptionalCallExpression" === t.type;
  }

  var ve = new RegExp("([ \n\r\t]+)"),
      ke = new RegExp("[^ \n\r\t]");

  function Le(t) {
    return Ce(t) && (ke.test(_e(t)) || !/\n/.test(_e(t)));
  }

  function Oe(t, e) {
    if (Pe(e)) return Ke(e);
    return e.comments && e.comments.some(function (e) {
      return e.leading && ae(t, ce(e));
    });
  }

  function Me(t) {
    return /^(\d+|\d+\.\d+)$/.test(t);
  }

  function Re(t) {
    return t.quasis.some(function (t) {
      return t.value.raw.includes("\n");
    });
  }

  function _e(t) {
    return t.extra ? t.extra.raw : t.raw;
  }

  var je = {
    "==": !0,
    "!=": !0,
    "===": !0,
    "!==": !0
  },
      Ue = {
    "*": !0,
    "/": !0,
    "%": !0
  },
      qe = {
    ">>": !0,
    ">>>": !0,
    "<<": !0
  };
  var Ve = {};

  function ze(t) {
    return Ve[t];
  }

  [["|>"], ["??"], ["||"], ["&&"], ["|"], ["^"], ["&"], ["==", "===", "!=", "!=="], ["<", ">", "<=", ">=", "in", "instanceof"], [">>", "<<", ">>>"], ["+", "-"], ["*", "/", "%"], ["**"]].forEach(function (t, e) {
    t.forEach(function (t) {
      Ve[t] = e;
    });
  });
  var He = new WeakMap();

  function We(t) {
    if (He.has(t)) return He.get(t);
    var e = [];
    return t.this && e.push(t.this), Array.isArray(t.parameters) ? e.push.apply(e, _toConsumableArray(t.parameters)) : Array.isArray(t.params) && e.push.apply(e, _toConsumableArray(t.params)), t.rest && e.push(t.rest), He.set(t, e), e;
  }

  var Xe = new WeakMap();

  function Ge(t) {
    return "prettier-ignore" === t.value.trim();
  }

  function Ke(t) {
    return t && (t.comments && t.comments.length > 0 && t.comments.some(function (t) {
      return Ge(t) && !t.unignore;
    }) || t.prettierIgnore);
  }

  function Je(t) {
    return Ke(t.getValue());
  }

  var $e = {
    classChildNeedsASIProtection: function classChildNeedsASIProtection(t) {
      if (t) {
        if (t.static || t.accessibility) return !1;

        if (!t.computed) {
          var _e5 = t.key && t.key.name;

          if ("in" === _e5 || "instanceof" === _e5) return !0;
        }

        switch (t.type) {
          case "ClassProperty":
          case "FieldDefinition":
          case "TSAbstractClassProperty":
            return t.computed;

          case "MethodDefinition":
          case "TSAbstractMethodDefinition":
          case "ClassMethod":
          case "ClassPrivateMethod":
            {
              var _e6 = t.value ? t.value.async : t.async,
                  _s7 = t.value ? t.value.generator : t.generator;

              return !_e6 && "get" !== t.kind && "set" !== t.kind && !(!t.computed && !_s7);
            }

          case "TSIndexSignature":
            return !0;

          default:
            return !1;
        }
      }
    },
    classPropMayCauseASIProblems: function classPropMayCauseASIProblems(t) {
      var e = t.getNode();
      if ("ClassProperty" !== e.type && "FieldDefinition" !== e.type) return !1;
      var s = e.key && e.key.name;
      return !("static" !== s && "get" !== s && "set" !== s || e.value || e.typeAnnotation) || void 0;
    },
    getFunctionParameters: We,
    iterateFunctionParametersPath: function iterateFunctionParametersPath(t, e) {
      var s = t.getValue();
      var r = 0;

      var i = function i(t) {
        return e(t, r++);
      };

      s.this && t.call(i, "this"), Array.isArray(s.parameters) ? t.each(i, "parameters") : Array.isArray(s.params) && t.each(i, "params"), s.rest && t.call(i, "rest");
    },
    getCallArguments: function getCallArguments(t) {
      if (Xe.has(t)) return Xe.get(t);
      var e = "ImportExpression" === t.type ? [t.source] : t.arguments;
      return Xe.set(t, e), e;
    },
    iterateCallArgumentsPath: function iterateCallArgumentsPath(t, e) {
      "ImportExpression" === t.getValue().type ? t.call(function (t) {
        return e(t, 0);
      }, "source") : t.each(e, "arguments");
    },
    hasRestParameter: function hasRestParameter(t) {
      if (t.rest) return !0;
      var e = We(t);
      return e.length > 0 && "RestElement" === ne(e).type;
    },
    getLeftSidePathName: function getLeftSidePathName(t, e) {
      if (e.expressions) return ["expressions", 0];
      if (e.left) return ["left"];
      if (e.test) return ["test"];
      if (e.object) return ["object"];
      if (e.callee) return ["callee"];
      if (e.tag) return ["tag"];
      if (e.argument) return ["argument"];
      if (e.expression) return ["expression"];
      throw new Error("Unexpected node has no left side.");
    },
    getParentExportDeclaration: function getParentExportDeclaration(t) {
      var e = t.getParentNode();
      return "declaration" === t.getName() && Ae(e) ? e : null;
    },
    getTypeScriptMappedTypeModifier: function getTypeScriptMappedTypeModifier(t, e) {
      return "+" === t ? "+" + e : "-" === t ? "-" + e : e;
    },
    hasDanglingComments: function hasDanglingComments(t) {
      return t.comments && t.comments.some(function (t) {
        return !t.leading && !t.trailing;
      });
    },
    hasFlowAnnotationComment: function hasFlowAnnotationComment(t) {
      return t && ye(t[0]) && De.test(t[0].value);
    },
    hasFlowShorthandAnnotationComment: function hasFlowShorthandAnnotationComment(t) {
      return t.extra && t.extra.parenthesized && t.trailingComments && ye(t.trailingComments[0]) && de.test(t.trailingComments[0].value);
    },
    hasLeadingComment: function hasLeadingComment(t) {
      return t.comments && t.comments.some(function (t) {
        return t.leading;
      });
    },
    hasLeadingOwnLineComment: Oe,
    hasNakedLeftSide: fe,
    hasNewlineBetweenOrAfterDecorators: function hasNewlineBetweenOrAfterDecorators(t, e) {
      return oe(e.originalText, he(t.decorators[0]), ce(ne(t.decorators))) || ae(e.originalText, ce(ne(t.decorators)));
    },
    hasNgSideEffect: function hasNgSideEffect(t) {
      return me(t.getValue(), function (t) {
        switch (t.type) {
          case void 0:
            return !1;

          case "CallExpression":
          case "OptionalCallExpression":
          case "AssignmentExpression":
            return !0;
        }
      });
    },
    hasNode: me,
    hasPrettierIgnore: function hasPrettierIgnore(t) {
      return Je(t) || function (t) {
        var e = t.getValue(),
            s = t.getParentNode();
        if (!(s && e && Pe(e) && Pe(s))) return !1;
        var r = null;

        for (var _t8 = s.children.indexOf(e); _t8 > 0; _t8--) {
          var _e7 = s.children[_t8 - 1];

          if ("JSXText" !== _e7.type || Le(_e7)) {
            r = _e7;
            break;
          }
        }

        return r && "JSXExpressionContainer" === r.type && "JSXEmptyExpression" === r.expression.type && r.expression.comments && r.expression.comments.some(function (t) {
          return Ge(t);
        });
      }(t);
    },
    hasTrailingComment: function hasTrailingComment(t) {
      return t.comments && t.comments.some(function (t) {
        return t.trailing;
      });
    },
    hasTrailingLineComment: function hasTrailingLineComment(t) {
      return t.comments && t.comments.some(function (t) {
        return t.trailing && !ye(t);
      });
    },
    hasIgnoreComment: Je,
    hasNodeIgnoreComment: Ke,
    identity: function identity(t) {
      return t;
    },
    isBinaryish: function isBinaryish(t) {
      return Be.has(t.type);
    },
    isBlockComment: ye,
    isLineComment: function isLineComment(t) {
      return "Line" === t.type || "CommentLine" === t.type || "SingleLine" === t.type || "HashbangComment" === t.type || "HTMLOpen" === t.type || "HTMLClose" === t.type;
    },
    isPrettierIgnoreComment: Ge,
    isCallOrOptionalCallExpression: Ie,
    isEmptyJSXElement: function isEmptyJSXElement(t) {
      if (0 === t.children.length) return !0;
      if (t.children.length > 1) return !1;
      var e = t.children[0];
      return Ce(e) && !Le(e);
    },
    isExportDeclaration: Ae,
    isFlowAnnotationComment: function isFlowAnnotationComment(t, e) {
      var s = he(e),
          r = ue(t, ce(e));
      return !1 !== r && "/*" === t.slice(s, s + 2) && "*/" === t.slice(r, r + 2);
    },
    isFunctionCompositionArgs: function isFunctionCompositionArgs(t) {
      if (t.length <= 1) return !1;
      var e = 0;

      var _iterator5 = _createForOfIteratorHelper(t),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _s8 = _step5.value;

          if (ge(_s8)) {
            if (e += 1, e > 1) return !0;
          } else if (Ie(_s8)) {
            var _iterator6 = _createForOfIteratorHelper(_s8.arguments),
                _step6;

            try {
              for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                var _t9 = _step6.value;
                if (ge(_t9)) return !0;
              }
            } catch (err) {
              _iterator6.e(err);
            } finally {
              _iterator6.f();
            }
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      return !1;
    },
    isFunctionNotation: we,
    isFunctionOrArrowExpression: ge,
    isGetterOrSetter: Te,
    isJestEachTemplateLiteral: function isJestEachTemplateLiteral(t, e) {
      var s = /^[fx]?(describe|it|test)$/;
      return "TaggedTemplateExpression" === e.type && e.quasi === t && "MemberExpression" === e.tag.type && "Identifier" === e.tag.property.type && "each" === e.tag.property.name && ("Identifier" === e.tag.object.type && s.test(e.tag.object.name) || "MemberExpression" === e.tag.object.type && "Identifier" === e.tag.object.property.type && ("only" === e.tag.object.property.name || "skip" === e.tag.object.property.name) && "Identifier" === e.tag.object.object.type && s.test(e.tag.object.object.name));
    },
    isJSXNode: Pe,
    isJSXWhitespaceExpression: function isJSXWhitespaceExpression(t) {
      return "JSXExpressionContainer" === t.type && Ce(t.expression) && " " === t.expression.value && !t.expression.comments;
    },
    isLastStatement: function isLastStatement(t) {
      var e = t.getParentNode();
      if (!e) return !0;
      var s = t.getValue(),
          r = (e.body || e.consequent).filter(function (t) {
        return "EmptyStatement" !== t.type;
      });
      return r[r.length - 1] === s;
    },
    isLiteral: Ce,
    isLongCurriedCallExpression: function isLongCurriedCallExpression(t) {
      var e = t.getValue(),
          s = t.getParentNode();
      return Ie(e) && Ie(s) && s.callee === e && e.arguments.length > s.arguments.length && s.arguments.length > 0;
    },
    isSimpleCallArgument: function t(e, s) {
      if (s >= 2) return !1;

      var r = function r(e) {
        return t(e, s + 1);
      },
          i = "Literal" === e.type && "regex" in e && e.regex.pattern || "RegExpLiteral" === e.type && e.pattern;

      return !(i && i.length > 5) && ("Literal" === e.type || "BigIntLiteral" === e.type || "DecimalLiteral" === e.type || "BooleanLiteral" === e.type || "NullLiteral" === e.type || "NumericLiteral" === e.type || "RegExpLiteral" === e.type || "StringLiteral" === e.type || "Identifier" === e.type || "ThisExpression" === e.type || "Super" === e.type || "PrivateName" === e.type || "ArgumentPlaceholder" === e.type || "Import" === e.type || ("TemplateLiteral" === e.type ? e.expressions.every(r) : "ObjectExpression" === e.type ? e.properties.every(function (t) {
        return !t.computed && (t.shorthand || t.value && r(t.value));
      }) : "ArrayExpression" === e.type ? e.elements.every(function (t) {
        return null === t || r(t);
      }) : "ImportExpression" === e.type ? r(e.source) : "CallExpression" === e.type || "OptionalCallExpression" === e.type || "NewExpression" === e.type ? t(e.callee, s) && e.arguments.every(r) : "MemberExpression" === e.type || "OptionalMemberExpression" === e.type ? t(e.object, s) && t(e.property, s) : "UnaryExpression" !== e.type || "!" !== e.operator && "-" !== e.operator ? "TSNonNullExpression" === e.type && t(e.expression, s) : t(e.argument, s)));
    },
    isMeaningfulJSXText: Le,
    isMemberExpressionChain: function t(e) {
      return ("MemberExpression" === e.type || "OptionalMemberExpression" === e.type) && ("Identifier" === e.object.type || t(e.object));
    },
    isMemberish: function isMemberish(t) {
      return "MemberExpression" === t.type || "OptionalMemberExpression" === t.type || "BindExpression" === t.type && Boolean(t.object);
    },
    isNgForOf: function isNgForOf(t, e, s) {
      return "NGMicrosyntaxKeyedExpression" === t.type && "of" === t.key.name && 1 === e && "NGMicrosyntaxLet" === s.body[0].type && null === s.body[0].value;
    },
    isNumericLiteral: xe,
    isObjectType: function isObjectType(t) {
      return "ObjectTypeAnnotation" === t.type || "TSTypeLiteral" === t.type;
    },
    isObjectTypePropertyAFunction: function isObjectTypePropertyAFunction(t) {
      return !("ObjectTypeProperty" !== t.type && "ObjectTypeInternalSlot" !== t.type || "FunctionTypeAnnotation" !== t.value.type || t.static || we(t));
    },
    isSimpleType: function isSimpleType(t) {
      return !!t && (!("GenericTypeAnnotation" !== t.type && "TSTypeReference" !== t.type || t.typeParameters) || !!Se.has(t.type));
    },
    isSimpleNumber: Me,
    isSimpleTemplateLiteral: function isSimpleTemplateLiteral(t) {
      var e = "expressions";
      "TSTemplateLiteralType" === t.type && (e = "types");
      var s = t[e];
      return 0 !== s.length && s.every(function (t) {
        if (t.comments) return !1;
        if ("Identifier" === t.type || "ThisExpression" === t.type) return !0;

        if ("MemberExpression" === t.type || "OptionalMemberExpression" === t.type) {
          var _e8 = t;

          for (; "MemberExpression" === _e8.type || "OptionalMemberExpression" === _e8.type;) {
            if ("Identifier" !== _e8.property.type && "Literal" !== _e8.property.type && "StringLiteral" !== _e8.property.type && "NumericLiteral" !== _e8.property.type) return !1;
            if (_e8 = _e8.object, _e8.comments) return !1;
          }

          return "Identifier" === _e8.type || "ThisExpression" === _e8.type;
        }

        return !1;
      });
    },
    isStringLiteral: Fe,
    isStringPropSafeToUnquote: function isStringPropSafeToUnquote(t, e) {
      return "json" !== e.parser && Fe(t.key) && _e(t.key).slice(1, -1) === t.key.value && (ie(t.key.value) && !(("typescript" === e.parser || "babel-ts" === e.parser) && "ClassProperty" === t.type) || Me(t.key.value) && String(Number(t.key.value)) === t.key.value && ("babel" === e.parser || "espree" === e.parser || "meriyah" === e.parser));
    },
    isTemplateOnItsOwnLine: function isTemplateOnItsOwnLine(t, e) {
      return ("TemplateLiteral" === t.type && Re(t) || "TaggedTemplateExpression" === t.type && Re(t.quasi)) && !ae(e, he(t), {
        backwards: !0
      });
    },
    isTestCall: function t(e, s) {
      if ("CallExpression" !== e.type) return !1;

      if (1 === e.arguments.length) {
        if (be(e) && s && t(s)) return ge(e.arguments[0]);
        if ("Identifier" === (r = e).callee.type && /^(before|after)(Each|All)$/.test(r.callee.name) && 1 === r.arguments.length) return be(e.arguments[0]);
      } else if ((2 === e.arguments.length || 3 === e.arguments.length) && ("Identifier" === e.callee.type && Ne.test(e.callee.name) || function (t) {
        return ("MemberExpression" === t.callee.type || "OptionalMemberExpression" === t.callee.type) && "Identifier" === t.callee.object.type && "Identifier" === t.callee.property.type && Ne.test(t.callee.object.name) && ("only" === t.callee.property.name || "skip" === t.callee.property.name);
      }(e)) && (function (t) {
        return "TemplateLiteral" === t.type;
      }(e.arguments[0]) || Fe(e.arguments[0]))) return !(e.arguments[2] && !xe(e.arguments[2])) && ((2 === e.arguments.length ? ge(e.arguments[1]) : function (t) {
        return "FunctionExpression" === t.type || "ArrowFunctionExpression" === t.type && "BlockStatement" === t.body.type;
      }(e.arguments[1]) && We(e.arguments[1]).length <= 1) || be(e.arguments[1]));

      var r;
      return !1;
    },
    isTheOnlyJSXElementInMarkdown: function isTheOnlyJSXElementInMarkdown(t, e) {
      if ("markdown" !== t.parentParser && "mdx" !== t.parentParser) return !1;
      var s = e.getNode();
      if (!s.expression || !Pe(s.expression)) return !1;
      var r = e.getParentNode();
      return "Program" === r.type && 1 === r.body.length;
    },
    isTSXFile: function isTSXFile(t) {
      return t.filepath && /\.tsx$/i.test(t.filepath);
    },
    isTypeAnnotationAFunction: function isTypeAnnotationAFunction(t) {
      return !("TypeAnnotation" !== t.type && "TSTypeAnnotation" !== t.type || "FunctionTypeAnnotation" !== t.typeAnnotation.type || t.static || pe(t, t.typeAnnotation));
    },
    matchJsxWhitespaceRegex: ve,
    needsHardlineAfterDanglingComment: function needsHardlineAfterDanglingComment(t) {
      if (!t.comments) return !1;
      var e = ne(t.comments.filter(function (t) {
        return !t.leading && !t.trailing;
      }));
      return e && !ye(e);
    },
    rawText: _e,
    returnArgumentHasLeadingComment: function returnArgumentHasLeadingComment(t, e) {
      if (Oe(t.originalText, e)) return !0;

      if (fe(e)) {
        var _r5,
            _i4 = e;

        for (; _r5 = (s = _i4).expressions ? s.expressions[0] : s.left || s.test || s.callee || s.object || s.tag || s.argument || s.expression;) {
          if (_i4 = _r5, Oe(t.originalText, _i4)) return !0;
        }
      }

      var s;
      return !1;
    },
    shouldPrintComma: function shouldPrintComma(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "es5";
      return "es5" === t.trailingComma && "es5" === e || "all" === t.trailingComma && ("all" === e || "es5" === e);
    },
    isBitwiseOperator: function isBitwiseOperator(t) {
      return !!qe[t] || "|" === t || "^" === t || "&" === t;
    },
    shouldFlatten: function shouldFlatten(t, e) {
      return ze(e) === ze(t) && "**" !== t && (!je[t] || !je[e]) && !("%" === e && Ue[t] || "%" === t && Ue[e]) && (e === t || !Ue[e] || !Ue[t]) && (!qe[t] || !qe[e]);
    },
    startsWithNoLookaheadToken: function t(e, s) {
      switch ((e = function (t) {
        for (; t.left;) {
          t = t.left;
        }

        return t;
      }(e)).type) {
        case "FunctionExpression":
        case "ClassExpression":
        case "DoExpression":
          return s;

        case "ObjectExpression":
          return !0;

        case "MemberExpression":
        case "OptionalMemberExpression":
          return t(e.object, s);

        case "TaggedTemplateExpression":
          return "FunctionExpression" !== e.tag.type && t(e.tag, s);

        case "CallExpression":
        case "OptionalCallExpression":
          return "FunctionExpression" !== e.callee.type && t(e.callee, s);

        case "ConditionalExpression":
          return t(e.test, s);

        case "UpdateExpression":
          return !e.prefix && t(e.argument, s);

        case "BindExpression":
          return e.object && t(e.object, s);

        case "SequenceExpression":
          return t(e.expressions[0], s);

        case "TSAsExpression":
          return t(e.expression, s);

        default:
          return !1;
      }
    },
    getPrecedence: ze
  };
  var Ye = Mt.getLast,
      Qe = Mt.hasNewline,
      Ze = Mt.getNextNonSpaceNonCommentCharacterIndexWithStartIndex,
      ts = Mt.getNextNonSpaceNonCommentCharacter,
      es = Mt.hasNewlineInRange,
      ss = Mt.addLeadingComment,
      rs = Mt.addTrailingComment,
      is = Mt.addDanglingComment,
      ns = Mt.getNextNonSpaceNonCommentCharacterIndex,
      as = $e.isBlockComment,
      os = $e.getFunctionParameters,
      us = $e.isPrettierIgnoreComment,
      hs = $e.isJSXNode,
      cs = $e.hasFlowShorthandAnnotationComment,
      ps = $e.hasFlowAnnotationComment,
      ls = $e.hasIgnoreComment,
      ds = te.locStart,
      Ds = te.locEnd;

  function ms(t, e) {
    var s = (t.body || t.properties).find(function (_ref11) {
      var t = _ref11.type;
      return "EmptyStatement" !== t;
    });
    s ? ss(s, e) : is(t, e);
  }

  function fs(t, e) {
    "BlockStatement" === t.type ? ms(t, e) : ss(t, e);
  }

  function ys(t, e) {
    var s = t.precedingNode,
        r = t.enclosingNode,
        i = t.followingNode;
    if (!r || "IfStatement" !== r.type || !i) return !1;
    return ")" === ts(e, t, Ds) ? (rs(s, t), !0) : s === r.consequent && i === r.alternate ? ("BlockStatement" === s.type ? rs(s, t) : is(r, t), !0) : "BlockStatement" === i.type ? (ms(i, t), !0) : "IfStatement" === i.type ? (fs(i.consequent, t), !0) : r.consequent === i && (ss(i, t), !0);
  }

  function Es(t, e) {
    var s = t.precedingNode,
        r = t.enclosingNode,
        i = t.followingNode;
    if (!r || "WhileStatement" !== r.type || !i) return !1;
    return ")" === ts(e, t, Ds) ? (rs(s, t), !0) : "BlockStatement" === i.type ? (ms(i, t), !0) : r.body === i && (ss(i, t), !0);
  }

  function As(t) {
    var e = t.precedingNode,
        s = t.enclosingNode,
        r = t.followingNode;
    return !(!s || "TryStatement" !== s.type && "CatchClause" !== s.type || !r) && ("CatchClause" === s.type && e ? (rs(e, t), !0) : "BlockStatement" === r.type ? (ms(r, t), !0) : "TryStatement" === r.type ? (fs(r.finalizer, t), !0) : "CatchClause" === r.type && (fs(r.body, t), !0));
  }

  function Cs(t) {
    var e = t.precedingNode,
        s = t.enclosingNode,
        r = t.followingNode;

    if (s && ("ClassDeclaration" === s.type || "ClassExpression" === s.type || "DeclareClass" === s.type || "DeclareInterface" === s.type || "InterfaceDeclaration" === s.type || "TSInterfaceDeclaration" === s.type)) {
      if (s.decorators && s.decorators.length > 0 && (!r || "Decorator" !== r.type)) return rs(s.decorators[s.decorators.length - 1], t), !0;
      if (s.body && r === s.body) return ms(s.body, t), !0;
      if (r) for (var _i5 = 0, _arr = ["implements", "extends", "mixins"]; _i5 < _arr.length; _i5++) {
        var _i6 = _arr[_i5];
        if (s[_i6] && r === s[_i6][0]) return !e || e !== s.id && e !== s.typeParameters && e !== s.superClass ? is(s, t, _i6) : rs(e, t), !0;
      }
    }

    return !1;
  }

  function xs(t, e) {
    var s = t.precedingNode,
        r = t.enclosingNode;
    return (r && s && ("Property" === r.type || "TSDeclareMethod" === r.type || "TSAbstractMethodDefinition" === r.type) && "Identifier" === s.type && r.key === s && ":" !== ts(e, s, Ds) || !(!s || !r || "Decorator" !== s.type || "ClassMethod" !== r.type && "ClassProperty" !== r.type && "FieldDefinition" !== r.type && "TSAbstractClassProperty" !== r.type && "TSAbstractMethodDefinition" !== r.type && "TSDeclareMethod" !== r.type && "MethodDefinition" !== r.type)) && (rs(s, t), !0);
  }

  function Fs(t, e) {
    var s = t.precedingNode,
        r = t.enclosingNode,
        i = t.followingNode;
    if (s && "FunctionTypeParam" === s.type && r && "FunctionTypeAnnotation" === r.type && i && "FunctionTypeParam" !== i.type) return rs(s, t), !0;
    if (s && ("Identifier" === s.type || "AssignmentPattern" === s.type) && r && ws(r) && ")" === ts(e, t, Ds)) return rs(s, t), !0;

    if (r && "FunctionDeclaration" === r.type && i && "BlockStatement" === i.type) {
      var _s9 = function () {
        var t = os(r);
        if (0 !== t.length) return Ze(e, Ds(Ye(t)));
        var s = Ze(e, Ds(r.id));
        return !1 !== s && Ze(e, s + 1);
      }();

      if (ds(t) > _s9) return ms(i, t), !0;
    }

    return !1;
  }

  function gs(t) {
    var e = t.enclosingNode;
    return !(!e || "ImportSpecifier" !== e.type) && (ss(e, t), !0);
  }

  function bs(t) {
    var e = t.enclosingNode;
    return !(!e || "LabeledStatement" !== e.type) && (ss(e, t), !0);
  }

  function Ps(t, e, s) {
    var r = t.enclosingNode;
    return e && e.body && 0 === e.body.length ? (s ? is(e, t) : ss(e, t), !0) : !(!r || "Program" !== r.type || 0 !== r.body.length || !r.directives || 0 !== r.directives.length) && (s ? is(r, t) : ss(r, t), !0);
  }

  function Ts(t) {
    var e = t.enclosingNode,
        s = t.followingNode;
    if (us(t) && e && "TSMappedType" === e.type && s && "TSTypeParameter" === s.type && s.constraint) return e.prettierIgnore = !0, t.unignore = !0, !0;
  }

  function ws(t) {
    return "ArrowFunctionExpression" === t.type || "FunctionExpression" === t.type || "FunctionDeclaration" === t.type || "ObjectMethod" === t.type || "ClassMethod" === t.type || "TSDeclareFunction" === t.type || "TSCallSignatureDeclaration" === t.type || "TSConstructSignatureDeclaration" === t.type || "TSMethodSignature" === t.type || "TSConstructorType" === t.type || "TSFunctionType" === t.type || "TSDeclareMethod" === t.type;
  }

  function Bs(t) {
    return as(t) && "*" === t.value[0] && /@type\b/.test(t.value);
  }

  var Ss = {
    handleOwnLineComment: function handleOwnLineComment(t, e, s, r, i) {
      return Ts(t) || Fs(t, e) || function (t) {
        var e = t.enclosingNode,
            s = t.followingNode;
        if (e && ("MemberExpression" === e.type || "OptionalMemberExpression" === e.type) && s && "Identifier" === s.type) return ss(e, t), !0;
        return !1;
      }(t) || ys(t, e) || Es(t, e) || As(t) || Cs(t) || gs(t) || function (t) {
        var e = t.enclosingNode;
        if (e && ("ForInStatement" === e.type || "ForOfStatement" === e.type)) return ss(e, t), !0;
        return !1;
      }(t) || function (t) {
        var e = t.precedingNode,
            s = t.enclosingNode,
            r = t.followingNode;
        if (s && ("UnionTypeAnnotation" === s.type || "TSUnionType" === s.type)) return us(t) && (r.prettierIgnore = !0, t.unignore = !0), !!e && (rs(e, t), !0);
        r && ("UnionTypeAnnotation" === r.type || "TSUnionType" === r.type) && us(t) && (r.types[0].prettierIgnore = !0, t.unignore = !0);
        return !1;
      }(t) || Ps(t, r, i) || function (t, e) {
        var s = t.precedingNode,
            r = t.enclosingNode;
        if (s && "ImportSpecifier" === s.type && r && "ImportDeclaration" === r.type && Qe(e, Ds(t))) return rs(s, t), !0;
        return !1;
      }(t, e) || function (t) {
        var e = t.enclosingNode;
        if (e && "AssignmentPattern" === e.type) return ss(e, t), !0;
        return !1;
      }(t) || xs(t, e) || bs(t);
    },
    handleEndOfLineComment: function handleEndOfLineComment(t, e, s, r, i) {
      return function (t) {
        var e = t.followingNode;
        if (e && Bs(t)) return ss(e, t), !0;
        return !1;
      }(t) || Fs(t, e) || function (t, e) {
        var s = t.precedingNode,
            r = t.enclosingNode,
            i = t.followingNode,
            n = s && !es(e, Ds(s), ds(t));
        if ((!s || !n) && r && ("ConditionalExpression" === r.type || "TSConditionalType" === r.type) && i) return ss(i, t), !0;
        return !1;
      }(t, e) || gs(t) || ys(t, e) || Es(t, e) || As(t) || Cs(t) || bs(t) || function (t) {
        var e = t.precedingNode,
            s = t.enclosingNode;
        if (s && ("CallExpression" === s.type || "OptionalCallExpression" === s.type) && e && s.callee === e && s.arguments.length > 0) return ss(s.arguments[0], t), !0;
        return !1;
      }(t) || function (t) {
        var e = t.enclosingNode;
        if (e && ("Property" === e.type || "ObjectProperty" === e.type)) return ss(e, t), !0;
        return !1;
      }(t) || Ps(t, r, i) || function (t) {
        var e = t.enclosingNode;
        if (e && "TypeAlias" === e.type) return ss(e, t), !0;
        return !1;
      }(t) || function (t) {
        var e = t.enclosingNode,
            s = t.followingNode;
        if (e && ("VariableDeclarator" === e.type || "AssignmentExpression" === e.type) && s && ("ObjectExpression" === s.type || "ArrayExpression" === s.type || "TemplateLiteral" === s.type || "TaggedTemplateExpression" === s.type || as(t))) return ss(s, t), !0;
        return !1;
      }(t);
    },
    handleRemainingComment: function handleRemainingComment(t, e, s, r, i) {
      return !!(Ts(t) || ys(t, e) || Es(t, e) || function (t) {
        var e = t.precedingNode,
            s = t.enclosingNode;
        if (s && ("ObjectProperty" === s.type || "Property" === s.type) && s.shorthand && s.key === e && "AssignmentPattern" === s.value.type) return rs(s.value.left, t), !0;
        return !1;
      }(t) || function (t, e) {
        if (")" !== ts(e, t, Ds)) return !1;
        var s = t.enclosingNode;
        if (s && (ws(s) && 0 === os(s).length || ("CallExpression" === s.type || "OptionalCallExpression" === s.type || "NewExpression" === s.type) && 0 === s.arguments.length)) return is(s, t), !0;
        if (s && "MethodDefinition" === s.type && 0 === os(s.value).length) return is(s.value, t), !0;
        return !1;
      }(t, e) || xs(t, e) || Ps(t, r, i) || function (t, e) {
        var s = t.enclosingNode;
        if (!s || "ArrowFunctionExpression" !== s.type) return !1;
        var r = ns(e, t, Ds);
        if (!1 !== r && "=>" === e.slice(r, r + 2)) return is(s, t), !0;
        return !1;
      }(t, e) || function (t, e) {
        if ("(" !== ts(e, t, Ds)) return !1;
        var s = t.precedingNode,
            r = t.enclosingNode;
        if (s && r && ("FunctionDeclaration" === r.type || "FunctionExpression" === r.type || "ClassMethod" === r.type || "MethodDefinition" === r.type || "ObjectMethod" === r.type)) return rs(s, t), !0;
        return !1;
      }(t, e) || function (t) {
        var e = t.precedingNode,
            s = t.enclosingNode,
            r = t.followingNode;
        if (!s || "TSMappedType" !== s.type) return !1;
        if (r && "TSTypeParameter" === r.type && r.name) return ss(r.name, t), !0;
        if (e && "TSTypeParameter" === e.type && e.constraint) return rs(e.constraint, t), !0;
        return !1;
      }(t) || function (t) {
        var e = t.enclosingNode;
        if (e && ("ContinueStatement" === e.type || "BreakStatement" === e.type) && !e.label) return rs(e, t), !0;
        return !1;
      }(t) || function (t, e) {
        var s = t.enclosingNode,
            r = t.followingNode;
        if (!r && s && ("TSMethodSignature" === s.type || "TSDeclareFunction" === s.type || "TSAbstractMethodDefinition" === s.type) && ";" === ts(e, t, Ds)) return rs(s, t), !0;
        return !1;
      }(t, e));
    },
    hasLeadingComment: function hasLeadingComment(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
        return !0;
      };
      return t.leadingComments ? t.leadingComments.some(e) : !!t.comments && t.comments.some(function (t) {
        return t.leading && e(t);
      });
    },
    isTypeCastComment: Bs,
    getGapRegex: function getGapRegex(t) {
      if (t && "BinaryExpression" !== t.type && "LogicalExpression" !== t.type) return /^[\s&(|]*$/;
    },
    getCommentChildNodes: function getCommentChildNodes(t, e) {
      if (("typescript" === e.parser || "flow" === e.parser || "espree" === e.parser || "meriyah" === e.parser) && "MethodDefinition" === t.type && t.value && "FunctionExpression" === t.value.type && 0 === os(t.value).length && !t.value.returnType && (!t.value.typeParameters || 0 === t.value.typeParameters.length) && t.value.body) return [].concat(_toConsumableArray(t.decorators || []), [t.key, t.value.body]);
    },
    willPrintOwnComments: function willPrintOwnComments(t) {
      var e = t.getValue(),
          s = t.getParentNode();
      return (e && (hs(e) || cs(e) || s && ("CallExpression" === s.type || "OptionalCallExpression" === s.type) && (ps(e.leadingComments) || ps(e.trailingComments))) || s && ("JSXSpreadAttribute" === s.type || "JSXSpreadChild" === s.type || "UnionTypeAnnotation" === s.type || "TSUnionType" === s.type || ("ClassDeclaration" === s.type || "ClassExpression" === s.type) && s.superClass === e)) && (!ls(t) || "UnionTypeAnnotation" === s.type || "TSUnionType" === s.type);
    }
  };
  var Ns = Mt.getLast,
      Is = Mt.getNextNonSpaceNonCommentCharacter,
      vs = Mt.getShebang,
      ks = te.composeLoc,
      Ls = te.locStart,
      Os = te.locEnd,
      Ms = Ss.isTypeCastComment;

  function Rs(t) {
    return "CallExpression" === t.type ? (t.type = "OptionalCallExpression", t.callee = Rs(t.callee)) : "MemberExpression" === t.type ? (t.type = "OptionalMemberExpression", t.object = Rs(t.object)) : "TSNonNullExpression" === t.type && (t.expression = Rs(t.expression)), t;
  }

  function _s(t, e) {
    var s;
    if (Array.isArray(t)) s = t.entries();else {
      if (!t || "object" != typeof t || "string" != typeof t.type) return t;
      s = Object.entries(t);
    }

    var _iterator7 = _createForOfIteratorHelper(s),
        _step7;

    try {
      for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
        var _step7$value = _slicedToArray(_step7.value, 2),
            _r6 = _step7$value[0],
            _i7 = _step7$value[1];

        t[_r6] = _s(_i7, e);
      }
    } catch (err) {
      _iterator7.e(err);
    } finally {
      _iterator7.f();
    }

    return Array.isArray(t) ? t : e(t) || t;
  }

  function js(t) {
    return "LogicalExpression" === t.type && "LogicalExpression" === t.right.type && t.operator === t.right.operator;
  }

  function Us(t) {
    return js(t) ? Us({
      type: "LogicalExpression",
      operator: t.operator,
      left: Us({
        type: "LogicalExpression",
        operator: t.operator,
        left: t.left,
        right: t.right.left,
        range: ks(t.left, t.right.left)
      }),
      right: t.right.right,
      range: ks(t)
    }) : t;
  }

  var qs = function qs(e, s) {
    if ("typescript" !== s.parser && "flow" !== s.parser && "espree" !== s.parser || function (t, e) {
      var s = vs(e.originalText);
      s && t.comments.unshift({
        type: "Line",
        value: s.slice(2),
        range: [0, s.length]
      });
    }(e, s), "typescript" === s.parser && s.originalText.includes("@")) {
      var _s$tsParseResult = s.tsParseResult,
          _r7 = _s$tsParseResult.esTreeNodeToTSNodeMap,
          _i8 = _s$tsParseResult.tsNodeToESTreeNodeMap;
      e = _s(e, function (e) {
        var s = _r7.get(e);

        if (!s) return;
        var n = s.decorators;
        if (!Array.isArray(n)) return;

        var a = _i8.get(s);

        if (a !== e) return;
        var o = a.decorators;

        if (!Array.isArray(o) || o.length !== n.length || n.some(function (t) {
          var e = _i8.get(t);

          return !e || !o.includes(e);
        })) {
          var _a$loc = a.loc,
              _e9 = _a$loc.start,
              _s10 = _a$loc.end;
          throw t("Leading decorators must be attached to a class declaration", {
            start: {
              line: _e9.line,
              column: _e9.column + 1
            },
            end: {
              line: _s10.line,
              column: _s10.column + 1
            }
          });
        }
      });
    }

    if ("typescript" !== s.parser && "flow" !== s.parser && "espree" !== s.parser && "meriyah" !== s.parser) {
      var _t10 = new Set();

      e = _s(e, function (e) {
        e.leadingComments && e.leadingComments.some(Ms) && _t10.add(Ls(e));
      }), e = _s(e, function (e) {
        if ("ParenthesizedExpression" === e.type) {
          var _s11 = e.expression;
          if ("TypeCastExpression" === _s11.type) return _s11.range = e.range, _s11;

          var _r8 = Ls(e);

          if (!_t10.has(_r8)) return _s11.extra = Object.assign({}, _s11.extra, {
            parenthesized: !0
          }), _s11;
        }
      });
    }

    return e = _s(e, function (t) {
      switch (t.type) {
        case "ChainExpression":
          return Rs(t.expression);

        case "LogicalExpression":
          if (js(t)) return Us(t);
          break;

        case "VariableDeclaration":
          {
            var _e10 = Ns(t.declarations);

            _e10 && _e10.init && function (t, e) {
              if (";" === s.originalText[Os(e)]) return;
              t.range = ks(t, e);
            }(t, _e10);
            break;
          }

        case "TSParenthesizedType":
          return t.typeAnnotation.range = ks(t), t.typeAnnotation;

        case "TSUnionType":
        case "TSIntersectionType":
          if (1 === t.types.length) {
            var _t$types = _slicedToArray(t.types, 1),
                _e11 = _t$types[0];

            return _e11.range = ks(t), _e11;
          }

          break;

        case "TSTypeParameter":
          "string" == typeof t.name && (t.name = {
            type: "Identifier",
            name: t.name,
            range: ks(t, t.name.length)
          });
          break;

        case "SequenceExpression":
          {
            var _e12 = Ns(t.expressions);

            Os(t) > Os(_e12) && (t.range = ks(t, _e12));
            break;
          }

        case "ClassProperty":
          t.key && "TSPrivateIdentifier" === t.key.type && "?" === Is(s.originalText, t.key, Os) && (t.optional = !0);
      }
    });
  },
      Vs = R(function (t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var s = !0,
        r = !0,
        i = !0,
        n = !0;

    var a = function a(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _classCallCheck(this, a);

      this.label = void 0, this.keyword = void 0, this.beforeExpr = void 0, this.startsExpr = void 0, this.rightAssociative = void 0, this.isLoop = void 0, this.isAssign = void 0, this.prefix = void 0, this.postfix = void 0, this.binop = void 0, this.updateContext = void 0, this.label = t, this.keyword = e.keyword, this.beforeExpr = !!e.beforeExpr, this.startsExpr = !!e.startsExpr, this.rightAssociative = !!e.rightAssociative, this.isLoop = !!e.isLoop, this.isAssign = !!e.isAssign, this.prefix = !!e.prefix, this.postfix = !!e.postfix, this.binop = null != e.binop ? e.binop : null, this.updateContext = null;
    };

    var o = new Map();

    function u(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      e.keyword = t;
      var s = new a(t, e);
      return o.set(t, s), s;
    }

    function h(t, e) {
      return new a(t, {
        beforeExpr: s,
        binop: e
      });
    }

    var c = {
      num: new a("num", {
        startsExpr: r
      }),
      bigint: new a("bigint", {
        startsExpr: r
      }),
      decimal: new a("decimal", {
        startsExpr: r
      }),
      regexp: new a("regexp", {
        startsExpr: r
      }),
      string: new a("string", {
        startsExpr: r
      }),
      name: new a("name", {
        startsExpr: r
      }),
      eof: new a("eof"),
      bracketL: new a("[", {
        beforeExpr: s,
        startsExpr: r
      }),
      bracketHashL: new a("#[", {
        beforeExpr: s,
        startsExpr: r
      }),
      bracketBarL: new a("[|", {
        beforeExpr: s,
        startsExpr: r
      }),
      bracketR: new a("]"),
      bracketBarR: new a("|]"),
      braceL: new a("{", {
        beforeExpr: s,
        startsExpr: r
      }),
      braceBarL: new a("{|", {
        beforeExpr: s,
        startsExpr: r
      }),
      braceHashL: new a("#{", {
        beforeExpr: s,
        startsExpr: r
      }),
      braceR: new a("}"),
      braceBarR: new a("|}"),
      parenL: new a("(", {
        beforeExpr: s,
        startsExpr: r
      }),
      parenR: new a(")"),
      comma: new a(",", {
        beforeExpr: s
      }),
      semi: new a(";", {
        beforeExpr: s
      }),
      colon: new a(":", {
        beforeExpr: s
      }),
      doubleColon: new a("::", {
        beforeExpr: s
      }),
      dot: new a("."),
      question: new a("?", {
        beforeExpr: s
      }),
      questionDot: new a("?."),
      arrow: new a("=>", {
        beforeExpr: s
      }),
      template: new a("template"),
      ellipsis: new a("...", {
        beforeExpr: s
      }),
      backQuote: new a("`", {
        startsExpr: r
      }),
      dollarBraceL: new a("${", {
        beforeExpr: s,
        startsExpr: r
      }),
      at: new a("@"),
      hash: new a("#", {
        startsExpr: r
      }),
      interpreterDirective: new a("#!..."),
      eq: new a("=", {
        beforeExpr: s,
        isAssign: true
      }),
      assign: new a("_=", {
        beforeExpr: s,
        isAssign: true
      }),
      incDec: new a("++/--", {
        prefix: n,
        postfix: !0,
        startsExpr: r
      }),
      bang: new a("!", {
        beforeExpr: s,
        prefix: n,
        startsExpr: r
      }),
      tilde: new a("~", {
        beforeExpr: s,
        prefix: n,
        startsExpr: r
      }),
      pipeline: h("|>", 0),
      nullishCoalescing: h("??", 1),
      logicalOR: h("||", 1),
      logicalAND: h("&&", 2),
      bitwiseOR: h("|", 3),
      bitwiseXOR: h("^", 4),
      bitwiseAND: h("&", 5),
      equality: h("==/!=/===/!==", 6),
      relational: h("</>/<=/>=", 7),
      bitShift: h("<</>>/>>>", 8),
      plusMin: new a("+/-", {
        beforeExpr: s,
        binop: 9,
        prefix: n,
        startsExpr: r
      }),
      modulo: new a("%", {
        beforeExpr: s,
        binop: 10,
        startsExpr: r
      }),
      star: new a("*", {
        binop: 10
      }),
      slash: h("/", 10),
      exponent: new a("**", {
        beforeExpr: s,
        binop: 11,
        rightAssociative: !0
      }),
      _break: u("break"),
      _case: u("case", {
        beforeExpr: s
      }),
      _catch: u("catch"),
      _continue: u("continue"),
      _debugger: u("debugger"),
      _default: u("default", {
        beforeExpr: s
      }),
      _do: u("do", {
        isLoop: i,
        beforeExpr: s
      }),
      _else: u("else", {
        beforeExpr: s
      }),
      _finally: u("finally"),
      _for: u("for", {
        isLoop: i
      }),
      _function: u("function", {
        startsExpr: r
      }),
      _if: u("if"),
      _return: u("return", {
        beforeExpr: s
      }),
      _switch: u("switch"),
      _throw: u("throw", {
        beforeExpr: s,
        prefix: n,
        startsExpr: r
      }),
      _try: u("try"),
      _var: u("var"),
      _const: u("const"),
      _while: u("while", {
        isLoop: i
      }),
      _with: u("with"),
      _new: u("new", {
        beforeExpr: s,
        startsExpr: r
      }),
      _this: u("this", {
        startsExpr: r
      }),
      _super: u("super", {
        startsExpr: r
      }),
      _class: u("class", {
        startsExpr: r
      }),
      _extends: u("extends", {
        beforeExpr: s
      }),
      _export: u("export"),
      _import: u("import", {
        startsExpr: r
      }),
      _null: u("null", {
        startsExpr: r
      }),
      _true: u("true", {
        startsExpr: r
      }),
      _false: u("false", {
        startsExpr: r
      }),
      _in: u("in", {
        beforeExpr: s,
        binop: 7
      }),
      _instanceof: u("instanceof", {
        beforeExpr: s,
        binop: 7
      }),
      _typeof: u("typeof", {
        beforeExpr: s,
        prefix: n,
        startsExpr: r
      }),
      _void: u("void", {
        beforeExpr: s,
        prefix: n,
        startsExpr: r
      }),
      _delete: u("delete", {
        beforeExpr: s,
        prefix: n,
        startsExpr: r
      })
    },
        p = 128,
        l = 128,
        d = 1024,
        D = 64,
        m = /\r\n?|[\n\u2028\u2029]/,
        f = new RegExp(m.source, "g");

    function y(t) {
      switch (t) {
        case 10:
        case 13:
        case 8232:
        case 8233:
          return !0;

        default:
          return !1;
      }
    }

    var E = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g;

    function A(t) {
      switch (t) {
        case 9:
        case 11:
        case 12:
        case 32:
        case 160:
        case 5760:
        case 8192:
        case 8193:
        case 8194:
        case 8195:
        case 8196:
        case 8197:
        case 8198:
        case 8199:
        case 8200:
        case 8201:
        case 8202:
        case 8239:
        case 8287:
        case 12288:
        case 65279:
          return !0;

        default:
          return !1;
      }
    }

    var C = function C(t, e) {
      _classCallCheck(this, C);

      this.line = void 0, this.column = void 0, this.line = t, this.column = e;
    };

    var x = function x(t, e) {
      _classCallCheck(this, x);

      this.start = void 0, this.end = void 0, this.filename = void 0, this.identifierName = void 0, this.start = t, this.end = e;
    };

    function F(t) {
      return t[t.length - 1];
    }

    var g = Object.freeze({
      AccessorIsGenerator: "A %0ter cannot be a generator",
      ArgumentsInClass: "'arguments' is only allowed in functions and class methods",
      AsyncFunctionInSingleStatementContext: "Async functions can only be declared at the top level or inside a block",
      AwaitBindingIdentifier: "Can not use 'await' as identifier inside an async function",
      AwaitExpressionFormalParameter: "await is not allowed in async function parameters",
      AwaitNotInAsyncContext: "'await' is only allowed within async functions and at the top levels of modules",
      AwaitNotInAsyncFunction: "'await' is only allowed within async functions",
      BadGetterArity: "getter must not have any formal parameters",
      BadSetterArity: "setter must have exactly one formal parameter",
      BadSetterRestParameter: "setter function argument must not be a rest parameter",
      ConstructorClassField: "Classes may not have a field named 'constructor'",
      ConstructorClassPrivateField: "Classes may not have a private field named '#constructor'",
      ConstructorIsAccessor: "Class constructor may not be an accessor",
      ConstructorIsAsync: "Constructor can't be an async function",
      ConstructorIsGenerator: "Constructor can't be a generator",
      DeclarationMissingInitializer: "%0 require an initialization value",
      DecoratorBeforeExport: "Decorators must be placed *before* the 'export' keyword. You can set the 'decoratorsBeforeExport' option to false to use the 'export @decorator class {}' syntax",
      DecoratorConstructor: "Decorators can't be used with a constructor. Did you mean '@dec class { ... }'?",
      DecoratorExportClass: "Using the export keyword between a decorator and a class is not allowed. Please use `export @dec class` instead.",
      DecoratorSemicolon: "Decorators must not be followed by a semicolon",
      DecoratorStaticBlock: "Decorators can't be used with a static block",
      DeletePrivateField: "Deleting a private field is not allowed",
      DestructureNamedImport: "ES2015 named imports do not destructure. Use another statement for destructuring after the import.",
      DuplicateConstructor: "Duplicate constructor in the same class",
      DuplicateDefaultExport: "Only one default export allowed per module.",
      DuplicateExport: "`%0` has already been exported. Exported identifiers must be unique.",
      DuplicateProto: "Redefinition of __proto__ property",
      DuplicateRegExpFlags: "Duplicate regular expression flag",
      DuplicateStaticBlock: "Duplicate static block in the same class",
      ElementAfterRest: "Rest element must be last element",
      EscapedCharNotAnIdentifier: "Invalid Unicode escape",
      ExportBindingIsString: "A string literal cannot be used as an exported binding without `from`.\n- Did you mean `export { %0 as '%1' } from 'some-module'`?",
      ExportDefaultFromAsIdentifier: "'from' is not allowed as an identifier after 'export default'",
      ForInOfLoopInitializer: "%0 loop variable declaration may not have an initializer",
      GeneratorInSingleStatementContext: "Generators can only be declared at the top level or inside a block",
      IllegalBreakContinue: "Unsyntactic %0",
      IllegalLanguageModeDirective: "Illegal 'use strict' directive in function with non-simple parameter list",
      IllegalReturn: "'return' outside of function",
      ImportBindingIsString: 'A string literal cannot be used as an imported binding.\n- Did you mean `import { "%0" as foo }`?',
      ImportCallArgumentTrailingComma: "Trailing comma is disallowed inside import(...) arguments",
      ImportCallArity: "import() requires exactly %0",
      ImportCallNotNewExpression: "Cannot use new with import(...)",
      ImportCallSpreadArgument: "... is not allowed in import()",
      ImportMetaOutsideModule: "import.meta may appear only with 'sourceType: \"module\"'",
      ImportOutsideModule: "'import' and 'export' may appear only with 'sourceType: \"module\"'",
      InvalidBigIntLiteral: "Invalid BigIntLiteral",
      InvalidCodePoint: "Code point out of bounds",
      InvalidDecimal: "Invalid decimal",
      InvalidDigit: "Expected number in radix %0",
      InvalidEscapeSequence: "Bad character escape sequence",
      InvalidEscapeSequenceTemplate: "Invalid escape sequence in template",
      InvalidEscapedReservedWord: "Escape sequence in keyword %0",
      InvalidIdentifier: "Invalid identifier %0",
      InvalidLhs: "Invalid left-hand side in %0",
      InvalidLhsBinding: "Binding invalid left-hand side in %0",
      InvalidNumber: "Invalid number",
      InvalidOrMissingExponent: "Floating-point numbers require a valid exponent after the 'e'",
      InvalidOrUnexpectedToken: "Unexpected character '%0'",
      InvalidParenthesizedAssignment: "Invalid parenthesized assignment pattern",
      InvalidPrivateFieldResolution: "Private name #%0 is not defined",
      InvalidPropertyBindingPattern: "Binding member expression",
      InvalidRecordProperty: "Only properties and spread elements are allowed in record definitions",
      InvalidRestAssignmentPattern: "Invalid rest operator's argument",
      LabelRedeclaration: "Label '%0' is already declared",
      LetInLexicalBinding: "'let' is not allowed to be used as a name in 'let' or 'const' declarations.",
      LineTerminatorBeforeArrow: "No line break is allowed before '=>'",
      MalformedRegExpFlags: "Invalid regular expression flag",
      MissingClassName: "A class name is required",
      MissingEqInAssignment: "Only '=' operator can be used for specifying default value.",
      MissingUnicodeEscape: "Expecting Unicode escape sequence \\uXXXX",
      MixingCoalesceWithLogical: "Nullish coalescing operator(??) requires parens when mixing with logical operators",
      ModuleAttributeDifferentFromType: "The only accepted module attribute is `type`",
      ModuleAttributeInvalidValue: "Only string literals are allowed as module attribute values",
      ModuleAttributesWithDuplicateKeys: 'Duplicate key "%0" is not allowed in module attributes',
      ModuleExportNameHasLoneSurrogate: "An export name cannot include a lone surrogate, found '\\u%0'",
      ModuleExportUndefined: "Export '%0' is not defined",
      MultipleDefaultsInSwitch: "Multiple default clauses",
      NewlineAfterThrow: "Illegal newline after throw",
      NoCatchOrFinally: "Missing catch or finally clause",
      NumberIdentifier: "Identifier directly after number",
      NumericSeparatorInEscapeSequence: "Numeric separators are not allowed inside unicode escape sequences or hex escape sequences",
      ObsoleteAwaitStar: "await* has been removed from the async functions proposal. Use Promise.all() instead.",
      OptionalChainingNoNew: "constructors in/after an Optional Chain are not allowed",
      OptionalChainingNoTemplate: "Tagged Template Literals are not allowed in optionalChain",
      ParamDupe: "Argument name clash",
      PatternHasAccessor: "Object pattern can't contain getter or setter",
      PatternHasMethod: "Object pattern can't contain methods",
      PipelineBodyNoArrow: 'Unexpected arrow "=>" after pipeline body; arrow function in pipeline body must be parenthesized',
      PipelineBodySequenceExpression: "Pipeline body may not be a comma-separated sequence expression",
      PipelineHeadSequenceExpression: "Pipeline head should not be a comma-separated sequence expression",
      PipelineTopicUnused: "Pipeline is in topic style but does not use topic reference",
      PrimaryTopicNotAllowed: "Topic reference was used in a lexical context without topic binding",
      PrimaryTopicRequiresSmartPipeline: "Primary Topic Reference found but pipelineOperator not passed 'smart' for 'proposal' option.",
      PrivateInExpectedIn: "Private names are only allowed in property accesses (`obj.#%0`) or in `in` expressions (`#%0 in obj`)",
      PrivateNameRedeclaration: "Duplicate private name #%0",
      RecordExpressionBarIncorrectEndSyntaxType: "Record expressions ending with '|}' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'",
      RecordExpressionBarIncorrectStartSyntaxType: "Record expressions starting with '{|' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'",
      RecordExpressionHashIncorrectStartSyntaxType: "Record expressions starting with '#{' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'hash'",
      RecordNoProto: "'__proto__' is not allowed in Record expressions",
      RestTrailingComma: "Unexpected trailing comma after rest element",
      SloppyFunction: "In non-strict mode code, functions can only be declared at top level, inside a block, or as the body of an if statement",
      StaticPrototype: "Classes may not have static property named prototype",
      StrictDelete: "Deleting local variable in strict mode",
      StrictEvalArguments: "Assigning to '%0' in strict mode",
      StrictEvalArgumentsBinding: "Binding '%0' in strict mode",
      StrictFunction: "In strict mode code, functions can only be declared at top level or inside a block",
      StrictNumericEscape: "The only valid numeric escape in strict mode is '\\0'",
      StrictOctalLiteral: "Legacy octal literals are not allowed in strict mode",
      StrictWith: "'with' in strict mode",
      SuperNotAllowed: "super() is only valid inside a class constructor of a subclass. Maybe a typo in the method name ('constructor') or not extending another class?",
      SuperPrivateField: "Private fields can't be accessed on super",
      TrailingDecorator: "Decorators must be attached to a class element",
      TupleExpressionBarIncorrectEndSyntaxType: "Tuple expressions ending with '|]' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'",
      TupleExpressionBarIncorrectStartSyntaxType: "Tuple expressions starting with '[|' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'",
      TupleExpressionHashIncorrectStartSyntaxType: "Tuple expressions starting with '#[' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'hash'",
      UnexpectedArgumentPlaceholder: "Unexpected argument placeholder",
      UnexpectedAwaitAfterPipelineBody: 'Unexpected "await" after pipeline body; await must have parentheses in minimal proposal',
      UnexpectedDigitAfterHash: "Unexpected digit after hash token",
      UnexpectedImportExport: "'import' and 'export' may only appear at the top level",
      UnexpectedKeyword: "Unexpected keyword '%0'",
      UnexpectedLeadingDecorator: "Leading decorators must be attached to a class declaration",
      UnexpectedLexicalDeclaration: "Lexical declaration cannot appear in a single-statement context",
      UnexpectedNewTarget: "new.target can only be used in functions",
      UnexpectedNumericSeparator: "A numeric separator is only allowed between two digits",
      UnexpectedPrivateField: "Private names can only be used as the name of a class element (i.e. class C { #p = 42; #m() {} } )\n or a property of member expression (i.e. this.#p).",
      UnexpectedReservedWord: "Unexpected reserved word '%0'",
      UnexpectedSuper: "super is only allowed in object methods and classes",
      UnexpectedToken: "Unexpected token '%0'",
      UnexpectedTokenUnaryExponentiation: "Illegal expression. Wrap left hand side or entire exponentiation in parentheses.",
      UnsupportedBind: "Binding should be performed on object property.",
      UnsupportedDecoratorExport: "A decorated export must export a class declaration",
      UnsupportedDefaultExport: "Only expressions, functions or classes are allowed as the `default` export.",
      UnsupportedImport: "import can only be used in import() or import.meta",
      UnsupportedMetaProperty: "The only valid meta property for %0 is %0.%1",
      UnsupportedParameterDecorator: "Decorators cannot be used to decorate parameters",
      UnsupportedPropertyDecorator: "Decorators cannot be used to decorate object literal properties",
      UnsupportedSuper: "super can only be used with function calls (i.e. super()) or in property accesses (i.e. super.prop or super[prop])",
      UnterminatedComment: "Unterminated comment",
      UnterminatedRegExp: "Unterminated regular expression",
      UnterminatedString: "Unterminated string constant",
      UnterminatedTemplate: "Unterminated template",
      VarRedeclaration: "Identifier '%0' has already been declared",
      YieldBindingIdentifier: "Can not use 'yield' as identifier inside a generator",
      YieldInParameter: "Yield expression is not allowed in formal parameters",
      ZeroDigitNumericSeparator: "Numeric separator can not be used after leading 0"
    });

    function b(t) {
      return null != t && "Property" === t.type && "init" === t.kind && !1 === t.method;
    }

    var P = function P(t, e, s, r) {
      _classCallCheck(this, P);

      this.token = void 0, this.isExpr = void 0, this.preserveSpace = void 0, this.override = void 0, this.token = t, this.isExpr = !!e, this.preserveSpace = !!s, this.override = r;
    };

    var T = {
      braceStatement: new P("{", !1),
      braceExpression: new P("{", !0),
      recordExpression: new P("#{", !0),
      templateQuasi: new P("${", !1),
      parenStatement: new P("(", !1),
      parenExpression: new P("(", !0),
      template: new P("`", !0, !0, function (t) {
        return t.readTmplToken();
      }),
      functionExpression: new P("function", !0),
      functionStatement: new P("function", !1)
    };
    c.parenR.updateContext = c.braceR.updateContext = function () {
      if (1 === this.state.context.length) return void (this.state.exprAllowed = !0);
      var t = this.state.context.pop();
      t === T.braceStatement && "function" === this.curContext().token && (t = this.state.context.pop()), this.state.exprAllowed = !t.isExpr;
    }, c.name.updateContext = function (t) {
      var e = !1;
      t !== c.dot && ("of" !== this.state.value || this.state.exprAllowed || t === c._function || t === c._class || (e = !0)), this.state.exprAllowed = e, this.state.isIterator && (this.state.isIterator = !1);
    }, c.braceL.updateContext = function (t) {
      this.state.context.push(this.braceIsBlock(t) ? T.braceStatement : T.braceExpression), this.state.exprAllowed = !0;
    }, c.dollarBraceL.updateContext = function () {
      this.state.context.push(T.templateQuasi), this.state.exprAllowed = !0;
    }, c.parenL.updateContext = function (t) {
      var e = t === c._if || t === c._for || t === c._with || t === c._while;
      this.state.context.push(e ? T.parenStatement : T.parenExpression), this.state.exprAllowed = !0;
    }, c.incDec.updateContext = function () {}, c._function.updateContext = c._class.updateContext = function (t) {
      !t.beforeExpr || t === c.semi || t === c._else || t === c._return && this.hasPrecedingLineBreak() || (t === c.colon || t === c.braceL) && this.curContext() === T.b_stat ? this.state.context.push(T.functionStatement) : this.state.context.push(T.functionExpression), this.state.exprAllowed = !1;
    }, c.backQuote.updateContext = function () {
      this.curContext() === T.template ? this.state.context.pop() : this.state.context.push(T.template), this.state.exprAllowed = !1;
    }, c.braceHashL.updateContext = function () {
      this.state.context.push(T.recordExpression), this.state.exprAllowed = !0;
    };
    var w = "\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08C7\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\u9FFC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7BF\uA7C2-\uA7CA\uA7F5-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC",
        B = "\u200C\u200D\xB7\u0300-\u036F\u0387\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u0669\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u06F0-\u06F9\u0711\u0730-\u074A\u07A6-\u07B0\u07C0-\u07C9\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0966-\u096F\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09E6-\u09EF\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A66-\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AE6-\u0AEF\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B66-\u0B6F\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0BE6-\u0BEF\u0C00-\u0C04\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C66-\u0C6F\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0CE6-\u0CEF\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D66-\u0D6F\u0D81-\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0E50-\u0E59\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECD\u0ED0-\u0ED9\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1040-\u1049\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F-\u109D\u135D-\u135F\u1369-\u1371\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u18A9\u1920-\u192B\u1930-\u193B\u1946-\u194F\u19D0-\u19DA\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AB0-\u1ABD\u1ABF\u1AC0\u1B00-\u1B04\u1B34-\u1B44\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BB0-\u1BB9\u1BE6-\u1BF3\u1C24-\u1C37\u1C40-\u1C49\u1C50-\u1C59\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u203F\u2040\u2054\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA620-\uA629\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA82C\uA880\uA881\uA8B4-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F1\uA8FF-\uA909\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9D0-\uA9D9\uA9E5\uA9F0-\uA9F9\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA50-\uAA59\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uABF0-\uABF9\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFF10-\uFF19\uFF3F";
    var S = new RegExp("[" + w + "]"),
        N = new RegExp("[" + w + B + "]");
    w = B = null;
    var I = [0, 11, 2, 25, 2, 18, 2, 1, 2, 14, 3, 13, 35, 122, 70, 52, 268, 28, 4, 48, 48, 31, 14, 29, 6, 37, 11, 29, 3, 35, 5, 7, 2, 4, 43, 157, 19, 35, 5, 35, 5, 39, 9, 51, 157, 310, 10, 21, 11, 7, 153, 5, 3, 0, 2, 43, 2, 1, 4, 0, 3, 22, 11, 22, 10, 30, 66, 18, 2, 1, 11, 21, 11, 25, 71, 55, 7, 1, 65, 0, 16, 3, 2, 2, 2, 28, 43, 28, 4, 28, 36, 7, 2, 27, 28, 53, 11, 21, 11, 18, 14, 17, 111, 72, 56, 50, 14, 50, 14, 35, 349, 41, 7, 1, 79, 28, 11, 0, 9, 21, 107, 20, 28, 22, 13, 52, 76, 44, 33, 24, 27, 35, 30, 0, 3, 0, 9, 34, 4, 0, 13, 47, 15, 3, 22, 0, 2, 0, 36, 17, 2, 24, 85, 6, 2, 0, 2, 3, 2, 14, 2, 9, 8, 46, 39, 7, 3, 1, 3, 21, 2, 6, 2, 1, 2, 4, 4, 0, 19, 0, 13, 4, 159, 52, 19, 3, 21, 2, 31, 47, 21, 1, 2, 0, 185, 46, 42, 3, 37, 47, 21, 0, 60, 42, 14, 0, 72, 26, 230, 43, 117, 63, 32, 7, 3, 0, 3, 7, 2, 1, 2, 23, 16, 0, 2, 0, 95, 7, 3, 38, 17, 0, 2, 0, 29, 0, 11, 39, 8, 0, 22, 0, 12, 45, 20, 0, 35, 56, 264, 8, 2, 36, 18, 0, 50, 29, 113, 6, 2, 1, 2, 37, 22, 0, 26, 5, 2, 1, 2, 31, 15, 0, 328, 18, 190, 0, 80, 921, 103, 110, 18, 195, 2749, 1070, 4050, 582, 8634, 568, 8, 30, 114, 29, 19, 47, 17, 3, 32, 20, 6, 18, 689, 63, 129, 74, 6, 0, 67, 12, 65, 1, 2, 0, 29, 6135, 9, 1237, 43, 8, 8952, 286, 50, 2, 18, 3, 9, 395, 2309, 106, 6, 12, 4, 8, 8, 9, 5991, 84, 2, 70, 2, 1, 3, 0, 3, 1, 3, 3, 2, 11, 2, 0, 2, 6, 2, 64, 2, 3, 3, 7, 2, 6, 2, 27, 2, 3, 2, 4, 2, 0, 4, 6, 2, 339, 3, 24, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 7, 2357, 44, 11, 6, 17, 0, 370, 43, 1301, 196, 60, 67, 8, 0, 1205, 3, 2, 26, 2, 1, 2, 0, 3, 0, 2, 9, 2, 3, 2, 0, 2, 0, 7, 0, 5, 0, 2, 0, 2, 0, 2, 2, 2, 1, 2, 0, 3, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 1, 2, 0, 3, 3, 2, 6, 2, 3, 2, 3, 2, 0, 2, 9, 2, 16, 6, 2, 2, 4, 2, 16, 4421, 42717, 35, 4148, 12, 221, 3, 5761, 15, 7472, 3104, 541, 1507, 4938],
        v = [509, 0, 227, 0, 150, 4, 294, 9, 1368, 2, 2, 1, 6, 3, 41, 2, 5, 0, 166, 1, 574, 3, 9, 9, 370, 1, 154, 10, 176, 2, 54, 14, 32, 9, 16, 3, 46, 10, 54, 9, 7, 2, 37, 13, 2, 9, 6, 1, 45, 0, 13, 2, 49, 13, 9, 3, 2, 11, 83, 11, 7, 0, 161, 11, 6, 9, 7, 3, 56, 1, 2, 6, 3, 1, 3, 2, 10, 0, 11, 1, 3, 6, 4, 4, 193, 17, 10, 9, 5, 0, 82, 19, 13, 9, 214, 6, 3, 8, 28, 1, 83, 16, 16, 9, 82, 12, 9, 9, 84, 14, 5, 9, 243, 14, 166, 9, 71, 5, 2, 1, 3, 3, 2, 0, 2, 1, 13, 9, 120, 6, 3, 6, 4, 0, 29, 9, 41, 6, 2, 3, 9, 0, 10, 10, 47, 15, 406, 7, 2, 7, 17, 9, 57, 21, 2, 13, 123, 5, 4, 0, 2, 1, 2, 6, 2, 0, 9, 9, 49, 4, 2, 1, 2, 4, 9, 9, 330, 3, 19306, 9, 135, 4, 60, 6, 26, 9, 1014, 0, 2, 54, 8, 3, 82, 0, 12, 1, 19628, 1, 5319, 4, 4, 5, 9, 7, 3, 6, 31, 3, 149, 2, 1418, 49, 513, 54, 5, 49, 9, 0, 15, 0, 23, 4, 2, 14, 1361, 6, 2, 16, 3, 6, 2, 1, 2, 4, 262, 6, 10, 9, 419, 13, 1495, 6, 110, 6, 6, 9, 4759, 9, 787719, 239];

    function k(t, e) {
      var s = 65536;

      for (var _r9 = 0, _i9 = e.length; _r9 < _i9; _r9 += 2) {
        if (s += e[_r9], s > t) return !1;
        if (s += e[_r9 + 1], s >= t) return !0;
      }

      return !1;
    }

    function L(t) {
      return t < 65 ? 36 === t : t <= 90 || (t < 97 ? 95 === t : t <= 122 || (t <= 65535 ? t >= 170 && S.test(String.fromCharCode(t)) : k(t, I)));
    }

    function O(t) {
      return t < 48 ? 36 === t : t < 58 || !(t < 65) && (t <= 90 || (t < 97 ? 95 === t : t <= 122 || (t <= 65535 ? t >= 170 && N.test(String.fromCharCode(t)) : k(t, I) || k(t, v))));
    }

    var M = ["implements", "interface", "let", "package", "private", "protected", "public", "static", "yield"],
        R = ["eval", "arguments"],
        _ = new Set(["break", "case", "catch", "continue", "debugger", "default", "do", "else", "finally", "for", "function", "if", "return", "switch", "throw", "try", "var", "const", "while", "with", "new", "this", "super", "class", "extends", "export", "import", "null", "true", "false", "in", "instanceof", "typeof", "void", "delete"]),
        j = new Set(M),
        U = new Set(R);

    function q(t, e) {
      return e && "await" === t || "enum" === t;
    }

    function V(t, e) {
      return q(t, e) || j.has(t);
    }

    function z(t) {
      return U.has(t);
    }

    function H(t, e) {
      return V(t, e) || z(t);
    }

    function W(t) {
      return _.has(t);
    }

    var X = /^in(stanceof)?$/;
    var G = new Set(["_", "any", "bool", "boolean", "empty", "extends", "false", "interface", "mixed", "null", "number", "static", "string", "true", "typeof", "void"]),
        K = Object.freeze({
      AmbiguousConditionalArrow: "Ambiguous expression: wrap the arrow functions in parentheses to disambiguate.",
      AmbiguousDeclareModuleKind: "Found both `declare module.exports` and `declare export` in the same module. Modules can only have 1 since they are either an ES module or they are a CommonJS module",
      AssignReservedType: "Cannot overwrite reserved type %0",
      DeclareClassElement: "The `declare` modifier can only appear on class fields.",
      DeclareClassFieldInitializer: "Initializers are not allowed in fields with the `declare` modifier.",
      DuplicateDeclareModuleExports: "Duplicate `declare module.exports` statement",
      EnumBooleanMemberNotInitialized: "Boolean enum members need to be initialized. Use either `%0 = true,` or `%0 = false,` in enum `%1`.",
      EnumDuplicateMemberName: "Enum member names need to be unique, but the name `%0` has already been used before in enum `%1`.",
      EnumInconsistentMemberValues: "Enum `%0` has inconsistent member initializers. Either use no initializers, or consistently use literals (either booleans, numbers, or strings) for all member initializers.",
      EnumInvalidExplicitType: "Enum type `%1` is not valid. Use one of `boolean`, `number`, `string`, or `symbol` in enum `%0`.",
      EnumInvalidExplicitTypeUnknownSupplied: "Supplied enum type is not valid. Use one of `boolean`, `number`, `string`, or `symbol` in enum `%0`.",
      EnumInvalidMemberInitializerPrimaryType: "Enum `%0` has type `%2`, so the initializer of `%1` needs to be a %2 literal.",
      EnumInvalidMemberInitializerSymbolType: "Symbol enum members cannot be initialized. Use `%1,` in enum `%0`.",
      EnumInvalidMemberInitializerUnknownType: "The enum member initializer for `%1` needs to be a literal (either a boolean, number, or string) in enum `%0`.",
      EnumInvalidMemberName: "Enum member names cannot start with lowercase 'a' through 'z'. Instead of using `%0`, consider using `%1`, in enum `%2`.",
      EnumNumberMemberNotInitialized: "Number enum members need to be initialized, e.g. `%1 = 1` in enum `%0`.",
      EnumStringMemberInconsistentlyInitailized: "String enum members need to consistently either all use initializers, or use no initializers, in enum `%0`.",
      ImportTypeShorthandOnlyInPureImport: "The `type` and `typeof` keywords on named imports can only be used on regular `import` statements. It cannot be used with `import type` or `import typeof` statements",
      InexactInsideExact: "Explicit inexact syntax cannot appear inside an explicit exact object type",
      InexactInsideNonObject: "Explicit inexact syntax cannot appear in class or interface definitions",
      InexactVariance: "Explicit inexact syntax cannot have variance",
      InvalidNonTypeImportInDeclareModule: "Imports within a `declare module` body must always be `import type` or `import typeof`",
      MissingTypeParamDefault: "Type parameter declaration needs a default, since a preceding type parameter declaration has a default.",
      NestedDeclareModule: "`declare module` cannot be used inside another `declare module`",
      NestedFlowComment: "Cannot have a flow comment inside another flow comment",
      OptionalBindingPattern: "A binding pattern parameter cannot be optional in an implementation signature.",
      SpreadVariance: "Spread properties cannot have variance",
      TypeBeforeInitializer: "Type annotations must come before default assignments, e.g. instead of `age = 25: number` use `age: number = 25`",
      TypeCastInPattern: "The type cast expression is expected to be wrapped with parenthesis",
      UnexpectedExplicitInexactInObject: "Explicit inexact syntax must appear at the end of an inexact object",
      UnexpectedReservedType: "Unexpected reserved type %0",
      UnexpectedReservedUnderscore: "`_` is only allowed as a type argument to call or new",
      UnexpectedSpaceBetweenModuloChecks: "Spaces between `%` and `checks` are not allowed here.",
      UnexpectedSpreadType: "Spread operator cannot appear in class or interface definitions",
      UnexpectedSubtractionOperand: 'Unexpected token, expected "number" or "bigint"',
      UnexpectedTokenAfterTypeParameter: "Expected an arrow function after this type parameter declaration",
      UnexpectedTypeParameterBeforeAsyncArrowFunction: "Type parameters must come after the async keyword, e.g. instead of `<T> async () => {}`, use `async <T>() => {}`",
      UnsupportedDeclareExportKind: "`declare export %0` is not supported. Use `%1` instead",
      UnsupportedStatementInDeclareModule: "Only declares and type imports are allowed inside declare module",
      UnterminatedFlowComment: "Unterminated flow-comment"
    });

    function J(t) {
      return "type" === t.importKind || "typeof" === t.importKind;
    }

    function $(t) {
      return (t.type === c.name || !!t.type.keyword) && "from" !== t.value;
    }

    var Y = {
      const: "declare export var",
      let: "declare export var",
      type: "export type",
      interface: "export interface"
    };
    var Q = /\*?\s*@((?:no)?flow)\b/;
    var Z = {
      quot: '"',
      amp: "&",
      apos: "'",
      lt: "<",
      gt: ">",
      nbsp: "\xa0",
      iexcl: "\xa1",
      cent: "\xa2",
      pound: "\xa3",
      curren: "\xa4",
      yen: "\xa5",
      brvbar: "\xa6",
      sect: "\xa7",
      uml: "\xa8",
      copy: "\xa9",
      ordf: "\xaa",
      laquo: "\xab",
      not: "\xac",
      shy: "\xad",
      reg: "\xae",
      macr: "\xaf",
      deg: "\xb0",
      plusmn: "\xb1",
      sup2: "\xb2",
      sup3: "\xb3",
      acute: "\xb4",
      micro: "\xb5",
      para: "\xb6",
      middot: "\xb7",
      cedil: "\xb8",
      sup1: "\xb9",
      ordm: "\xba",
      raquo: "\xbb",
      frac14: "\xbc",
      frac12: "\xbd",
      frac34: "\xbe",
      iquest: "\xbf",
      Agrave: "\xc0",
      Aacute: "\xc1",
      Acirc: "\xc2",
      Atilde: "\xc3",
      Auml: "\xc4",
      Aring: "\xc5",
      AElig: "\xc6",
      Ccedil: "\xc7",
      Egrave: "\xc8",
      Eacute: "\xc9",
      Ecirc: "\xca",
      Euml: "\xcb",
      Igrave: "\xcc",
      Iacute: "\xcd",
      Icirc: "\xce",
      Iuml: "\xcf",
      ETH: "\xd0",
      Ntilde: "\xd1",
      Ograve: "\xd2",
      Oacute: "\xd3",
      Ocirc: "\xd4",
      Otilde: "\xd5",
      Ouml: "\xd6",
      times: "\xd7",
      Oslash: "\xd8",
      Ugrave: "\xd9",
      Uacute: "\xda",
      Ucirc: "\xdb",
      Uuml: "\xdc",
      Yacute: "\xdd",
      THORN: "\xde",
      szlig: "\xdf",
      agrave: "\xe0",
      aacute: "\xe1",
      acirc: "\xe2",
      atilde: "\xe3",
      auml: "\xe4",
      aring: "\xe5",
      aelig: "\xe6",
      ccedil: "\xe7",
      egrave: "\xe8",
      eacute: "\xe9",
      ecirc: "\xea",
      euml: "\xeb",
      igrave: "\xec",
      iacute: "\xed",
      icirc: "\xee",
      iuml: "\xef",
      eth: "\xf0",
      ntilde: "\xf1",
      ograve: "\xf2",
      oacute: "\xf3",
      ocirc: "\xf4",
      otilde: "\xf5",
      ouml: "\xf6",
      divide: "\xf7",
      oslash: "\xf8",
      ugrave: "\xf9",
      uacute: "\xfa",
      ucirc: "\xfb",
      uuml: "\xfc",
      yacute: "\xfd",
      thorn: "\xfe",
      yuml: "\xff",
      OElig: "\u0152",
      oelig: "\u0153",
      Scaron: "\u0160",
      scaron: "\u0161",
      Yuml: "\u0178",
      fnof: "\u0192",
      circ: "\u02C6",
      tilde: "\u02DC",
      Alpha: "\u0391",
      Beta: "\u0392",
      Gamma: "\u0393",
      Delta: "\u0394",
      Epsilon: "\u0395",
      Zeta: "\u0396",
      Eta: "\u0397",
      Theta: "\u0398",
      Iota: "\u0399",
      Kappa: "\u039A",
      Lambda: "\u039B",
      Mu: "\u039C",
      Nu: "\u039D",
      Xi: "\u039E",
      Omicron: "\u039F",
      Pi: "\u03A0",
      Rho: "\u03A1",
      Sigma: "\u03A3",
      Tau: "\u03A4",
      Upsilon: "\u03A5",
      Phi: "\u03A6",
      Chi: "\u03A7",
      Psi: "\u03A8",
      Omega: "\u03A9",
      alpha: "\u03B1",
      beta: "\u03B2",
      gamma: "\u03B3",
      delta: "\u03B4",
      epsilon: "\u03B5",
      zeta: "\u03B6",
      eta: "\u03B7",
      theta: "\u03B8",
      iota: "\u03B9",
      kappa: "\u03BA",
      lambda: "\u03BB",
      mu: "\u03BC",
      nu: "\u03BD",
      xi: "\u03BE",
      omicron: "\u03BF",
      pi: "\u03C0",
      rho: "\u03C1",
      sigmaf: "\u03C2",
      sigma: "\u03C3",
      tau: "\u03C4",
      upsilon: "\u03C5",
      phi: "\u03C6",
      chi: "\u03C7",
      psi: "\u03C8",
      omega: "\u03C9",
      thetasym: "\u03D1",
      upsih: "\u03D2",
      piv: "\u03D6",
      ensp: "\u2002",
      emsp: "\u2003",
      thinsp: "\u2009",
      zwnj: "\u200C",
      zwj: "\u200D",
      lrm: "\u200E",
      rlm: "\u200F",
      ndash: "\u2013",
      mdash: "\u2014",
      lsquo: "\u2018",
      rsquo: "\u2019",
      sbquo: "\u201A",
      ldquo: "\u201C",
      rdquo: "\u201D",
      bdquo: "\u201E",
      dagger: "\u2020",
      Dagger: "\u2021",
      bull: "\u2022",
      hellip: "\u2026",
      permil: "\u2030",
      prime: "\u2032",
      Prime: "\u2033",
      lsaquo: "\u2039",
      rsaquo: "\u203A",
      oline: "\u203E",
      frasl: "\u2044",
      euro: "\u20AC",
      image: "\u2111",
      weierp: "\u2118",
      real: "\u211C",
      trade: "\u2122",
      alefsym: "\u2135",
      larr: "\u2190",
      uarr: "\u2191",
      rarr: "\u2192",
      darr: "\u2193",
      harr: "\u2194",
      crarr: "\u21B5",
      lArr: "\u21D0",
      uArr: "\u21D1",
      rArr: "\u21D2",
      dArr: "\u21D3",
      hArr: "\u21D4",
      forall: "\u2200",
      part: "\u2202",
      exist: "\u2203",
      empty: "\u2205",
      nabla: "\u2207",
      isin: "\u2208",
      notin: "\u2209",
      ni: "\u220B",
      prod: "\u220F",
      sum: "\u2211",
      minus: "\u2212",
      lowast: "\u2217",
      radic: "\u221A",
      prop: "\u221D",
      infin: "\u221E",
      ang: "\u2220",
      and: "\u2227",
      or: "\u2228",
      cap: "\u2229",
      cup: "\u222A",
      int: "\u222B",
      there4: "\u2234",
      sim: "\u223C",
      cong: "\u2245",
      asymp: "\u2248",
      ne: "\u2260",
      equiv: "\u2261",
      le: "\u2264",
      ge: "\u2265",
      sub: "\u2282",
      sup: "\u2283",
      nsub: "\u2284",
      sube: "\u2286",
      supe: "\u2287",
      oplus: "\u2295",
      otimes: "\u2297",
      perp: "\u22A5",
      sdot: "\u22C5",
      lceil: "\u2308",
      rceil: "\u2309",
      lfloor: "\u230A",
      rfloor: "\u230B",
      lang: "\u2329",
      rang: "\u232A",
      loz: "\u25CA",
      spades: "\u2660",
      clubs: "\u2663",
      hearts: "\u2665",
      diams: "\u2666"
    },
        tt = /^[\da-fA-F]+$/,
        et = /^\d+$/,
        st = Object.freeze({
      AttributeIsEmpty: "JSX attributes must only be assigned a non-empty expression",
      MissingClosingTagFragment: "Expected corresponding JSX closing tag for <>",
      MissingClosingTagElement: "Expected corresponding JSX closing tag for <%0>",
      UnsupportedJsxValue: "JSX value should be either an expression or a quoted JSX text",
      UnterminatedJsxContent: "Unterminated JSX contents",
      UnwrappedAdjacentJSXElements: "Adjacent JSX elements must be wrapped in an enclosing tag. Did you want a JSX fragment <>...</>?"
    });

    function rt(t) {
      return !!t && ("JSXOpeningFragment" === t.type || "JSXClosingFragment" === t.type);
    }

    function it(t) {
      if ("JSXIdentifier" === t.type) return t.name;
      if ("JSXNamespacedName" === t.type) return t.namespace.name + ":" + t.name.name;
      if ("JSXMemberExpression" === t.type) return it(t.object) + "." + it(t.property);
      throw new Error("Node had unexpected type: " + t.type);
    }

    T.j_oTag = new P("<tag", !1), T.j_cTag = new P("</tag", !1), T.j_expr = new P("<tag>...</tag>", !0, !0), c.jsxName = new a("jsxName"), c.jsxText = new a("jsxText", {
      beforeExpr: !0
    }), c.jsxTagStart = new a("jsxTagStart", {
      startsExpr: !0
    }), c.jsxTagEnd = new a("jsxTagEnd"), c.jsxTagStart.updateContext = function () {
      this.state.context.push(T.j_expr), this.state.context.push(T.j_oTag), this.state.exprAllowed = !1;
    }, c.jsxTagEnd.updateContext = function (t) {
      var e = this.state.context.pop();
      e === T.j_oTag && t === c.slash || e === T.j_cTag ? (this.state.context.pop(), this.state.exprAllowed = this.curContext() === T.j_expr) : this.state.exprAllowed = !0;
    };

    var nt = function nt(t) {
      _classCallCheck(this, nt);

      this.flags = void 0, this.var = [], this.lexical = [], this.functions = [], this.flags = t;
    };

    var at = /*#__PURE__*/function () {
      function at(t, e) {
        _classCallCheck(this, at);

        this.scopeStack = [], this.undefinedExports = new Map(), this.undefinedPrivateNames = new Map(), this.raise = t, this.inModule = e;
      }

      _createClass(at, [{
        key: "inFunction",
        get: function get() {
          return (2 & this.currentVarScope().flags) > 0;
        }
      }, {
        key: "allowSuper",
        get: function get() {
          return (16 & this.currentThisScope().flags) > 0;
        }
      }, {
        key: "allowDirectSuper",
        get: function get() {
          return (32 & this.currentThisScope().flags) > 0;
        }
      }, {
        key: "inClass",
        get: function get() {
          return (64 & this.currentThisScope().flags) > 0;
        }
      }, {
        key: "inNonArrowFunction",
        get: function get() {
          return (2 & this.currentThisScope().flags) > 0;
        }
      }, {
        key: "treatFunctionsAsVar",
        get: function get() {
          return this.treatFunctionsAsVarInScope(this.currentScope());
        }
      }, {
        key: "createScope",
        value: function createScope(t) {
          return new nt(t);
        }
      }, {
        key: "enter",
        value: function enter(t) {
          this.scopeStack.push(this.createScope(t));
        }
      }, {
        key: "exit",
        value: function exit() {
          this.scopeStack.pop();
        }
      }, {
        key: "treatFunctionsAsVarInScope",
        value: function treatFunctionsAsVarInScope(t) {
          return !!(2 & t.flags || !this.inModule && 1 & t.flags);
        }
      }, {
        key: "declareName",
        value: function declareName(t, e, s) {
          var r = this.currentScope();
          if (8 & e || 16 & e) this.checkRedeclarationInScope(r, t, e, s), 16 & e ? r.functions.push(t) : r.lexical.push(t), 8 & e && this.maybeExportDefined(r, t);else if (4 & e) for (var _i10 = this.scopeStack.length - 1; _i10 >= 0 && (r = this.scopeStack[_i10], this.checkRedeclarationInScope(r, t, e, s), r.var.push(t), this.maybeExportDefined(r, t), !(131 & r.flags)); --_i10) {
            ;
          }
          this.inModule && 1 & r.flags && this.undefinedExports.delete(t);
        }
      }, {
        key: "maybeExportDefined",
        value: function maybeExportDefined(t, e) {
          this.inModule && 1 & t.flags && this.undefinedExports.delete(e);
        }
      }, {
        key: "checkRedeclarationInScope",
        value: function checkRedeclarationInScope(t, e, s, r) {
          this.isRedeclaredInScope(t, e, s) && this.raise(r, g.VarRedeclaration, e);
        }
      }, {
        key: "isRedeclaredInScope",
        value: function isRedeclaredInScope(t, e, s) {
          return !!(1 & s) && (8 & s ? t.lexical.indexOf(e) > -1 || t.functions.indexOf(e) > -1 || t.var.indexOf(e) > -1 : 16 & s ? t.lexical.indexOf(e) > -1 || !this.treatFunctionsAsVarInScope(t) && t.var.indexOf(e) > -1 : t.lexical.indexOf(e) > -1 && !(8 & t.flags && t.lexical[0] === e) || !this.treatFunctionsAsVarInScope(t) && t.functions.indexOf(e) > -1);
        }
      }, {
        key: "checkLocalExport",
        value: function checkLocalExport(t) {
          -1 === this.scopeStack[0].lexical.indexOf(t.name) && -1 === this.scopeStack[0].var.indexOf(t.name) && -1 === this.scopeStack[0].functions.indexOf(t.name) && this.undefinedExports.set(t.name, t.start);
        }
      }, {
        key: "currentScope",
        value: function currentScope() {
          return this.scopeStack[this.scopeStack.length - 1];
        }
      }, {
        key: "currentVarScope",
        value: function currentVarScope() {
          for (var _t11 = this.scopeStack.length - 1;; _t11--) {
            var _e13 = this.scopeStack[_t11];
            if (131 & _e13.flags) return _e13;
          }
        }
      }, {
        key: "currentThisScope",
        value: function currentThisScope() {
          for (var _t12 = this.scopeStack.length - 1;; _t12--) {
            var _e14 = this.scopeStack[_t12];
            if ((131 & _e14.flags || 64 & _e14.flags) && !(4 & _e14.flags)) return _e14;
          }
        }
      }]);

      return at;
    }();

    var ot = /*#__PURE__*/function (_nt) {
      _inherits(ot, _nt);

      var _super = _createSuper(ot);

      function ot() {
        var _this;

        _classCallCheck(this, ot);

        for (var _len2 = arguments.length, t = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          t[_key2] = arguments[_key2];
        }

        _this = _super.call.apply(_super, [this].concat(t)), _this.types = [], _this.enums = [], _this.constEnums = [], _this.classes = [], _this.exportOnlyBindings = [];
        return _this;
      }

      return ot;
    }(nt);

    var ut = /*#__PURE__*/function (_at) {
      _inherits(ut, _at);

      var _super2 = _createSuper(ut);

      function ut() {
        _classCallCheck(this, ut);

        return _super2.apply(this, arguments);
      }

      _createClass(ut, [{
        key: "createScope",
        value: function createScope(t) {
          return new ot(t);
        }
      }, {
        key: "declareName",
        value: function declareName(t, e, s) {
          var r = this.currentScope();
          if (e & d) return this.maybeExportDefined(r, t), void r.exportOnlyBindings.push(t);
          _get(_getPrototypeOf(ut.prototype), "declareName", this).apply(this, arguments), 2 & e && (1 & e || (this.checkRedeclarationInScope(r, t, e, s), this.maybeExportDefined(r, t)), r.types.push(t)), 256 & e && r.enums.push(t), 512 & e && r.constEnums.push(t), e & l && r.classes.push(t);
        }
      }, {
        key: "isRedeclaredInScope",
        value: function isRedeclaredInScope(t, e, s) {
          if (t.enums.indexOf(e) > -1) {
            if (256 & s) {
              return !!(512 & s) !== t.constEnums.indexOf(e) > -1;
            }

            return !0;
          }

          return s & l && t.classes.indexOf(e) > -1 ? t.lexical.indexOf(e) > -1 && !!(1 & s) : !!(2 & s && t.types.indexOf(e) > -1) || _get(_getPrototypeOf(ut.prototype), "isRedeclaredInScope", this).apply(this, arguments);
        }
      }, {
        key: "checkLocalExport",
        value: function checkLocalExport(t) {
          -1 === this.scopeStack[0].types.indexOf(t.name) && -1 === this.scopeStack[0].exportOnlyBindings.indexOf(t.name) && _get(_getPrototypeOf(ut.prototype), "checkLocalExport", this).call(this, t);
        }
      }]);

      return ut;
    }(at);

    var ht = /*#__PURE__*/function () {
      function ht() {
        _classCallCheck(this, ht);

        this.stacks = [];
      }

      _createClass(ht, [{
        key: "enter",
        value: function enter(t) {
          this.stacks.push(t);
        }
      }, {
        key: "exit",
        value: function exit() {
          this.stacks.pop();
        }
      }, {
        key: "currentFlags",
        value: function currentFlags() {
          return this.stacks[this.stacks.length - 1];
        }
      }, {
        key: "hasAwait",
        get: function get() {
          return (2 & this.currentFlags()) > 0;
        }
      }, {
        key: "hasYield",
        get: function get() {
          return (1 & this.currentFlags()) > 0;
        }
      }, {
        key: "hasReturn",
        get: function get() {
          return (4 & this.currentFlags()) > 0;
        }
      }, {
        key: "hasIn",
        get: function get() {
          return (8 & this.currentFlags()) > 0;
        }
      }]);

      return ht;
    }();

    function ct(t, e) {
      return (t ? 2 : 0) | (e ? 1 : 0);
    }

    function pt(t) {
      if (null == t) throw new Error("Unexpected ".concat(t, " value."));
      return t;
    }

    function lt(t) {
      if (!t) throw new Error("Assert fail");
    }

    var dt = Object.freeze({
      ClassMethodHasDeclare: "Class methods cannot have the 'declare' modifier",
      ClassMethodHasReadonly: "Class methods cannot have the 'readonly' modifier",
      ConstructorHasTypeParameters: "Type parameters cannot appear on a constructor declaration.",
      DeclareClassFieldHasInitializer: "Initializers are not allowed in ambient contexts.",
      DeclareFunctionHasImplementation: "An implementation cannot be declared in ambient contexts.",
      DuplicateModifier: "Duplicate modifier: '%0'",
      EmptyHeritageClauseType: "'%0' list cannot be empty.",
      EmptyTypeArguments: "Type argument list cannot be empty.",
      EmptyTypeParameters: "Type parameter list cannot be empty.",
      IndexSignatureHasAbstract: "Index signatures cannot have the 'abstract' modifier",
      IndexSignatureHasAccessibility: "Index signatures cannot have an accessibility modifier ('%0')",
      IndexSignatureHasStatic: "Index signatures cannot have the 'static' modifier",
      IndexSignatureHasDeclare: "Index signatures cannot have the 'declare' modifier",
      InvalidTupleMemberLabel: "Tuple members must be labeled with a simple identifier.",
      MixedLabeledAndUnlabeledElements: "Tuple members must all have names or all not have names.",
      OptionalTypeBeforeRequired: "A required element cannot follow an optional element.",
      PatternIsOptional: "A binding pattern parameter cannot be optional in an implementation signature.",
      PrivateElementHasAbstract: "Private elements cannot have the 'abstract' modifier.",
      PrivateElementHasAccessibility: "Private elements cannot have an accessibility modifier ('%0')",
      TypeAnnotationAfterAssign: "Type annotations must come before default assignments, e.g. instead of `age = 25: number` use `age: number = 25`",
      UnexpectedParameterModifier: "A parameter property is only allowed in a constructor implementation.",
      UnexpectedReadonly: "'readonly' type modifier is only permitted on array and tuple literal types.",
      UnexpectedTypeAnnotation: "Did not expect a type annotation here.",
      UnexpectedTypeCastInParameter: "Unexpected type cast in parameter position.",
      UnsupportedImportTypeArgument: "Argument in a type import must be a string literal",
      UnsupportedParameterPropertyKind: "A parameter property may not be declared using a binding pattern.",
      UnsupportedSignatureParameterKind: "Name in a signature must be an Identifier, ObjectPattern or ArrayPattern, instead got %0"
    });
    c.placeholder = new a("%%", {
      startsExpr: !0
    });

    function Dt(t, e) {
      return t.some(function (t) {
        return Array.isArray(t) ? t[0] === e : t === e;
      });
    }

    function mt(t, e, s) {
      var r = t.find(function (t) {
        return Array.isArray(t) ? t[0] === e : t === e;
      });
      return r && Array.isArray(r) ? r[1][s] : null;
    }

    var ft = ["minimal", "smart", "fsharp"],
        yt = ["hash", "bar"];
    var Et = {
      estree: function estree(t) {
        return /*#__PURE__*/function (_t13) {
          _inherits(_class, _t13);

          var _super3 = _createSuper(_class);

          function _class() {
            _classCallCheck(this, _class);

            return _super3.apply(this, arguments);
          }

          _createClass(_class, [{
            key: "estreeParseRegExpLiteral",
            value: function estreeParseRegExpLiteral(_ref12) {
              var t = _ref12.pattern,
                  e = _ref12.flags;
              var s = null;

              try {
                s = new RegExp(t, e);
              } catch (t) {}

              var r = this.estreeParseLiteral(s);
              return r.regex = {
                pattern: t,
                flags: e
              }, r;
            }
          }, {
            key: "estreeParseBigIntLiteral",
            value: function estreeParseBigIntLiteral(t) {
              var e = "undefined" != typeof BigInt ? BigInt(t) : null,
                  s = this.estreeParseLiteral(e);
              return s.bigint = String(s.value || t), s;
            }
          }, {
            key: "estreeParseDecimalLiteral",
            value: function estreeParseDecimalLiteral(t) {
              var e = this.estreeParseLiteral(null);
              return e.decimal = String(e.value || t), e;
            }
          }, {
            key: "estreeParseLiteral",
            value: function estreeParseLiteral(t) {
              return this.parseLiteral(t, "Literal");
            }
          }, {
            key: "directiveToStmt",
            value: function directiveToStmt(t) {
              var e = t.value,
                  s = this.startNodeAt(t.start, t.loc.start),
                  r = this.startNodeAt(e.start, e.loc.start);
              return r.value = e.value, r.raw = e.extra.raw, s.expression = this.finishNodeAt(r, "Literal", e.end, e.loc.end), s.directive = e.extra.raw.slice(1, -1), this.finishNodeAt(s, "ExpressionStatement", t.end, t.loc.end);
            }
          }, {
            key: "initFunction",
            value: function initFunction(t, e) {
              _get(_getPrototypeOf(_class.prototype), "initFunction", this).call(this, t, e), t.expression = !1;
            }
          }, {
            key: "checkDeclaration",
            value: function checkDeclaration(t) {
              b(t) ? this.checkDeclaration(t.value) : _get(_getPrototypeOf(_class.prototype), "checkDeclaration", this).call(this, t);
            }
          }, {
            key: "getObjectOrClassMethodParams",
            value: function getObjectOrClassMethodParams(t) {
              return t.value.params;
            }
          }, {
            key: "checkLVal",
            value: function checkLVal(t) {
              var _this2 = this;

              var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 64;
              var s = arguments.length > 2 ? arguments[2] : undefined;
              var r = arguments.length > 3 ? arguments[3] : undefined;
              var i = arguments.length > 4 ? arguments[4] : undefined;

              switch (t.type) {
                case "ObjectPattern":
                  t.properties.forEach(function (t) {
                    _this2.checkLVal("Property" === t.type ? t.value : t, e, s, "object destructuring pattern", i);
                  });
                  break;

                default:
                  _get(_getPrototypeOf(_class.prototype), "checkLVal", this).call(this, t, e, s, r, i);

              }
            }
          }, {
            key: "checkProto",
            value: function checkProto(t, e, s, r) {
              t.method || _get(_getPrototypeOf(_class.prototype), "checkProto", this).call(this, t, e, s, r);
            }
          }, {
            key: "isValidDirective",
            value: function isValidDirective(t) {
              var e;
              return "ExpressionStatement" === t.type && "Literal" === t.expression.type && "string" == typeof t.expression.value && !(null == (e = t.expression.extra) ? void 0 : e.parenthesized);
            }
          }, {
            key: "stmtToDirective",
            value: function stmtToDirective(t) {
              var e = _get(_getPrototypeOf(_class.prototype), "stmtToDirective", this).call(this, t),
                  s = t.expression.value;

              return e.value.value = s, e;
            }
          }, {
            key: "parseBlockBody",
            value: function parseBlockBody(t, e, s, r) {
              var _this3 = this;

              _get(_getPrototypeOf(_class.prototype), "parseBlockBody", this).call(this, t, e, s, r);

              var i = t.directives.map(function (t) {
                return _this3.directiveToStmt(t);
              });
              t.body = i.concat(t.body), delete t.directives;
            }
          }, {
            key: "pushClassMethod",
            value: function pushClassMethod(t, e, s, r, i, n) {
              this.parseMethod(e, s, r, i, n, "ClassMethod", !0), e.typeParameters && (e.value.typeParameters = e.typeParameters, delete e.typeParameters), t.body.push(e);
            }
          }, {
            key: "parseExprAtom",
            value: function parseExprAtom(t) {
              switch (this.state.type) {
                case c.num:
                case c.string:
                  return this.estreeParseLiteral(this.state.value);

                case c.regexp:
                  return this.estreeParseRegExpLiteral(this.state.value);

                case c.bigint:
                  return this.estreeParseBigIntLiteral(this.state.value);

                case c.decimal:
                  return this.estreeParseDecimalLiteral(this.state.value);

                case c._null:
                  return this.estreeParseLiteral(null);

                case c._true:
                  return this.estreeParseLiteral(!0);

                case c._false:
                  return this.estreeParseLiteral(!1);

                default:
                  return _get(_getPrototypeOf(_class.prototype), "parseExprAtom", this).call(this, t);
              }
            }
          }, {
            key: "parseLiteral",
            value: function parseLiteral(t, e, s, r) {
              var i = _get(_getPrototypeOf(_class.prototype), "parseLiteral", this).call(this, t, e, s, r);

              return i.raw = i.extra.raw, delete i.extra, i;
            }
          }, {
            key: "parseFunctionBody",
            value: function parseFunctionBody(t, e) {
              var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
              _get(_getPrototypeOf(_class.prototype), "parseFunctionBody", this).call(this, t, e, s), t.expression = "BlockStatement" !== t.body.type;
            }
          }, {
            key: "parseMethod",
            value: function parseMethod(t, e, s, r, i, n) {
              var a = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : !1;
              var o = this.startNode();
              return o.kind = t.kind, o = _get(_getPrototypeOf(_class.prototype), "parseMethod", this).call(this, o, e, s, r, i, n, a), o.type = "FunctionExpression", delete o.kind, t.value = o, n = "ClassMethod" === n ? "MethodDefinition" : n, this.finishNode(t, n);
            }
          }, {
            key: "parseObjectMethod",
            value: function parseObjectMethod(t, e, s, r, i) {
              var n = _get(_getPrototypeOf(_class.prototype), "parseObjectMethod", this).call(this, t, e, s, r, i);

              return n && (n.type = "Property", "method" === n.kind && (n.kind = "init"), n.shorthand = !1), n;
            }
          }, {
            key: "parseObjectProperty",
            value: function parseObjectProperty(t, e, s, r, i) {
              var n = _get(_getPrototypeOf(_class.prototype), "parseObjectProperty", this).call(this, t, e, s, r, i);

              return n && (n.kind = "init", n.type = "Property"), n;
            }
          }, {
            key: "toAssignable",
            value: function toAssignable(t) {
              return b(t) ? (this.toAssignable(t.value), t) : _get(_getPrototypeOf(_class.prototype), "toAssignable", this).call(this, t);
            }
          }, {
            key: "toAssignableObjectExpressionProp",
            value: function toAssignableObjectExpressionProp(t, e) {
              if ("get" === t.kind || "set" === t.kind) throw this.raise(t.key.start, g.PatternHasAccessor);
              if (t.method) throw this.raise(t.key.start, g.PatternHasMethod);

              _get(_getPrototypeOf(_class.prototype), "toAssignableObjectExpressionProp", this).call(this, t, e);
            }
          }, {
            key: "finishCallExpression",
            value: function finishCallExpression(t, e) {
              return _get(_getPrototypeOf(_class.prototype), "finishCallExpression", this).call(this, t, e), "Import" === t.callee.type && (t.type = "ImportExpression", t.source = t.arguments[0], delete t.arguments, delete t.callee), t;
            }
          }, {
            key: "toReferencedArguments",
            value: function toReferencedArguments(t) {
              "ImportExpression" !== t.type && _get(_getPrototypeOf(_class.prototype), "toReferencedArguments", this).call(this, t);
            }
          }, {
            key: "parseExport",
            value: function parseExport(t) {
              switch (_get(_getPrototypeOf(_class.prototype), "parseExport", this).call(this, t), t.type) {
                case "ExportAllDeclaration":
                  t.exported = null;
                  break;

                case "ExportNamedDeclaration":
                  1 === t.specifiers.length && "ExportNamespaceSpecifier" === t.specifiers[0].type && (t.type = "ExportAllDeclaration", t.exported = t.specifiers[0].exported, delete t.specifiers);
              }

              return t;
            }
          }, {
            key: "parseSubscript",
            value: function parseSubscript(t, e, s, r, i) {
              var n = _get(_getPrototypeOf(_class.prototype), "parseSubscript", this).call(this, t, e, s, r, i);

              if (i.optionalChainMember) {
                if ("OptionalMemberExpression" !== n.type && "OptionalCallExpression" !== n.type || (n.type = n.type.substring(8)), i.stop) {
                  var _t14 = this.startNodeAtNode(n);

                  return _t14.expression = n, this.finishNode(_t14, "ChainExpression");
                }
              } else "MemberExpression" !== n.type && "CallExpression" !== n.type || (n.optional = !1);

              return n;
            }
          }]);

          return _class;
        }(t);
      },
      jsx: function jsx(t) {
        return /*#__PURE__*/function (_t15) {
          _inherits(_class2, _t15);

          var _super4 = _createSuper(_class2);

          function _class2() {
            _classCallCheck(this, _class2);

            return _super4.apply(this, arguments);
          }

          _createClass(_class2, [{
            key: "jsxReadToken",
            value: function jsxReadToken() {
              var t = "",
                  e = this.state.pos;

              for (;;) {
                if (this.state.pos >= this.length) throw this.raise(this.state.start, st.UnterminatedJsxContent);

                var _s12 = this.input.charCodeAt(this.state.pos);

                switch (_s12) {
                  case 60:
                  case 123:
                    return this.state.pos === this.state.start ? 60 === _s12 && this.state.exprAllowed ? (++this.state.pos, this.finishToken(c.jsxTagStart)) : _get(_getPrototypeOf(_class2.prototype), "getTokenFromCode", this).call(this, _s12) : (t += this.input.slice(e, this.state.pos), this.finishToken(c.jsxText, t));

                  case 38:
                    t += this.input.slice(e, this.state.pos), t += this.jsxReadEntity(), e = this.state.pos;
                    break;

                  default:
                    y(_s12) ? (t += this.input.slice(e, this.state.pos), t += this.jsxReadNewLine(!0), e = this.state.pos) : ++this.state.pos;
                }
              }
            }
          }, {
            key: "jsxReadNewLine",
            value: function jsxReadNewLine(t) {
              var e = this.input.charCodeAt(this.state.pos);
              var s;
              return ++this.state.pos, 13 === e && 10 === this.input.charCodeAt(this.state.pos) ? (++this.state.pos, s = t ? "\n" : "\r\n") : s = String.fromCharCode(e), ++this.state.curLine, this.state.lineStart = this.state.pos, s;
            }
          }, {
            key: "jsxReadString",
            value: function jsxReadString(t) {
              var e = "",
                  s = ++this.state.pos;

              for (;;) {
                if (this.state.pos >= this.length) throw this.raise(this.state.start, g.UnterminatedString);

                var _r10 = this.input.charCodeAt(this.state.pos);

                if (_r10 === t) break;
                38 === _r10 ? (e += this.input.slice(s, this.state.pos), e += this.jsxReadEntity(), s = this.state.pos) : y(_r10) ? (e += this.input.slice(s, this.state.pos), e += this.jsxReadNewLine(!1), s = this.state.pos) : ++this.state.pos;
              }

              return e += this.input.slice(s, this.state.pos++), this.finishToken(c.string, e);
            }
          }, {
            key: "jsxReadEntity",
            value: function jsxReadEntity() {
              var t,
                  e = "",
                  s = 0,
                  r = this.input[this.state.pos];
              var i = ++this.state.pos;

              for (; this.state.pos < this.length && s++ < 10;) {
                if (r = this.input[this.state.pos++], ";" === r) {
                  "#" === e[0] ? "x" === e[1] ? (e = e.substr(2), tt.test(e) && (t = String.fromCodePoint(parseInt(e, 16)))) : (e = e.substr(1), et.test(e) && (t = String.fromCodePoint(parseInt(e, 10)))) : t = Z[e];
                  break;
                }

                e += r;
              }

              return t || (this.state.pos = i, "&");
            }
          }, {
            key: "jsxReadWord",
            value: function jsxReadWord() {
              var t;
              var e = this.state.pos;

              do {
                t = this.input.charCodeAt(++this.state.pos);
              } while (O(t) || 45 === t);

              return this.finishToken(c.jsxName, this.input.slice(e, this.state.pos));
            }
          }, {
            key: "jsxParseIdentifier",
            value: function jsxParseIdentifier() {
              var t = this.startNode();
              return this.match(c.jsxName) ? t.name = this.state.value : this.state.type.keyword ? t.name = this.state.type.keyword : this.unexpected(), this.next(), this.finishNode(t, "JSXIdentifier");
            }
          }, {
            key: "jsxParseNamespacedName",
            value: function jsxParseNamespacedName() {
              var t = this.state.start,
                  e = this.state.startLoc,
                  s = this.jsxParseIdentifier();
              if (!this.eat(c.colon)) return s;
              var r = this.startNodeAt(t, e);
              return r.namespace = s, r.name = this.jsxParseIdentifier(), this.finishNode(r, "JSXNamespacedName");
            }
          }, {
            key: "jsxParseElementName",
            value: function jsxParseElementName() {
              var t = this.state.start,
                  e = this.state.startLoc;
              var s = this.jsxParseNamespacedName();
              if ("JSXNamespacedName" === s.type) return s;

              for (; this.eat(c.dot);) {
                var _r11 = this.startNodeAt(t, e);

                _r11.object = s, _r11.property = this.jsxParseIdentifier(), s = this.finishNode(_r11, "JSXMemberExpression");
              }

              return s;
            }
          }, {
            key: "jsxParseAttributeValue",
            value: function jsxParseAttributeValue() {
              var t;

              switch (this.state.type) {
                case c.braceL:
                  return t = this.startNode(), this.next(), t = this.jsxParseExpressionContainer(t), "JSXEmptyExpression" === t.expression.type && this.raise(t.start, st.AttributeIsEmpty), t;

                case c.jsxTagStart:
                case c.string:
                  return this.parseExprAtom();

                default:
                  throw this.raise(this.state.start, st.UnsupportedJsxValue);
              }
            }
          }, {
            key: "jsxParseEmptyExpression",
            value: function jsxParseEmptyExpression() {
              var t = this.startNodeAt(this.state.lastTokEnd, this.state.lastTokEndLoc);
              return this.finishNodeAt(t, "JSXEmptyExpression", this.state.start, this.state.startLoc);
            }
          }, {
            key: "jsxParseSpreadChild",
            value: function jsxParseSpreadChild(t) {
              return this.next(), t.expression = this.parseExpression(), this.expect(c.braceR), this.finishNode(t, "JSXSpreadChild");
            }
          }, {
            key: "jsxParseExpressionContainer",
            value: function jsxParseExpressionContainer(t) {
              return this.match(c.braceR) ? t.expression = this.jsxParseEmptyExpression() : t.expression = this.parseExpression(), this.expect(c.braceR), this.finishNode(t, "JSXExpressionContainer");
            }
          }, {
            key: "jsxParseAttribute",
            value: function jsxParseAttribute() {
              var t = this.startNode();
              return this.eat(c.braceL) ? (this.expect(c.ellipsis), t.argument = this.parseMaybeAssignAllowIn(), this.expect(c.braceR), this.finishNode(t, "JSXSpreadAttribute")) : (t.name = this.jsxParseNamespacedName(), t.value = this.eat(c.eq) ? this.jsxParseAttributeValue() : null, this.finishNode(t, "JSXAttribute"));
            }
          }, {
            key: "jsxParseOpeningElementAt",
            value: function jsxParseOpeningElementAt(t, e) {
              var s = this.startNodeAt(t, e);
              return this.match(c.jsxTagEnd) ? (this.expect(c.jsxTagEnd), this.finishNode(s, "JSXOpeningFragment")) : (s.name = this.jsxParseElementName(), this.jsxParseOpeningElementAfterName(s));
            }
          }, {
            key: "jsxParseOpeningElementAfterName",
            value: function jsxParseOpeningElementAfterName(t) {
              var e = [];

              for (; !this.match(c.slash) && !this.match(c.jsxTagEnd);) {
                e.push(this.jsxParseAttribute());
              }

              return t.attributes = e, t.selfClosing = this.eat(c.slash), this.expect(c.jsxTagEnd), this.finishNode(t, "JSXOpeningElement");
            }
          }, {
            key: "jsxParseClosingElementAt",
            value: function jsxParseClosingElementAt(t, e) {
              var s = this.startNodeAt(t, e);
              return this.match(c.jsxTagEnd) ? (this.expect(c.jsxTagEnd), this.finishNode(s, "JSXClosingFragment")) : (s.name = this.jsxParseElementName(), this.expect(c.jsxTagEnd), this.finishNode(s, "JSXClosingElement"));
            }
          }, {
            key: "jsxParseElementAt",
            value: function jsxParseElementAt(t, e) {
              var s = this.startNodeAt(t, e),
                  r = [],
                  i = this.jsxParseOpeningElementAt(t, e);
              var n = null;

              if (!i.selfClosing) {
                t: for (;;) {
                  switch (this.state.type) {
                    case c.jsxTagStart:
                      if (t = this.state.start, e = this.state.startLoc, this.next(), this.eat(c.slash)) {
                        n = this.jsxParseClosingElementAt(t, e);
                        break t;
                      }

                      r.push(this.jsxParseElementAt(t, e));
                      break;

                    case c.jsxText:
                      r.push(this.parseExprAtom());
                      break;

                    case c.braceL:
                      {
                        var _t16 = this.startNode();

                        this.next(), this.match(c.ellipsis) ? r.push(this.jsxParseSpreadChild(_t16)) : r.push(this.jsxParseExpressionContainer(_t16));
                        break;
                      }

                    default:
                      throw this.unexpected();
                  }
                }

                rt(i) && !rt(n) ? this.raise(n.start, st.MissingClosingTagFragment) : !rt(i) && rt(n) ? this.raise(n.start, st.MissingClosingTagElement, it(i.name)) : rt(i) || rt(n) || it(n.name) !== it(i.name) && this.raise(n.start, st.MissingClosingTagElement, it(i.name));
              }

              if (rt(i) ? (s.openingFragment = i, s.closingFragment = n) : (s.openingElement = i, s.closingElement = n), s.children = r, this.isRelational("<")) throw this.raise(this.state.start, st.UnwrappedAdjacentJSXElements);
              return rt(i) ? this.finishNode(s, "JSXFragment") : this.finishNode(s, "JSXElement");
            }
          }, {
            key: "jsxParseElement",
            value: function jsxParseElement() {
              var t = this.state.start,
                  e = this.state.startLoc;
              return this.next(), this.jsxParseElementAt(t, e);
            }
          }, {
            key: "parseExprAtom",
            value: function parseExprAtom(t) {
              return this.match(c.jsxText) ? this.parseLiteral(this.state.value, "JSXText") : this.match(c.jsxTagStart) ? this.jsxParseElement() : this.isRelational("<") && 33 !== this.input.charCodeAt(this.state.pos) ? (this.finishToken(c.jsxTagStart), this.jsxParseElement()) : _get(_getPrototypeOf(_class2.prototype), "parseExprAtom", this).call(this, t);
            }
          }, {
            key: "getTokenFromCode",
            value: function getTokenFromCode(t) {
              if (this.state.inPropertyName) return _get(_getPrototypeOf(_class2.prototype), "getTokenFromCode", this).call(this, t);
              var e = this.curContext();
              if (e === T.j_expr) return this.jsxReadToken();

              if (e === T.j_oTag || e === T.j_cTag) {
                if (L(t)) return this.jsxReadWord();
                if (62 === t) return ++this.state.pos, this.finishToken(c.jsxTagEnd);
                if ((34 === t || 39 === t) && e === T.j_oTag) return this.jsxReadString(t);
              }

              return 60 === t && this.state.exprAllowed && 33 !== this.input.charCodeAt(this.state.pos + 1) ? (++this.state.pos, this.finishToken(c.jsxTagStart)) : _get(_getPrototypeOf(_class2.prototype), "getTokenFromCode", this).call(this, t);
            }
          }, {
            key: "updateContext",
            value: function updateContext(t) {
              if (this.match(c.braceL)) {
                var _e15 = this.curContext();

                _e15 === T.j_oTag ? this.state.context.push(T.braceExpression) : _e15 === T.j_expr ? this.state.context.push(T.templateQuasi) : _get(_getPrototypeOf(_class2.prototype), "updateContext", this).call(this, t), this.state.exprAllowed = !0;
              } else {
                if (!this.match(c.slash) || t !== c.jsxTagStart) return _get(_getPrototypeOf(_class2.prototype), "updateContext", this).call(this, t);
                this.state.context.length -= 2, this.state.context.push(T.j_cTag), this.state.exprAllowed = !1;
              }
            }
          }]);

          return _class2;
        }(t);
      },
      flow: function flow(t) {
        return /*#__PURE__*/function (_t17) {
          _inherits(_class3, _t17);

          var _super5 = _createSuper(_class3);

          function _class3(t, e) {
            var _this4;

            _classCallCheck(this, _class3);

            _this4 = _super5.call(this, t, e), _this4.flowPragma = void 0, _this4.flowPragma = void 0;
            return _this4;
          }

          _createClass(_class3, [{
            key: "shouldParseTypes",
            value: function shouldParseTypes() {
              return this.getPluginOption("flow", "all") || "flow" === this.flowPragma;
            }
          }, {
            key: "shouldParseEnums",
            value: function shouldParseEnums() {
              return !!this.getPluginOption("flow", "enums");
            }
          }, {
            key: "finishToken",
            value: function finishToken(t, e) {
              return t !== c.string && t !== c.semi && t !== c.interpreterDirective && void 0 === this.flowPragma && (this.flowPragma = null), _get(_getPrototypeOf(_class3.prototype), "finishToken", this).call(this, t, e);
            }
          }, {
            key: "addComment",
            value: function addComment(t) {
              if (void 0 === this.flowPragma) {
                var _e16 = Q.exec(t.value);

                if (_e16) {
                  if ("flow" === _e16[1]) this.flowPragma = "flow";else {
                    if ("noflow" !== _e16[1]) throw new Error("Unexpected flow pragma");
                    this.flowPragma = "noflow";
                  }
                } else ;
              }

              return _get(_getPrototypeOf(_class3.prototype), "addComment", this).call(this, t);
            }
          }, {
            key: "flowParseTypeInitialiser",
            value: function flowParseTypeInitialiser(t) {
              var e = this.state.inType;
              this.state.inType = !0, this.expect(t || c.colon);
              var s = this.flowParseType();
              return this.state.inType = e, s;
            }
          }, {
            key: "flowParsePredicate",
            value: function flowParsePredicate() {
              var t = this.startNode(),
                  e = this.state.startLoc,
                  s = this.state.start;
              this.expect(c.modulo);
              var r = this.state.startLoc;
              return this.expectContextual("checks"), e.line === r.line && e.column === r.column - 1 || this.raise(s, K.UnexpectedSpaceBetweenModuloChecks), this.eat(c.parenL) ? (t.value = this.parseExpression(), this.expect(c.parenR), this.finishNode(t, "DeclaredPredicate")) : this.finishNode(t, "InferredPredicate");
            }
          }, {
            key: "flowParseTypeAndPredicateInitialiser",
            value: function flowParseTypeAndPredicateInitialiser() {
              var t = this.state.inType;
              this.state.inType = !0, this.expect(c.colon);
              var e = null,
                  s = null;
              return this.match(c.modulo) ? (this.state.inType = t, s = this.flowParsePredicate()) : (e = this.flowParseType(), this.state.inType = t, this.match(c.modulo) && (s = this.flowParsePredicate())), [e, s];
            }
          }, {
            key: "flowParseDeclareClass",
            value: function flowParseDeclareClass(t) {
              return this.next(), this.flowParseInterfaceish(t, !0), this.finishNode(t, "DeclareClass");
            }
          }, {
            key: "flowParseDeclareFunction",
            value: function flowParseDeclareFunction(t) {
              var _this$flowParseTypeAn, _this$flowParseTypeAn2;

              this.next();
              var e = t.id = this.parseIdentifier(),
                  s = this.startNode(),
                  r = this.startNode();
              this.isRelational("<") ? s.typeParameters = this.flowParseTypeParameterDeclaration() : s.typeParameters = null, this.expect(c.parenL);
              var i = this.flowParseFunctionTypeParams();
              return s.params = i.params, s.rest = i.rest, this.expect(c.parenR), (_this$flowParseTypeAn = this.flowParseTypeAndPredicateInitialiser(), _this$flowParseTypeAn2 = _slicedToArray(_this$flowParseTypeAn, 2), s.returnType = _this$flowParseTypeAn2[0], t.predicate = _this$flowParseTypeAn2[1], _this$flowParseTypeAn), r.typeAnnotation = this.finishNode(s, "FunctionTypeAnnotation"), e.typeAnnotation = this.finishNode(r, "TypeAnnotation"), this.resetEndLocation(e), this.semicolon(), this.finishNode(t, "DeclareFunction");
            }
          }, {
            key: "flowParseDeclare",
            value: function flowParseDeclare(t, e) {
              if (this.match(c._class)) return this.flowParseDeclareClass(t);
              if (this.match(c._function)) return this.flowParseDeclareFunction(t);
              if (this.match(c._var)) return this.flowParseDeclareVariable(t);
              if (this.eatContextual("module")) return this.match(c.dot) ? this.flowParseDeclareModuleExports(t) : (e && this.raise(this.state.lastTokStart, K.NestedDeclareModule), this.flowParseDeclareModule(t));
              if (this.isContextual("type")) return this.flowParseDeclareTypeAlias(t);
              if (this.isContextual("opaque")) return this.flowParseDeclareOpaqueType(t);
              if (this.isContextual("interface")) return this.flowParseDeclareInterface(t);
              if (this.match(c._export)) return this.flowParseDeclareExportDeclaration(t, e);
              throw this.unexpected();
            }
          }, {
            key: "flowParseDeclareVariable",
            value: function flowParseDeclareVariable(t) {
              return this.next(), t.id = this.flowParseTypeAnnotatableIdentifier(!0), this.scope.declareName(t.id.name, 5, t.id.start), this.semicolon(), this.finishNode(t, "DeclareVariable");
            }
          }, {
            key: "flowParseDeclareModule",
            value: function flowParseDeclareModule(t) {
              var _this5 = this;

              this.scope.enter(0), this.match(c.string) ? t.id = this.parseExprAtom() : t.id = this.parseIdentifier();
              var e = t.body = this.startNode(),
                  s = e.body = [];

              for (this.expect(c.braceL); !this.match(c.braceR);) {
                var _t18 = this.startNode();

                this.match(c._import) ? (this.next(), this.isContextual("type") || this.match(c._typeof) || this.raise(this.state.lastTokStart, K.InvalidNonTypeImportInDeclareModule), this.parseImport(_t18)) : (this.expectContextual("declare", K.UnsupportedStatementInDeclareModule), _t18 = this.flowParseDeclare(_t18, !0)), s.push(_t18);
              }

              this.scope.exit(), this.expect(c.braceR), this.finishNode(e, "BlockStatement");
              var r = null,
                  i = !1;
              return s.forEach(function (t) {
                !function (t) {
                  return "DeclareExportAllDeclaration" === t.type || "DeclareExportDeclaration" === t.type && (!t.declaration || "TypeAlias" !== t.declaration.type && "InterfaceDeclaration" !== t.declaration.type);
                }(t) ? "DeclareModuleExports" === t.type && (i && _this5.raise(t.start, K.DuplicateDeclareModuleExports), "ES" === r && _this5.raise(t.start, K.AmbiguousDeclareModuleKind), r = "CommonJS", i = !0) : ("CommonJS" === r && _this5.raise(t.start, K.AmbiguousDeclareModuleKind), r = "ES");
              }), t.kind = r || "CommonJS", this.finishNode(t, "DeclareModule");
            }
          }, {
            key: "flowParseDeclareExportDeclaration",
            value: function flowParseDeclareExportDeclaration(t, e) {
              if (this.expect(c._export), this.eat(c._default)) return this.match(c._function) || this.match(c._class) ? t.declaration = this.flowParseDeclare(this.startNode()) : (t.declaration = this.flowParseType(), this.semicolon()), t.default = !0, this.finishNode(t, "DeclareExportDeclaration");

              if (this.match(c._const) || this.isLet() || (this.isContextual("type") || this.isContextual("interface")) && !e) {
                var _t19 = this.state.value,
                    _e17 = Y[_t19];
                throw this.raise(this.state.start, K.UnsupportedDeclareExportKind, _t19, _e17);
              }

              if (this.match(c._var) || this.match(c._function) || this.match(c._class) || this.isContextual("opaque")) return t.declaration = this.flowParseDeclare(this.startNode()), t.default = !1, this.finishNode(t, "DeclareExportDeclaration");
              if (this.match(c.star) || this.match(c.braceL) || this.isContextual("interface") || this.isContextual("type") || this.isContextual("opaque")) return "ExportNamedDeclaration" === (t = this.parseExport(t)).type && (t.type = "ExportDeclaration", t.default = !1, delete t.exportKind), t.type = "Declare" + t.type, t;
              throw this.unexpected();
            }
          }, {
            key: "flowParseDeclareModuleExports",
            value: function flowParseDeclareModuleExports(t) {
              return this.next(), this.expectContextual("exports"), t.typeAnnotation = this.flowParseTypeAnnotation(), this.semicolon(), this.finishNode(t, "DeclareModuleExports");
            }
          }, {
            key: "flowParseDeclareTypeAlias",
            value: function flowParseDeclareTypeAlias(t) {
              return this.next(), this.flowParseTypeAlias(t), t.type = "DeclareTypeAlias", t;
            }
          }, {
            key: "flowParseDeclareOpaqueType",
            value: function flowParseDeclareOpaqueType(t) {
              return this.next(), this.flowParseOpaqueType(t, !0), t.type = "DeclareOpaqueType", t;
            }
          }, {
            key: "flowParseDeclareInterface",
            value: function flowParseDeclareInterface(t) {
              return this.next(), this.flowParseInterfaceish(t), this.finishNode(t, "DeclareInterface");
            }
          }, {
            key: "flowParseInterfaceish",
            value: function flowParseInterfaceish(t) {
              var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
              if (t.id = this.flowParseRestrictedIdentifier(!e, !0), this.scope.declareName(t.id.name, e ? 17 : 9, t.id.start), this.isRelational("<") ? t.typeParameters = this.flowParseTypeParameterDeclaration() : t.typeParameters = null, t.extends = [], t.implements = [], t.mixins = [], this.eat(c._extends)) do {
                t.extends.push(this.flowParseInterfaceExtends());
              } while (!e && this.eat(c.comma));

              if (this.isContextual("mixins")) {
                this.next();

                do {
                  t.mixins.push(this.flowParseInterfaceExtends());
                } while (this.eat(c.comma));
              }

              if (this.isContextual("implements")) {
                this.next();

                do {
                  t.implements.push(this.flowParseInterfaceExtends());
                } while (this.eat(c.comma));
              }

              t.body = this.flowParseObjectType({
                allowStatic: e,
                allowExact: !1,
                allowSpread: !1,
                allowProto: e,
                allowInexact: !1
              });
            }
          }, {
            key: "flowParseInterfaceExtends",
            value: function flowParseInterfaceExtends() {
              var t = this.startNode();
              return t.id = this.flowParseQualifiedTypeIdentifier(), this.isRelational("<") ? t.typeParameters = this.flowParseTypeParameterInstantiation() : t.typeParameters = null, this.finishNode(t, "InterfaceExtends");
            }
          }, {
            key: "flowParseInterface",
            value: function flowParseInterface(t) {
              return this.flowParseInterfaceish(t), this.finishNode(t, "InterfaceDeclaration");
            }
          }, {
            key: "checkNotUnderscore",
            value: function checkNotUnderscore(t) {
              "_" === t && this.raise(this.state.start, K.UnexpectedReservedUnderscore);
            }
          }, {
            key: "checkReservedType",
            value: function checkReservedType(t, e, s) {
              G.has(t) && this.raise(e, s ? K.AssignReservedType : K.UnexpectedReservedType, t);
            }
          }, {
            key: "flowParseRestrictedIdentifier",
            value: function flowParseRestrictedIdentifier(t, e) {
              return this.checkReservedType(this.state.value, this.state.start, e), this.parseIdentifier(t);
            }
          }, {
            key: "flowParseTypeAlias",
            value: function flowParseTypeAlias(t) {
              return t.id = this.flowParseRestrictedIdentifier(!1, !0), this.scope.declareName(t.id.name, 9, t.id.start), this.isRelational("<") ? t.typeParameters = this.flowParseTypeParameterDeclaration() : t.typeParameters = null, t.right = this.flowParseTypeInitialiser(c.eq), this.semicolon(), this.finishNode(t, "TypeAlias");
            }
          }, {
            key: "flowParseOpaqueType",
            value: function flowParseOpaqueType(t, e) {
              return this.expectContextual("type"), t.id = this.flowParseRestrictedIdentifier(!0, !0), this.scope.declareName(t.id.name, 9, t.id.start), this.isRelational("<") ? t.typeParameters = this.flowParseTypeParameterDeclaration() : t.typeParameters = null, t.supertype = null, this.match(c.colon) && (t.supertype = this.flowParseTypeInitialiser(c.colon)), t.impltype = null, e || (t.impltype = this.flowParseTypeInitialiser(c.eq)), this.semicolon(), this.finishNode(t, "OpaqueType");
            }
          }, {
            key: "flowParseTypeParameter",
            value: function flowParseTypeParameter() {
              var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
              var e = this.state.start,
                  s = this.startNode(),
                  r = this.flowParseVariance(),
                  i = this.flowParseTypeAnnotatableIdentifier();
              return s.name = i.name, s.variance = r, s.bound = i.typeAnnotation, this.match(c.eq) ? (this.eat(c.eq), s.default = this.flowParseType()) : t && this.raise(e, K.MissingTypeParamDefault), this.finishNode(s, "TypeParameter");
            }
          }, {
            key: "flowParseTypeParameterDeclaration",
            value: function flowParseTypeParameterDeclaration() {
              var t = this.state.inType,
                  e = this.startNode();
              e.params = [], this.state.inType = !0, this.isRelational("<") || this.match(c.jsxTagStart) ? this.next() : this.unexpected();
              var s = !1;

              do {
                var _t20 = this.flowParseTypeParameter(s);

                e.params.push(_t20), _t20.default && (s = !0), this.isRelational(">") || this.expect(c.comma);
              } while (!this.isRelational(">"));

              return this.expectRelational(">"), this.state.inType = t, this.finishNode(e, "TypeParameterDeclaration");
            }
          }, {
            key: "flowParseTypeParameterInstantiation",
            value: function flowParseTypeParameterInstantiation() {
              var t = this.startNode(),
                  e = this.state.inType;
              t.params = [], this.state.inType = !0, this.expectRelational("<");
              var s = this.state.noAnonFunctionType;

              for (this.state.noAnonFunctionType = !1; !this.isRelational(">");) {
                t.params.push(this.flowParseType()), this.isRelational(">") || this.expect(c.comma);
              }

              return this.state.noAnonFunctionType = s, this.expectRelational(">"), this.state.inType = e, this.finishNode(t, "TypeParameterInstantiation");
            }
          }, {
            key: "flowParseTypeParameterInstantiationCallOrNew",
            value: function flowParseTypeParameterInstantiationCallOrNew() {
              var t = this.startNode(),
                  e = this.state.inType;

              for (t.params = [], this.state.inType = !0, this.expectRelational("<"); !this.isRelational(">");) {
                t.params.push(this.flowParseTypeOrImplicitInstantiation()), this.isRelational(">") || this.expect(c.comma);
              }

              return this.expectRelational(">"), this.state.inType = e, this.finishNode(t, "TypeParameterInstantiation");
            }
          }, {
            key: "flowParseInterfaceType",
            value: function flowParseInterfaceType() {
              var t = this.startNode();
              if (this.expectContextual("interface"), t.extends = [], this.eat(c._extends)) do {
                t.extends.push(this.flowParseInterfaceExtends());
              } while (this.eat(c.comma));
              return t.body = this.flowParseObjectType({
                allowStatic: !1,
                allowExact: !1,
                allowSpread: !1,
                allowProto: !1,
                allowInexact: !1
              }), this.finishNode(t, "InterfaceTypeAnnotation");
            }
          }, {
            key: "flowParseObjectPropertyKey",
            value: function flowParseObjectPropertyKey() {
              return this.match(c.num) || this.match(c.string) ? this.parseExprAtom() : this.parseIdentifier(!0);
            }
          }, {
            key: "flowParseObjectTypeIndexer",
            value: function flowParseObjectTypeIndexer(t, e, s) {
              return t.static = e, this.lookahead().type === c.colon ? (t.id = this.flowParseObjectPropertyKey(), t.key = this.flowParseTypeInitialiser()) : (t.id = null, t.key = this.flowParseType()), this.expect(c.bracketR), t.value = this.flowParseTypeInitialiser(), t.variance = s, this.finishNode(t, "ObjectTypeIndexer");
            }
          }, {
            key: "flowParseObjectTypeInternalSlot",
            value: function flowParseObjectTypeInternalSlot(t, e) {
              return t.static = e, t.id = this.flowParseObjectPropertyKey(), this.expect(c.bracketR), this.expect(c.bracketR), this.isRelational("<") || this.match(c.parenL) ? (t.method = !0, t.optional = !1, t.value = this.flowParseObjectTypeMethodish(this.startNodeAt(t.start, t.loc.start))) : (t.method = !1, this.eat(c.question) && (t.optional = !0), t.value = this.flowParseTypeInitialiser()), this.finishNode(t, "ObjectTypeInternalSlot");
            }
          }, {
            key: "flowParseObjectTypeMethodish",
            value: function flowParseObjectTypeMethodish(t) {
              for (t.params = [], t.rest = null, t.typeParameters = null, this.isRelational("<") && (t.typeParameters = this.flowParseTypeParameterDeclaration()), this.expect(c.parenL); !this.match(c.parenR) && !this.match(c.ellipsis);) {
                t.params.push(this.flowParseFunctionTypeParam()), this.match(c.parenR) || this.expect(c.comma);
              }

              return this.eat(c.ellipsis) && (t.rest = this.flowParseFunctionTypeParam()), this.expect(c.parenR), t.returnType = this.flowParseTypeInitialiser(), this.finishNode(t, "FunctionTypeAnnotation");
            }
          }, {
            key: "flowParseObjectTypeCallProperty",
            value: function flowParseObjectTypeCallProperty(t, e) {
              var s = this.startNode();
              return t.static = e, t.value = this.flowParseObjectTypeMethodish(s), this.finishNode(t, "ObjectTypeCallProperty");
            }
          }, {
            key: "flowParseObjectType",
            value: function flowParseObjectType(_ref13) {
              var t = _ref13.allowStatic,
                  e = _ref13.allowExact,
                  s = _ref13.allowSpread,
                  r = _ref13.allowProto,
                  i = _ref13.allowInexact;
              var n = this.state.inType;
              this.state.inType = !0;
              var a = this.startNode();
              var o, u;
              a.callProperties = [], a.properties = [], a.indexers = [], a.internalSlots = [];
              var h = !1;

              for (e && this.match(c.braceBarL) ? (this.expect(c.braceBarL), o = c.braceBarR, u = !0) : (this.expect(c.braceL), o = c.braceR, u = !1), a.exact = u; !this.match(o);) {
                var _e18 = !1,
                    _n2 = null,
                    _o = null;

                var _p = this.startNode();

                if (r && this.isContextual("proto")) {
                  var _e19 = this.lookahead();

                  _e19.type !== c.colon && _e19.type !== c.question && (this.next(), _n2 = this.state.start, t = !1);
                }

                if (t && this.isContextual("static")) {
                  var _t21 = this.lookahead();

                  _t21.type !== c.colon && _t21.type !== c.question && (this.next(), _e18 = !0);
                }

                var _l = this.flowParseVariance();

                if (this.eat(c.bracketL)) null != _n2 && this.unexpected(_n2), this.eat(c.bracketL) ? (_l && this.unexpected(_l.start), a.internalSlots.push(this.flowParseObjectTypeInternalSlot(_p, _e18))) : a.indexers.push(this.flowParseObjectTypeIndexer(_p, _e18, _l));else if (this.match(c.parenL) || this.isRelational("<")) null != _n2 && this.unexpected(_n2), _l && this.unexpected(_l.start), a.callProperties.push(this.flowParseObjectTypeCallProperty(_p, _e18));else {
                  var _t22 = "init";

                  if (this.isContextual("get") || this.isContextual("set")) {
                    var _e20 = this.lookahead();

                    _e20.type !== c.name && _e20.type !== c.string && _e20.type !== c.num || (_t22 = this.state.value, this.next());
                  }

                  var _r12 = this.flowParseObjectTypeProperty(_p, _e18, _n2, _l, _t22, s, null != i ? i : !u);

                  null === _r12 ? (h = !0, _o = this.state.lastTokStart) : a.properties.push(_r12);
                }
                this.flowObjectTypeSemicolon(), !_o || this.match(c.braceR) || this.match(c.braceBarR) || this.raise(_o, K.UnexpectedExplicitInexactInObject);
              }

              this.expect(o), s && (a.inexact = h);
              var p = this.finishNode(a, "ObjectTypeAnnotation");
              return this.state.inType = n, p;
            }
          }, {
            key: "flowParseObjectTypeProperty",
            value: function flowParseObjectTypeProperty(t, e, s, r, i, n, a) {
              if (this.eat(c.ellipsis)) {
                return this.match(c.comma) || this.match(c.semi) || this.match(c.braceR) || this.match(c.braceBarR) ? (n ? a || this.raise(this.state.lastTokStart, K.InexactInsideExact) : this.raise(this.state.lastTokStart, K.InexactInsideNonObject), r && this.raise(r.start, K.InexactVariance), null) : (n || this.raise(this.state.lastTokStart, K.UnexpectedSpreadType), null != s && this.unexpected(s), r && this.raise(r.start, K.SpreadVariance), t.argument = this.flowParseType(), this.finishNode(t, "ObjectTypeSpreadProperty"));
              }

              {
                t.key = this.flowParseObjectPropertyKey(), t.static = e, t.proto = null != s, t.kind = i;

                var _n3 = !1;

                return this.isRelational("<") || this.match(c.parenL) ? (t.method = !0, null != s && this.unexpected(s), r && this.unexpected(r.start), t.value = this.flowParseObjectTypeMethodish(this.startNodeAt(t.start, t.loc.start)), "get" !== i && "set" !== i || this.flowCheckGetterSetterParams(t)) : ("init" !== i && this.unexpected(), t.method = !1, this.eat(c.question) && (_n3 = !0), t.value = this.flowParseTypeInitialiser(), t.variance = r), t.optional = _n3, this.finishNode(t, "ObjectTypeProperty");
              }
            }
          }, {
            key: "flowCheckGetterSetterParams",
            value: function flowCheckGetterSetterParams(t) {
              var e = "get" === t.kind ? 0 : 1,
                  s = t.start;
              t.value.params.length + (t.value.rest ? 1 : 0) !== e && ("get" === t.kind ? this.raise(s, g.BadGetterArity) : this.raise(s, g.BadSetterArity)), "set" === t.kind && t.value.rest && this.raise(s, g.BadSetterRestParameter);
            }
          }, {
            key: "flowObjectTypeSemicolon",
            value: function flowObjectTypeSemicolon() {
              this.eat(c.semi) || this.eat(c.comma) || this.match(c.braceR) || this.match(c.braceBarR) || this.unexpected();
            }
          }, {
            key: "flowParseQualifiedTypeIdentifier",
            value: function flowParseQualifiedTypeIdentifier(t, e, s) {
              t = t || this.state.start, e = e || this.state.startLoc;
              var r = s || this.flowParseRestrictedIdentifier(!0);

              for (; this.eat(c.dot);) {
                var _s13 = this.startNodeAt(t, e);

                _s13.qualification = r, _s13.id = this.flowParseRestrictedIdentifier(!0), r = this.finishNode(_s13, "QualifiedTypeIdentifier");
              }

              return r;
            }
          }, {
            key: "flowParseGenericType",
            value: function flowParseGenericType(t, e, s) {
              var r = this.startNodeAt(t, e);
              return r.typeParameters = null, r.id = this.flowParseQualifiedTypeIdentifier(t, e, s), this.isRelational("<") && (r.typeParameters = this.flowParseTypeParameterInstantiation()), this.finishNode(r, "GenericTypeAnnotation");
            }
          }, {
            key: "flowParseTypeofType",
            value: function flowParseTypeofType() {
              var t = this.startNode();
              return this.expect(c._typeof), t.argument = this.flowParsePrimaryType(), this.finishNode(t, "TypeofTypeAnnotation");
            }
          }, {
            key: "flowParseTupleType",
            value: function flowParseTupleType() {
              var t = this.startNode();

              for (t.types = [], this.expect(c.bracketL); this.state.pos < this.length && !this.match(c.bracketR) && (t.types.push(this.flowParseType()), !this.match(c.bracketR));) {
                this.expect(c.comma);
              }

              return this.expect(c.bracketR), this.finishNode(t, "TupleTypeAnnotation");
            }
          }, {
            key: "flowParseFunctionTypeParam",
            value: function flowParseFunctionTypeParam() {
              var t = null,
                  e = !1,
                  s = null;
              var r = this.startNode(),
                  i = this.lookahead();
              return i.type === c.colon || i.type === c.question ? (t = this.parseIdentifier(), this.eat(c.question) && (e = !0), s = this.flowParseTypeInitialiser()) : s = this.flowParseType(), r.name = t, r.optional = e, r.typeAnnotation = s, this.finishNode(r, "FunctionTypeParam");
            }
          }, {
            key: "reinterpretTypeAsFunctionTypeParam",
            value: function reinterpretTypeAsFunctionTypeParam(t) {
              var e = this.startNodeAt(t.start, t.loc.start);
              return e.name = null, e.optional = !1, e.typeAnnotation = t, this.finishNode(e, "FunctionTypeParam");
            }
          }, {
            key: "flowParseFunctionTypeParams",
            value: function flowParseFunctionTypeParams() {
              var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
              var e = null;

              for (; !this.match(c.parenR) && !this.match(c.ellipsis);) {
                t.push(this.flowParseFunctionTypeParam()), this.match(c.parenR) || this.expect(c.comma);
              }

              return this.eat(c.ellipsis) && (e = this.flowParseFunctionTypeParam()), {
                params: t,
                rest: e
              };
            }
          }, {
            key: "flowIdentToTypeAnnotation",
            value: function flowIdentToTypeAnnotation(t, e, s, r) {
              switch (r.name) {
                case "any":
                  return this.finishNode(s, "AnyTypeAnnotation");

                case "bool":
                case "boolean":
                  return this.finishNode(s, "BooleanTypeAnnotation");

                case "mixed":
                  return this.finishNode(s, "MixedTypeAnnotation");

                case "empty":
                  return this.finishNode(s, "EmptyTypeAnnotation");

                case "number":
                  return this.finishNode(s, "NumberTypeAnnotation");

                case "string":
                  return this.finishNode(s, "StringTypeAnnotation");

                case "symbol":
                  return this.finishNode(s, "SymbolTypeAnnotation");

                default:
                  return this.checkNotUnderscore(r.name), this.flowParseGenericType(t, e, r);
              }
            }
          }, {
            key: "flowParsePrimaryType",
            value: function flowParsePrimaryType() {
              var t = this.state.start,
                  e = this.state.startLoc,
                  s = this.startNode();
              var r,
                  i,
                  n = !1;
              var a = this.state.noAnonFunctionType;

              switch (this.state.type) {
                case c.name:
                  return this.isContextual("interface") ? this.flowParseInterfaceType() : this.flowIdentToTypeAnnotation(t, e, s, this.parseIdentifier());

                case c.braceL:
                  return this.flowParseObjectType({
                    allowStatic: !1,
                    allowExact: !1,
                    allowSpread: !0,
                    allowProto: !1,
                    allowInexact: !0
                  });

                case c.braceBarL:
                  return this.flowParseObjectType({
                    allowStatic: !1,
                    allowExact: !0,
                    allowSpread: !0,
                    allowProto: !1,
                    allowInexact: !1
                  });

                case c.bracketL:
                  return this.state.noAnonFunctionType = !1, i = this.flowParseTupleType(), this.state.noAnonFunctionType = a, i;

                case c.relational:
                  if ("<" === this.state.value) return s.typeParameters = this.flowParseTypeParameterDeclaration(), this.expect(c.parenL), r = this.flowParseFunctionTypeParams(), s.params = r.params, s.rest = r.rest, this.expect(c.parenR), this.expect(c.arrow), s.returnType = this.flowParseType(), this.finishNode(s, "FunctionTypeAnnotation");
                  break;

                case c.parenL:
                  if (this.next(), !this.match(c.parenR) && !this.match(c.ellipsis)) if (this.match(c.name)) {
                    var _t23 = this.lookahead().type;
                    n = _t23 !== c.question && _t23 !== c.colon;
                  } else n = !0;

                  if (n) {
                    if (this.state.noAnonFunctionType = !1, i = this.flowParseType(), this.state.noAnonFunctionType = a, this.state.noAnonFunctionType || !(this.match(c.comma) || this.match(c.parenR) && this.lookahead().type === c.arrow)) return this.expect(c.parenR), i;
                    this.eat(c.comma);
                  }

                  return r = i ? this.flowParseFunctionTypeParams([this.reinterpretTypeAsFunctionTypeParam(i)]) : this.flowParseFunctionTypeParams(), s.params = r.params, s.rest = r.rest, this.expect(c.parenR), this.expect(c.arrow), s.returnType = this.flowParseType(), s.typeParameters = null, this.finishNode(s, "FunctionTypeAnnotation");

                case c.string:
                  return this.parseLiteral(this.state.value, "StringLiteralTypeAnnotation");

                case c._true:
                case c._false:
                  return s.value = this.match(c._true), this.next(), this.finishNode(s, "BooleanLiteralTypeAnnotation");

                case c.plusMin:
                  if ("-" === this.state.value) {
                    if (this.next(), this.match(c.num)) return this.parseLiteral(-this.state.value, "NumberLiteralTypeAnnotation", s.start, s.loc.start);
                    if (this.match(c.bigint)) return this.parseLiteral(-this.state.value, "BigIntLiteralTypeAnnotation", s.start, s.loc.start);
                    throw this.raise(this.state.start, K.UnexpectedSubtractionOperand);
                  }

                  throw this.unexpected();

                case c.num:
                  return this.parseLiteral(this.state.value, "NumberLiteralTypeAnnotation");

                case c.bigint:
                  return this.parseLiteral(this.state.value, "BigIntLiteralTypeAnnotation");

                case c._void:
                  return this.next(), this.finishNode(s, "VoidTypeAnnotation");

                case c._null:
                  return this.next(), this.finishNode(s, "NullLiteralTypeAnnotation");

                case c._this:
                  return this.next(), this.finishNode(s, "ThisTypeAnnotation");

                case c.star:
                  return this.next(), this.finishNode(s, "ExistsTypeAnnotation");

                default:
                  if ("typeof" === this.state.type.keyword) return this.flowParseTypeofType();

                  if (this.state.type.keyword) {
                    var _t24 = this.state.type.label;
                    return this.next(), _get(_getPrototypeOf(_class3.prototype), "createIdentifier", this).call(this, s, _t24);
                  }

              }

              throw this.unexpected();
            }
          }, {
            key: "flowParsePostfixType",
            value: function flowParsePostfixType() {
              var t = this.state.start,
                  e = this.state.startLoc;
              var s = this.flowParsePrimaryType();

              for (; this.match(c.bracketL) && !this.canInsertSemicolon();) {
                var _r13 = this.startNodeAt(t, e);

                _r13.elementType = s, this.expect(c.bracketL), this.expect(c.bracketR), s = this.finishNode(_r13, "ArrayTypeAnnotation");
              }

              return s;
            }
          }, {
            key: "flowParsePrefixType",
            value: function flowParsePrefixType() {
              var t = this.startNode();
              return this.eat(c.question) ? (t.typeAnnotation = this.flowParsePrefixType(), this.finishNode(t, "NullableTypeAnnotation")) : this.flowParsePostfixType();
            }
          }, {
            key: "flowParseAnonFunctionWithoutParens",
            value: function flowParseAnonFunctionWithoutParens() {
              var t = this.flowParsePrefixType();

              if (!this.state.noAnonFunctionType && this.eat(c.arrow)) {
                var _e21 = this.startNodeAt(t.start, t.loc.start);

                return _e21.params = [this.reinterpretTypeAsFunctionTypeParam(t)], _e21.rest = null, _e21.returnType = this.flowParseType(), _e21.typeParameters = null, this.finishNode(_e21, "FunctionTypeAnnotation");
              }

              return t;
            }
          }, {
            key: "flowParseIntersectionType",
            value: function flowParseIntersectionType() {
              var t = this.startNode();
              this.eat(c.bitwiseAND);
              var e = this.flowParseAnonFunctionWithoutParens();

              for (t.types = [e]; this.eat(c.bitwiseAND);) {
                t.types.push(this.flowParseAnonFunctionWithoutParens());
              }

              return 1 === t.types.length ? e : this.finishNode(t, "IntersectionTypeAnnotation");
            }
          }, {
            key: "flowParseUnionType",
            value: function flowParseUnionType() {
              var t = this.startNode();
              this.eat(c.bitwiseOR);
              var e = this.flowParseIntersectionType();

              for (t.types = [e]; this.eat(c.bitwiseOR);) {
                t.types.push(this.flowParseIntersectionType());
              }

              return 1 === t.types.length ? e : this.finishNode(t, "UnionTypeAnnotation");
            }
          }, {
            key: "flowParseType",
            value: function flowParseType() {
              var t = this.state.inType;
              this.state.inType = !0;
              var e = this.flowParseUnionType();
              return this.state.inType = t, this.state.exprAllowed = this.state.exprAllowed || this.state.noAnonFunctionType, e;
            }
          }, {
            key: "flowParseTypeOrImplicitInstantiation",
            value: function flowParseTypeOrImplicitInstantiation() {
              if (this.state.type === c.name && "_" === this.state.value) {
                var _t25 = this.state.start,
                    _e22 = this.state.startLoc,
                    _s14 = this.parseIdentifier();

                return this.flowParseGenericType(_t25, _e22, _s14);
              }

              return this.flowParseType();
            }
          }, {
            key: "flowParseTypeAnnotation",
            value: function flowParseTypeAnnotation() {
              var t = this.startNode();
              return t.typeAnnotation = this.flowParseTypeInitialiser(), this.finishNode(t, "TypeAnnotation");
            }
          }, {
            key: "flowParseTypeAnnotatableIdentifier",
            value: function flowParseTypeAnnotatableIdentifier(t) {
              var e = t ? this.parseIdentifier() : this.flowParseRestrictedIdentifier();
              return this.match(c.colon) && (e.typeAnnotation = this.flowParseTypeAnnotation(), this.resetEndLocation(e)), e;
            }
          }, {
            key: "typeCastToParameter",
            value: function typeCastToParameter(t) {
              return t.expression.typeAnnotation = t.typeAnnotation, this.resetEndLocation(t.expression, t.typeAnnotation.end, t.typeAnnotation.loc.end), t.expression;
            }
          }, {
            key: "flowParseVariance",
            value: function flowParseVariance() {
              var t = null;
              return this.match(c.plusMin) && (t = this.startNode(), "+" === this.state.value ? t.kind = "plus" : t.kind = "minus", this.next(), this.finishNode(t, "Variance")), t;
            }
          }, {
            key: "parseFunctionBody",
            value: function parseFunctionBody(t, e) {
              var _this6 = this;

              var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
              return e ? this.forwardNoArrowParamsConversionAt(t, function () {
                return _get(_getPrototypeOf(_class3.prototype), "parseFunctionBody", _this6).call(_this6, t, !0, s);
              }) : _get(_getPrototypeOf(_class3.prototype), "parseFunctionBody", this).call(this, t, !1, s);
            }
          }, {
            key: "parseFunctionBodyAndFinish",
            value: function parseFunctionBodyAndFinish(t, e) {
              var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;

              if (this.match(c.colon)) {
                var _this$flowParseTypeAn3, _this$flowParseTypeAn4;

                var _e23 = this.startNode();

                (_this$flowParseTypeAn3 = this.flowParseTypeAndPredicateInitialiser(), _this$flowParseTypeAn4 = _slicedToArray(_this$flowParseTypeAn3, 2), _e23.typeAnnotation = _this$flowParseTypeAn4[0], t.predicate = _this$flowParseTypeAn4[1], _this$flowParseTypeAn3), t.returnType = _e23.typeAnnotation ? this.finishNode(_e23, "TypeAnnotation") : null;
              }

              _get(_getPrototypeOf(_class3.prototype), "parseFunctionBodyAndFinish", this).call(this, t, e, s);
            }
          }, {
            key: "parseStatement",
            value: function parseStatement(t, e) {
              if (this.state.strict && this.match(c.name) && "interface" === this.state.value) {
                var _t26 = this.lookahead();

                if (_t26.type === c.name || W(_t26.value)) {
                  var _t27 = this.startNode();

                  return this.next(), this.flowParseInterface(_t27);
                }
              } else if (this.shouldParseEnums() && this.isContextual("enum")) {
                var _t28 = this.startNode();

                return this.next(), this.flowParseEnumDeclaration(_t28);
              }

              var s = _get(_getPrototypeOf(_class3.prototype), "parseStatement", this).call(this, t, e);

              return void 0 !== this.flowPragma || this.isValidDirective(s) || (this.flowPragma = null), s;
            }
          }, {
            key: "parseExpressionStatement",
            value: function parseExpressionStatement(t, e) {
              if ("Identifier" === e.type) if ("declare" === e.name) {
                if (this.match(c._class) || this.match(c.name) || this.match(c._function) || this.match(c._var) || this.match(c._export)) return this.flowParseDeclare(t);
              } else if (this.match(c.name)) {
                if ("interface" === e.name) return this.flowParseInterface(t);
                if ("type" === e.name) return this.flowParseTypeAlias(t);
                if ("opaque" === e.name) return this.flowParseOpaqueType(t, !1);
              }
              return _get(_getPrototypeOf(_class3.prototype), "parseExpressionStatement", this).call(this, t, e);
            }
          }, {
            key: "shouldParseExportDeclaration",
            value: function shouldParseExportDeclaration() {
              return this.isContextual("type") || this.isContextual("interface") || this.isContextual("opaque") || this.shouldParseEnums() && this.isContextual("enum") || _get(_getPrototypeOf(_class3.prototype), "shouldParseExportDeclaration", this).call(this);
            }
          }, {
            key: "isExportDefaultSpecifier",
            value: function isExportDefaultSpecifier() {
              return (!this.match(c.name) || !("type" === this.state.value || "interface" === this.state.value || "opaque" === this.state.value || this.shouldParseEnums() && "enum" === this.state.value)) && _get(_getPrototypeOf(_class3.prototype), "isExportDefaultSpecifier", this).call(this);
            }
          }, {
            key: "parseExportDefaultExpression",
            value: function parseExportDefaultExpression() {
              if (this.shouldParseEnums() && this.isContextual("enum")) {
                var _t29 = this.startNode();

                return this.next(), this.flowParseEnumDeclaration(_t29);
              }

              return _get(_getPrototypeOf(_class3.prototype), "parseExportDefaultExpression", this).call(this);
            }
          }, {
            key: "parseConditional",
            value: function parseConditional(t, e, s, r) {
              var _this7 = this;

              if (!this.match(c.question)) return t;

              if (r) {
                var _i11 = this.tryParse(function () {
                  return _get(_getPrototypeOf(_class3.prototype), "parseConditional", _this7).call(_this7, t, e, s);
                });

                return _i11.node ? (_i11.error && (this.state = _i11.failState), _i11.node) : (r.start = _i11.error.pos || this.state.start, t);
              }

              this.expect(c.question);
              var i = this.state.clone(),
                  n = this.state.noArrowAt,
                  a = this.startNodeAt(e, s);

              var _this$tryParseConditi = this.tryParseConditionalConsequent(),
                  o = _this$tryParseConditi.consequent,
                  u = _this$tryParseConditi.failed,
                  _this$getArrowLikeExp = this.getArrowLikeExpressions(o),
                  _this$getArrowLikeExp2 = _slicedToArray(_this$getArrowLikeExp, 2),
                  h = _this$getArrowLikeExp2[0],
                  p = _this$getArrowLikeExp2[1];

              if (u || p.length > 0) {
                var _this$tryParseConditi3;

                var _t30 = _toConsumableArray(n);

                if (p.length > 0) {
                  var _this$tryParseConditi2, _this$getArrowLikeExp3, _this$getArrowLikeExp4;

                  this.state = i, this.state.noArrowAt = _t30;

                  for (var _e24 = 0; _e24 < p.length; _e24++) {
                    _t30.push(p[_e24].start);
                  }

                  (_this$tryParseConditi2 = this.tryParseConditionalConsequent(), o = _this$tryParseConditi2.consequent, u = _this$tryParseConditi2.failed, _this$tryParseConditi2), (_this$getArrowLikeExp3 = this.getArrowLikeExpressions(o), _this$getArrowLikeExp4 = _slicedToArray(_this$getArrowLikeExp3, 2), h = _this$getArrowLikeExp4[0], p = _this$getArrowLikeExp4[1], _this$getArrowLikeExp3);
                }

                u && h.length > 1 && this.raise(i.start, K.AmbiguousConditionalArrow), u && 1 === h.length && (this.state = i, this.state.noArrowAt = _t30.concat(h[0].start), (_this$tryParseConditi3 = this.tryParseConditionalConsequent(), o = _this$tryParseConditi3.consequent, u = _this$tryParseConditi3.failed, _this$tryParseConditi3));
              }

              return this.getArrowLikeExpressions(o, !0), this.state.noArrowAt = n, this.expect(c.colon), a.test = t, a.consequent = o, a.alternate = this.forwardNoArrowParamsConversionAt(a, function () {
                return _this7.parseMaybeAssign(void 0, void 0, void 0);
              }), this.finishNode(a, "ConditionalExpression");
            }
          }, {
            key: "tryParseConditionalConsequent",
            value: function tryParseConditionalConsequent() {
              this.state.noArrowParamsConversionAt.push(this.state.start);
              var t = this.parseMaybeAssignAllowIn(),
                  e = !this.match(c.colon);
              return this.state.noArrowParamsConversionAt.pop(), {
                consequent: t,
                failed: e
              };
            }
          }, {
            key: "getArrowLikeExpressions",
            value: function getArrowLikeExpressions(t, e) {
              var _this8 = this;

              var s = [t],
                  r = [];

              for (; 0 !== s.length;) {
                var _t31 = s.pop();

                "ArrowFunctionExpression" === _t31.type ? (_t31.typeParameters || !_t31.returnType ? this.finishArrowValidation(_t31) : r.push(_t31), s.push(_t31.body)) : "ConditionalExpression" === _t31.type && (s.push(_t31.consequent), s.push(_t31.alternate));
              }

              return e ? (r.forEach(function (t) {
                return _this8.finishArrowValidation(t);
              }), [r, []]) : function (t, e) {
                var s = [],
                    r = [];

                for (var _i12 = 0; _i12 < t.length; _i12++) {
                  (e(t[_i12], _i12, t) ? s : r).push(t[_i12]);
                }

                return [s, r];
              }(r, function (t) {
                return t.params.every(function (t) {
                  return _this8.isAssignable(t, !0);
                });
              });
            }
          }, {
            key: "finishArrowValidation",
            value: function finishArrowValidation(t) {
              var e;
              this.toAssignableList(t.params, null == (e = t.extra) ? void 0 : e.trailingComma), this.scope.enter(6), _get(_getPrototypeOf(_class3.prototype), "checkParams", this).call(this, t, !1, !0), this.scope.exit();
            }
          }, {
            key: "forwardNoArrowParamsConversionAt",
            value: function forwardNoArrowParamsConversionAt(t, e) {
              var s;
              return -1 !== this.state.noArrowParamsConversionAt.indexOf(t.start) ? (this.state.noArrowParamsConversionAt.push(this.state.start), s = e(), this.state.noArrowParamsConversionAt.pop()) : s = e(), s;
            }
          }, {
            key: "parseParenItem",
            value: function parseParenItem(t, e, s) {
              if (t = _get(_getPrototypeOf(_class3.prototype), "parseParenItem", this).call(this, t, e, s), this.eat(c.question) && (t.optional = !0, this.resetEndLocation(t)), this.match(c.colon)) {
                var _r14 = this.startNodeAt(e, s);

                return _r14.expression = t, _r14.typeAnnotation = this.flowParseTypeAnnotation(), this.finishNode(_r14, "TypeCastExpression");
              }

              return t;
            }
          }, {
            key: "assertModuleNodeAllowed",
            value: function assertModuleNodeAllowed(t) {
              "ImportDeclaration" === t.type && ("type" === t.importKind || "typeof" === t.importKind) || "ExportNamedDeclaration" === t.type && "type" === t.exportKind || "ExportAllDeclaration" === t.type && "type" === t.exportKind || _get(_getPrototypeOf(_class3.prototype), "assertModuleNodeAllowed", this).call(this, t);
            }
          }, {
            key: "parseExport",
            value: function parseExport(t) {
              var e = _get(_getPrototypeOf(_class3.prototype), "parseExport", this).call(this, t);

              return "ExportNamedDeclaration" !== e.type && "ExportAllDeclaration" !== e.type || (e.exportKind = e.exportKind || "value"), e;
            }
          }, {
            key: "parseExportDeclaration",
            value: function parseExportDeclaration(t) {
              if (this.isContextual("type")) {
                t.exportKind = "type";

                var _e25 = this.startNode();

                return this.next(), this.match(c.braceL) ? (t.specifiers = this.parseExportSpecifiers(), this.parseExportFrom(t), null) : this.flowParseTypeAlias(_e25);
              }

              if (this.isContextual("opaque")) {
                t.exportKind = "type";

                var _e26 = this.startNode();

                return this.next(), this.flowParseOpaqueType(_e26, !1);
              }

              if (this.isContextual("interface")) {
                t.exportKind = "type";

                var _e27 = this.startNode();

                return this.next(), this.flowParseInterface(_e27);
              }

              if (this.shouldParseEnums() && this.isContextual("enum")) {
                t.exportKind = "value";

                var _e28 = this.startNode();

                return this.next(), this.flowParseEnumDeclaration(_e28);
              }

              return _get(_getPrototypeOf(_class3.prototype), "parseExportDeclaration", this).call(this, t);
            }
          }, {
            key: "eatExportStar",
            value: function eatExportStar(t) {
              return !!_get(_getPrototypeOf(_class3.prototype), "eatExportStar", this).apply(this, arguments) || !(!this.isContextual("type") || this.lookahead().type !== c.star) && (t.exportKind = "type", this.next(), this.next(), !0);
            }
          }, {
            key: "maybeParseExportNamespaceSpecifier",
            value: function maybeParseExportNamespaceSpecifier(t) {
              var e = this.state.start,
                  s = _get(_getPrototypeOf(_class3.prototype), "maybeParseExportNamespaceSpecifier", this).call(this, t);

              return s && "type" === t.exportKind && this.unexpected(e), s;
            }
          }, {
            key: "parseClassId",
            value: function parseClassId(t, e, s) {
              _get(_getPrototypeOf(_class3.prototype), "parseClassId", this).call(this, t, e, s), this.isRelational("<") && (t.typeParameters = this.flowParseTypeParameterDeclaration());
            }
          }, {
            key: "parseClassMember",
            value: function parseClassMember(t, e, s) {
              var r = this.state.start;

              if (this.isContextual("declare")) {
                if (this.parseClassMemberFromModifier(t, e)) return;
                e.declare = !0;
              }

              _get(_getPrototypeOf(_class3.prototype), "parseClassMember", this).call(this, t, e, s), e.declare && ("ClassProperty" !== e.type && "ClassPrivateProperty" !== e.type ? this.raise(r, K.DeclareClassElement) : e.value && this.raise(e.value.start, K.DeclareClassFieldInitializer));
            }
          }, {
            key: "getTokenFromCode",
            value: function getTokenFromCode(t) {
              var e = this.input.charCodeAt(this.state.pos + 1);
              return 123 === t && 124 === e ? this.finishOp(c.braceBarL, 2) : !this.state.inType || 62 !== t && 60 !== t ? this.state.inType && 63 === t ? this.finishOp(c.question, 1) : function (t, e) {
                return 64 === t && 64 === e;
              }(t, e) ? (this.state.isIterator = !0, _get(_getPrototypeOf(_class3.prototype), "readWord", this).call(this)) : _get(_getPrototypeOf(_class3.prototype), "getTokenFromCode", this).call(this, t) : this.finishOp(c.relational, 1);
            }
          }, {
            key: "isAssignable",
            value: function isAssignable(t, e) {
              var _this9 = this;

              switch (t.type) {
                case "Identifier":
                case "ObjectPattern":
                case "ArrayPattern":
                case "AssignmentPattern":
                  return !0;

                case "ObjectExpression":
                  {
                    var _e29 = t.properties.length - 1;

                    return t.properties.every(function (t, s) {
                      return "ObjectMethod" !== t.type && (s === _e29 || "SpreadElement" === t.type) && _this9.isAssignable(t);
                    });
                  }

                case "ObjectProperty":
                  return this.isAssignable(t.value);

                case "SpreadElement":
                  return this.isAssignable(t.argument);

                case "ArrayExpression":
                  return t.elements.every(function (t) {
                    return _this9.isAssignable(t);
                  });

                case "AssignmentExpression":
                  return "=" === t.operator;

                case "ParenthesizedExpression":
                case "TypeCastExpression":
                  return this.isAssignable(t.expression);

                case "MemberExpression":
                case "OptionalMemberExpression":
                  return !e;

                default:
                  return !1;
              }
            }
          }, {
            key: "toAssignable",
            value: function toAssignable(t) {
              return "TypeCastExpression" === t.type ? _get(_getPrototypeOf(_class3.prototype), "toAssignable", this).call(this, this.typeCastToParameter(t)) : _get(_getPrototypeOf(_class3.prototype), "toAssignable", this).call(this, t);
            }
          }, {
            key: "toAssignableList",
            value: function toAssignableList(t, e) {
              for (var _e30 = 0; _e30 < t.length; _e30++) {
                var _s15 = t[_e30];
                "TypeCastExpression" === (null == _s15 ? void 0 : _s15.type) && (t[_e30] = this.typeCastToParameter(_s15));
              }

              return _get(_getPrototypeOf(_class3.prototype), "toAssignableList", this).call(this, t, e);
            }
          }, {
            key: "toReferencedList",
            value: function toReferencedList(t, e) {
              for (var _r15 = 0; _r15 < t.length; _r15++) {
                var s;
                var _i13 = t[_r15];
                _i13 && "TypeCastExpression" === _i13.type && !(null == (s = _i13.extra) ? void 0 : s.parenthesized) && (t.length > 1 || !e) && this.raise(_i13.typeAnnotation.start, K.TypeCastInPattern);
              }

              return t;
            }
          }, {
            key: "parseArrayLike",
            value: function parseArrayLike(t, e, s, r) {
              var i = _get(_getPrototypeOf(_class3.prototype), "parseArrayLike", this).call(this, t, e, s, r);

              return e && !this.state.maybeInArrowParameters && this.toReferencedList(i.elements), i;
            }
          }, {
            key: "checkLVal",
            value: function checkLVal(t) {
              var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 64;
              var s = arguments.length > 2 ? arguments[2] : undefined;
              var r = arguments.length > 3 ? arguments[3] : undefined;
              if ("TypeCastExpression" !== t.type) return _get(_getPrototypeOf(_class3.prototype), "checkLVal", this).call(this, t, e, s, r);
            }
          }, {
            key: "parseClassProperty",
            value: function parseClassProperty(t) {
              return this.match(c.colon) && (t.typeAnnotation = this.flowParseTypeAnnotation()), _get(_getPrototypeOf(_class3.prototype), "parseClassProperty", this).call(this, t);
            }
          }, {
            key: "parseClassPrivateProperty",
            value: function parseClassPrivateProperty(t) {
              return this.match(c.colon) && (t.typeAnnotation = this.flowParseTypeAnnotation()), _get(_getPrototypeOf(_class3.prototype), "parseClassPrivateProperty", this).call(this, t);
            }
          }, {
            key: "isClassMethod",
            value: function isClassMethod() {
              return this.isRelational("<") || _get(_getPrototypeOf(_class3.prototype), "isClassMethod", this).call(this);
            }
          }, {
            key: "isClassProperty",
            value: function isClassProperty() {
              return this.match(c.colon) || _get(_getPrototypeOf(_class3.prototype), "isClassProperty", this).call(this);
            }
          }, {
            key: "isNonstaticConstructor",
            value: function isNonstaticConstructor(t) {
              return !this.match(c.colon) && _get(_getPrototypeOf(_class3.prototype), "isNonstaticConstructor", this).call(this, t);
            }
          }, {
            key: "pushClassMethod",
            value: function pushClassMethod(t, e, s, r, i, n) {
              e.variance && this.unexpected(e.variance.start), delete e.variance, this.isRelational("<") && (e.typeParameters = this.flowParseTypeParameterDeclaration()), _get(_getPrototypeOf(_class3.prototype), "pushClassMethod", this).call(this, t, e, s, r, i, n);
            }
          }, {
            key: "pushClassPrivateMethod",
            value: function pushClassPrivateMethod(t, e, s, r) {
              e.variance && this.unexpected(e.variance.start), delete e.variance, this.isRelational("<") && (e.typeParameters = this.flowParseTypeParameterDeclaration()), _get(_getPrototypeOf(_class3.prototype), "pushClassPrivateMethod", this).call(this, t, e, s, r);
            }
          }, {
            key: "parseClassSuper",
            value: function parseClassSuper(t) {
              if (_get(_getPrototypeOf(_class3.prototype), "parseClassSuper", this).call(this, t), t.superClass && this.isRelational("<") && (t.superTypeParameters = this.flowParseTypeParameterInstantiation()), this.isContextual("implements")) {
                this.next();

                var _e31 = t.implements = [];

                do {
                  var _t32 = this.startNode();

                  _t32.id = this.flowParseRestrictedIdentifier(!0), this.isRelational("<") ? _t32.typeParameters = this.flowParseTypeParameterInstantiation() : _t32.typeParameters = null, _e31.push(this.finishNode(_t32, "ClassImplements"));
                } while (this.eat(c.comma));
              }
            }
          }, {
            key: "parsePropertyName",
            value: function parsePropertyName(t, e) {
              var s = this.flowParseVariance(),
                  r = _get(_getPrototypeOf(_class3.prototype), "parsePropertyName", this).call(this, t, e);

              return t.variance = s, r;
            }
          }, {
            key: "parseObjPropValue",
            value: function parseObjPropValue(t, e, s, r, i, n, a, o) {
              var u;
              t.variance && this.unexpected(t.variance.start), delete t.variance, this.isRelational("<") && !a && (u = this.flowParseTypeParameterDeclaration(), this.match(c.parenL) || this.unexpected()), _get(_getPrototypeOf(_class3.prototype), "parseObjPropValue", this).call(this, t, e, s, r, i, n, a, o), u && ((t.value || t).typeParameters = u);
            }
          }, {
            key: "parseAssignableListItemTypes",
            value: function parseAssignableListItemTypes(t) {
              return this.eat(c.question) && ("Identifier" !== t.type && this.raise(t.start, K.OptionalBindingPattern), t.optional = !0), this.match(c.colon) && (t.typeAnnotation = this.flowParseTypeAnnotation()), this.resetEndLocation(t), t;
            }
          }, {
            key: "parseMaybeDefault",
            value: function parseMaybeDefault(t, e, s) {
              var r = _get(_getPrototypeOf(_class3.prototype), "parseMaybeDefault", this).call(this, t, e, s);

              return "AssignmentPattern" === r.type && r.typeAnnotation && r.right.start < r.typeAnnotation.start && this.raise(r.typeAnnotation.start, K.TypeBeforeInitializer), r;
            }
          }, {
            key: "shouldParseDefaultImport",
            value: function shouldParseDefaultImport(t) {
              return J(t) ? $(this.state) : _get(_getPrototypeOf(_class3.prototype), "shouldParseDefaultImport", this).call(this, t);
            }
          }, {
            key: "parseImportSpecifierLocal",
            value: function parseImportSpecifierLocal(t, e, s, r) {
              e.local = J(t) ? this.flowParseRestrictedIdentifier(!0, !0) : this.parseIdentifier(), this.checkLVal(e.local, 9, void 0, r), t.specifiers.push(this.finishNode(e, s));
            }
          }, {
            key: "maybeParseDefaultImportSpecifier",
            value: function maybeParseDefaultImportSpecifier(t) {
              t.importKind = "value";
              var e = null;

              if (this.match(c._typeof) ? e = "typeof" : this.isContextual("type") && (e = "type"), e) {
                var _s16 = this.lookahead();

                "type" === e && _s16.type === c.star && this.unexpected(_s16.start), ($(_s16) || _s16.type === c.braceL || _s16.type === c.star) && (this.next(), t.importKind = e);
              }

              return _get(_getPrototypeOf(_class3.prototype), "maybeParseDefaultImportSpecifier", this).call(this, t);
            }
          }, {
            key: "parseImportSpecifier",
            value: function parseImportSpecifier(t) {
              var e = this.startNode(),
                  s = this.state.start,
                  r = this.parseModuleExportName();
              var i = null;
              "Identifier" === r.type && ("type" === r.name ? i = "type" : "typeof" === r.name && (i = "typeof"));
              var n = !1;

              if (this.isContextual("as") && !this.isLookaheadContextual("as")) {
                var _t33 = this.parseIdentifier(!0);

                null === i || this.match(c.name) || this.state.type.keyword ? (e.imported = r, e.importKind = null, e.local = this.parseIdentifier()) : (e.imported = _t33, e.importKind = i, e.local = _t33.__clone());
              } else if (null !== i && (this.match(c.name) || this.state.type.keyword)) e.imported = this.parseIdentifier(!0), e.importKind = i, this.eatContextual("as") ? e.local = this.parseIdentifier() : (n = !0, e.local = e.imported.__clone());else {
                if ("StringLiteral" === r.type) throw this.raise(e.start, g.ImportBindingIsString, r.value);
                n = !0, e.imported = r, e.importKind = null, e.local = e.imported.__clone();
              }

              var a = J(t),
                  o = J(e);
              a && o && this.raise(s, K.ImportTypeShorthandOnlyInPureImport), (a || o) && this.checkReservedType(e.local.name, e.local.start, !0), !n || a || o || this.checkReservedWord(e.local.name, e.start, !0, !0), this.checkLVal(e.local, 9, void 0, "import specifier"), t.specifiers.push(this.finishNode(e, "ImportSpecifier"));
            }
          }, {
            key: "parseFunctionParams",
            value: function parseFunctionParams(t, e) {
              var s = t.kind;
              "get" !== s && "set" !== s && this.isRelational("<") && (t.typeParameters = this.flowParseTypeParameterDeclaration()), _get(_getPrototypeOf(_class3.prototype), "parseFunctionParams", this).call(this, t, e);
            }
          }, {
            key: "parseVarId",
            value: function parseVarId(t, e) {
              _get(_getPrototypeOf(_class3.prototype), "parseVarId", this).call(this, t, e), this.match(c.colon) && (t.id.typeAnnotation = this.flowParseTypeAnnotation(), this.resetEndLocation(t.id));
            }
          }, {
            key: "parseAsyncArrowFromCallExpression",
            value: function parseAsyncArrowFromCallExpression(t, e) {
              if (this.match(c.colon)) {
                var _e32 = this.state.noAnonFunctionType;
                this.state.noAnonFunctionType = !0, t.returnType = this.flowParseTypeAnnotation(), this.state.noAnonFunctionType = _e32;
              }

              return _get(_getPrototypeOf(_class3.prototype), "parseAsyncArrowFromCallExpression", this).call(this, t, e);
            }
          }, {
            key: "shouldParseAsyncArrow",
            value: function shouldParseAsyncArrow() {
              return this.match(c.colon) || _get(_getPrototypeOf(_class3.prototype), "shouldParseAsyncArrow", this).call(this);
            }
          }, {
            key: "parseMaybeAssign",
            value: function parseMaybeAssign(t, e, s) {
              var _this10 = this;

              var r;
              var i,
                  n = null;

              if (this.hasPlugin("jsx") && (this.match(c.jsxTagStart) || this.isRelational("<"))) {
                if (n = this.state.clone(), i = this.tryParse(function () {
                  return _get(_getPrototypeOf(_class3.prototype), "parseMaybeAssign", _this10).call(_this10, t, e, s);
                }, n), !i.error) return i.node;
                var _r16 = this.state.context;
                _r16[_r16.length - 1] === T.j_oTag ? _r16.length -= 2 : _r16[_r16.length - 1] === T.j_expr && (_r16.length -= 1);
              }

              if ((null == (r = i) ? void 0 : r.error) || this.isRelational("<")) {
                var a, o;

                var _r17;

                n = n || this.state.clone();

                var _u = this.tryParse(function (i) {
                  var n;
                  _r17 = _this10.flowParseTypeParameterDeclaration();

                  var a = _this10.forwardNoArrowParamsConversionAt(_r17, function () {
                    var i = _get(_getPrototypeOf(_class3.prototype), "parseMaybeAssign", _this10).call(_this10, t, e, s);

                    return _this10.resetStartLocationFromNode(i, _r17), i;
                  });

                  "ArrowFunctionExpression" !== a.type && (null == (n = a.extra) ? void 0 : n.parenthesized) && i();

                  var o = _this10.maybeUnwrapTypeCastExpression(a);

                  return o.typeParameters = _r17, _this10.resetStartLocationFromNode(o, _r17), a;
                }, n);

                var _h = null;

                if (_u.node && "ArrowFunctionExpression" === this.maybeUnwrapTypeCastExpression(_u.node).type) {
                  if (!_u.error && !_u.aborted) return _u.node.async && this.raise(_r17.start, K.UnexpectedTypeParameterBeforeAsyncArrowFunction), _u.node;
                  _h = _u.node;
                }

                if (null == (a = i) ? void 0 : a.node) return this.state = i.failState, i.node;
                if (_h) return this.state = _u.failState, _h;
                if (null == (o = i) ? void 0 : o.thrown) throw i.error;
                if (_u.thrown) throw _u.error;
                throw this.raise(_r17.start, K.UnexpectedTokenAfterTypeParameter);
              }

              return _get(_getPrototypeOf(_class3.prototype), "parseMaybeAssign", this).call(this, t, e, s);
            }
          }, {
            key: "parseArrow",
            value: function parseArrow(t) {
              var _this11 = this;

              if (this.match(c.colon)) {
                var _e33 = this.tryParse(function () {
                  var _this11$flowParseType, _this11$flowParseType2;

                  var e = _this11.state.noAnonFunctionType;
                  _this11.state.noAnonFunctionType = !0;

                  var s = _this11.startNode();

                  return (_this11$flowParseType = _this11.flowParseTypeAndPredicateInitialiser(), _this11$flowParseType2 = _slicedToArray(_this11$flowParseType, 2), s.typeAnnotation = _this11$flowParseType2[0], t.predicate = _this11$flowParseType2[1], _this11$flowParseType), _this11.state.noAnonFunctionType = e, _this11.canInsertSemicolon() && _this11.unexpected(), _this11.match(c.arrow) || _this11.unexpected(), s;
                });

                if (_e33.thrown) return null;
                _e33.error && (this.state = _e33.failState), t.returnType = _e33.node.typeAnnotation ? this.finishNode(_e33.node, "TypeAnnotation") : null;
              }

              return _get(_getPrototypeOf(_class3.prototype), "parseArrow", this).call(this, t);
            }
          }, {
            key: "shouldParseArrow",
            value: function shouldParseArrow() {
              return this.match(c.colon) || _get(_getPrototypeOf(_class3.prototype), "shouldParseArrow", this).call(this);
            }
          }, {
            key: "setArrowFunctionParameters",
            value: function setArrowFunctionParameters(t, e) {
              -1 !== this.state.noArrowParamsConversionAt.indexOf(t.start) ? t.params = e : _get(_getPrototypeOf(_class3.prototype), "setArrowFunctionParameters", this).call(this, t, e);
            }
          }, {
            key: "checkParams",
            value: function checkParams(t, e, s) {
              if (!s || -1 === this.state.noArrowParamsConversionAt.indexOf(t.start)) return _get(_getPrototypeOf(_class3.prototype), "checkParams", this).apply(this, arguments);
            }
          }, {
            key: "parseParenAndDistinguishExpression",
            value: function parseParenAndDistinguishExpression(t) {
              return _get(_getPrototypeOf(_class3.prototype), "parseParenAndDistinguishExpression", this).call(this, t && -1 === this.state.noArrowAt.indexOf(this.state.start));
            }
          }, {
            key: "parseSubscripts",
            value: function parseSubscripts(t, e, s, r) {
              var _this12 = this;

              if ("Identifier" === t.type && "async" === t.name && -1 !== this.state.noArrowAt.indexOf(e)) {
                this.next();

                var _r18 = this.startNodeAt(e, s);

                _r18.callee = t, _r18.arguments = this.parseCallExpressionArguments(c.parenR, !1), t = this.finishNode(_r18, "CallExpression");
              } else if ("Identifier" === t.type && "async" === t.name && this.isRelational("<")) {
                var _i14 = this.state.clone(),
                    _n4 = this.tryParse(function (t) {
                  return _this12.parseAsyncArrowWithTypeParameters(e, s) || t();
                }, _i14);

                if (!_n4.error && !_n4.aborted) return _n4.node;

                var _a2 = this.tryParse(function () {
                  return _get(_getPrototypeOf(_class3.prototype), "parseSubscripts", _this12).call(_this12, t, e, s, r);
                }, _i14);

                if (_a2.node && !_a2.error) return _a2.node;
                if (_n4.node) return this.state = _n4.failState, _n4.node;
                if (_a2.node) return this.state = _a2.failState, _a2.node;
                throw _n4.error || _a2.error;
              }

              return _get(_getPrototypeOf(_class3.prototype), "parseSubscripts", this).call(this, t, e, s, r);
            }
          }, {
            key: "parseSubscript",
            value: function parseSubscript(t, e, s, r, i) {
              var _this13 = this;

              if (this.match(c.questionDot) && this.isLookaheadToken_lt()) {
                if (i.optionalChainMember = !0, r) return i.stop = !0, t;
                this.next();

                var _n5 = this.startNodeAt(e, s);

                return _n5.callee = t, _n5.typeArguments = this.flowParseTypeParameterInstantiation(), this.expect(c.parenL), _n5.arguments = this.parseCallExpressionArguments(c.parenR, !1), _n5.optional = !0, this.finishCallExpression(_n5, !0);
              }

              if (!r && this.shouldParseTypes() && this.isRelational("<")) {
                var _r19 = this.startNodeAt(e, s);

                _r19.callee = t;

                var _n6 = this.tryParse(function () {
                  return _r19.typeArguments = _this13.flowParseTypeParameterInstantiationCallOrNew(), _this13.expect(c.parenL), _r19.arguments = _this13.parseCallExpressionArguments(c.parenR, !1), i.optionalChainMember && (_r19.optional = !1), _this13.finishCallExpression(_r19, i.optionalChainMember);
                });

                if (_n6.node) return _n6.error && (this.state = _n6.failState), _n6.node;
              }

              return _get(_getPrototypeOf(_class3.prototype), "parseSubscript", this).call(this, t, e, s, r, i);
            }
          }, {
            key: "parseNewArguments",
            value: function parseNewArguments(t) {
              var _this14 = this;

              var e = null;
              this.shouldParseTypes() && this.isRelational("<") && (e = this.tryParse(function () {
                return _this14.flowParseTypeParameterInstantiationCallOrNew();
              }).node), t.typeArguments = e, _get(_getPrototypeOf(_class3.prototype), "parseNewArguments", this).call(this, t);
            }
          }, {
            key: "parseAsyncArrowWithTypeParameters",
            value: function parseAsyncArrowWithTypeParameters(t, e) {
              var s = this.startNodeAt(t, e);
              if (this.parseFunctionParams(s), this.parseArrow(s)) return this.parseArrowExpression(s, void 0, !0);
            }
          }, {
            key: "readToken_mult_modulo",
            value: function readToken_mult_modulo(t) {
              var e = this.input.charCodeAt(this.state.pos + 1);
              if (42 === t && 47 === e && this.state.hasFlowComment) return this.state.hasFlowComment = !1, this.state.pos += 2, void this.nextToken();

              _get(_getPrototypeOf(_class3.prototype), "readToken_mult_modulo", this).call(this, t);
            }
          }, {
            key: "readToken_pipe_amp",
            value: function readToken_pipe_amp(t) {
              var e = this.input.charCodeAt(this.state.pos + 1);
              124 !== t || 125 !== e ? _get(_getPrototypeOf(_class3.prototype), "readToken_pipe_amp", this).call(this, t) : this.finishOp(c.braceBarR, 2);
            }
          }, {
            key: "parseTopLevel",
            value: function parseTopLevel(t, e) {
              var s = _get(_getPrototypeOf(_class3.prototype), "parseTopLevel", this).call(this, t, e);

              return this.state.hasFlowComment && this.raise(this.state.pos, K.UnterminatedFlowComment), s;
            }
          }, {
            key: "skipBlockComment",
            value: function skipBlockComment() {
              if (this.hasPlugin("flowComments") && this.skipFlowComment()) return this.state.hasFlowComment && this.unexpected(null, K.NestedFlowComment), this.hasFlowCommentCompletion(), this.state.pos += this.skipFlowComment(), void (this.state.hasFlowComment = !0);

              if (this.state.hasFlowComment) {
                var _t34 = this.input.indexOf("*-/", this.state.pos += 2);

                if (-1 === _t34) throw this.raise(this.state.pos - 2, g.UnterminatedComment);
                this.state.pos = _t34 + 3;
              } else _get(_getPrototypeOf(_class3.prototype), "skipBlockComment", this).call(this);
            }
          }, {
            key: "skipFlowComment",
            value: function skipFlowComment() {
              var t = this.state.pos;
              var e = 2;

              for (; [32, 9].includes(this.input.charCodeAt(t + e));) {
                e++;
              }

              var s = this.input.charCodeAt(e + t),
                  r = this.input.charCodeAt(e + t + 1);
              return 58 === s && 58 === r ? e + 2 : "flow-include" === this.input.slice(e + t, e + t + 12) ? e + 12 : 58 === s && 58 !== r && e;
            }
          }, {
            key: "hasFlowCommentCompletion",
            value: function hasFlowCommentCompletion() {
              if (-1 === this.input.indexOf("*/", this.state.pos)) throw this.raise(this.state.pos, g.UnterminatedComment);
            }
          }, {
            key: "flowEnumErrorBooleanMemberNotInitialized",
            value: function flowEnumErrorBooleanMemberNotInitialized(t, _ref14) {
              var e = _ref14.enumName,
                  s = _ref14.memberName;
              this.raise(t, K.EnumBooleanMemberNotInitialized, s, e);
            }
          }, {
            key: "flowEnumErrorInvalidMemberName",
            value: function flowEnumErrorInvalidMemberName(t, _ref15) {
              var e = _ref15.enumName,
                  s = _ref15.memberName;
              var r = s[0].toUpperCase() + s.slice(1);
              this.raise(t, K.EnumInvalidMemberName, s, r, e);
            }
          }, {
            key: "flowEnumErrorDuplicateMemberName",
            value: function flowEnumErrorDuplicateMemberName(t, _ref16) {
              var e = _ref16.enumName,
                  s = _ref16.memberName;
              this.raise(t, K.EnumDuplicateMemberName, s, e);
            }
          }, {
            key: "flowEnumErrorInconsistentMemberValues",
            value: function flowEnumErrorInconsistentMemberValues(t, _ref17) {
              var e = _ref17.enumName;
              this.raise(t, K.EnumInconsistentMemberValues, e);
            }
          }, {
            key: "flowEnumErrorInvalidExplicitType",
            value: function flowEnumErrorInvalidExplicitType(t, _ref18) {
              var e = _ref18.enumName,
                  s = _ref18.suppliedType;
              return this.raise(t, null === s ? K.EnumInvalidExplicitTypeUnknownSupplied : K.EnumInvalidExplicitType, e, s);
            }
          }, {
            key: "flowEnumErrorInvalidMemberInitializer",
            value: function flowEnumErrorInvalidMemberInitializer(t, _ref19) {
              var e = _ref19.enumName,
                  s = _ref19.explicitType,
                  r = _ref19.memberName;
              var i = null;

              switch (s) {
                case "boolean":
                case "number":
                case "string":
                  i = K.EnumInvalidMemberInitializerPrimaryType;
                  break;

                case "symbol":
                  i = K.EnumInvalidMemberInitializerSymbolType;
                  break;

                default:
                  i = K.EnumInvalidMemberInitializerUnknownType;
              }

              return this.raise(t, i, e, r, s);
            }
          }, {
            key: "flowEnumErrorNumberMemberNotInitialized",
            value: function flowEnumErrorNumberMemberNotInitialized(t, _ref20) {
              var e = _ref20.enumName,
                  s = _ref20.memberName;
              this.raise(t, K.EnumNumberMemberNotInitialized, e, s);
            }
          }, {
            key: "flowEnumErrorStringMemberInconsistentlyInitailized",
            value: function flowEnumErrorStringMemberInconsistentlyInitailized(t, _ref21) {
              var e = _ref21.enumName;
              this.raise(t, K.EnumStringMemberInconsistentlyInitailized, e);
            }
          }, {
            key: "flowEnumMemberInit",
            value: function flowEnumMemberInit() {
              var _this15 = this;

              var t = this.state.start,
                  e = function e() {
                return _this15.match(c.comma) || _this15.match(c.braceR);
              };

              switch (this.state.type) {
                case c.num:
                  {
                    var _s17 = this.parseLiteral(this.state.value, "NumericLiteral");

                    return e() ? {
                      type: "number",
                      pos: _s17.start,
                      value: _s17
                    } : {
                      type: "invalid",
                      pos: t
                    };
                  }

                case c.string:
                  {
                    var _s18 = this.parseLiteral(this.state.value, "StringLiteral");

                    return e() ? {
                      type: "string",
                      pos: _s18.start,
                      value: _s18
                    } : {
                      type: "invalid",
                      pos: t
                    };
                  }

                case c._true:
                case c._false:
                  {
                    var _s19 = this.parseBooleanLiteral();

                    return e() ? {
                      type: "boolean",
                      pos: _s19.start,
                      value: _s19
                    } : {
                      type: "invalid",
                      pos: t
                    };
                  }

                default:
                  return {
                    type: "invalid",
                    pos: t
                  };
              }
            }
          }, {
            key: "flowEnumMemberRaw",
            value: function flowEnumMemberRaw() {
              var t = this.state.start;
              return {
                id: this.parseIdentifier(!0),
                init: this.eat(c.eq) ? this.flowEnumMemberInit() : {
                  type: "none",
                  pos: t
                }
              };
            }
          }, {
            key: "flowEnumCheckExplicitTypeMismatch",
            value: function flowEnumCheckExplicitTypeMismatch(t, e, s) {
              var r = e.explicitType;
              null !== r && r !== s && this.flowEnumErrorInvalidMemberInitializer(t, e);
            }
          }, {
            key: "flowEnumMembers",
            value: function flowEnumMembers(_ref22) {
              var t = _ref22.enumName,
                  e = _ref22.explicitType;
              var s = new Set(),
                  r = {
                booleanMembers: [],
                numberMembers: [],
                stringMembers: [],
                defaultedMembers: []
              };

              for (; !this.match(c.braceR);) {
                var _i15 = this.startNode(),
                    _this$flowEnumMemberR = this.flowEnumMemberRaw(),
                    _n7 = _this$flowEnumMemberR.id,
                    _a3 = _this$flowEnumMemberR.init,
                    _o2 = _n7.name;

                if ("" === _o2) continue;
                /^[a-z]/.test(_o2) && this.flowEnumErrorInvalidMemberName(_n7.start, {
                  enumName: t,
                  memberName: _o2
                }), s.has(_o2) && this.flowEnumErrorDuplicateMemberName(_n7.start, {
                  enumName: t,
                  memberName: _o2
                }), s.add(_o2);
                var _u2 = {
                  enumName: t,
                  explicitType: e,
                  memberName: _o2
                };

                switch (_i15.id = _n7, _a3.type) {
                  case "boolean":
                    this.flowEnumCheckExplicitTypeMismatch(_a3.pos, _u2, "boolean"), _i15.init = _a3.value, r.booleanMembers.push(this.finishNode(_i15, "EnumBooleanMember"));
                    break;

                  case "number":
                    this.flowEnumCheckExplicitTypeMismatch(_a3.pos, _u2, "number"), _i15.init = _a3.value, r.numberMembers.push(this.finishNode(_i15, "EnumNumberMember"));
                    break;

                  case "string":
                    this.flowEnumCheckExplicitTypeMismatch(_a3.pos, _u2, "string"), _i15.init = _a3.value, r.stringMembers.push(this.finishNode(_i15, "EnumStringMember"));
                    break;

                  case "invalid":
                    throw this.flowEnumErrorInvalidMemberInitializer(_a3.pos, _u2);

                  case "none":
                    switch (e) {
                      case "boolean":
                        this.flowEnumErrorBooleanMemberNotInitialized(_a3.pos, _u2);
                        break;

                      case "number":
                        this.flowEnumErrorNumberMemberNotInitialized(_a3.pos, _u2);
                        break;

                      default:
                        r.defaultedMembers.push(this.finishNode(_i15, "EnumDefaultedMember"));
                    }

                }

                this.match(c.braceR) || this.expect(c.comma);
              }

              return r;
            }
          }, {
            key: "flowEnumStringMembers",
            value: function flowEnumStringMembers(t, e, _ref23) {
              var s = _ref23.enumName;
              if (0 === t.length) return e;
              if (0 === e.length) return t;

              if (e.length > t.length) {
                for (var _e34 = 0; _e34 < t.length; _e34++) {
                  var _r20 = t[_e34];
                  this.flowEnumErrorStringMemberInconsistentlyInitailized(_r20.start, {
                    enumName: s
                  });
                }

                return e;
              }

              for (var _t35 = 0; _t35 < e.length; _t35++) {
                var _r21 = e[_t35];
                this.flowEnumErrorStringMemberInconsistentlyInitailized(_r21.start, {
                  enumName: s
                });
              }

              return t;
            }
          }, {
            key: "flowEnumParseExplicitType",
            value: function flowEnumParseExplicitType(_ref24) {
              var t = _ref24.enumName;

              if (this.eatContextual("of")) {
                if (!this.match(c.name)) throw this.flowEnumErrorInvalidExplicitType(this.state.start, {
                  enumName: t,
                  suppliedType: null
                });
                var _e35 = this.state.value;
                return this.next(), "boolean" !== _e35 && "number" !== _e35 && "string" !== _e35 && "symbol" !== _e35 && this.flowEnumErrorInvalidExplicitType(this.state.start, {
                  enumName: t,
                  suppliedType: _e35
                }), _e35;
              }

              return null;
            }
          }, {
            key: "flowEnumBody",
            value: function flowEnumBody(t, _ref25) {
              var _this16 = this;

              var e = _ref25.enumName,
                  s = _ref25.nameLoc;
              var r = this.flowEnumParseExplicitType({
                enumName: e
              });
              this.expect(c.braceL);
              var i = this.flowEnumMembers({
                enumName: e,
                explicitType: r
              });

              switch (r) {
                case "boolean":
                  return t.explicitType = !0, t.members = i.booleanMembers, this.expect(c.braceR), this.finishNode(t, "EnumBooleanBody");

                case "number":
                  return t.explicitType = !0, t.members = i.numberMembers, this.expect(c.braceR), this.finishNode(t, "EnumNumberBody");

                case "string":
                  return t.explicitType = !0, t.members = this.flowEnumStringMembers(i.stringMembers, i.defaultedMembers, {
                    enumName: e
                  }), this.expect(c.braceR), this.finishNode(t, "EnumStringBody");

                case "symbol":
                  return t.members = i.defaultedMembers, this.expect(c.braceR), this.finishNode(t, "EnumSymbolBody");

                default:
                  {
                    var _r22 = function _r22() {
                      return t.members = [], _this16.expect(c.braceR), _this16.finishNode(t, "EnumStringBody");
                    };

                    t.explicitType = !1;
                    var _n8 = i.booleanMembers.length,
                        _a4 = i.numberMembers.length,
                        _o3 = i.stringMembers.length,
                        _u3 = i.defaultedMembers.length;

                    if (_n8 || _a4 || _o3 || _u3) {
                      if (_n8 || _a4) {
                        if (!_a4 && !_o3 && _n8 >= _u3) {
                          for (var _t36 = 0, _s20 = i.defaultedMembers; _t36 < _s20.length; _t36++) {
                            var _r23 = _s20[_t36];
                            this.flowEnumErrorBooleanMemberNotInitialized(_r23.start, {
                              enumName: e,
                              memberName: _r23.id.name
                            });
                          }

                          return t.members = i.booleanMembers, this.expect(c.braceR), this.finishNode(t, "EnumBooleanBody");
                        }

                        if (!_n8 && !_o3 && _a4 >= _u3) {
                          for (var _t37 = 0, _s21 = i.defaultedMembers; _t37 < _s21.length; _t37++) {
                            var _r24 = _s21[_t37];
                            this.flowEnumErrorNumberMemberNotInitialized(_r24.start, {
                              enumName: e,
                              memberName: _r24.id.name
                            });
                          }

                          return t.members = i.numberMembers, this.expect(c.braceR), this.finishNode(t, "EnumNumberBody");
                        }

                        return this.flowEnumErrorInconsistentMemberValues(s, {
                          enumName: e
                        }), _r22();
                      }

                      return t.members = this.flowEnumStringMembers(i.stringMembers, i.defaultedMembers, {
                        enumName: e
                      }), this.expect(c.braceR), this.finishNode(t, "EnumStringBody");
                    }

                    return _r22();
                  }
              }
            }
          }, {
            key: "flowParseEnumDeclaration",
            value: function flowParseEnumDeclaration(t) {
              var e = this.parseIdentifier();
              return t.id = e, t.body = this.flowEnumBody(this.startNode(), {
                enumName: e.name,
                nameLoc: e.start
              }), this.finishNode(t, "EnumDeclaration");
            }
          }, {
            key: "updateContext",
            value: function updateContext(t) {
              this.match(c.name) && "of" === this.state.value && t === c.name && "interface" === this.input.slice(this.state.lastTokStart, this.state.lastTokEnd) ? this.state.exprAllowed = !1 : _get(_getPrototypeOf(_class3.prototype), "updateContext", this).call(this, t);
            }
          }, {
            key: "isLookaheadToken_lt",
            value: function isLookaheadToken_lt() {
              var t = this.nextTokenStart();

              if (60 === this.input.charCodeAt(t)) {
                var _e36 = this.input.charCodeAt(t + 1);

                return 60 !== _e36 && 61 !== _e36;
              }

              return !1;
            }
          }, {
            key: "maybeUnwrapTypeCastExpression",
            value: function maybeUnwrapTypeCastExpression(t) {
              return "TypeCastExpression" === t.type ? t.expression : t;
            }
          }]);

          return _class3;
        }(t);
      },
      typescript: function typescript(t) {
        return /*#__PURE__*/function (_t38) {
          _inherits(_class4, _t38);

          var _super6 = _createSuper(_class4);

          function _class4() {
            _classCallCheck(this, _class4);

            return _super6.apply(this, arguments);
          }

          _createClass(_class4, [{
            key: "getScopeHandler",
            value: function getScopeHandler() {
              return ut;
            }
          }, {
            key: "tsIsIdentifier",
            value: function tsIsIdentifier() {
              return this.match(c.name);
            }
          }, {
            key: "tsNextTokenCanFollowModifier",
            value: function tsNextTokenCanFollowModifier() {
              return this.next(), !(this.hasPrecedingLineBreak() || this.match(c.parenL) || this.match(c.parenR) || this.match(c.colon) || this.match(c.eq) || this.match(c.question) || this.match(c.bang));
            }
          }, {
            key: "tsParseModifier",
            value: function tsParseModifier(t) {
              if (!this.match(c.name)) return;
              var e = this.state.value;
              return -1 !== t.indexOf(e) && this.tsTryParse(this.tsNextTokenCanFollowModifier.bind(this)) ? e : void 0;
            }
          }, {
            key: "tsParseModifiers",
            value: function tsParseModifiers(t, e) {
              for (;;) {
                var _s22 = this.state.start,
                    _r25 = this.tsParseModifier(e);

                if (!_r25) break;
                Object.hasOwnProperty.call(t, _r25) && this.raise(_s22, dt.DuplicateModifier, _r25), t[_r25] = !0;
              }
            }
          }, {
            key: "tsIsListTerminator",
            value: function tsIsListTerminator(t) {
              switch (t) {
                case "EnumMembers":
                case "TypeMembers":
                  return this.match(c.braceR);

                case "HeritageClauseElement":
                  return this.match(c.braceL);

                case "TupleElementTypes":
                  return this.match(c.bracketR);

                case "TypeParametersOrArguments":
                  return this.isRelational(">");
              }

              throw new Error("Unreachable");
            }
          }, {
            key: "tsParseList",
            value: function tsParseList(t, e) {
              var s = [];

              for (; !this.tsIsListTerminator(t);) {
                s.push(e());
              }

              return s;
            }
          }, {
            key: "tsParseDelimitedList",
            value: function tsParseDelimitedList(t, e) {
              return pt(this.tsParseDelimitedListWorker(t, e, !0));
            }
          }, {
            key: "tsParseDelimitedListWorker",
            value: function tsParseDelimitedListWorker(t, e, s) {
              var r = [];

              for (; !this.tsIsListTerminator(t);) {
                var _i16 = e();

                if (null == _i16) return;

                if (r.push(_i16), !this.eat(c.comma)) {
                  if (this.tsIsListTerminator(t)) break;
                  return void (s && this.expect(c.comma));
                }
              }

              return r;
            }
          }, {
            key: "tsParseBracketedList",
            value: function tsParseBracketedList(t, e, s, r) {
              r || (s ? this.expect(c.bracketL) : this.expectRelational("<"));
              var i = this.tsParseDelimitedList(t, e);
              return s ? this.expect(c.bracketR) : this.expectRelational(">"), i;
            }
          }, {
            key: "tsParseImportType",
            value: function tsParseImportType() {
              var t = this.startNode();
              return this.expect(c._import), this.expect(c.parenL), this.match(c.string) || this.raise(this.state.start, dt.UnsupportedImportTypeArgument), t.argument = this.parseExprAtom(), this.expect(c.parenR), this.eat(c.dot) && (t.qualifier = this.tsParseEntityName(!0)), this.isRelational("<") && (t.typeParameters = this.tsParseTypeArguments()), this.finishNode(t, "TSImportType");
            }
          }, {
            key: "tsParseEntityName",
            value: function tsParseEntityName(t) {
              var e = this.parseIdentifier();

              for (; this.eat(c.dot);) {
                var _s23 = this.startNodeAtNode(e);

                _s23.left = e, _s23.right = this.parseIdentifier(t), e = this.finishNode(_s23, "TSQualifiedName");
              }

              return e;
            }
          }, {
            key: "tsParseTypeReference",
            value: function tsParseTypeReference() {
              var t = this.startNode();
              return t.typeName = this.tsParseEntityName(!1), !this.hasPrecedingLineBreak() && this.isRelational("<") && (t.typeParameters = this.tsParseTypeArguments()), this.finishNode(t, "TSTypeReference");
            }
          }, {
            key: "tsParseThisTypePredicate",
            value: function tsParseThisTypePredicate(t) {
              this.next();
              var e = this.startNodeAtNode(t);
              return e.parameterName = t, e.typeAnnotation = this.tsParseTypeAnnotation(!1), this.finishNode(e, "TSTypePredicate");
            }
          }, {
            key: "tsParseThisTypeNode",
            value: function tsParseThisTypeNode() {
              var t = this.startNode();
              return this.next(), this.finishNode(t, "TSThisType");
            }
          }, {
            key: "tsParseTypeQuery",
            value: function tsParseTypeQuery() {
              var t = this.startNode();
              return this.expect(c._typeof), this.match(c._import) ? t.exprName = this.tsParseImportType() : t.exprName = this.tsParseEntityName(!0), this.finishNode(t, "TSTypeQuery");
            }
          }, {
            key: "tsParseTypeParameter",
            value: function tsParseTypeParameter() {
              var t = this.startNode();
              return t.name = this.parseIdentifierName(t.start), t.constraint = this.tsEatThenParseType(c._extends), t.default = this.tsEatThenParseType(c.eq), this.finishNode(t, "TSTypeParameter");
            }
          }, {
            key: "tsTryParseTypeParameters",
            value: function tsTryParseTypeParameters() {
              if (this.isRelational("<")) return this.tsParseTypeParameters();
            }
          }, {
            key: "tsParseTypeParameters",
            value: function tsParseTypeParameters() {
              var t = this.startNode();
              return this.isRelational("<") || this.match(c.jsxTagStart) ? this.next() : this.unexpected(), t.params = this.tsParseBracketedList("TypeParametersOrArguments", this.tsParseTypeParameter.bind(this), !1, !0), 0 === t.params.length && this.raise(t.start, dt.EmptyTypeParameters), this.finishNode(t, "TSTypeParameterDeclaration");
            }
          }, {
            key: "tsTryNextParseConstantContext",
            value: function tsTryNextParseConstantContext() {
              return this.lookahead().type === c._const ? (this.next(), this.tsParseTypeReference()) : null;
            }
          }, {
            key: "tsFillSignature",
            value: function tsFillSignature(t, e) {
              var s = t === c.arrow;
              e.typeParameters = this.tsTryParseTypeParameters(), this.expect(c.parenL), e.parameters = this.tsParseBindingListForSignature(), (s || this.match(t)) && (e.typeAnnotation = this.tsParseTypeOrTypePredicateAnnotation(t));
            }
          }, {
            key: "tsParseBindingListForSignature",
            value: function tsParseBindingListForSignature() {
              var _this17 = this;

              return this.parseBindingList(c.parenR, 41).map(function (t) {
                return "Identifier" !== t.type && "RestElement" !== t.type && "ObjectPattern" !== t.type && "ArrayPattern" !== t.type && _this17.raise(t.start, dt.UnsupportedSignatureParameterKind, t.type), t;
              });
            }
          }, {
            key: "tsParseTypeMemberSemicolon",
            value: function tsParseTypeMemberSemicolon() {
              this.eat(c.comma) || this.semicolon();
            }
          }, {
            key: "tsParseSignatureMember",
            value: function tsParseSignatureMember(t, e) {
              return this.tsFillSignature(c.colon, e), this.tsParseTypeMemberSemicolon(), this.finishNode(e, t);
            }
          }, {
            key: "tsIsUnambiguouslyIndexSignature",
            value: function tsIsUnambiguouslyIndexSignature() {
              return this.next(), this.eat(c.name) && this.match(c.colon);
            }
          }, {
            key: "tsTryParseIndexSignature",
            value: function tsTryParseIndexSignature(t) {
              if (!this.match(c.bracketL) || !this.tsLookAhead(this.tsIsUnambiguouslyIndexSignature.bind(this))) return;
              this.expect(c.bracketL);
              var e = this.parseIdentifier();
              e.typeAnnotation = this.tsParseTypeAnnotation(), this.resetEndLocation(e), this.expect(c.bracketR), t.parameters = [e];
              var s = this.tsTryParseTypeAnnotation();
              return s && (t.typeAnnotation = s), this.tsParseTypeMemberSemicolon(), this.finishNode(t, "TSIndexSignature");
            }
          }, {
            key: "tsParsePropertyOrMethodSignature",
            value: function tsParsePropertyOrMethodSignature(t, e) {
              this.eat(c.question) && (t.optional = !0);
              var s = t;

              if (e || !this.match(c.parenL) && !this.isRelational("<")) {
                var _t39 = s;
                e && (_t39.readonly = !0);

                var _r26 = this.tsTryParseTypeAnnotation();

                return _r26 && (_t39.typeAnnotation = _r26), this.tsParseTypeMemberSemicolon(), this.finishNode(_t39, "TSPropertySignature");
              }

              {
                var _t40 = s;
                return this.tsFillSignature(c.colon, _t40), this.tsParseTypeMemberSemicolon(), this.finishNode(_t40, "TSMethodSignature");
              }
            }
          }, {
            key: "tsParseTypeMember",
            value: function tsParseTypeMember() {
              var t = this.startNode();
              if (this.match(c.parenL) || this.isRelational("<")) return this.tsParseSignatureMember("TSCallSignatureDeclaration", t);

              if (this.match(c._new)) {
                var _e37 = this.startNode();

                return this.next(), this.match(c.parenL) || this.isRelational("<") ? this.tsParseSignatureMember("TSConstructSignatureDeclaration", t) : (t.key = this.createIdentifier(_e37, "new"), this.tsParsePropertyOrMethodSignature(t, !1));
              }

              var e = !!this.tsParseModifier(["readonly"]),
                  s = this.tsTryParseIndexSignature(t);
              return s ? (e && (t.readonly = !0), s) : (this.parsePropertyName(t, !1), this.tsParsePropertyOrMethodSignature(t, e));
            }
          }, {
            key: "tsParseTypeLiteral",
            value: function tsParseTypeLiteral() {
              var t = this.startNode();
              return t.members = this.tsParseObjectTypeMembers(), this.finishNode(t, "TSTypeLiteral");
            }
          }, {
            key: "tsParseObjectTypeMembers",
            value: function tsParseObjectTypeMembers() {
              this.expect(c.braceL);
              var t = this.tsParseList("TypeMembers", this.tsParseTypeMember.bind(this));
              return this.expect(c.braceR), t;
            }
          }, {
            key: "tsIsStartOfMappedType",
            value: function tsIsStartOfMappedType() {
              return this.next(), this.eat(c.plusMin) ? this.isContextual("readonly") : (this.isContextual("readonly") && this.next(), !!this.match(c.bracketL) && (this.next(), !!this.tsIsIdentifier() && (this.next(), this.match(c._in))));
            }
          }, {
            key: "tsParseMappedTypeParameter",
            value: function tsParseMappedTypeParameter() {
              var t = this.startNode();
              return t.name = this.parseIdentifierName(t.start), t.constraint = this.tsExpectThenParseType(c._in), this.finishNode(t, "TSTypeParameter");
            }
          }, {
            key: "tsParseMappedType",
            value: function tsParseMappedType() {
              var t = this.startNode();
              return this.expect(c.braceL), this.match(c.plusMin) ? (t.readonly = this.state.value, this.next(), this.expectContextual("readonly")) : this.eatContextual("readonly") && (t.readonly = !0), this.expect(c.bracketL), t.typeParameter = this.tsParseMappedTypeParameter(), t.nameType = this.eatContextual("as") ? this.tsParseType() : null, this.expect(c.bracketR), this.match(c.plusMin) ? (t.optional = this.state.value, this.next(), this.expect(c.question)) : this.eat(c.question) && (t.optional = !0), t.typeAnnotation = this.tsTryParseType(), this.semicolon(), this.expect(c.braceR), this.finishNode(t, "TSMappedType");
            }
          }, {
            key: "tsParseTupleType",
            value: function tsParseTupleType() {
              var _this18 = this;

              var t = this.startNode();
              t.elementTypes = this.tsParseBracketedList("TupleElementTypes", this.tsParseTupleElementType.bind(this), !0, !1);
              var e = !1,
                  s = null;
              return t.elementTypes.forEach(function (t) {
                var r;
                var _t41 = t,
                    i = _t41.type;
                !e || "TSRestType" === i || "TSOptionalType" === i || "TSNamedTupleMember" === i && t.optional || _this18.raise(t.start, dt.OptionalTypeBeforeRequired), e = e || "TSNamedTupleMember" === i && t.optional || "TSOptionalType" === i, "TSRestType" === i && (i = (t = t.typeAnnotation).type);
                var n = "TSNamedTupleMember" === i;
                s = null != (r = s) ? r : n, s !== n && _this18.raise(t.start, dt.MixedLabeledAndUnlabeledElements);
              }), this.finishNode(t, "TSTupleType");
            }
          }, {
            key: "tsParseTupleElementType",
            value: function tsParseTupleElementType() {
              var _this$state = this.state,
                  t = _this$state.start,
                  e = _this$state.startLoc,
                  s = this.eat(c.ellipsis);
              var r = this.tsParseType();
              var i = this.eat(c.question);

              if (this.eat(c.colon)) {
                var _t42 = this.startNodeAtNode(r);

                _t42.optional = i, "TSTypeReference" !== r.type || r.typeParameters || "Identifier" !== r.typeName.type ? (this.raise(r.start, dt.InvalidTupleMemberLabel), _t42.label = r) : _t42.label = r.typeName, _t42.elementType = this.tsParseType(), r = this.finishNode(_t42, "TSNamedTupleMember");
              } else if (i) {
                var _t43 = this.startNodeAtNode(r);

                _t43.typeAnnotation = r, r = this.finishNode(_t43, "TSOptionalType");
              }

              if (s) {
                var _s24 = this.startNodeAt(t, e);

                _s24.typeAnnotation = r, r = this.finishNode(_s24, "TSRestType");
              }

              return r;
            }
          }, {
            key: "tsParseParenthesizedType",
            value: function tsParseParenthesizedType() {
              var t = this.startNode();
              return this.expect(c.parenL), t.typeAnnotation = this.tsParseType(), this.expect(c.parenR), this.finishNode(t, "TSParenthesizedType");
            }
          }, {
            key: "tsParseFunctionOrConstructorType",
            value: function tsParseFunctionOrConstructorType(t) {
              var e = this.startNode();
              return "TSConstructorType" === t && this.expect(c._new), this.tsFillSignature(c.arrow, e), this.finishNode(e, t);
            }
          }, {
            key: "tsParseLiteralTypeNode",
            value: function tsParseLiteralTypeNode() {
              var _this19 = this;

              var t = this.startNode();
              return t.literal = function () {
                switch (_this19.state.type) {
                  case c.num:
                  case c.bigint:
                  case c.string:
                  case c._true:
                  case c._false:
                    return _this19.parseExprAtom();

                  default:
                    throw _this19.unexpected();
                }
              }(), this.finishNode(t, "TSLiteralType");
            }
          }, {
            key: "tsParseTemplateLiteralType",
            value: function tsParseTemplateLiteralType() {
              var t = this.startNode();
              return t.literal = this.parseTemplate(!1), this.finishNode(t, "TSLiteralType");
            }
          }, {
            key: "parseTemplateSubstitution",
            value: function parseTemplateSubstitution() {
              return this.state.inType ? this.tsParseType() : _get(_getPrototypeOf(_class4.prototype), "parseTemplateSubstitution", this).call(this);
            }
          }, {
            key: "tsParseThisTypeOrThisTypePredicate",
            value: function tsParseThisTypeOrThisTypePredicate() {
              var t = this.tsParseThisTypeNode();
              return this.isContextual("is") && !this.hasPrecedingLineBreak() ? this.tsParseThisTypePredicate(t) : t;
            }
          }, {
            key: "tsParseNonArrayType",
            value: function tsParseNonArrayType() {
              switch (this.state.type) {
                case c.name:
                case c._void:
                case c._null:
                  {
                    var _t44 = this.match(c._void) ? "TSVoidKeyword" : this.match(c._null) ? "TSNullKeyword" : function (t) {
                      switch (t) {
                        case "any":
                          return "TSAnyKeyword";

                        case "boolean":
                          return "TSBooleanKeyword";

                        case "bigint":
                          return "TSBigIntKeyword";

                        case "never":
                          return "TSNeverKeyword";

                        case "number":
                          return "TSNumberKeyword";

                        case "object":
                          return "TSObjectKeyword";

                        case "string":
                          return "TSStringKeyword";

                        case "symbol":
                          return "TSSymbolKeyword";

                        case "undefined":
                          return "TSUndefinedKeyword";

                        case "unknown":
                          return "TSUnknownKeyword";

                        default:
                          return;
                      }
                    }(this.state.value);

                    if (void 0 !== _t44 && 46 !== this.lookaheadCharCode()) {
                      var _e38 = this.startNode();

                      return this.next(), this.finishNode(_e38, _t44);
                    }

                    return this.tsParseTypeReference();
                  }

                case c.string:
                case c.num:
                case c.bigint:
                case c._true:
                case c._false:
                  return this.tsParseLiteralTypeNode();

                case c.plusMin:
                  if ("-" === this.state.value) {
                    var _t45 = this.startNode(),
                        _e39 = this.lookahead();

                    if (_e39.type !== c.num && _e39.type !== c.bigint) throw this.unexpected();
                    return _t45.literal = this.parseMaybeUnary(), this.finishNode(_t45, "TSLiteralType");
                  }

                  break;

                case c._this:
                  return this.tsParseThisTypeOrThisTypePredicate();

                case c._typeof:
                  return this.tsParseTypeQuery();

                case c._import:
                  return this.tsParseImportType();

                case c.braceL:
                  return this.tsLookAhead(this.tsIsStartOfMappedType.bind(this)) ? this.tsParseMappedType() : this.tsParseTypeLiteral();

                case c.bracketL:
                  return this.tsParseTupleType();

                case c.parenL:
                  return this.tsParseParenthesizedType();

                case c.backQuote:
                  return this.tsParseTemplateLiteralType();
              }

              throw this.unexpected();
            }
          }, {
            key: "tsParseArrayTypeOrHigher",
            value: function tsParseArrayTypeOrHigher() {
              var t = this.tsParseNonArrayType();

              for (; !this.hasPrecedingLineBreak() && this.eat(c.bracketL);) {
                if (this.match(c.bracketR)) {
                  var _e40 = this.startNodeAtNode(t);

                  _e40.elementType = t, this.expect(c.bracketR), t = this.finishNode(_e40, "TSArrayType");
                } else {
                  var _e41 = this.startNodeAtNode(t);

                  _e41.objectType = t, _e41.indexType = this.tsParseType(), this.expect(c.bracketR), t = this.finishNode(_e41, "TSIndexedAccessType");
                }
              }

              return t;
            }
          }, {
            key: "tsParseTypeOperator",
            value: function tsParseTypeOperator(t) {
              var e = this.startNode();
              return this.expectContextual(t), e.operator = t, e.typeAnnotation = this.tsParseTypeOperatorOrHigher(), "readonly" === t && this.tsCheckTypeAnnotationForReadOnly(e), this.finishNode(e, "TSTypeOperator");
            }
          }, {
            key: "tsCheckTypeAnnotationForReadOnly",
            value: function tsCheckTypeAnnotationForReadOnly(t) {
              switch (t.typeAnnotation.type) {
                case "TSTupleType":
                case "TSArrayType":
                  return;

                default:
                  this.raise(t.start, dt.UnexpectedReadonly);
              }
            }
          }, {
            key: "tsParseInferType",
            value: function tsParseInferType() {
              var t = this.startNode();
              this.expectContextual("infer");
              var e = this.startNode();
              return e.name = this.parseIdentifierName(e.start), t.typeParameter = this.finishNode(e, "TSTypeParameter"), this.finishNode(t, "TSInferType");
            }
          }, {
            key: "tsParseTypeOperatorOrHigher",
            value: function tsParseTypeOperatorOrHigher() {
              var _this20 = this;

              var t = ["keyof", "unique", "readonly"].find(function (t) {
                return _this20.isContextual(t);
              });
              return t ? this.tsParseTypeOperator(t) : this.isContextual("infer") ? this.tsParseInferType() : this.tsParseArrayTypeOrHigher();
            }
          }, {
            key: "tsParseUnionOrIntersectionType",
            value: function tsParseUnionOrIntersectionType(t, e, s) {
              this.eat(s);
              var r = e();

              if (this.match(s)) {
                var _i17 = [r];

                for (; this.eat(s);) {
                  _i17.push(e());
                }

                var _n9 = this.startNodeAtNode(r);

                _n9.types = _i17, r = this.finishNode(_n9, t);
              }

              return r;
            }
          }, {
            key: "tsParseIntersectionTypeOrHigher",
            value: function tsParseIntersectionTypeOrHigher() {
              return this.tsParseUnionOrIntersectionType("TSIntersectionType", this.tsParseTypeOperatorOrHigher.bind(this), c.bitwiseAND);
            }
          }, {
            key: "tsParseUnionTypeOrHigher",
            value: function tsParseUnionTypeOrHigher() {
              return this.tsParseUnionOrIntersectionType("TSUnionType", this.tsParseIntersectionTypeOrHigher.bind(this), c.bitwiseOR);
            }
          }, {
            key: "tsIsStartOfFunctionType",
            value: function tsIsStartOfFunctionType() {
              return !!this.isRelational("<") || this.match(c.parenL) && this.tsLookAhead(this.tsIsUnambiguouslyStartOfFunctionType.bind(this));
            }
          }, {
            key: "tsSkipParameterStart",
            value: function tsSkipParameterStart() {
              if (this.match(c.name) || this.match(c._this)) return this.next(), !0;

              if (this.match(c.braceL)) {
                var _t46 = 1;

                for (this.next(); _t46 > 0;) {
                  this.match(c.braceL) ? ++_t46 : this.match(c.braceR) && --_t46, this.next();
                }

                return !0;
              }

              if (this.match(c.bracketL)) {
                var _t47 = 1;

                for (this.next(); _t47 > 0;) {
                  this.match(c.bracketL) ? ++_t47 : this.match(c.bracketR) && --_t47, this.next();
                }

                return !0;
              }

              return !1;
            }
          }, {
            key: "tsIsUnambiguouslyStartOfFunctionType",
            value: function tsIsUnambiguouslyStartOfFunctionType() {
              if (this.next(), this.match(c.parenR) || this.match(c.ellipsis)) return !0;

              if (this.tsSkipParameterStart()) {
                if (this.match(c.colon) || this.match(c.comma) || this.match(c.question) || this.match(c.eq)) return !0;
                if (this.match(c.parenR) && (this.next(), this.match(c.arrow))) return !0;
              }

              return !1;
            }
          }, {
            key: "tsParseTypeOrTypePredicateAnnotation",
            value: function tsParseTypeOrTypePredicateAnnotation(t) {
              var _this21 = this;

              return this.tsInType(function () {
                var e = _this21.startNode();

                _this21.expect(t);

                var s = !!_this21.tsTryParse(_this21.tsParseTypePredicateAsserts.bind(_this21));

                if (s && _this21.match(c._this)) {
                  var _t48 = _this21.tsParseThisTypeOrThisTypePredicate();

                  if ("TSThisType" === _t48.type) {
                    var _s25 = _this21.startNodeAtNode(e);

                    _s25.parameterName = _t48, _s25.asserts = !0, _t48 = _this21.finishNode(_s25, "TSTypePredicate");
                  } else _t48.asserts = !0;

                  return e.typeAnnotation = _t48, _this21.finishNode(e, "TSTypeAnnotation");
                }

                var r = _this21.tsIsIdentifier() && _this21.tsTryParse(_this21.tsParseTypePredicatePrefix.bind(_this21));

                if (!r) {
                  if (!s) return _this21.tsParseTypeAnnotation(!1, e);

                  var _t49 = _this21.startNodeAtNode(e);

                  return _t49.parameterName = _this21.parseIdentifier(), _t49.asserts = s, e.typeAnnotation = _this21.finishNode(_t49, "TSTypePredicate"), _this21.finishNode(e, "TSTypeAnnotation");
                }

                var i = _this21.tsParseTypeAnnotation(!1),
                    n = _this21.startNodeAtNode(e);

                return n.parameterName = r, n.typeAnnotation = i, n.asserts = s, e.typeAnnotation = _this21.finishNode(n, "TSTypePredicate"), _this21.finishNode(e, "TSTypeAnnotation");
              });
            }
          }, {
            key: "tsTryParseTypeOrTypePredicateAnnotation",
            value: function tsTryParseTypeOrTypePredicateAnnotation() {
              return this.match(c.colon) ? this.tsParseTypeOrTypePredicateAnnotation(c.colon) : void 0;
            }
          }, {
            key: "tsTryParseTypeAnnotation",
            value: function tsTryParseTypeAnnotation() {
              return this.match(c.colon) ? this.tsParseTypeAnnotation() : void 0;
            }
          }, {
            key: "tsTryParseType",
            value: function tsTryParseType() {
              return this.tsEatThenParseType(c.colon);
            }
          }, {
            key: "tsParseTypePredicatePrefix",
            value: function tsParseTypePredicatePrefix() {
              var t = this.parseIdentifier();
              if (this.isContextual("is") && !this.hasPrecedingLineBreak()) return this.next(), t;
            }
          }, {
            key: "tsParseTypePredicateAsserts",
            value: function tsParseTypePredicateAsserts() {
              if (!this.match(c.name) || "asserts" !== this.state.value || this.hasPrecedingLineBreak()) return !1;
              var t = this.state.containsEsc;
              return this.next(), !(!this.match(c.name) && !this.match(c._this)) && (t && this.raise(this.state.lastTokStart, g.InvalidEscapedReservedWord, "asserts"), !0);
            }
          }, {
            key: "tsParseTypeAnnotation",
            value: function tsParseTypeAnnotation() {
              var _this22 = this;

              var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
              var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.startNode();
              return this.tsInType(function () {
                t && _this22.expect(c.colon), e.typeAnnotation = _this22.tsParseType();
              }), this.finishNode(e, "TSTypeAnnotation");
            }
          }, {
            key: "tsParseType",
            value: function tsParseType() {
              lt(this.state.inType);
              var t = this.tsParseNonConditionalType();
              if (this.hasPrecedingLineBreak() || !this.eat(c._extends)) return t;
              var e = this.startNodeAtNode(t);
              return e.checkType = t, e.extendsType = this.tsParseNonConditionalType(), this.expect(c.question), e.trueType = this.tsParseType(), this.expect(c.colon), e.falseType = this.tsParseType(), this.finishNode(e, "TSConditionalType");
            }
          }, {
            key: "tsParseNonConditionalType",
            value: function tsParseNonConditionalType() {
              return this.tsIsStartOfFunctionType() ? this.tsParseFunctionOrConstructorType("TSFunctionType") : this.match(c._new) ? this.tsParseFunctionOrConstructorType("TSConstructorType") : this.tsParseUnionTypeOrHigher();
            }
          }, {
            key: "tsParseTypeAssertion",
            value: function tsParseTypeAssertion() {
              var t = this.startNode(),
                  e = this.tsTryNextParseConstantContext();
              return t.typeAnnotation = e || this.tsNextThenParseType(), this.expectRelational(">"), t.expression = this.parseMaybeUnary(), this.finishNode(t, "TSTypeAssertion");
            }
          }, {
            key: "tsParseHeritageClause",
            value: function tsParseHeritageClause(t) {
              var e = this.state.start,
                  s = this.tsParseDelimitedList("HeritageClauseElement", this.tsParseExpressionWithTypeArguments.bind(this));
              return s.length || this.raise(e, dt.EmptyHeritageClauseType, t), s;
            }
          }, {
            key: "tsParseExpressionWithTypeArguments",
            value: function tsParseExpressionWithTypeArguments() {
              var t = this.startNode();
              return t.expression = this.tsParseEntityName(!1), this.isRelational("<") && (t.typeParameters = this.tsParseTypeArguments()), this.finishNode(t, "TSExpressionWithTypeArguments");
            }
          }, {
            key: "tsParseInterfaceDeclaration",
            value: function tsParseInterfaceDeclaration(t) {
              t.id = this.parseIdentifier(), this.checkLVal(t.id, 130, void 0, "typescript interface declaration"), t.typeParameters = this.tsTryParseTypeParameters(), this.eat(c._extends) && (t.extends = this.tsParseHeritageClause("extends"));
              var e = this.startNode();
              return e.body = this.tsInType(this.tsParseObjectTypeMembers.bind(this)), t.body = this.finishNode(e, "TSInterfaceBody"), this.finishNode(t, "TSInterfaceDeclaration");
            }
          }, {
            key: "tsParseTypeAliasDeclaration",
            value: function tsParseTypeAliasDeclaration(t) {
              var _this23 = this;

              return t.id = this.parseIdentifier(), this.checkLVal(t.id, 2, void 0, "typescript type alias"), t.typeParameters = this.tsTryParseTypeParameters(), t.typeAnnotation = this.tsInType(function () {
                if (_this23.expect(c.eq), _this23.isContextual("intrinsic") && _this23.lookahead().type !== c.dot) {
                  var _t50 = _this23.startNode();

                  return _this23.next(), _this23.finishNode(_t50, "TSIntrinsicKeyword");
                }

                return _this23.tsParseType();
              }), this.semicolon(), this.finishNode(t, "TSTypeAliasDeclaration");
            }
          }, {
            key: "tsInNoContext",
            value: function tsInNoContext(t) {
              var e = this.state.context;
              this.state.context = [e[0]];

              try {
                return t();
              } finally {
                this.state.context = e;
              }
            }
          }, {
            key: "tsInType",
            value: function tsInType(t) {
              var e = this.state.inType;
              this.state.inType = !0;

              try {
                return t();
              } finally {
                this.state.inType = e;
              }
            }
          }, {
            key: "tsEatThenParseType",
            value: function tsEatThenParseType(t) {
              return this.match(t) ? this.tsNextThenParseType() : void 0;
            }
          }, {
            key: "tsExpectThenParseType",
            value: function tsExpectThenParseType(t) {
              var _this24 = this;

              return this.tsDoThenParseType(function () {
                return _this24.expect(t);
              });
            }
          }, {
            key: "tsNextThenParseType",
            value: function tsNextThenParseType() {
              var _this25 = this;

              return this.tsDoThenParseType(function () {
                return _this25.next();
              });
            }
          }, {
            key: "tsDoThenParseType",
            value: function tsDoThenParseType(t) {
              var _this26 = this;

              return this.tsInType(function () {
                return t(), _this26.tsParseType();
              });
            }
          }, {
            key: "tsParseEnumMember",
            value: function tsParseEnumMember() {
              var t = this.startNode();
              return t.id = this.match(c.string) ? this.parseExprAtom() : this.parseIdentifier(!0), this.eat(c.eq) && (t.initializer = this.parseMaybeAssignAllowIn()), this.finishNode(t, "TSEnumMember");
            }
          }, {
            key: "tsParseEnumDeclaration",
            value: function tsParseEnumDeclaration(t, e) {
              return e && (t.const = !0), t.id = this.parseIdentifier(), this.checkLVal(t.id, e ? 779 : 267, void 0, "typescript enum declaration"), this.expect(c.braceL), t.members = this.tsParseDelimitedList("EnumMembers", this.tsParseEnumMember.bind(this)), this.expect(c.braceR), this.finishNode(t, "TSEnumDeclaration");
            }
          }, {
            key: "tsParseModuleBlock",
            value: function tsParseModuleBlock() {
              var t = this.startNode();
              return this.scope.enter(0), this.expect(c.braceL), this.parseBlockOrModuleBlockBody(t.body = [], void 0, !0, c.braceR), this.scope.exit(), this.finishNode(t, "TSModuleBlock");
            }
          }, {
            key: "tsParseModuleOrNamespaceDeclaration",
            value: function tsParseModuleOrNamespaceDeclaration(t) {
              var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;

              if (t.id = this.parseIdentifier(), e || this.checkLVal(t.id, 1024, null, "module or namespace declaration"), this.eat(c.dot)) {
                var _e42 = this.startNode();

                this.tsParseModuleOrNamespaceDeclaration(_e42, !0), t.body = _e42;
              } else this.scope.enter(p), this.prodParam.enter(0), t.body = this.tsParseModuleBlock(), this.prodParam.exit(), this.scope.exit();

              return this.finishNode(t, "TSModuleDeclaration");
            }
          }, {
            key: "tsParseAmbientExternalModuleDeclaration",
            value: function tsParseAmbientExternalModuleDeclaration(t) {
              return this.isContextual("global") ? (t.global = !0, t.id = this.parseIdentifier()) : this.match(c.string) ? t.id = this.parseExprAtom() : this.unexpected(), this.match(c.braceL) ? (this.scope.enter(p), this.prodParam.enter(0), t.body = this.tsParseModuleBlock(), this.prodParam.exit(), this.scope.exit()) : this.semicolon(), this.finishNode(t, "TSModuleDeclaration");
            }
          }, {
            key: "tsParseImportEqualsDeclaration",
            value: function tsParseImportEqualsDeclaration(t, e) {
              return t.isExport = e || !1, t.id = this.parseIdentifier(), this.checkLVal(t.id, 9, void 0, "import equals declaration"), this.expect(c.eq), t.moduleReference = this.tsParseModuleReference(), this.semicolon(), this.finishNode(t, "TSImportEqualsDeclaration");
            }
          }, {
            key: "tsIsExternalModuleReference",
            value: function tsIsExternalModuleReference() {
              return this.isContextual("require") && 40 === this.lookaheadCharCode();
            }
          }, {
            key: "tsParseModuleReference",
            value: function tsParseModuleReference() {
              return this.tsIsExternalModuleReference() ? this.tsParseExternalModuleReference() : this.tsParseEntityName(!1);
            }
          }, {
            key: "tsParseExternalModuleReference",
            value: function tsParseExternalModuleReference() {
              var t = this.startNode();
              if (this.expectContextual("require"), this.expect(c.parenL), !this.match(c.string)) throw this.unexpected();
              return t.expression = this.parseExprAtom(), this.expect(c.parenR), this.finishNode(t, "TSExternalModuleReference");
            }
          }, {
            key: "tsLookAhead",
            value: function tsLookAhead(t) {
              var e = this.state.clone(),
                  s = t();
              return this.state = e, s;
            }
          }, {
            key: "tsTryParseAndCatch",
            value: function tsTryParseAndCatch(t) {
              var e = this.tryParse(function (e) {
                return t() || e();
              });
              if (!e.aborted && e.node) return e.error && (this.state = e.failState), e.node;
            }
          }, {
            key: "tsTryParse",
            value: function tsTryParse(t) {
              var e = this.state.clone(),
                  s = t();
              return void 0 !== s && !1 !== s ? s : void (this.state = e);
            }
          }, {
            key: "tsTryParseDeclare",
            value: function tsTryParseDeclare(t) {
              var _this27 = this;

              if (this.isLineTerminator()) return;
              var e,
                  s = this.state.type;
              return this.isContextual("let") && (s = c._var, e = "let"), this.tsInDeclareContext(function () {
                switch (s) {
                  case c._function:
                    return t.declare = !0, _this27.parseFunctionStatement(t, !1, !0);

                  case c._class:
                    return t.declare = !0, _this27.parseClass(t, !0, !1);

                  case c._const:
                    if (_this27.match(c._const) && _this27.isLookaheadContextual("enum")) return _this27.expect(c._const), _this27.expectContextual("enum"), _this27.tsParseEnumDeclaration(t, !0);

                  case c._var:
                    return e = e || _this27.state.value, _this27.parseVarStatement(t, e);

                  case c.name:
                    {
                      var _e43 = _this27.state.value;
                      return "global" === _e43 ? _this27.tsParseAmbientExternalModuleDeclaration(t) : _this27.tsParseDeclaration(t, _e43, !0);
                    }
                }
              });
            }
          }, {
            key: "tsTryParseExportDeclaration",
            value: function tsTryParseExportDeclaration() {
              return this.tsParseDeclaration(this.startNode(), this.state.value, !0);
            }
          }, {
            key: "tsParseExpressionStatement",
            value: function tsParseExpressionStatement(t, e) {
              switch (e.name) {
                case "declare":
                  {
                    var _e44 = this.tsTryParseDeclare(t);

                    if (_e44) return _e44.declare = !0, _e44;
                    break;
                  }

                case "global":
                  if (this.match(c.braceL)) {
                    this.scope.enter(p), this.prodParam.enter(0);
                    var _s26 = t;
                    return _s26.global = !0, _s26.id = e, _s26.body = this.tsParseModuleBlock(), this.scope.exit(), this.prodParam.exit(), this.finishNode(_s26, "TSModuleDeclaration");
                  }

                  break;

                default:
                  return this.tsParseDeclaration(t, e.name, !1);
              }
            }
          }, {
            key: "tsParseDeclaration",
            value: function tsParseDeclaration(t, e, s) {
              switch (e) {
                case "abstract":
                  if (this.tsCheckLineTerminatorAndMatch(c._class, s)) {
                    var _e45 = t;
                    return _e45.abstract = !0, s && (this.next(), this.match(c._class) || this.unexpected(null, c._class)), this.parseClass(_e45, !0, !1);
                  }

                  break;

                case "enum":
                  if (s || this.match(c.name)) return s && this.next(), this.tsParseEnumDeclaration(t, !1);
                  break;

                case "interface":
                  if (this.tsCheckLineTerminatorAndMatch(c.name, s)) return s && this.next(), this.tsParseInterfaceDeclaration(t);
                  break;

                case "module":
                  if (s && this.next(), this.match(c.string)) return this.tsParseAmbientExternalModuleDeclaration(t);
                  if (this.tsCheckLineTerminatorAndMatch(c.name, s)) return this.tsParseModuleOrNamespaceDeclaration(t);
                  break;

                case "namespace":
                  if (this.tsCheckLineTerminatorAndMatch(c.name, s)) return s && this.next(), this.tsParseModuleOrNamespaceDeclaration(t);
                  break;

                case "type":
                  if (this.tsCheckLineTerminatorAndMatch(c.name, s)) return s && this.next(), this.tsParseTypeAliasDeclaration(t);
              }
            }
          }, {
            key: "tsCheckLineTerminatorAndMatch",
            value: function tsCheckLineTerminatorAndMatch(t, e) {
              return (e || this.match(t)) && !this.isLineTerminator();
            }
          }, {
            key: "tsTryParseGenericAsyncArrowFunction",
            value: function tsTryParseGenericAsyncArrowFunction(t, e) {
              var _this28 = this;

              if (!this.isRelational("<")) return;
              var s = this.state.maybeInArrowParameters;
              this.state.maybeInArrowParameters = !0;
              var r = this.tsTryParseAndCatch(function () {
                var s = _this28.startNodeAt(t, e);

                return s.typeParameters = _this28.tsParseTypeParameters(), _get(_getPrototypeOf(_class4.prototype), "parseFunctionParams", _this28).call(_this28, s), s.returnType = _this28.tsTryParseTypeOrTypePredicateAnnotation(), _this28.expect(c.arrow), s;
              });
              return this.state.maybeInArrowParameters = s, r ? this.parseArrowExpression(r, null, !0) : void 0;
            }
          }, {
            key: "tsParseTypeArguments",
            value: function tsParseTypeArguments() {
              var _this29 = this;

              var t = this.startNode();
              return t.params = this.tsInType(function () {
                return _this29.tsInNoContext(function () {
                  return _this29.expectRelational("<"), _this29.tsParseDelimitedList("TypeParametersOrArguments", _this29.tsParseType.bind(_this29));
                });
              }), 0 === t.params.length && this.raise(t.start, dt.EmptyTypeArguments), this.state.exprAllowed = !1, this.expectRelational(">"), this.finishNode(t, "TSTypeParameterInstantiation");
            }
          }, {
            key: "tsIsDeclarationStart",
            value: function tsIsDeclarationStart() {
              if (this.match(c.name)) switch (this.state.value) {
                case "abstract":
                case "declare":
                case "enum":
                case "interface":
                case "module":
                case "namespace":
                case "type":
                  return !0;
              }
              return !1;
            }
          }, {
            key: "isExportDefaultSpecifier",
            value: function isExportDefaultSpecifier() {
              return !this.tsIsDeclarationStart() && _get(_getPrototypeOf(_class4.prototype), "isExportDefaultSpecifier", this).call(this);
            }
          }, {
            key: "parseAssignableListItem",
            value: function parseAssignableListItem(t, e) {
              var s = this.state.start,
                  r = this.state.startLoc;
              var i,
                  n = !1;
              void 0 !== t && (i = this.parseAccessModifier(), n = !!this.tsParseModifier(["readonly"]), !1 === t && (i || n) && this.raise(s, dt.UnexpectedParameterModifier));
              var a = this.parseMaybeDefault();
              this.parseAssignableListItemTypes(a);
              var o = this.parseMaybeDefault(a.start, a.loc.start, a);

              if (i || n) {
                var _t51 = this.startNodeAt(s, r);

                return e.length && (_t51.decorators = e), i && (_t51.accessibility = i), n && (_t51.readonly = n), "Identifier" !== o.type && "AssignmentPattern" !== o.type && this.raise(_t51.start, dt.UnsupportedParameterPropertyKind), _t51.parameter = o, this.finishNode(_t51, "TSParameterProperty");
              }

              return e.length && (a.decorators = e), o;
            }
          }, {
            key: "parseFunctionBodyAndFinish",
            value: function parseFunctionBodyAndFinish(t, e) {
              var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
              this.match(c.colon) && (t.returnType = this.tsParseTypeOrTypePredicateAnnotation(c.colon));
              var r = "FunctionDeclaration" === e ? "TSDeclareFunction" : "ClassMethod" === e ? "TSDeclareMethod" : void 0;
              r && !this.match(c.braceL) && this.isLineTerminator() ? this.finishNode(t, r) : "TSDeclareFunction" === r && this.state.isDeclareContext && (this.raise(t.start, dt.DeclareFunctionHasImplementation), t.declare) ? _get(_getPrototypeOf(_class4.prototype), "parseFunctionBodyAndFinish", this).call(this, t, r, s) : _get(_getPrototypeOf(_class4.prototype), "parseFunctionBodyAndFinish", this).call(this, t, e, s);
            }
          }, {
            key: "registerFunctionStatementId",
            value: function registerFunctionStatementId(t) {
              !t.body && t.id ? this.checkLVal(t.id, 1024, null, "function name") : _get(_getPrototypeOf(_class4.prototype), "registerFunctionStatementId", this).apply(this, arguments);
            }
          }, {
            key: "tsCheckForInvalidTypeCasts",
            value: function tsCheckForInvalidTypeCasts(t) {
              var _this30 = this;

              t.forEach(function (t) {
                "TSTypeCastExpression" === (null == t ? void 0 : t.type) && _this30.raise(t.typeAnnotation.start, dt.UnexpectedTypeAnnotation);
              });
            }
          }, {
            key: "toReferencedList",
            value: function toReferencedList(t, e) {
              return this.tsCheckForInvalidTypeCasts(t), t;
            }
          }, {
            key: "parseArrayLike",
            value: function parseArrayLike() {
              var _get2;

              for (var _len3 = arguments.length, t = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                t[_key3] = arguments[_key3];
              }

              var e = (_get2 = _get(_getPrototypeOf(_class4.prototype), "parseArrayLike", this)).call.apply(_get2, [this].concat(t));

              return "ArrayExpression" === e.type && this.tsCheckForInvalidTypeCasts(e.elements), e;
            }
          }, {
            key: "parseSubscript",
            value: function parseSubscript(t, e, s, r, i) {
              var _this31 = this;

              if (!this.hasPrecedingLineBreak() && this.match(c.bang)) {
                this.state.exprAllowed = !1, this.next();

                var _r27 = this.startNodeAt(e, s);

                return _r27.expression = t, this.finishNode(_r27, "TSNonNullExpression");
              }

              if (this.isRelational("<")) {
                var _n10 = this.tsTryParseAndCatch(function () {
                  if (!r && _this31.atPossibleAsyncArrow(t)) {
                    var _t52 = _this31.tsTryParseGenericAsyncArrowFunction(e, s);

                    if (_t52) return _t52;
                  }

                  var n = _this31.startNodeAt(e, s);

                  n.callee = t;

                  var a = _this31.tsParseTypeArguments();

                  if (a) {
                    if (!r && _this31.eat(c.parenL)) return n.arguments = _this31.parseCallExpressionArguments(c.parenR, !1), _this31.tsCheckForInvalidTypeCasts(n.arguments), n.typeParameters = a, _this31.finishCallExpression(n, i.optionalChainMember);

                    if (_this31.match(c.backQuote)) {
                      var _r28 = _this31.parseTaggedTemplateExpression(t, e, s, i);

                      return _r28.typeParameters = a, _r28;
                    }
                  }

                  _this31.unexpected();
                });

                if (_n10) return _n10;
              }

              return _get(_getPrototypeOf(_class4.prototype), "parseSubscript", this).call(this, t, e, s, r, i);
            }
          }, {
            key: "parseNewArguments",
            value: function parseNewArguments(t) {
              var _this32 = this;

              if (this.isRelational("<")) {
                var _e46 = this.tsTryParseAndCatch(function () {
                  var t = _this32.tsParseTypeArguments();

                  return _this32.match(c.parenL) || _this32.unexpected(), t;
                });

                _e46 && (t.typeParameters = _e46);
              }

              _get(_getPrototypeOf(_class4.prototype), "parseNewArguments", this).call(this, t);
            }
          }, {
            key: "parseExprOp",
            value: function parseExprOp(t, e, s, r) {
              if (pt(c._in.binop) > r && !this.hasPrecedingLineBreak() && this.isContextual("as")) {
                var _i18 = this.startNodeAt(e, s);

                _i18.expression = t;

                var _n11 = this.tsTryNextParseConstantContext();

                return _i18.typeAnnotation = _n11 || this.tsNextThenParseType(), this.finishNode(_i18, "TSAsExpression"), this.reScan_lt_gt(), this.parseExprOp(_i18, e, s, r);
              }

              return _get(_getPrototypeOf(_class4.prototype), "parseExprOp", this).call(this, t, e, s, r);
            }
          }, {
            key: "checkReservedWord",
            value: function checkReservedWord(t, e, s, r) {}
          }, {
            key: "checkDuplicateExports",
            value: function checkDuplicateExports() {}
          }, {
            key: "parseImport",
            value: function parseImport(t) {
              if (this.match(c.name) || this.match(c.star) || this.match(c.braceL)) {
                var _e47 = this.lookahead();

                if (this.match(c.name) && _e47.type === c.eq) return this.tsParseImportEqualsDeclaration(t);
                !this.isContextual("type") || _e47.type === c.comma || _e47.type === c.name && "from" === _e47.value || (t.importKind = "type", this.next());
              }

              t.importKind || (t.importKind = "value");

              var e = _get(_getPrototypeOf(_class4.prototype), "parseImport", this).call(this, t);

              return "type" === e.importKind && e.specifiers.length > 1 && "ImportDefaultSpecifier" === e.specifiers[0].type && this.raise(e.start, "A type-only import can specify a default import or named bindings, but not both."), e;
            }
          }, {
            key: "parseExport",
            value: function parseExport(t) {
              if (this.match(c._import)) return this.expect(c._import), this.tsParseImportEqualsDeclaration(t, !0);

              if (this.eat(c.eq)) {
                var _e48 = t;
                return _e48.expression = this.parseExpression(), this.semicolon(), this.finishNode(_e48, "TSExportAssignment");
              }

              if (this.eatContextual("as")) {
                var _e49 = t;
                return this.expectContextual("namespace"), _e49.id = this.parseIdentifier(), this.semicolon(), this.finishNode(_e49, "TSNamespaceExportDeclaration");
              }

              return this.isContextual("type") && this.lookahead().type === c.braceL ? (this.next(), t.exportKind = "type") : t.exportKind = "value", _get(_getPrototypeOf(_class4.prototype), "parseExport", this).call(this, t);
            }
          }, {
            key: "isAbstractClass",
            value: function isAbstractClass() {
              return this.isContextual("abstract") && this.lookahead().type === c._class;
            }
          }, {
            key: "parseExportDefaultExpression",
            value: function parseExportDefaultExpression() {
              if (this.isAbstractClass()) {
                var _t53 = this.startNode();

                return this.next(), this.parseClass(_t53, !0, !0), _t53.abstract = !0, _t53;
              }

              if ("interface" === this.state.value) {
                var _t54 = this.tsParseDeclaration(this.startNode(), this.state.value, !0);

                if (_t54) return _t54;
              }

              return _get(_getPrototypeOf(_class4.prototype), "parseExportDefaultExpression", this).call(this);
            }
          }, {
            key: "parseStatementContent",
            value: function parseStatementContent(t, e) {
              if (this.state.type === c._const) {
                var _t55 = this.lookahead();

                if (_t55.type === c.name && "enum" === _t55.value) {
                  var _t56 = this.startNode();

                  return this.expect(c._const), this.expectContextual("enum"), this.tsParseEnumDeclaration(_t56, !0);
                }
              }

              return _get(_getPrototypeOf(_class4.prototype), "parseStatementContent", this).call(this, t, e);
            }
          }, {
            key: "parseAccessModifier",
            value: function parseAccessModifier() {
              return this.tsParseModifier(["public", "protected", "private"]);
            }
          }, {
            key: "parseClassMember",
            value: function parseClassMember(t, e, s) {
              var _this33 = this;

              this.tsParseModifiers(e, ["declare"]);
              var r = this.parseAccessModifier();
              r && (e.accessibility = r), this.tsParseModifiers(e, ["declare"]);

              var i = function i() {
                _get(_getPrototypeOf(_class4.prototype), "parseClassMember", _this33).call(_this33, t, e, s);
              };

              e.declare ? this.tsInDeclareContext(i) : i();
            }
          }, {
            key: "parseClassMemberWithIsStatic",
            value: function parseClassMemberWithIsStatic(t, e, s, r) {
              this.tsParseModifiers(e, ["abstract", "readonly", "declare"]);
              var i = this.tsTryParseIndexSignature(e);
              if (i) return t.body.push(i), e.abstract && this.raise(e.start, dt.IndexSignatureHasAbstract), r && this.raise(e.start, dt.IndexSignatureHasStatic), e.accessibility && this.raise(e.start, dt.IndexSignatureHasAccessibility, e.accessibility), void (e.declare && this.raise(e.start, dt.IndexSignatureHasDeclare));

              _get(_getPrototypeOf(_class4.prototype), "parseClassMemberWithIsStatic", this).call(this, t, e, s, r);
            }
          }, {
            key: "parsePostMemberNameModifiers",
            value: function parsePostMemberNameModifiers(t) {
              this.eat(c.question) && (t.optional = !0), t.readonly && this.match(c.parenL) && this.raise(t.start, dt.ClassMethodHasReadonly), t.declare && this.match(c.parenL) && this.raise(t.start, dt.ClassMethodHasDeclare);
            }
          }, {
            key: "parseExpressionStatement",
            value: function parseExpressionStatement(t, e) {
              return ("Identifier" === e.type ? this.tsParseExpressionStatement(t, e) : void 0) || _get(_getPrototypeOf(_class4.prototype), "parseExpressionStatement", this).call(this, t, e);
            }
          }, {
            key: "shouldParseExportDeclaration",
            value: function shouldParseExportDeclaration() {
              return !!this.tsIsDeclarationStart() || _get(_getPrototypeOf(_class4.prototype), "shouldParseExportDeclaration", this).call(this);
            }
          }, {
            key: "parseConditional",
            value: function parseConditional(t, e, s, r) {
              var _this34 = this;

              if (!r || !this.match(c.question)) return _get(_getPrototypeOf(_class4.prototype), "parseConditional", this).call(this, t, e, s, r);
              var i = this.tryParse(function () {
                return _get(_getPrototypeOf(_class4.prototype), "parseConditional", _this34).call(_this34, t, e, s);
              });
              return i.node ? (i.error && (this.state = i.failState), i.node) : (r.start = i.error.pos || this.state.start, t);
            }
          }, {
            key: "parseParenItem",
            value: function parseParenItem(t, e, s) {
              if (t = _get(_getPrototypeOf(_class4.prototype), "parseParenItem", this).call(this, t, e, s), this.eat(c.question) && (t.optional = !0, this.resetEndLocation(t)), this.match(c.colon)) {
                var _r29 = this.startNodeAt(e, s);

                return _r29.expression = t, _r29.typeAnnotation = this.tsParseTypeAnnotation(), this.finishNode(_r29, "TSTypeCastExpression");
              }

              return t;
            }
          }, {
            key: "parseExportDeclaration",
            value: function parseExportDeclaration(t) {
              var e = this.state.start,
                  s = this.state.startLoc,
                  r = this.eatContextual("declare");
              var i;
              return this.match(c.name) && (i = this.tsTryParseExportDeclaration()), i || (i = _get(_getPrototypeOf(_class4.prototype), "parseExportDeclaration", this).call(this, t)), i && ("TSInterfaceDeclaration" === i.type || "TSTypeAliasDeclaration" === i.type || r) && (t.exportKind = "type"), i && r && (this.resetStartLocation(i, e, s), i.declare = !0), i;
            }
          }, {
            key: "parseClassId",
            value: function parseClassId(t, e, s) {
              if ((!e || s) && this.isContextual("implements")) return;

              _get(_getPrototypeOf(_class4.prototype), "parseClassId", this).call(this, t, e, s, t.declare ? 1024 : 139);

              var r = this.tsTryParseTypeParameters();
              r && (t.typeParameters = r);
            }
          }, {
            key: "parseClassPropertyAnnotation",
            value: function parseClassPropertyAnnotation(t) {
              !t.optional && this.eat(c.bang) && (t.definite = !0);
              var e = this.tsTryParseTypeAnnotation();
              e && (t.typeAnnotation = e);
            }
          }, {
            key: "parseClassProperty",
            value: function parseClassProperty(t) {
              return this.parseClassPropertyAnnotation(t), this.state.isDeclareContext && this.match(c.eq) && this.raise(this.state.start, dt.DeclareClassFieldHasInitializer), _get(_getPrototypeOf(_class4.prototype), "parseClassProperty", this).call(this, t);
            }
          }, {
            key: "parseClassPrivateProperty",
            value: function parseClassPrivateProperty(t) {
              return t.abstract && this.raise(t.start, dt.PrivateElementHasAbstract), t.accessibility && this.raise(t.start, dt.PrivateElementHasAccessibility, t.accessibility), this.parseClassPropertyAnnotation(t), _get(_getPrototypeOf(_class4.prototype), "parseClassPrivateProperty", this).call(this, t);
            }
          }, {
            key: "pushClassMethod",
            value: function pushClassMethod(t, e, s, r, i, n) {
              var a = this.tsTryParseTypeParameters();
              a && i && this.raise(a.start, dt.ConstructorHasTypeParameters), a && (e.typeParameters = a), _get(_getPrototypeOf(_class4.prototype), "pushClassMethod", this).call(this, t, e, s, r, i, n);
            }
          }, {
            key: "pushClassPrivateMethod",
            value: function pushClassPrivateMethod(t, e, s, r) {
              var i = this.tsTryParseTypeParameters();
              i && (e.typeParameters = i), _get(_getPrototypeOf(_class4.prototype), "pushClassPrivateMethod", this).call(this, t, e, s, r);
            }
          }, {
            key: "parseClassSuper",
            value: function parseClassSuper(t) {
              _get(_getPrototypeOf(_class4.prototype), "parseClassSuper", this).call(this, t), t.superClass && this.isRelational("<") && (t.superTypeParameters = this.tsParseTypeArguments()), this.eatContextual("implements") && (t.implements = this.tsParseHeritageClause("implements"));
            }
          }, {
            key: "parseObjPropValue",
            value: function parseObjPropValue(t) {
              var _get3;

              var s = this.tsTryParseTypeParameters();

              for (var _len4 = arguments.length, e = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
                e[_key4 - 1] = arguments[_key4];
              }

              s && (t.typeParameters = s), (_get3 = _get(_getPrototypeOf(_class4.prototype), "parseObjPropValue", this)).call.apply(_get3, [this, t].concat(e));
            }
          }, {
            key: "parseFunctionParams",
            value: function parseFunctionParams(t, e) {
              var s = this.tsTryParseTypeParameters();
              s && (t.typeParameters = s), _get(_getPrototypeOf(_class4.prototype), "parseFunctionParams", this).call(this, t, e);
            }
          }, {
            key: "parseVarId",
            value: function parseVarId(t, e) {
              _get(_getPrototypeOf(_class4.prototype), "parseVarId", this).call(this, t, e), "Identifier" === t.id.type && this.eat(c.bang) && (t.definite = !0);
              var s = this.tsTryParseTypeAnnotation();
              s && (t.id.typeAnnotation = s, this.resetEndLocation(t.id));
            }
          }, {
            key: "parseAsyncArrowFromCallExpression",
            value: function parseAsyncArrowFromCallExpression(t, e) {
              return this.match(c.colon) && (t.returnType = this.tsParseTypeAnnotation()), _get(_getPrototypeOf(_class4.prototype), "parseAsyncArrowFromCallExpression", this).call(this, t, e);
            }
          }, {
            key: "parseMaybeAssign",
            value: function parseMaybeAssign() {
              var _this35 = this,
                  _get5;

              for (var _len5 = arguments.length, t = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                t[_key5] = arguments[_key5];
              }

              var e, s, r, i, n, a, o;
              var u, h, p, l;

              if (this.match(c.jsxTagStart)) {
                if (u = this.state.clone(), h = this.tryParse(function () {
                  var _get4;

                  return (_get4 = _get(_getPrototypeOf(_class4.prototype), "parseMaybeAssign", _this35)).call.apply(_get4, [_this35].concat(t));
                }, u), !h.error) return h.node;
                var _e50 = this.state.context;
                _e50[_e50.length - 1] === T.j_oTag ? _e50.length -= 2 : _e50[_e50.length - 1] === T.j_expr && (_e50.length -= 1);
              }

              if (!(null == (e = h) ? void 0 : e.error) && !this.isRelational("<")) return (_get5 = _get(_getPrototypeOf(_class4.prototype), "parseMaybeAssign", this)).call.apply(_get5, [this].concat(t));
              u = u || this.state.clone();
              var d = this.tryParse(function (e) {
                var _get6;

                var s;
                l = _this35.tsParseTypeParameters();

                var r = (_get6 = _get(_getPrototypeOf(_class4.prototype), "parseMaybeAssign", _this35)).call.apply(_get6, [_this35].concat(t));

                return ("ArrowFunctionExpression" !== r.type || r.extra && r.extra.parenthesized) && e(), 0 !== (null == (s = l) ? void 0 : s.params.length) && _this35.resetStartLocationFromNode(r, l), r.typeParameters = l, r;
              }, u);
              if (!d.error && !d.aborted) return d.node;
              if (!h && (lt(!this.hasPlugin("jsx")), p = this.tryParse(function () {
                var _get7;

                return (_get7 = _get(_getPrototypeOf(_class4.prototype), "parseMaybeAssign", _this35)).call.apply(_get7, [_this35].concat(t));
              }, u), !p.error)) return p.node;
              if (null == (s = h) ? void 0 : s.node) return this.state = h.failState, h.node;
              if (d.node) return this.state = d.failState, d.node;
              if (null == (r = p) ? void 0 : r.node) return this.state = p.failState, p.node;
              if (null == (i = h) ? void 0 : i.thrown) throw h.error;
              if (d.thrown) throw d.error;
              if (null == (n = p) ? void 0 : n.thrown) throw p.error;
              throw (null == (a = h) ? void 0 : a.error) || d.error || (null == (o = p) ? void 0 : o.error);
            }
          }, {
            key: "parseMaybeUnary",
            value: function parseMaybeUnary(t) {
              return !this.hasPlugin("jsx") && this.isRelational("<") ? this.tsParseTypeAssertion() : _get(_getPrototypeOf(_class4.prototype), "parseMaybeUnary", this).call(this, t);
            }
          }, {
            key: "parseArrow",
            value: function parseArrow(t) {
              var _this36 = this;

              if (this.match(c.colon)) {
                var _e51 = this.tryParse(function (t) {
                  var e = _this36.tsParseTypeOrTypePredicateAnnotation(c.colon);

                  return !_this36.canInsertSemicolon() && _this36.match(c.arrow) || t(), e;
                });

                if (_e51.aborted) return;
                _e51.thrown || (_e51.error && (this.state = _e51.failState), t.returnType = _e51.node);
              }

              return _get(_getPrototypeOf(_class4.prototype), "parseArrow", this).call(this, t);
            }
          }, {
            key: "parseAssignableListItemTypes",
            value: function parseAssignableListItemTypes(t) {
              this.eat(c.question) && ("Identifier" === t.type || this.state.isDeclareContext || this.state.inType || this.raise(t.start, dt.PatternIsOptional), t.optional = !0);
              var e = this.tsTryParseTypeAnnotation();
              return e && (t.typeAnnotation = e), this.resetEndLocation(t), t;
            }
          }, {
            key: "toAssignable",
            value: function toAssignable(t) {
              switch (t.type) {
                case "TSTypeCastExpression":
                  return _get(_getPrototypeOf(_class4.prototype), "toAssignable", this).call(this, this.typeCastToParameter(t));

                case "TSParameterProperty":
                  return _get(_getPrototypeOf(_class4.prototype), "toAssignable", this).call(this, t);

                case "TSAsExpression":
                case "TSNonNullExpression":
                case "TSTypeAssertion":
                  return t.expression = this.toAssignable(t.expression), t;

                default:
                  return _get(_getPrototypeOf(_class4.prototype), "toAssignable", this).call(this, t);
              }
            }
          }, {
            key: "checkLVal",
            value: function checkLVal(t) {
              var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 64;
              var s = arguments.length > 2 ? arguments[2] : undefined;
              var r = arguments.length > 3 ? arguments[3] : undefined;

              switch (t.type) {
                case "TSTypeCastExpression":
                  return;

                case "TSParameterProperty":
                  return void this.checkLVal(t.parameter, e, s, "parameter property");

                case "TSAsExpression":
                case "TSNonNullExpression":
                case "TSTypeAssertion":
                  return void this.checkLVal(t.expression, e, s, r);

                default:
                  return void _get(_getPrototypeOf(_class4.prototype), "checkLVal", this).call(this, t, e, s, r);
              }
            }
          }, {
            key: "parseBindingAtom",
            value: function parseBindingAtom() {
              switch (this.state.type) {
                case c._this:
                  return this.parseIdentifier(!0);

                default:
                  return _get(_getPrototypeOf(_class4.prototype), "parseBindingAtom", this).call(this);
              }
            }
          }, {
            key: "parseMaybeDecoratorArguments",
            value: function parseMaybeDecoratorArguments(t) {
              if (this.isRelational("<")) {
                var _e52 = this.tsParseTypeArguments();

                if (this.match(c.parenL)) {
                  var _s27 = _get(_getPrototypeOf(_class4.prototype), "parseMaybeDecoratorArguments", this).call(this, t);

                  return _s27.typeParameters = _e52, _s27;
                }

                this.unexpected(this.state.start, c.parenL);
              }

              return _get(_getPrototypeOf(_class4.prototype), "parseMaybeDecoratorArguments", this).call(this, t);
            }
          }, {
            key: "isClassMethod",
            value: function isClassMethod() {
              return this.isRelational("<") || _get(_getPrototypeOf(_class4.prototype), "isClassMethod", this).call(this);
            }
          }, {
            key: "isClassProperty",
            value: function isClassProperty() {
              return this.match(c.bang) || this.match(c.colon) || _get(_getPrototypeOf(_class4.prototype), "isClassProperty", this).call(this);
            }
          }, {
            key: "parseMaybeDefault",
            value: function parseMaybeDefault() {
              var _get8;

              for (var _len6 = arguments.length, t = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
                t[_key6] = arguments[_key6];
              }

              var e = (_get8 = _get(_getPrototypeOf(_class4.prototype), "parseMaybeDefault", this)).call.apply(_get8, [this].concat(t));

              return "AssignmentPattern" === e.type && e.typeAnnotation && e.right.start < e.typeAnnotation.start && this.raise(e.typeAnnotation.start, dt.TypeAnnotationAfterAssign), e;
            }
          }, {
            key: "getTokenFromCode",
            value: function getTokenFromCode(t) {
              return !this.state.inType || 62 !== t && 60 !== t ? _get(_getPrototypeOf(_class4.prototype), "getTokenFromCode", this).call(this, t) : this.finishOp(c.relational, 1);
            }
          }, {
            key: "reScan_lt_gt",
            value: function reScan_lt_gt() {
              if (this.match(c.relational)) {
                var _t57 = this.input.charCodeAt(this.state.start);

                60 !== _t57 && 62 !== _t57 || (this.state.pos -= 1, this.readToken_lt_gt(_t57));
              }
            }
          }, {
            key: "toAssignableList",
            value: function toAssignableList(t) {
              for (var _e53 = 0; _e53 < t.length; _e53++) {
                var _s28 = t[_e53];
                if (_s28) switch (_s28.type) {
                  case "TSTypeCastExpression":
                    t[_e53] = this.typeCastToParameter(_s28);
                    break;

                  case "TSAsExpression":
                  case "TSTypeAssertion":
                    this.state.maybeInArrowParameters ? this.raise(_s28.start, dt.UnexpectedTypeCastInParameter) : t[_e53] = this.typeCastToParameter(_s28);
                }
              }

              return _get(_getPrototypeOf(_class4.prototype), "toAssignableList", this).apply(this, arguments);
            }
          }, {
            key: "typeCastToParameter",
            value: function typeCastToParameter(t) {
              return t.expression.typeAnnotation = t.typeAnnotation, this.resetEndLocation(t.expression, t.typeAnnotation.end, t.typeAnnotation.loc.end), t.expression;
            }
          }, {
            key: "shouldParseArrow",
            value: function shouldParseArrow() {
              return this.match(c.colon) || _get(_getPrototypeOf(_class4.prototype), "shouldParseArrow", this).call(this);
            }
          }, {
            key: "shouldParseAsyncArrow",
            value: function shouldParseAsyncArrow() {
              return this.match(c.colon) || _get(_getPrototypeOf(_class4.prototype), "shouldParseAsyncArrow", this).call(this);
            }
          }, {
            key: "canHaveLeadingDecorator",
            value: function canHaveLeadingDecorator() {
              return _get(_getPrototypeOf(_class4.prototype), "canHaveLeadingDecorator", this).call(this) || this.isAbstractClass();
            }
          }, {
            key: "jsxParseOpeningElementAfterName",
            value: function jsxParseOpeningElementAfterName(t) {
              var _this37 = this;

              if (this.isRelational("<")) {
                var _e54 = this.tsTryParseAndCatch(function () {
                  return _this37.tsParseTypeArguments();
                });

                _e54 && (t.typeParameters = _e54);
              }

              return _get(_getPrototypeOf(_class4.prototype), "jsxParseOpeningElementAfterName", this).call(this, t);
            }
          }, {
            key: "getGetterSetterExpectedParamCount",
            value: function getGetterSetterExpectedParamCount(t) {
              var e = _get(_getPrototypeOf(_class4.prototype), "getGetterSetterExpectedParamCount", this).call(this, t),
                  s = t.params[0];

              return s && "Identifier" === s.type && "this" === s.name ? e + 1 : e;
            }
          }, {
            key: "parseCatchClauseParam",
            value: function parseCatchClauseParam() {
              var t = _get(_getPrototypeOf(_class4.prototype), "parseCatchClauseParam", this).call(this),
                  e = this.tsTryParseTypeAnnotation();

              return e && (t.typeAnnotation = e, this.resetEndLocation(t)), t;
            }
          }, {
            key: "tsInDeclareContext",
            value: function tsInDeclareContext(t) {
              var e = this.state.isDeclareContext;
              this.state.isDeclareContext = !0;

              try {
                return t();
              } finally {
                this.state.isDeclareContext = e;
              }
            }
          }]);

          return _class4;
        }(t);
      },
      v8intrinsic: function v8intrinsic(t) {
        return /*#__PURE__*/function (_t58) {
          _inherits(_class5, _t58);

          var _super7 = _createSuper(_class5);

          function _class5() {
            _classCallCheck(this, _class5);

            return _super7.apply(this, arguments);
          }

          _createClass(_class5, [{
            key: "parseV8Intrinsic",
            value: function parseV8Intrinsic() {
              if (this.match(c.modulo)) {
                var _t59 = this.state.start,
                    _e55 = this.startNode();

                if (this.eat(c.modulo), this.match(c.name)) {
                  var _t60 = this.parseIdentifierName(this.state.start),
                      _s29 = this.createIdentifier(_e55, _t60);

                  if (_s29.type = "V8IntrinsicIdentifier", this.match(c.parenL)) return _s29;
                }

                this.unexpected(_t59);
              }
            }
          }, {
            key: "parseExprAtom",
            value: function parseExprAtom() {
              return this.parseV8Intrinsic() || _get(_getPrototypeOf(_class5.prototype), "parseExprAtom", this).apply(this, arguments);
            }
          }]);

          return _class5;
        }(t);
      },
      placeholders: function placeholders(t) {
        return /*#__PURE__*/function (_t61) {
          _inherits(_class6, _t61);

          var _super8 = _createSuper(_class6);

          function _class6() {
            _classCallCheck(this, _class6);

            return _super8.apply(this, arguments);
          }

          _createClass(_class6, [{
            key: "parsePlaceholder",
            value: function parsePlaceholder(t) {
              if (this.match(c.placeholder)) {
                var _e56 = this.startNode();

                return this.next(), this.assertNoSpace("Unexpected space in placeholder."), _e56.name = _get(_getPrototypeOf(_class6.prototype), "parseIdentifier", this).call(this, !0), this.assertNoSpace("Unexpected space in placeholder."), this.expect(c.placeholder), this.finishPlaceholder(_e56, t);
              }
            }
          }, {
            key: "finishPlaceholder",
            value: function finishPlaceholder(t, e) {
              var s = !(!t.expectedNode || "Placeholder" !== t.type);
              return t.expectedNode = e, s ? t : this.finishNode(t, "Placeholder");
            }
          }, {
            key: "getTokenFromCode",
            value: function getTokenFromCode(t) {
              return 37 === t && 37 === this.input.charCodeAt(this.state.pos + 1) ? this.finishOp(c.placeholder, 2) : _get(_getPrototypeOf(_class6.prototype), "getTokenFromCode", this).apply(this, arguments);
            }
          }, {
            key: "parseExprAtom",
            value: function parseExprAtom() {
              return this.parsePlaceholder("Expression") || _get(_getPrototypeOf(_class6.prototype), "parseExprAtom", this).apply(this, arguments);
            }
          }, {
            key: "parseIdentifier",
            value: function parseIdentifier() {
              return this.parsePlaceholder("Identifier") || _get(_getPrototypeOf(_class6.prototype), "parseIdentifier", this).apply(this, arguments);
            }
          }, {
            key: "checkReservedWord",
            value: function checkReservedWord(t) {
              void 0 !== t && _get(_getPrototypeOf(_class6.prototype), "checkReservedWord", this).apply(this, arguments);
            }
          }, {
            key: "parseBindingAtom",
            value: function parseBindingAtom() {
              return this.parsePlaceholder("Pattern") || _get(_getPrototypeOf(_class6.prototype), "parseBindingAtom", this).apply(this, arguments);
            }
          }, {
            key: "checkLVal",
            value: function checkLVal(t) {
              "Placeholder" !== t.type && _get(_getPrototypeOf(_class6.prototype), "checkLVal", this).apply(this, arguments);
            }
          }, {
            key: "toAssignable",
            value: function toAssignable(t) {
              return t && "Placeholder" === t.type && "Expression" === t.expectedNode ? (t.expectedNode = "Pattern", t) : _get(_getPrototypeOf(_class6.prototype), "toAssignable", this).apply(this, arguments);
            }
          }, {
            key: "verifyBreakContinue",
            value: function verifyBreakContinue(t) {
              t.label && "Placeholder" === t.label.type || _get(_getPrototypeOf(_class6.prototype), "verifyBreakContinue", this).apply(this, arguments);
            }
          }, {
            key: "parseExpressionStatement",
            value: function parseExpressionStatement(t, e) {
              if ("Placeholder" !== e.type || e.extra && e.extra.parenthesized) return _get(_getPrototypeOf(_class6.prototype), "parseExpressionStatement", this).apply(this, arguments);

              if (this.match(c.colon)) {
                var _s30 = t;
                return _s30.label = this.finishPlaceholder(e, "Identifier"), this.next(), _s30.body = this.parseStatement("label"), this.finishNode(_s30, "LabeledStatement");
              }

              return this.semicolon(), t.name = e.name, this.finishPlaceholder(t, "Statement");
            }
          }, {
            key: "parseBlock",
            value: function parseBlock() {
              return this.parsePlaceholder("BlockStatement") || _get(_getPrototypeOf(_class6.prototype), "parseBlock", this).apply(this, arguments);
            }
          }, {
            key: "parseFunctionId",
            value: function parseFunctionId() {
              return this.parsePlaceholder("Identifier") || _get(_getPrototypeOf(_class6.prototype), "parseFunctionId", this).apply(this, arguments);
            }
          }, {
            key: "parseClass",
            value: function parseClass(t, e, s) {
              var r = e ? "ClassDeclaration" : "ClassExpression";
              this.next(), this.takeDecorators(t);
              var i = this.state.strict,
                  n = this.parsePlaceholder("Identifier");
              if (n) {
                if (this.match(c._extends) || this.match(c.placeholder) || this.match(c.braceL)) t.id = n;else {
                  if (s || !e) return t.id = null, t.body = this.finishPlaceholder(n, "ClassBody"), this.finishNode(t, r);
                  this.unexpected(null, "A class name is required");
                }
              } else this.parseClassId(t, e, s);
              return this.parseClassSuper(t), t.body = this.parsePlaceholder("ClassBody") || this.parseClassBody(!!t.superClass, i), this.finishNode(t, r);
            }
          }, {
            key: "parseExport",
            value: function parseExport(t) {
              var e = this.parsePlaceholder("Identifier");
              if (!e) return _get(_getPrototypeOf(_class6.prototype), "parseExport", this).apply(this, arguments);
              if (!this.isContextual("from") && !this.match(c.comma)) return t.specifiers = [], t.source = null, t.declaration = this.finishPlaceholder(e, "Declaration"), this.finishNode(t, "ExportNamedDeclaration");
              this.expectPlugin("exportDefaultFrom");
              var s = this.startNode();
              return s.exported = e, t.specifiers = [this.finishNode(s, "ExportDefaultSpecifier")], _get(_getPrototypeOf(_class6.prototype), "parseExport", this).call(this, t);
            }
          }, {
            key: "isExportDefaultSpecifier",
            value: function isExportDefaultSpecifier() {
              if (this.match(c._default)) {
                var _t62 = this.nextTokenStart();

                if (this.isUnparsedContextual(_t62, "from") && this.input.startsWith(c.placeholder.label, this.nextTokenStartSince(_t62 + 4))) return !0;
              }

              return _get(_getPrototypeOf(_class6.prototype), "isExportDefaultSpecifier", this).call(this);
            }
          }, {
            key: "maybeParseExportDefaultSpecifier",
            value: function maybeParseExportDefaultSpecifier(t) {
              return !!(t.specifiers && t.specifiers.length > 0) || _get(_getPrototypeOf(_class6.prototype), "maybeParseExportDefaultSpecifier", this).apply(this, arguments);
            }
          }, {
            key: "checkExport",
            value: function checkExport(t) {
              var e = t.specifiers;
              (null == e ? void 0 : e.length) && (t.specifiers = e.filter(function (t) {
                return "Placeholder" === t.exported.type;
              })), _get(_getPrototypeOf(_class6.prototype), "checkExport", this).call(this, t), t.specifiers = e;
            }
          }, {
            key: "parseImport",
            value: function parseImport(t) {
              var e = this.parsePlaceholder("Identifier");
              if (!e) return _get(_getPrototypeOf(_class6.prototype), "parseImport", this).apply(this, arguments);
              if (t.specifiers = [], !this.isContextual("from") && !this.match(c.comma)) return t.source = this.finishPlaceholder(e, "StringLiteral"), this.semicolon(), this.finishNode(t, "ImportDeclaration");
              var s = this.startNodeAtNode(e);

              if (s.local = e, this.finishNode(s, "ImportDefaultSpecifier"), t.specifiers.push(s), this.eat(c.comma)) {
                this.maybeParseStarImportSpecifier(t) || this.parseNamedImportSpecifiers(t);
              }

              return this.expectContextual("from"), t.source = this.parseImportSource(), this.semicolon(), this.finishNode(t, "ImportDeclaration");
            }
          }, {
            key: "parseImportSource",
            value: function parseImportSource() {
              return this.parsePlaceholder("StringLiteral") || _get(_getPrototypeOf(_class6.prototype), "parseImportSource", this).apply(this, arguments);
            }
          }]);

          return _class6;
        }(t);
      }
    },
        At = Object.keys(Et),
        Ct = {
      sourceType: "script",
      sourceFilename: void 0,
      startLine: 1,
      allowAwaitOutsideFunction: !1,
      allowReturnOutsideFunction: !1,
      allowImportExportEverywhere: !1,
      allowSuperOutsideMethod: !1,
      allowUndeclaredExports: !1,
      plugins: [],
      strictMode: null,
      ranges: !1,
      tokens: !1,
      createParenthesizedExpressions: !1,
      errorRecovery: !1
    };

    var xt = /*#__PURE__*/function () {
      function xt() {
        _classCallCheck(this, xt);

        this.strict = void 0, this.curLine = void 0, this.startLoc = void 0, this.endLoc = void 0, this.errors = [], this.potentialArrowAt = -1, this.noArrowAt = [], this.noArrowParamsConversionAt = [], this.maybeInArrowParameters = !1, this.inPipeline = !1, this.inType = !1, this.noAnonFunctionType = !1, this.inPropertyName = !1, this.hasFlowComment = !1, this.isIterator = !1, this.isDeclareContext = !1, this.topicContext = {
          maxNumOfResolvableTopics: 0,
          maxTopicIndex: null
        }, this.soloAwait = !1, this.inFSharpPipelineDirectBody = !1, this.labels = [], this.decoratorStack = [[]], this.comments = [], this.trailingComments = [], this.leadingComments = [], this.commentStack = [], this.commentPreviousNode = null, this.pos = 0, this.lineStart = 0, this.type = c.eof, this.value = null, this.start = 0, this.end = 0, this.lastTokEndLoc = null, this.lastTokStartLoc = null, this.lastTokStart = 0, this.lastTokEnd = 0, this.context = [T.braceStatement], this.exprAllowed = !0, this.containsEsc = !1, this.octalPositions = [], this.exportedIdentifiers = [], this.tokensLength = 0;
      }

      _createClass(xt, [{
        key: "init",
        value: function init(t) {
          this.strict = !1 !== t.strictMode && "module" === t.sourceType, this.curLine = t.startLine, this.startLoc = this.endLoc = this.curPosition();
        }
      }, {
        key: "curPosition",
        value: function curPosition() {
          return new C(this.curLine, this.pos - this.lineStart);
        }
      }, {
        key: "clone",
        value: function clone(t) {
          var e = new xt(),
              s = Object.keys(this);

          for (var _r30 = 0, _i19 = s.length; _r30 < _i19; _r30++) {
            var _i20 = s[_r30];
            var _n12 = this[_i20];
            !t && Array.isArray(_n12) && (_n12 = _n12.slice()), e[_i20] = _n12;
          }

          return e;
        }
      }]);

      return xt;
    }();

    var Ft = function Ft(t) {
      return t >= 48 && t <= 57;
    };

    var gt = new Set(["g", "m", "s", "i", "y", "u"]),
        bt = {
      decBinOct: [46, 66, 69, 79, 95, 98, 101, 111],
      hex: [46, 88, 95, 120]
    },
        Pt = {
      bin: [48, 49]
    };
    Pt.oct = [].concat(_toConsumableArray(Pt.bin), [50, 51, 52, 53, 54, 55]), Pt.dec = [].concat(_toConsumableArray(Pt.oct), [56, 57]), Pt.hex = [].concat(_toConsumableArray(Pt.dec), [65, 66, 67, 68, 69, 70, 97, 98, 99, 100, 101, 102]);

    var Tt = function Tt(t) {
      _classCallCheck(this, Tt);

      this.type = t.type, this.value = t.value, this.start = t.start, this.end = t.end, this.loc = new x(t.startLoc, t.endLoc);
    };

    var wt = function wt() {
      _classCallCheck(this, wt);

      this.shorthandAssign = -1, this.doubleProto = -1;
    };

    var Bt = /*#__PURE__*/function () {
      function Bt(t, e, s) {
        _classCallCheck(this, Bt);

        this.type = void 0, this.start = void 0, this.end = void 0, this.loc = void 0, this.range = void 0, this.leadingComments = void 0, this.trailingComments = void 0, this.innerComments = void 0, this.extra = void 0, this.type = "", this.start = e, this.end = 0, this.loc = new x(s), (null == t ? void 0 : t.options.ranges) && (this.range = [e, 0]), (null == t ? void 0 : t.filename) && (this.loc.filename = t.filename);
      }

      _createClass(Bt, [{
        key: "__clone",
        value: function __clone() {
          var t = new Bt(),
              e = Object.keys(this);

          for (var _s31 = 0, _r31 = e.length; _s31 < _r31; _s31++) {
            var _r32 = e[_s31];
            "leadingComments" !== _r32 && "trailingComments" !== _r32 && "innerComments" !== _r32 && (t[_r32] = this[_r32]);
          }

          return t;
        }
      }]);

      return Bt;
    }();

    var St = function St(t) {
      return "ParenthesizedExpression" === t.type ? St(t.expression) : t;
    };

    var Nt = /*#__PURE__*/function () {
      function Nt() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

        _classCallCheck(this, Nt);

        this.type = void 0, this.type = t;
      }

      _createClass(Nt, [{
        key: "canBeArrowParameterDeclaration",
        value: function canBeArrowParameterDeclaration() {
          return 2 === this.type || 1 === this.type;
        }
      }, {
        key: "isCertainlyParameterDeclaration",
        value: function isCertainlyParameterDeclaration() {
          return 3 === this.type;
        }
      }]);

      return Nt;
    }();

    var It = /*#__PURE__*/function (_Nt) {
      _inherits(It, _Nt);

      var _super9 = _createSuper(It);

      function It(t) {
        var _this38;

        _classCallCheck(this, It);

        _this38 = _super9.call(this, t), _this38.errors = new Map();
        return _this38;
      }

      _createClass(It, [{
        key: "recordDeclarationError",
        value: function recordDeclarationError(t, e) {
          this.errors.set(t, e);
        }
      }, {
        key: "clearDeclarationError",
        value: function clearDeclarationError(t) {
          this.errors.delete(t);
        }
      }, {
        key: "iterateErrors",
        value: function iterateErrors(t) {
          this.errors.forEach(t);
        }
      }]);

      return It;
    }(Nt);

    var vt = /*#__PURE__*/function () {
      function vt(t) {
        _classCallCheck(this, vt);

        this.stack = [new Nt()], this.raise = t;
      }

      _createClass(vt, [{
        key: "enter",
        value: function enter(t) {
          this.stack.push(t);
        }
      }, {
        key: "exit",
        value: function exit() {
          this.stack.pop();
        }
      }, {
        key: "recordParameterInitializerError",
        value: function recordParameterInitializerError(t, e) {
          var s = this.stack;
          var r = s.length - 1,
              i = s[r];

          for (; !i.isCertainlyParameterDeclaration();) {
            if (!i.canBeArrowParameterDeclaration()) return;
            i.recordDeclarationError(t, e), i = s[--r];
          }

          this.raise(t, e);
        }
      }, {
        key: "recordAsyncArrowParametersError",
        value: function recordAsyncArrowParametersError(t, e) {
          var s = this.stack;
          var r = s.length - 1,
              i = s[r];

          for (; i.canBeArrowParameterDeclaration();) {
            2 === i.type && i.recordDeclarationError(t, e), i = s[--r];
          }
        }
      }, {
        key: "validateAsPattern",
        value: function validateAsPattern() {
          var _this39 = this;

          var t = this.stack,
              e = t[t.length - 1];
          e.canBeArrowParameterDeclaration() && e.iterateErrors(function (e, s) {
            _this39.raise(s, e);

            var r = t.length - 2,
                i = t[r];

            for (; i.canBeArrowParameterDeclaration();) {
              i.clearDeclarationError(s), i = t[--r];
            }
          });
        }
      }]);

      return vt;
    }();

    function kt() {
      return new Nt();
    }

    var Lt = {
      kind: "loop"
    },
        Ot = {
      kind: "switch"
    },
        Mt = /(?:[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/;

    var Rt = function Rt() {
      _classCallCheck(this, Rt);

      this.privateNames = new Set(), this.loneAccessors = new Map(), this.undefinedPrivateNames = new Map();
    };

    var _t = /*#__PURE__*/function () {
      function _t(t) {
        _classCallCheck(this, _t);

        this.stack = [], this.undefinedPrivateNames = new Map(), this.raise = t;
      }

      _createClass(_t, [{
        key: "current",
        value: function current() {
          return this.stack[this.stack.length - 1];
        }
      }, {
        key: "enter",
        value: function enter() {
          this.stack.push(new Rt());
        }
      }, {
        key: "exit",
        value: function exit() {
          var t = this.stack.pop(),
              e = this.current();

          for (var _s32 = 0, _r33 = Array.from(t.undefinedPrivateNames); _s32 < _r33.length; _s32++) {
            var _r33$_s = _slicedToArray(_r33[_s32], 2),
                _t63 = _r33$_s[0],
                _i21 = _r33$_s[1];

            e ? e.undefinedPrivateNames.has(_t63) || e.undefinedPrivateNames.set(_t63, _i21) : this.raise(_i21, g.InvalidPrivateFieldResolution, _t63);
          }
        }
      }, {
        key: "declarePrivateName",
        value: function declarePrivateName(t, e, s) {
          var r = this.current();
          var i = r.privateNames.has(t);

          if (3 & e) {
            var _s33 = i && r.loneAccessors.get(t);

            if (_s33) {
              var _n13 = 4 & _s33,
                  _a5 = 4 & e;

              i = (3 & _s33) === (3 & e) || _n13 !== _a5, i || r.loneAccessors.delete(t);
            } else i || r.loneAccessors.set(t, e);
          }

          i && this.raise(s, g.PrivateNameRedeclaration, t), r.privateNames.add(t), r.undefinedPrivateNames.delete(t);
        }
      }, {
        key: "usePrivateName",
        value: function usePrivateName(t, e) {
          var s;

          for (var _e57 = 0, _r34 = this.stack; _e57 < _r34.length; _e57++) {
            if (s = _r34[_e57], s.privateNames.has(t)) return;
          }

          s ? s.undefinedPrivateNames.set(t, e) : this.raise(e, g.InvalidPrivateFieldResolution, t);
        }
      }]);

      return _t;
    }();

    var jt = /*#__PURE__*/function (_ref26) {
      _inherits(jt, _ref26);

      var _super10 = _createSuper(jt);

      function jt(t, e) {
        var _this40;

        _classCallCheck(this, jt);

        _this40 = _super10.call(this, t = function (t) {
          var e = {};

          for (var _s34 = 0, _r35 = Object.keys(Ct); _s34 < _r35.length; _s34++) {
            var _i22 = _r35[_s34];
            e[_i22] = t && null != t[_i22] ? t[_i22] : Ct[_i22];
          }

          return e;
        }(t), e);

        var s = _this40.getScopeHandler();

        _this40.options = t, _this40.inModule = "module" === _this40.options.sourceType, _this40.scope = new s(_this40.raise.bind(_assertThisInitialized(_this40)), _this40.inModule), _this40.prodParam = new ht(), _this40.classScope = new _t(_this40.raise.bind(_assertThisInitialized(_this40))), _this40.expressionScope = new vt(_this40.raise.bind(_assertThisInitialized(_this40))), _this40.plugins = function (t) {
          var e = new Map();

          for (var _s35 = 0; _s35 < t.length; _s35++) {
            var _r36 = t[_s35],
                _ref27 = Array.isArray(_r36) ? _r36 : [_r36, {}],
                _ref28 = _slicedToArray(_ref27, 2),
                _i23 = _ref28[0],
                _n14 = _ref28[1];

            e.has(_i23) || e.set(_i23, _n14 || {});
          }

          return e;
        }(_this40.options.plugins), _this40.filename = t.sourceFilename;
        return _this40;
      }

      _createClass(jt, [{
        key: "getScopeHandler",
        value: function getScopeHandler() {
          return at;
        }
      }, {
        key: "parse",
        value: function parse() {
          var t = 0;
          this.hasPlugin("topLevelAwait") && this.inModule && (t |= 2), this.scope.enter(1), this.prodParam.enter(t);
          var e = this.startNode(),
              s = this.startNode();
          return this.nextToken(), e.errors = null, this.parseTopLevel(e, s), e.errors = this.state.errors, e;
        }
      }]);

      return jt;
    }( /*#__PURE__*/function (_ref29) {
      _inherits(_class7, _ref29);

      var _super11 = _createSuper(_class7);

      function _class7() {
        _classCallCheck(this, _class7);

        return _super11.apply(this, arguments);
      }

      _createClass(_class7, [{
        key: "parseTopLevel",
        value: function parseTopLevel(t, e) {
          if (e.sourceType = this.options.sourceType, e.interpreter = this.parseInterpreterDirective(), this.parseBlockBody(e, !0, !0, c.eof), this.inModule && !this.options.allowUndeclaredExports && this.scope.undefinedExports.size > 0) for (var _t64 = 0, _e58 = Array.from(this.scope.undefinedExports); _t64 < _e58.length; _t64++) {
            var _e58$_t = _slicedToArray(_e58[_t64], 1),
                _s36 = _e58$_t[0],
                _r37 = this.scope.undefinedExports.get(_s36);

            this.raise(_r37, g.ModuleExportUndefined, _s36);
          }
          return t.program = this.finishNode(e, "Program"), t.comments = this.state.comments, this.options.tokens && (t.tokens = this.tokens), this.finishNode(t, "File");
        }
      }, {
        key: "stmtToDirective",
        value: function stmtToDirective(t) {
          var e = t.expression,
              s = this.startNodeAt(e.start, e.loc.start),
              r = this.startNodeAt(t.start, t.loc.start),
              i = this.input.slice(e.start, e.end),
              n = s.value = i.slice(1, -1);
          return this.addExtra(s, "raw", i), this.addExtra(s, "rawValue", n), r.value = this.finishNodeAt(s, "DirectiveLiteral", e.end, e.loc.end), this.finishNodeAt(r, "Directive", t.end, t.loc.end);
        }
      }, {
        key: "parseInterpreterDirective",
        value: function parseInterpreterDirective() {
          if (!this.match(c.interpreterDirective)) return null;
          var t = this.startNode();
          return t.value = this.state.value, this.next(), this.finishNode(t, "InterpreterDirective");
        }
      }, {
        key: "isLet",
        value: function isLet(t) {
          if (!this.isContextual("let")) return !1;
          var e = this.nextTokenStart(),
              s = this.input.charCodeAt(e);
          if (91 === s) return !0;
          if (t) return !1;
          if (123 === s) return !0;

          if (L(s)) {
            var _t65 = e + 1;

            for (; O(this.input.charCodeAt(_t65));) {
              ++_t65;
            }

            var _s37 = this.input.slice(e, _t65);

            if (!X.test(_s37)) return !0;
          }

          return !1;
        }
      }, {
        key: "parseStatement",
        value: function parseStatement(t, e) {
          return this.match(c.at) && this.parseDecorators(!0), this.parseStatementContent(t, e);
        }
      }, {
        key: "parseStatementContent",
        value: function parseStatementContent(t, e) {
          var s = this.state.type;
          var r = this.startNode();
          var i;

          switch (this.isLet(t) && (s = c._var, i = "let"), s) {
            case c._break:
            case c._continue:
              return this.parseBreakContinueStatement(r, s.keyword);

            case c._debugger:
              return this.parseDebuggerStatement(r);

            case c._do:
              return this.parseDoStatement(r);

            case c._for:
              return this.parseForStatement(r);

            case c._function:
              if (46 === this.lookaheadCharCode()) break;
              return t && (this.state.strict ? this.raise(this.state.start, g.StrictFunction) : "if" !== t && "label" !== t && this.raise(this.state.start, g.SloppyFunction)), this.parseFunctionStatement(r, !1, !t);

            case c._class:
              return t && this.unexpected(), this.parseClass(r, !0);

            case c._if:
              return this.parseIfStatement(r);

            case c._return:
              return this.parseReturnStatement(r);

            case c._switch:
              return this.parseSwitchStatement(r);

            case c._throw:
              return this.parseThrowStatement(r);

            case c._try:
              return this.parseTryStatement(r);

            case c._const:
            case c._var:
              return i = i || this.state.value, t && "var" !== i && this.raise(this.state.start, g.UnexpectedLexicalDeclaration), this.parseVarStatement(r, i);

            case c._while:
              return this.parseWhileStatement(r);

            case c._with:
              return this.parseWithStatement(r);

            case c.braceL:
              return this.parseBlock();

            case c.semi:
              return this.parseEmptyStatement(r);

            case c._import:
              {
                var _t66 = this.lookaheadCharCode();

                if (40 === _t66 || 46 === _t66) break;
              }

            case c._export:
              {
                var _t67;

                return this.options.allowImportExportEverywhere || e || this.raise(this.state.start, g.UnexpectedImportExport), this.next(), s === c._import ? (_t67 = this.parseImport(r), "ImportDeclaration" !== _t67.type || _t67.importKind && "value" !== _t67.importKind || (this.sawUnambiguousESM = !0)) : (_t67 = this.parseExport(r), ("ExportNamedDeclaration" !== _t67.type || _t67.exportKind && "value" !== _t67.exportKind) && ("ExportAllDeclaration" !== _t67.type || _t67.exportKind && "value" !== _t67.exportKind) && "ExportDefaultDeclaration" !== _t67.type || (this.sawUnambiguousESM = !0)), this.assertModuleNodeAllowed(r), _t67;
              }

            default:
              if (this.isAsyncFunction()) return t && this.raise(this.state.start, g.AsyncFunctionInSingleStatementContext), this.next(), this.parseFunctionStatement(r, !0, !t);
          }

          var n = this.state.value,
              a = this.parseExpression();
          return s === c.name && "Identifier" === a.type && this.eat(c.colon) ? this.parseLabeledStatement(r, n, a, t) : this.parseExpressionStatement(r, a);
        }
      }, {
        key: "assertModuleNodeAllowed",
        value: function assertModuleNodeAllowed(t) {
          this.options.allowImportExportEverywhere || this.inModule || this.raiseWithData(t.start, {
            code: "BABEL_PARSER_SOURCETYPE_MODULE_REQUIRED"
          }, g.ImportOutsideModule);
        }
      }, {
        key: "takeDecorators",
        value: function takeDecorators(t) {
          var e = this.state.decoratorStack[this.state.decoratorStack.length - 1];
          e.length && (t.decorators = e, this.resetStartLocationFromNode(t, e[0]), this.state.decoratorStack[this.state.decoratorStack.length - 1] = []);
        }
      }, {
        key: "canHaveLeadingDecorator",
        value: function canHaveLeadingDecorator() {
          return this.match(c._class);
        }
      }, {
        key: "parseDecorators",
        value: function parseDecorators(t) {
          var e = this.state.decoratorStack[this.state.decoratorStack.length - 1];

          for (; this.match(c.at);) {
            var _t68 = this.parseDecorator();

            e.push(_t68);
          }

          if (this.match(c._export)) t || this.unexpected(), this.hasPlugin("decorators") && !this.getPluginOption("decorators", "decoratorsBeforeExport") && this.raise(this.state.start, g.DecoratorExportClass);else if (!this.canHaveLeadingDecorator()) throw this.raise(this.state.start, g.UnexpectedLeadingDecorator);
        }
      }, {
        key: "parseDecorator",
        value: function parseDecorator() {
          this.expectOnePlugin(["decorators-legacy", "decorators"]);
          var t = this.startNode();

          if (this.next(), this.hasPlugin("decorators")) {
            this.state.decoratorStack.push([]);
            var _e59 = this.state.start,
                _s38 = this.state.startLoc;

            var _r38;

            if (this.eat(c.parenL)) _r38 = this.parseExpression(), this.expect(c.parenR);else for (_r38 = this.parseIdentifier(!1); this.eat(c.dot);) {
              var _t69 = this.startNodeAt(_e59, _s38);

              _t69.object = _r38, _t69.property = this.parseIdentifier(!0), _t69.computed = !1, _r38 = this.finishNode(_t69, "MemberExpression");
            }
            t.expression = this.parseMaybeDecoratorArguments(_r38), this.state.decoratorStack.pop();
          } else t.expression = this.parseExprSubscripts();

          return this.finishNode(t, "Decorator");
        }
      }, {
        key: "parseMaybeDecoratorArguments",
        value: function parseMaybeDecoratorArguments(t) {
          if (this.eat(c.parenL)) {
            var _e60 = this.startNodeAtNode(t);

            return _e60.callee = t, _e60.arguments = this.parseCallExpressionArguments(c.parenR, !1), this.toReferencedList(_e60.arguments), this.finishNode(_e60, "CallExpression");
          }

          return t;
        }
      }, {
        key: "parseBreakContinueStatement",
        value: function parseBreakContinueStatement(t, e) {
          var s = "break" === e;
          return this.next(), this.isLineTerminator() ? t.label = null : (t.label = this.parseIdentifier(), this.semicolon()), this.verifyBreakContinue(t, e), this.finishNode(t, s ? "BreakStatement" : "ContinueStatement");
        }
      }, {
        key: "verifyBreakContinue",
        value: function verifyBreakContinue(t, e) {
          var s = "break" === e;
          var r;

          for (r = 0; r < this.state.labels.length; ++r) {
            var _e61 = this.state.labels[r];

            if (null == t.label || _e61.name === t.label.name) {
              if (null != _e61.kind && (s || "loop" === _e61.kind)) break;
              if (t.label && s) break;
            }
          }

          r === this.state.labels.length && this.raise(t.start, g.IllegalBreakContinue, e);
        }
      }, {
        key: "parseDebuggerStatement",
        value: function parseDebuggerStatement(t) {
          return this.next(), this.semicolon(), this.finishNode(t, "DebuggerStatement");
        }
      }, {
        key: "parseHeaderExpression",
        value: function parseHeaderExpression() {
          this.expect(c.parenL);
          var t = this.parseExpression();
          return this.expect(c.parenR), t;
        }
      }, {
        key: "parseDoStatement",
        value: function parseDoStatement(t) {
          var _this41 = this;

          return this.next(), this.state.labels.push(Lt), t.body = this.withTopicForbiddingContext(function () {
            return _this41.parseStatement("do");
          }), this.state.labels.pop(), this.expect(c._while), t.test = this.parseHeaderExpression(), this.eat(c.semi), this.finishNode(t, "DoWhileStatement");
        }
      }, {
        key: "parseForStatement",
        value: function parseForStatement(t) {
          this.next(), this.state.labels.push(Lt);
          var e = -1;
          if (this.isAwaitAllowed() && this.eatContextual("await") && (e = this.state.lastTokStart), this.scope.enter(0), this.expect(c.parenL), this.match(c.semi)) return e > -1 && this.unexpected(e), this.parseFor(t, null);
          var s = this.isLet();

          if (this.match(c._var) || this.match(c._const) || s) {
            var _r39 = this.startNode(),
                _i24 = s ? "let" : this.state.value;

            return this.next(), this.parseVar(_r39, !0, _i24), this.finishNode(_r39, "VariableDeclaration"), (this.match(c._in) || this.isContextual("of")) && 1 === _r39.declarations.length ? this.parseForIn(t, _r39, e) : (e > -1 && this.unexpected(e), this.parseFor(t, _r39));
          }

          var r = new wt(),
              i = this.parseExpression(!0, r);

          if (this.match(c._in) || this.isContextual("of")) {
            this.toAssignable(i);

            var _s39 = this.isContextual("of") ? "for-of statement" : "for-in statement";

            return this.checkLVal(i, void 0, void 0, _s39), this.parseForIn(t, i, e);
          }

          return this.checkExpressionErrors(r, !0), e > -1 && this.unexpected(e), this.parseFor(t, i);
        }
      }, {
        key: "parseFunctionStatement",
        value: function parseFunctionStatement(t, e, s) {
          return this.next(), this.parseFunction(t, 1 | (s ? 0 : 2), e);
        }
      }, {
        key: "parseIfStatement",
        value: function parseIfStatement(t) {
          return this.next(), t.test = this.parseHeaderExpression(), t.consequent = this.parseStatement("if"), t.alternate = this.eat(c._else) ? this.parseStatement("if") : null, this.finishNode(t, "IfStatement");
        }
      }, {
        key: "parseReturnStatement",
        value: function parseReturnStatement(t) {
          return this.prodParam.hasReturn || this.options.allowReturnOutsideFunction || this.raise(this.state.start, g.IllegalReturn), this.next(), this.isLineTerminator() ? t.argument = null : (t.argument = this.parseExpression(), this.semicolon()), this.finishNode(t, "ReturnStatement");
        }
      }, {
        key: "parseSwitchStatement",
        value: function parseSwitchStatement(t) {
          this.next(), t.discriminant = this.parseHeaderExpression();
          var e = t.cases = [];
          var s, r;

          for (this.expect(c.braceL), this.state.labels.push(Ot), this.scope.enter(0); !this.match(c.braceR);) {
            if (this.match(c._case) || this.match(c._default)) {
              var _t70 = this.match(c._case);

              s && this.finishNode(s, "SwitchCase"), e.push(s = this.startNode()), s.consequent = [], this.next(), _t70 ? s.test = this.parseExpression() : (r && this.raise(this.state.lastTokStart, g.MultipleDefaultsInSwitch), r = !0, s.test = null), this.expect(c.colon);
            } else s ? s.consequent.push(this.parseStatement(null)) : this.unexpected();
          }

          return this.scope.exit(), s && this.finishNode(s, "SwitchCase"), this.next(), this.state.labels.pop(), this.finishNode(t, "SwitchStatement");
        }
      }, {
        key: "parseThrowStatement",
        value: function parseThrowStatement(t) {
          return this.next(), this.hasPrecedingLineBreak() && this.raise(this.state.lastTokEnd, g.NewlineAfterThrow), t.argument = this.parseExpression(), this.semicolon(), this.finishNode(t, "ThrowStatement");
        }
      }, {
        key: "parseCatchClauseParam",
        value: function parseCatchClauseParam() {
          var t = this.parseBindingAtom(),
              e = "Identifier" === t.type;
          return this.scope.enter(e ? 8 : 0), this.checkLVal(t, 9, null, "catch clause"), t;
        }
      }, {
        key: "parseTryStatement",
        value: function parseTryStatement(t) {
          var _this42 = this;

          if (this.next(), t.block = this.parseBlock(), t.handler = null, this.match(c._catch)) {
            var _e62 = this.startNode();

            this.next(), this.match(c.parenL) ? (this.expect(c.parenL), _e62.param = this.parseCatchClauseParam(), this.expect(c.parenR)) : (_e62.param = null, this.scope.enter(0)), _e62.body = this.withTopicForbiddingContext(function () {
              return _this42.parseBlock(!1, !1);
            }), this.scope.exit(), t.handler = this.finishNode(_e62, "CatchClause");
          }

          return t.finalizer = this.eat(c._finally) ? this.parseBlock() : null, t.handler || t.finalizer || this.raise(t.start, g.NoCatchOrFinally), this.finishNode(t, "TryStatement");
        }
      }, {
        key: "parseVarStatement",
        value: function parseVarStatement(t, e) {
          return this.next(), this.parseVar(t, !1, e), this.semicolon(), this.finishNode(t, "VariableDeclaration");
        }
      }, {
        key: "parseWhileStatement",
        value: function parseWhileStatement(t) {
          var _this43 = this;

          return this.next(), t.test = this.parseHeaderExpression(), this.state.labels.push(Lt), t.body = this.withTopicForbiddingContext(function () {
            return _this43.parseStatement("while");
          }), this.state.labels.pop(), this.finishNode(t, "WhileStatement");
        }
      }, {
        key: "parseWithStatement",
        value: function parseWithStatement(t) {
          var _this44 = this;

          return this.state.strict && this.raise(this.state.start, g.StrictWith), this.next(), t.object = this.parseHeaderExpression(), t.body = this.withTopicForbiddingContext(function () {
            return _this44.parseStatement("with");
          }), this.finishNode(t, "WithStatement");
        }
      }, {
        key: "parseEmptyStatement",
        value: function parseEmptyStatement(t) {
          return this.next(), this.finishNode(t, "EmptyStatement");
        }
      }, {
        key: "parseLabeledStatement",
        value: function parseLabeledStatement(t, e, s, r) {
          for (var _t71 = 0, _r40 = this.state.labels; _t71 < _r40.length; _t71++) {
            _r40[_t71].name === e && this.raise(s.start, g.LabelRedeclaration, e);
          }

          var i = this.state.type.isLoop ? "loop" : this.match(c._switch) ? "switch" : null;

          for (var _e63 = this.state.labels.length - 1; _e63 >= 0; _e63--) {
            var _s40 = this.state.labels[_e63];
            if (_s40.statementStart !== t.start) break;
            _s40.statementStart = this.state.start, _s40.kind = i;
          }

          return this.state.labels.push({
            name: e,
            kind: i,
            statementStart: this.state.start
          }), t.body = this.parseStatement(r ? -1 === r.indexOf("label") ? r + "label" : r : "label"), this.state.labels.pop(), t.label = s, this.finishNode(t, "LabeledStatement");
        }
      }, {
        key: "parseExpressionStatement",
        value: function parseExpressionStatement(t, e) {
          return t.expression = e, this.semicolon(), this.finishNode(t, "ExpressionStatement");
        }
      }, {
        key: "parseBlock",
        value: function parseBlock() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
          var s = arguments.length > 2 ? arguments[2] : undefined;
          var r = this.startNode();
          return this.expect(c.braceL), e && this.scope.enter(0), this.parseBlockBody(r, t, !1, c.braceR, s), e && this.scope.exit(), this.finishNode(r, "BlockStatement");
        }
      }, {
        key: "isValidDirective",
        value: function isValidDirective(t) {
          return "ExpressionStatement" === t.type && "StringLiteral" === t.expression.type && !t.expression.extra.parenthesized;
        }
      }, {
        key: "parseBlockBody",
        value: function parseBlockBody(t, e, s, r, i) {
          var n = t.body = [],
              a = t.directives = [];
          this.parseBlockOrModuleBlockBody(n, e ? a : void 0, s, r, i);
        }
      }, {
        key: "parseBlockOrModuleBlockBody",
        value: function parseBlockOrModuleBlockBody(t, e, s, r, i) {
          var n = [],
              a = this.state.strict;
          var o = !1,
              u = !1;

          for (; !this.match(r);) {
            !u && this.state.octalPositions.length && n.push.apply(n, _toConsumableArray(this.state.octalPositions));

            var _r41 = this.parseStatement(null, s);

            if (e && !u && this.isValidDirective(_r41)) {
              var _t72 = this.stmtToDirective(_r41);

              e.push(_t72), o || "use strict" !== _t72.value.value || (o = !0, this.setStrict(!0));
            } else u = !0, t.push(_r41);
          }

          if (this.state.strict && n.length) for (var _t73 = 0; _t73 < n.length; _t73++) {
            var _e64 = n[_t73];
            this.raise(_e64, g.StrictOctalLiteral);
          }
          i && i.call(this, o), a || this.setStrict(!1), this.next();
        }
      }, {
        key: "parseFor",
        value: function parseFor(t, e) {
          var _this45 = this;

          return t.init = e, this.expect(c.semi), t.test = this.match(c.semi) ? null : this.parseExpression(), this.expect(c.semi), t.update = this.match(c.parenR) ? null : this.parseExpression(), this.expect(c.parenR), t.body = this.withTopicForbiddingContext(function () {
            return _this45.parseStatement("for");
          }), this.scope.exit(), this.state.labels.pop(), this.finishNode(t, "ForStatement");
        }
      }, {
        key: "parseForIn",
        value: function parseForIn(t, e, s) {
          var _this46 = this;

          var r = this.match(c._in);
          return this.next(), r ? s > -1 && this.unexpected(s) : t.await = s > -1, "VariableDeclaration" !== e.type || null == e.declarations[0].init || r && !this.state.strict && "var" === e.kind && "Identifier" === e.declarations[0].id.type ? "AssignmentPattern" === e.type && this.raise(e.start, g.InvalidLhs, "for-loop") : this.raise(e.start, g.ForInOfLoopInitializer, r ? "for-in" : "for-of"), t.left = e, t.right = r ? this.parseExpression() : this.parseMaybeAssignAllowIn(), this.expect(c.parenR), t.body = this.withTopicForbiddingContext(function () {
            return _this46.parseStatement("for");
          }), this.scope.exit(), this.state.labels.pop(), this.finishNode(t, r ? "ForInStatement" : "ForOfStatement");
        }
      }, {
        key: "parseVar",
        value: function parseVar(t, e, s) {
          var r = t.declarations = [],
              i = this.hasPlugin("typescript");

          for (t.kind = s;;) {
            var _t74 = this.startNode();

            if (this.parseVarId(_t74, s), this.eat(c.eq) ? _t74.init = e ? this.parseMaybeAssignDisallowIn() : this.parseMaybeAssignAllowIn() : ("const" !== s || this.match(c._in) || this.isContextual("of") ? "Identifier" === _t74.id.type || e && (this.match(c._in) || this.isContextual("of")) || this.raise(this.state.lastTokEnd, g.DeclarationMissingInitializer, "Complex binding patterns") : i || this.raise(this.state.lastTokEnd, g.DeclarationMissingInitializer, "Const declarations"), _t74.init = null), r.push(this.finishNode(_t74, "VariableDeclarator")), !this.eat(c.comma)) break;
          }

          return t;
        }
      }, {
        key: "parseVarId",
        value: function parseVarId(t, e) {
          t.id = this.parseBindingAtom(), this.checkLVal(t.id, "var" === e ? 5 : 9, void 0, "variable declaration", "var" !== e);
        }
      }, {
        key: "parseFunction",
        value: function parseFunction(t) {
          var _this47 = this;

          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
          var r = 1 & e,
              i = 2 & e,
              n = !(!r || 4 & e);
          this.initFunction(t, s), this.match(c.star) && i && this.raise(this.state.start, g.GeneratorInSingleStatementContext), t.generator = this.eat(c.star), r && (t.id = this.parseFunctionId(n));
          var a = this.state.maybeInArrowParameters;
          return this.state.maybeInArrowParameters = !1, this.scope.enter(2), this.prodParam.enter(ct(s, t.generator)), r || (t.id = this.parseFunctionId()), this.parseFunctionParams(t, !1), this.withTopicForbiddingContext(function () {
            _this47.parseFunctionBodyAndFinish(t, r ? "FunctionDeclaration" : "FunctionExpression");
          }), this.prodParam.exit(), this.scope.exit(), r && !i && this.registerFunctionStatementId(t), this.state.maybeInArrowParameters = a, t;
        }
      }, {
        key: "parseFunctionId",
        value: function parseFunctionId(t) {
          return t || this.match(c.name) ? this.parseIdentifier() : null;
        }
      }, {
        key: "parseFunctionParams",
        value: function parseFunctionParams(t, e) {
          this.expect(c.parenL), this.expressionScope.enter(new Nt(3)), t.params = this.parseBindingList(c.parenR, 41, !1, e), this.expressionScope.exit();
        }
      }, {
        key: "registerFunctionStatementId",
        value: function registerFunctionStatementId(t) {
          t.id && this.scope.declareName(t.id.name, this.state.strict || t.generator || t.async ? this.scope.treatFunctionsAsVar ? 5 : 9 : 17, t.id.start);
        }
      }, {
        key: "parseClass",
        value: function parseClass(t, e, s) {
          this.next(), this.takeDecorators(t);
          var r = this.state.strict;
          return this.state.strict = !0, this.parseClassId(t, e, s), this.parseClassSuper(t), t.body = this.parseClassBody(!!t.superClass, r), this.finishNode(t, e ? "ClassDeclaration" : "ClassExpression");
        }
      }, {
        key: "isClassProperty",
        value: function isClassProperty() {
          return this.match(c.eq) || this.match(c.semi) || this.match(c.braceR);
        }
      }, {
        key: "isClassMethod",
        value: function isClassMethod() {
          return this.match(c.parenL);
        }
      }, {
        key: "isNonstaticConstructor",
        value: function isNonstaticConstructor(t) {
          return !(t.computed || t.static || "constructor" !== t.key.name && "constructor" !== t.key.value);
        }
      }, {
        key: "parseClassBody",
        value: function parseClassBody(t, e) {
          var _this48 = this;

          this.classScope.enter();
          var s = {
            constructorAllowsSuper: t,
            hadConstructor: !1,
            hadStaticBlock: !1
          };
          var r = [];
          var i = this.startNode();
          if (i.body = [], this.expect(c.braceL), this.withTopicForbiddingContext(function () {
            for (; !_this48.match(c.braceR);) {
              if (_this48.eat(c.semi)) {
                if (r.length > 0) throw _this48.raise(_this48.state.lastTokEnd, g.DecoratorSemicolon);
                continue;
              }

              if (_this48.match(c.at)) {
                r.push(_this48.parseDecorator());
                continue;
              }

              var _t75 = _this48.startNode();

              r.length && (_t75.decorators = r, _this48.resetStartLocationFromNode(_t75, r[0]), r = []), _this48.parseClassMember(i, _t75, s), "constructor" === _t75.kind && _t75.decorators && _t75.decorators.length > 0 && _this48.raise(_t75.start, g.DecoratorConstructor);
            }
          }), this.state.strict = e, this.next(), r.length) throw this.raise(this.state.start, g.TrailingDecorator);
          return this.classScope.exit(), this.finishNode(i, "ClassBody");
        }
      }, {
        key: "parseClassMemberFromModifier",
        value: function parseClassMemberFromModifier(t, e) {
          var s = this.parseIdentifier(!0);

          if (this.isClassMethod()) {
            var _r42 = e;
            return _r42.kind = "method", _r42.computed = !1, _r42.key = s, _r42.static = !1, this.pushClassMethod(t, _r42, !1, !1, !1, !1), !0;
          }

          if (this.isClassProperty()) {
            var _r43 = e;
            return _r43.computed = !1, _r43.key = s, _r43.static = !1, t.body.push(this.parseClassProperty(_r43)), !0;
          }

          return !1;
        }
      }, {
        key: "parseClassMember",
        value: function parseClassMember(t, e, s) {
          var r = this.isContextual("static");

          if (r) {
            if (this.parseClassMemberFromModifier(t, e)) return;
            if (this.eat(c.braceL)) return void this.parseClassStaticBlock(t, e, s);
          }

          this.parseClassMemberWithIsStatic(t, e, s, r);
        }
      }, {
        key: "parseClassMemberWithIsStatic",
        value: function parseClassMemberWithIsStatic(t, e, s, r) {
          var i = e,
              n = e,
              a = e,
              o = e,
              u = i,
              h = i;
          if (e.static = r, this.eat(c.star)) return u.kind = "method", this.parseClassElementName(u), "PrivateName" === u.key.type ? void this.pushClassPrivateMethod(t, n, !0, !1) : (this.isNonstaticConstructor(i) && this.raise(i.key.start, g.ConstructorIsGenerator), void this.pushClassMethod(t, i, !0, !1, !1, !1));
          var p = this.state.containsEsc,
              l = this.parseClassElementName(e),
              d = "PrivateName" === l.type,
              D = "Identifier" === l.type,
              m = this.state.start;

          if (this.parsePostMemberNameModifiers(h), this.isClassMethod()) {
            if (u.kind = "method", d) return void this.pushClassPrivateMethod(t, n, !1, !1);

            var _e65 = this.isNonstaticConstructor(i);

            var _r44 = !1;

            _e65 && (i.kind = "constructor", s.hadConstructor && !this.hasPlugin("typescript") && this.raise(l.start, g.DuplicateConstructor), s.hadConstructor = !0, _r44 = s.constructorAllowsSuper), this.pushClassMethod(t, i, !1, !1, _e65, _r44);
          } else if (this.isClassProperty()) d ? this.pushClassPrivateProperty(t, o) : this.pushClassProperty(t, a);else if (!D || "async" !== l.name || p || this.isLineTerminator()) !D || "get" !== l.name && "set" !== l.name || p || this.match(c.star) && this.isLineTerminator() ? this.isLineTerminator() ? d ? this.pushClassPrivateProperty(t, o) : this.pushClassProperty(t, a) : this.unexpected() : (u.kind = l.name, this.parseClassElementName(i), "PrivateName" === u.key.type ? this.pushClassPrivateMethod(t, n, !1, !1) : (this.isNonstaticConstructor(i) && this.raise(i.key.start, g.ConstructorIsAccessor), this.pushClassMethod(t, i, !1, !1, !1, !1)), this.checkGetterSetterParams(i));else {
            var _e66 = this.eat(c.star);

            h.optional && this.unexpected(m), u.kind = "method", this.parseClassElementName(u), this.parsePostMemberNameModifiers(h), "PrivateName" === u.key.type ? this.pushClassPrivateMethod(t, n, _e66, !0) : (this.isNonstaticConstructor(i) && this.raise(i.key.start, g.ConstructorIsAsync), this.pushClassMethod(t, i, _e66, !0, !1, !1));
          }
        }
      }, {
        key: "parseClassElementName",
        value: function parseClassElementName(t) {
          var e = this.parsePropertyName(t, !0);
          return t.computed || !t.static || "prototype" !== e.name && "prototype" !== e.value || this.raise(e.start, g.StaticPrototype), "PrivateName" === e.type && "constructor" === e.id.name && this.raise(e.start, g.ConstructorClassPrivateField), e;
        }
      }, {
        key: "parseClassStaticBlock",
        value: function parseClassStaticBlock(t, e, s) {
          var r;
          this.expectPlugin("classStaticBlock", e.start), this.scope.enter(80), this.expressionScope.enter(kt());
          var i = this.state.labels;
          this.state.labels = [], this.prodParam.enter(0);
          var n = e.body = [];
          this.parseBlockOrModuleBlockBody(n, void 0, !1, c.braceR), this.prodParam.exit(), this.expressionScope.exit(), this.scope.exit(), this.state.labels = i, t.body.push(this.finishNode(e, "StaticBlock")), s.hadStaticBlock && this.raise(e.start, g.DuplicateStaticBlock), (null == (r = e.decorators) ? void 0 : r.length) && this.raise(e.start, g.DecoratorStaticBlock), s.hadStaticBlock = !0;
        }
      }, {
        key: "pushClassProperty",
        value: function pushClassProperty(t, e) {
          e.computed || "constructor" !== e.key.name && "constructor" !== e.key.value || this.raise(e.key.start, g.ConstructorClassField), t.body.push(this.parseClassProperty(e));
        }
      }, {
        key: "pushClassPrivateProperty",
        value: function pushClassPrivateProperty(t, e) {
          this.expectPlugin("classPrivateProperties", e.key.start);
          var s = this.parseClassPrivateProperty(e);
          t.body.push(s), this.classScope.declarePrivateName(s.key.id.name, 0, s.key.start);
        }
      }, {
        key: "pushClassMethod",
        value: function pushClassMethod(t, e, s, r, i, n) {
          t.body.push(this.parseMethod(e, s, r, i, n, "ClassMethod", !0));
        }
      }, {
        key: "pushClassPrivateMethod",
        value: function pushClassPrivateMethod(t, e, s, r) {
          this.expectPlugin("classPrivateMethods", e.key.start);
          var i = this.parseMethod(e, s, r, !1, !1, "ClassPrivateMethod", !0);
          t.body.push(i);
          var n = "get" === i.kind ? i.static ? 6 : 2 : "set" === i.kind ? i.static ? 5 : 1 : 0;
          this.classScope.declarePrivateName(i.key.id.name, n, i.key.start);
        }
      }, {
        key: "parsePostMemberNameModifiers",
        value: function parsePostMemberNameModifiers(t) {}
      }, {
        key: "parseClassPrivateProperty",
        value: function parseClassPrivateProperty(t) {
          return this.parseInitializer(t), this.semicolon(), this.finishNode(t, "ClassPrivateProperty");
        }
      }, {
        key: "parseClassProperty",
        value: function parseClassProperty(t) {
          return t.typeAnnotation && !this.match(c.eq) || this.expectPlugin("classProperties"), this.parseInitializer(t), this.semicolon(), this.finishNode(t, "ClassProperty");
        }
      }, {
        key: "parseInitializer",
        value: function parseInitializer(t) {
          this.scope.enter(80), this.expressionScope.enter(kt()), this.prodParam.enter(0), t.value = this.eat(c.eq) ? this.parseMaybeAssignAllowIn() : null, this.expressionScope.exit(), this.prodParam.exit(), this.scope.exit();
        }
      }, {
        key: "parseClassId",
        value: function parseClassId(t, e, s) {
          var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 139;
          this.match(c.name) ? (t.id = this.parseIdentifier(), e && this.checkLVal(t.id, r, void 0, "class name")) : s || !e ? t.id = null : this.unexpected(null, g.MissingClassName);
        }
      }, {
        key: "parseClassSuper",
        value: function parseClassSuper(t) {
          t.superClass = this.eat(c._extends) ? this.parseExprSubscripts() : null;
        }
      }, {
        key: "parseExport",
        value: function parseExport(t) {
          var e = this.maybeParseExportDefaultSpecifier(t),
              s = !e || this.eat(c.comma),
              r = s && this.eatExportStar(t),
              i = r && this.maybeParseExportNamespaceSpecifier(t),
              n = s && (!i || this.eat(c.comma)),
              a = e || r;
          if (r && !i) return e && this.unexpected(), this.parseExportFrom(t, !0), this.finishNode(t, "ExportAllDeclaration");
          var o = this.maybeParseExportNamedSpecifiers(t);
          if (e && s && !r && !o || i && n && !o) throw this.unexpected(null, c.braceL);
          var u;
          if (a || o ? (u = !1, this.parseExportFrom(t, a)) : u = this.maybeParseExportDeclaration(t), a || o || u) return this.checkExport(t, !0, !1, !!t.source), this.finishNode(t, "ExportNamedDeclaration");
          if (this.eat(c._default)) return t.declaration = this.parseExportDefaultExpression(), this.checkExport(t, !0, !0), this.finishNode(t, "ExportDefaultDeclaration");
          throw this.unexpected(null, c.braceL);
        }
      }, {
        key: "eatExportStar",
        value: function eatExportStar(t) {
          return this.eat(c.star);
        }
      }, {
        key: "maybeParseExportDefaultSpecifier",
        value: function maybeParseExportDefaultSpecifier(t) {
          if (this.isExportDefaultSpecifier()) {
            this.expectPlugin("exportDefaultFrom");

            var _e67 = this.startNode();

            return _e67.exported = this.parseIdentifier(!0), t.specifiers = [this.finishNode(_e67, "ExportDefaultSpecifier")], !0;
          }

          return !1;
        }
      }, {
        key: "maybeParseExportNamespaceSpecifier",
        value: function maybeParseExportNamespaceSpecifier(t) {
          if (this.isContextual("as")) {
            t.specifiers || (t.specifiers = []);

            var _e68 = this.startNodeAt(this.state.lastTokStart, this.state.lastTokStartLoc);

            return this.next(), _e68.exported = this.parseModuleExportName(), t.specifiers.push(this.finishNode(_e68, "ExportNamespaceSpecifier")), !0;
          }

          return !1;
        }
      }, {
        key: "maybeParseExportNamedSpecifiers",
        value: function maybeParseExportNamedSpecifiers(t) {
          var _t$specifiers;

          return !!this.match(c.braceL) && (t.specifiers || (t.specifiers = []), (_t$specifiers = t.specifiers).push.apply(_t$specifiers, _toConsumableArray(this.parseExportSpecifiers())), t.source = null, t.declaration = null, !0);
        }
      }, {
        key: "maybeParseExportDeclaration",
        value: function maybeParseExportDeclaration(t) {
          return !!this.shouldParseExportDeclaration() && (t.specifiers = [], t.source = null, t.declaration = this.parseExportDeclaration(t), !0);
        }
      }, {
        key: "isAsyncFunction",
        value: function isAsyncFunction() {
          if (!this.isContextual("async")) return !1;
          var t = this.nextTokenStart();
          return !m.test(this.input.slice(this.state.pos, t)) && this.isUnparsedContextual(t, "function");
        }
      }, {
        key: "parseExportDefaultExpression",
        value: function parseExportDefaultExpression() {
          var t = this.startNode(),
              e = this.isAsyncFunction();
          if (this.match(c._function) || e) return this.next(), e && this.next(), this.parseFunction(t, 5, e);
          if (this.match(c._class)) return this.parseClass(t, !0, !0);
          if (this.match(c.at)) return this.hasPlugin("decorators") && this.getPluginOption("decorators", "decoratorsBeforeExport") && this.raise(this.state.start, g.DecoratorBeforeExport), this.parseDecorators(!1), this.parseClass(t, !0, !0);
          if (this.match(c._const) || this.match(c._var) || this.isLet()) throw this.raise(this.state.start, g.UnsupportedDefaultExport);
          {
            var _t76 = this.parseMaybeAssignAllowIn();

            return this.semicolon(), _t76;
          }
        }
      }, {
        key: "parseExportDeclaration",
        value: function parseExportDeclaration(t) {
          return this.parseStatement(null);
        }
      }, {
        key: "isExportDefaultSpecifier",
        value: function isExportDefaultSpecifier() {
          if (this.match(c.name)) {
            var _t77 = this.state.value;
            if ("async" === _t77 && !this.state.containsEsc || "let" === _t77) return !1;

            if (("type" === _t77 || "interface" === _t77) && !this.state.containsEsc) {
              var _t78 = this.lookahead();

              if (_t78.type === c.name && "from" !== _t78.value || _t78.type === c.braceL) return this.expectOnePlugin(["flow", "typescript"]), !1;
            }
          } else if (!this.match(c._default)) return !1;

          var t = this.nextTokenStart(),
              e = this.isUnparsedContextual(t, "from");
          if (44 === this.input.charCodeAt(t) || this.match(c.name) && e) return !0;

          if (this.match(c._default) && e) {
            var _e69 = this.input.charCodeAt(this.nextTokenStartSince(t + 4));

            return 34 === _e69 || 39 === _e69;
          }

          return !1;
        }
      }, {
        key: "parseExportFrom",
        value: function parseExportFrom(t, e) {
          if (this.eatContextual("from")) {
            t.source = this.parseImportSource(), this.checkExport(t);

            var _e70 = this.maybeParseImportAssertions();

            _e70 && (t.assertions = _e70);
          } else e ? this.unexpected() : t.source = null;

          this.semicolon();
        }
      }, {
        key: "shouldParseExportDeclaration",
        value: function shouldParseExportDeclaration() {
          if (this.match(c.at) && (this.expectOnePlugin(["decorators", "decorators-legacy"]), this.hasPlugin("decorators"))) {
            if (!this.getPluginOption("decorators", "decoratorsBeforeExport")) return !0;
            this.unexpected(this.state.start, g.DecoratorBeforeExport);
          }

          return "var" === this.state.type.keyword || "const" === this.state.type.keyword || "function" === this.state.type.keyword || "class" === this.state.type.keyword || this.isLet() || this.isAsyncFunction();
        }
      }, {
        key: "checkExport",
        value: function checkExport(t, e, s, r) {
          if (e) if (s) {
            if (this.checkDuplicateExports(t, "default"), this.hasPlugin("exportDefaultFrom")) {
              var i;
              var _e71 = t.declaration;
              "Identifier" !== _e71.type || "from" !== _e71.name || _e71.end - _e71.start != 4 || (null == (i = _e71.extra) ? void 0 : i.parenthesized) || this.raise(_e71.start, g.ExportDefaultFromAsIdentifier);
            }
          } else if (t.specifiers && t.specifiers.length) for (var _e72 = 0, _s41 = t.specifiers; _e72 < _s41.length; _e72++) {
            var _t79 = _s41[_e72],
                _i25 = _t79.exported,
                _n15 = "Identifier" === _i25.type ? _i25.name : _i25.value;

            if (this.checkDuplicateExports(_t79, _n15), !r && _t79.local) {
              var _e73 = _t79.local;
              "StringLiteral" === _e73.type ? this.raise(_t79.start, g.ExportBindingIsString, _e73.extra.raw, _n15) : (this.checkReservedWord(_e73.name, _e73.start, !0, !1), this.scope.checkLocalExport(_e73));
            }
          } else if (t.declaration) if ("FunctionDeclaration" === t.declaration.type || "ClassDeclaration" === t.declaration.type) {
            var _e74 = t.declaration.id;
            if (!_e74) throw new Error("Assertion failure");
            this.checkDuplicateExports(t, _e74.name);
          } else if ("VariableDeclaration" === t.declaration.type) for (var _e75 = 0, _s42 = t.declaration.declarations; _e75 < _s42.length; _e75++) {
            var _t80 = _s42[_e75];
            this.checkDeclaration(_t80.id);
          }
          if (this.state.decoratorStack[this.state.decoratorStack.length - 1].length) throw this.raise(t.start, g.UnsupportedDecoratorExport);
        }
      }, {
        key: "checkDeclaration",
        value: function checkDeclaration(t) {
          if ("Identifier" === t.type) this.checkDuplicateExports(t, t.name);else if ("ObjectPattern" === t.type) for (var _e76 = 0, _s43 = t.properties; _e76 < _s43.length; _e76++) {
            var _t81 = _s43[_e76];
            this.checkDeclaration(_t81);
          } else if ("ArrayPattern" === t.type) for (var _e77 = 0, _s44 = t.elements; _e77 < _s44.length; _e77++) {
            var _t82 = _s44[_e77];
            _t82 && this.checkDeclaration(_t82);
          } else "ObjectProperty" === t.type ? this.checkDeclaration(t.value) : "RestElement" === t.type ? this.checkDeclaration(t.argument) : "AssignmentPattern" === t.type && this.checkDeclaration(t.left);
        }
      }, {
        key: "checkDuplicateExports",
        value: function checkDuplicateExports(t, e) {
          this.state.exportedIdentifiers.indexOf(e) > -1 && this.raise(t.start, "default" === e ? g.DuplicateDefaultExport : g.DuplicateExport, e), this.state.exportedIdentifiers.push(e);
        }
      }, {
        key: "parseExportSpecifiers",
        value: function parseExportSpecifiers() {
          var t = [];
          var e = !0;

          for (this.expect(c.braceL); !this.eat(c.braceR);) {
            if (e) e = !1;else if (this.expect(c.comma), this.eat(c.braceR)) break;

            var _s45 = this.startNode();

            _s45.local = this.parseModuleExportName(), _s45.exported = this.eatContextual("as") ? this.parseModuleExportName() : _s45.local.__clone(), t.push(this.finishNode(_s45, "ExportSpecifier"));
          }

          return t;
        }
      }, {
        key: "parseModuleExportName",
        value: function parseModuleExportName() {
          if (this.match(c.string)) {
            this.expectPlugin("moduleStringNames");

            var _t83 = this.parseLiteral(this.state.value, "StringLiteral"),
                _e78 = _t83.value.match(Mt);

            return _e78 && this.raise(_t83.start, g.ModuleExportNameHasLoneSurrogate, _e78[0].charCodeAt(0).toString(16)), _t83;
          }

          return this.parseIdentifier(!0);
        }
      }, {
        key: "parseImport",
        value: function parseImport(t) {
          if (t.specifiers = [], !this.match(c.string)) {
            var _e79 = !this.maybeParseDefaultImportSpecifier(t) || this.eat(c.comma),
                _s46 = _e79 && this.maybeParseStarImportSpecifier(t);

            _e79 && !_s46 && this.parseNamedImportSpecifiers(t), this.expectContextual("from");
          }

          t.source = this.parseImportSource();
          var e = this.maybeParseImportAssertions();
          if (e) t.assertions = e;else {
            var _e80 = this.maybeParseModuleAttributes();

            _e80 && (t.attributes = _e80);
          }
          return this.semicolon(), this.finishNode(t, "ImportDeclaration");
        }
      }, {
        key: "parseImportSource",
        value: function parseImportSource() {
          return this.match(c.string) || this.unexpected(), this.parseExprAtom();
        }
      }, {
        key: "shouldParseDefaultImport",
        value: function shouldParseDefaultImport(t) {
          return this.match(c.name);
        }
      }, {
        key: "parseImportSpecifierLocal",
        value: function parseImportSpecifierLocal(t, e, s, r) {
          e.local = this.parseIdentifier(), this.checkLVal(e.local, 9, void 0, r), t.specifiers.push(this.finishNode(e, s));
        }
      }, {
        key: "parseAssertEntries",
        value: function parseAssertEntries() {
          var t = [],
              e = new Set();

          do {
            if (this.match(c.braceR)) break;

            var _s47 = this.startNode(),
                _r45 = this.state.value;

            if (this.match(c.string) ? _s47.key = this.parseLiteral(_r45, "StringLiteral") : _s47.key = this.parseIdentifier(!0), this.expect(c.colon), "type" !== _r45 && this.raise(_s47.key.start, g.ModuleAttributeDifferentFromType, _r45), e.has(_r45) && this.raise(_s47.key.start, g.ModuleAttributesWithDuplicateKeys, _r45), e.add(_r45), !this.match(c.string)) throw this.unexpected(this.state.start, g.ModuleAttributeInvalidValue);
            _s47.value = this.parseLiteral(this.state.value, "StringLiteral"), this.finishNode(_s47, "ImportAttribute"), t.push(_s47);
          } while (this.eat(c.comma));

          return t;
        }
      }, {
        key: "maybeParseModuleAttributes",
        value: function maybeParseModuleAttributes() {
          if (!this.match(c._with) || this.hasPrecedingLineBreak()) return this.hasPlugin("moduleAttributes") ? [] : null;
          this.expectPlugin("moduleAttributes"), this.next();
          var t = [],
              e = new Set();

          do {
            var _s48 = this.startNode();

            if (_s48.key = this.parseIdentifier(!0), "type" !== _s48.key.name && this.raise(_s48.key.start, g.ModuleAttributeDifferentFromType, _s48.key.name), e.has(_s48.key.name) && this.raise(_s48.key.start, g.ModuleAttributesWithDuplicateKeys, _s48.key.name), e.add(_s48.key.name), this.expect(c.colon), !this.match(c.string)) throw this.unexpected(this.state.start, g.ModuleAttributeInvalidValue);
            _s48.value = this.parseLiteral(this.state.value, "StringLiteral"), this.finishNode(_s48, "ImportAttribute"), t.push(_s48);
          } while (this.eat(c.comma));

          return t;
        }
      }, {
        key: "maybeParseImportAssertions",
        value: function maybeParseImportAssertions() {
          if (!this.isContextual("assert") || this.hasPrecedingLineBreak()) return this.hasPlugin("importAssertions") ? [] : null;
          this.expectPlugin("importAssertions"), this.next(), this.eat(c.braceL);
          var t = this.parseAssertEntries();
          return this.eat(c.braceR), t;
        }
      }, {
        key: "maybeParseDefaultImportSpecifier",
        value: function maybeParseDefaultImportSpecifier(t) {
          return !!this.shouldParseDefaultImport(t) && (this.parseImportSpecifierLocal(t, this.startNode(), "ImportDefaultSpecifier", "default import specifier"), !0);
        }
      }, {
        key: "maybeParseStarImportSpecifier",
        value: function maybeParseStarImportSpecifier(t) {
          if (this.match(c.star)) {
            var _e81 = this.startNode();

            return this.next(), this.expectContextual("as"), this.parseImportSpecifierLocal(t, _e81, "ImportNamespaceSpecifier", "import namespace specifier"), !0;
          }

          return !1;
        }
      }, {
        key: "parseNamedImportSpecifiers",
        value: function parseNamedImportSpecifiers(t) {
          var e = !0;

          for (this.expect(c.braceL); !this.eat(c.braceR);) {
            if (e) e = !1;else {
              if (this.eat(c.colon)) throw this.raise(this.state.start, g.DestructureNamedImport);
              if (this.expect(c.comma), this.eat(c.braceR)) break;
            }
            this.parseImportSpecifier(t);
          }
        }
      }, {
        key: "parseImportSpecifier",
        value: function parseImportSpecifier(t) {
          var e = this.startNode();
          if (e.imported = this.parseModuleExportName(), this.eatContextual("as")) e.local = this.parseIdentifier();else {
            var _t84 = e.imported;
            if ("StringLiteral" === _t84.type) throw this.raise(e.start, g.ImportBindingIsString, _t84.value);
            this.checkReservedWord(_t84.name, e.start, !0, !0), e.local = _t84.__clone();
          }
          this.checkLVal(e.local, 9, void 0, "import specifier"), t.specifiers.push(this.finishNode(e, "ImportSpecifier"));
        }
      }]);

      return _class7;
    }( /*#__PURE__*/function (_ref30) {
      _inherits(_class8, _ref30);

      var _super12 = _createSuper(_class8);

      function _class8() {
        _classCallCheck(this, _class8);

        return _super12.apply(this, arguments);
      }

      _createClass(_class8, [{
        key: "checkProto",
        value: function checkProto(t, e, s, r) {
          if ("SpreadElement" === t.type || "ObjectMethod" === t.type || t.computed || t.shorthand) return;
          var i = t.key;

          if ("__proto__" === ("Identifier" === i.type ? i.name : i.value)) {
            if (e) return void this.raise(i.start, g.RecordNoProto);
            s.used && (r ? -1 === r.doubleProto && (r.doubleProto = i.start) : this.raise(i.start, g.DuplicateProto)), s.used = !0;
          }
        }
      }, {
        key: "shouldExitDescending",
        value: function shouldExitDescending(t, e) {
          return "ArrowFunctionExpression" === t.type && t.start === e;
        }
      }, {
        key: "getExpression",
        value: function getExpression() {
          var t = 0;
          this.hasPlugin("topLevelAwait") && this.inModule && (t |= 2), this.scope.enter(1), this.prodParam.enter(t), this.nextToken();
          var e = this.parseExpression();
          return this.match(c.eof) || this.unexpected(), e.comments = this.state.comments, e.errors = this.state.errors, e;
        }
      }, {
        key: "parseExpression",
        value: function parseExpression(t, e) {
          var _this49 = this;

          return t ? this.disallowInAnd(function () {
            return _this49.parseExpressionBase(e);
          }) : this.allowInAnd(function () {
            return _this49.parseExpressionBase(e);
          });
        }
      }, {
        key: "parseExpressionBase",
        value: function parseExpressionBase(t) {
          var e = this.state.start,
              s = this.state.startLoc,
              r = this.parseMaybeAssign(t);

          if (this.match(c.comma)) {
            var _i26 = this.startNodeAt(e, s);

            for (_i26.expressions = [r]; this.eat(c.comma);) {
              _i26.expressions.push(this.parseMaybeAssign(t));
            }

            return this.toReferencedList(_i26.expressions), this.finishNode(_i26, "SequenceExpression");
          }

          return r;
        }
      }, {
        key: "parseMaybeAssignDisallowIn",
        value: function parseMaybeAssignDisallowIn(t, e, s) {
          var _this50 = this;

          return this.disallowInAnd(function () {
            return _this50.parseMaybeAssign(t, e, s);
          });
        }
      }, {
        key: "parseMaybeAssignAllowIn",
        value: function parseMaybeAssignAllowIn(t, e, s) {
          var _this51 = this;

          return this.allowInAnd(function () {
            return _this51.parseMaybeAssign(t, e, s);
          });
        }
      }, {
        key: "parseMaybeAssign",
        value: function parseMaybeAssign(t, e, s) {
          var r = this.state.start,
              i = this.state.startLoc;

          if (this.isContextual("yield") && this.prodParam.hasYield) {
            this.state.exprAllowed = !0;

            var _t85 = this.parseYield();

            return e && (_t85 = e.call(this, _t85, r, i)), _t85;
          }

          var n;
          t ? n = !1 : (t = new wt(), n = !0), (this.match(c.parenL) || this.match(c.name)) && (this.state.potentialArrowAt = this.state.start);
          var a = this.parseMaybeConditional(t, s);

          if (e && (a = e.call(this, a, r, i)), this.state.type.isAssign) {
            var _e82 = this.startNodeAt(r, i),
                _s49 = this.state.value;

            return _e82.operator = _s49, this.match(c.eq) ? (_e82.left = this.toAssignable(a), t.doubleProto = -1) : _e82.left = a, t.shorthandAssign >= _e82.left.start && (t.shorthandAssign = -1), this.checkLVal(a, void 0, void 0, "assignment expression"), this.next(), _e82.right = this.parseMaybeAssign(), this.finishNode(_e82, "AssignmentExpression");
          }

          return n && this.checkExpressionErrors(t, !0), a;
        }
      }, {
        key: "parseMaybeConditional",
        value: function parseMaybeConditional(t, e) {
          var s = this.state.start,
              r = this.state.startLoc,
              i = this.state.potentialArrowAt,
              n = this.parseExprOps(t);
          return this.shouldExitDescending(n, i) ? n : this.parseConditional(n, s, r, e);
        }
      }, {
        key: "parseConditional",
        value: function parseConditional(t, e, s, r) {
          if (this.eat(c.question)) {
            var _r46 = this.startNodeAt(e, s);

            return _r46.test = t, _r46.consequent = this.parseMaybeAssignAllowIn(), this.expect(c.colon), _r46.alternate = this.parseMaybeAssign(), this.finishNode(_r46, "ConditionalExpression");
          }

          return t;
        }
      }, {
        key: "parseExprOps",
        value: function parseExprOps(t) {
          var e = this.state.start,
              s = this.state.startLoc,
              r = this.state.potentialArrowAt,
              i = this.parseMaybeUnary(t);
          return this.shouldExitDescending(i, r) ? i : this.parseExprOp(i, e, s, -1);
        }
      }, {
        key: "parseExprOp",
        value: function parseExprOp(t, e, s, r) {
          var i = this.state.type.binop;

          if (null != i && (this.prodParam.hasIn || !this.match(c._in)) && i > r) {
            var _n16 = this.state.type;

            if (_n16 === c.pipeline) {
              if (this.expectPlugin("pipelineOperator"), this.state.inFSharpPipelineDirectBody) return t;
              this.state.inPipeline = !0, this.checkPipelineAtInfixOperator(t, e);
            }

            var _a6 = this.startNodeAt(e, s);

            _a6.left = t, _a6.operator = this.state.value, _n16 !== c.exponent || "UnaryExpression" !== t.type || !this.options.createParenthesizedExpressions && t.extra && t.extra.parenthesized || this.raise(t.argument.start, g.UnexpectedTokenUnaryExponentiation);

            var _o4 = _n16 === c.logicalOR || _n16 === c.logicalAND,
                _u4 = _n16 === c.nullishCoalescing;

            if (_u4 && (i = c.logicalAND.binop), this.next(), _n16 === c.pipeline && "minimal" === this.getPluginOption("pipelineOperator", "proposal") && this.match(c.name) && "await" === this.state.value && this.prodParam.hasAwait) throw this.raise(this.state.start, g.UnexpectedAwaitAfterPipelineBody);
            _a6.right = this.parseExprOpRightExpr(_n16, i), this.finishNode(_a6, _o4 || _u4 ? "LogicalExpression" : "BinaryExpression");
            var _h2 = this.state.type;
            if (_u4 && (_h2 === c.logicalOR || _h2 === c.logicalAND) || _o4 && _h2 === c.nullishCoalescing) throw this.raise(this.state.start, g.MixingCoalesceWithLogical);
            return this.parseExprOp(_a6, e, s, r);
          }

          return t;
        }
      }, {
        key: "parseExprOpRightExpr",
        value: function parseExprOpRightExpr(t, e) {
          var _this52 = this;

          var s = this.state.start,
              r = this.state.startLoc;

          switch (t) {
            case c.pipeline:
              switch (this.getPluginOption("pipelineOperator", "proposal")) {
                case "smart":
                  return this.withTopicPermittingContext(function () {
                    return _this52.parseSmartPipelineBody(_this52.parseExprOpBaseRightExpr(t, e), s, r);
                  });

                case "fsharp":
                  return this.withSoloAwaitPermittingContext(function () {
                    return _this52.parseFSharpPipelineBody(e);
                  });
              }

            default:
              return this.parseExprOpBaseRightExpr(t, e);
          }
        }
      }, {
        key: "parseExprOpBaseRightExpr",
        value: function parseExprOpBaseRightExpr(t, e) {
          var s = this.state.start,
              r = this.state.startLoc;
          return this.parseExprOp(this.parseMaybeUnary(), s, r, t.rightAssociative ? e - 1 : e);
        }
      }, {
        key: "parseMaybeUnary",
        value: function parseMaybeUnary(t) {
          if (this.isContextual("await") && this.isAwaitAllowed()) return this.parseAwait();
          var e = this.match(c.incDec),
              s = this.startNode();

          if (this.state.type.prefix) {
            s.operator = this.state.value, s.prefix = !0, this.match(c._throw) && this.expectPlugin("throwExpressions");

            var _r47 = this.match(c._delete);

            if (this.next(), s.argument = this.parseMaybeUnary(), this.checkExpressionErrors(t, !0), this.state.strict && _r47) {
              var _t86 = s.argument;
              "Identifier" === _t86.type ? this.raise(s.start, g.StrictDelete) : "MemberExpression" !== _t86.type && "OptionalMemberExpression" !== _t86.type || "PrivateName" !== _t86.property.type || this.raise(s.start, g.DeletePrivateField);
            }

            if (!e) return this.finishNode(s, "UnaryExpression");
          }

          return this.parseUpdate(s, e, t);
        }
      }, {
        key: "parseUpdate",
        value: function parseUpdate(t, e, s) {
          if (e) return this.checkLVal(t.argument, void 0, void 0, "prefix operation"), this.finishNode(t, "UpdateExpression");
          var r = this.state.start,
              i = this.state.startLoc;
          var n = this.parseExprSubscripts(s);
          if (this.checkExpressionErrors(s, !1)) return n;

          for (; this.state.type.postfix && !this.canInsertSemicolon();) {
            var _t87 = this.startNodeAt(r, i);

            _t87.operator = this.state.value, _t87.prefix = !1, _t87.argument = n, this.checkLVal(n, void 0, void 0, "postfix operation"), this.next(), n = this.finishNode(_t87, "UpdateExpression");
          }

          return n;
        }
      }, {
        key: "parseExprSubscripts",
        value: function parseExprSubscripts(t) {
          var e = this.state.start,
              s = this.state.startLoc,
              r = this.state.potentialArrowAt,
              i = this.parseExprAtom(t);
          return this.shouldExitDescending(i, r) ? i : this.parseSubscripts(i, e, s);
        }
      }, {
        key: "parseSubscripts",
        value: function parseSubscripts(t, e, s, r) {
          var i = {
            optionalChainMember: !1,
            maybeAsyncArrow: this.atPossibleAsyncArrow(t),
            stop: !1
          };

          do {
            t = this.parseSubscript(t, e, s, r, i), i.maybeAsyncArrow = !1;
          } while (!i.stop);

          return t;
        }
      }, {
        key: "parseSubscript",
        value: function parseSubscript(t, e, s, r, i) {
          if (!r && this.eat(c.doubleColon)) return this.parseBind(t, e, s, r, i);
          if (this.match(c.backQuote)) return this.parseTaggedTemplateExpression(t, e, s, i);
          var n = !1;

          if (this.match(c.questionDot)) {
            if (i.optionalChainMember = n = !0, r && 40 === this.lookaheadCharCode()) return i.stop = !0, t;
            this.next();
          }

          return !r && this.match(c.parenL) ? this.parseCoverCallAndAsyncArrowHead(t, e, s, i, n) : n || this.match(c.bracketL) || this.eat(c.dot) ? this.parseMember(t, e, s, i, n) : (i.stop = !0, t);
        }
      }, {
        key: "parseMember",
        value: function parseMember(t, e, s, r, i) {
          var n = this.startNodeAt(e, s),
              a = this.eat(c.bracketL);
          n.object = t, n.computed = a;
          var o = a ? this.parseExpression() : this.parseMaybePrivateName(!0);
          return "PrivateName" === o.type && ("Super" === n.object.type && this.raise(e, g.SuperPrivateField), this.classScope.usePrivateName(o.id.name, o.start)), n.property = o, a && this.expect(c.bracketR), r.optionalChainMember ? (n.optional = i, this.finishNode(n, "OptionalMemberExpression")) : this.finishNode(n, "MemberExpression");
        }
      }, {
        key: "parseBind",
        value: function parseBind(t, e, s, r, i) {
          var n = this.startNodeAt(e, s);
          return n.object = t, n.callee = this.parseNoCallExpr(), i.stop = !0, this.parseSubscripts(this.finishNode(n, "BindExpression"), e, s, r);
        }
      }, {
        key: "parseCoverCallAndAsyncArrowHead",
        value: function parseCoverCallAndAsyncArrowHead(t, e, s, r, i) {
          var n = this.state.maybeInArrowParameters;
          this.state.maybeInArrowParameters = !0, this.next();
          var a = this.startNodeAt(e, s);
          return a.callee = t, r.maybeAsyncArrow && this.expressionScope.enter(new It(2)), r.optionalChainMember && (a.optional = i), a.arguments = i ? this.parseCallExpressionArguments(c.parenR, !1) : this.parseCallExpressionArguments(c.parenR, r.maybeAsyncArrow, "Import" === t.type, "Super" !== t.type, a), this.finishCallExpression(a, r.optionalChainMember), r.maybeAsyncArrow && this.shouldParseAsyncArrow() && !i ? (r.stop = !0, this.expressionScope.validateAsPattern(), this.expressionScope.exit(), a = this.parseAsyncArrowFromCallExpression(this.startNodeAt(e, s), a)) : (r.maybeAsyncArrow && this.expressionScope.exit(), this.toReferencedArguments(a)), this.state.maybeInArrowParameters = n, a;
        }
      }, {
        key: "toReferencedArguments",
        value: function toReferencedArguments(t, e) {
          this.toReferencedListDeep(t.arguments, e);
        }
      }, {
        key: "parseTaggedTemplateExpression",
        value: function parseTaggedTemplateExpression(t, e, s, r) {
          var i = this.startNodeAt(e, s);
          return i.tag = t, i.quasi = this.parseTemplate(!0), r.optionalChainMember && this.raise(e, g.OptionalChainingNoTemplate), this.finishNode(i, "TaggedTemplateExpression");
        }
      }, {
        key: "atPossibleAsyncArrow",
        value: function atPossibleAsyncArrow(t) {
          return "Identifier" === t.type && "async" === t.name && this.state.lastTokEnd === t.end && !this.canInsertSemicolon() && t.end - t.start == 5 && t.start === this.state.potentialArrowAt;
        }
      }, {
        key: "finishCallExpression",
        value: function finishCallExpression(t, e) {
          if ("Import" === t.callee.type) if (2 === t.arguments.length && (this.hasPlugin("moduleAttributes") || this.expectPlugin("importAssertions")), 0 === t.arguments.length || t.arguments.length > 2) this.raise(t.start, g.ImportCallArity, this.hasPlugin("importAssertions") || this.hasPlugin("moduleAttributes") ? "one or two arguments" : "one argument");else for (var _e83 = 0, _s50 = t.arguments; _e83 < _s50.length; _e83++) {
            var _t88 = _s50[_e83];
            "SpreadElement" === _t88.type && this.raise(_t88.start, g.ImportCallSpreadArgument);
          }
          return this.finishNode(t, e ? "OptionalCallExpression" : "CallExpression");
        }
      }, {
        key: "parseCallExpressionArguments",
        value: function parseCallExpressionArguments(t, e, s, r, i) {
          var n = [];
          var a,
              o = !0;
          var u = this.state.inFSharpPipelineDirectBody;

          for (this.state.inFSharpPipelineDirectBody = !1; !this.eat(t);) {
            if (o) o = !1;else if (this.expect(c.comma), this.match(t)) {
              !s || this.hasPlugin("importAssertions") || this.hasPlugin("moduleAttributes") || this.raise(this.state.lastTokStart, g.ImportCallArgumentTrailingComma), i && this.addExtra(i, "trailingComma", this.state.lastTokStart), this.next();
              break;
            }
            this.match(c.parenL) && !a && (a = this.state.start), n.push(this.parseExprListItem(!1, e ? new wt() : void 0, e ? {
              start: 0
            } : void 0, r));
          }

          return e && a && this.shouldParseAsyncArrow() && this.unexpected(), this.state.inFSharpPipelineDirectBody = u, n;
        }
      }, {
        key: "shouldParseAsyncArrow",
        value: function shouldParseAsyncArrow() {
          return this.match(c.arrow) && !this.canInsertSemicolon();
        }
      }, {
        key: "parseAsyncArrowFromCallExpression",
        value: function parseAsyncArrowFromCallExpression(t, e) {
          var s;
          return this.expect(c.arrow), this.parseArrowExpression(t, e.arguments, !0, null == (s = e.extra) ? void 0 : s.trailingComma), t;
        }
      }, {
        key: "parseNoCallExpr",
        value: function parseNoCallExpr() {
          var t = this.state.start,
              e = this.state.startLoc;
          return this.parseSubscripts(this.parseExprAtom(), t, e, !0);
        }
      }, {
        key: "parseExprAtom",
        value: function parseExprAtom(t) {
          this.state.type === c.slash && this.readRegexp();
          var e = this.state.potentialArrowAt === this.state.start;
          var s;

          switch (this.state.type) {
            case c._super:
              return this.parseSuper();

            case c._import:
              return s = this.startNode(), this.next(), this.match(c.dot) ? this.parseImportMetaProperty(s) : (this.match(c.parenL) || this.raise(this.state.lastTokStart, g.UnsupportedImport), this.finishNode(s, "Import"));

            case c._this:
              return s = this.startNode(), this.next(), this.finishNode(s, "ThisExpression");

            case c.name:
              {
                var _t89 = this.state.containsEsc,
                    _s51 = this.parseIdentifier();

                if (!_t89 && "async" === _s51.name && !this.canInsertSemicolon()) {
                  if (this.match(c._function)) {
                    var _t90 = this.state.context.length - 1;

                    if (this.state.context[_t90] !== T.functionStatement) throw new Error("Internal error");
                    return this.state.context[_t90] = T.functionExpression, this.next(), this.parseFunction(this.startNodeAtNode(_s51), void 0, !0);
                  }

                  if (this.match(c.name)) return this.parseAsyncArrowUnaryFunction(_s51);
                }

                return e && this.match(c.arrow) && !this.canInsertSemicolon() ? (this.next(), this.parseArrowExpression(this.startNodeAtNode(_s51), [_s51], !1)) : _s51;
              }

            case c._do:
              return this.parseDo();

            case c.regexp:
              {
                var _t91 = this.state.value;
                return s = this.parseLiteral(_t91.value, "RegExpLiteral"), s.pattern = _t91.pattern, s.flags = _t91.flags, s;
              }

            case c.num:
              return this.parseLiteral(this.state.value, "NumericLiteral");

            case c.bigint:
              return this.parseLiteral(this.state.value, "BigIntLiteral");

            case c.decimal:
              return this.parseLiteral(this.state.value, "DecimalLiteral");

            case c.string:
              return this.parseLiteral(this.state.value, "StringLiteral");

            case c._null:
              return s = this.startNode(), this.next(), this.finishNode(s, "NullLiteral");

            case c._true:
            case c._false:
              return this.parseBooleanLiteral();

            case c.parenL:
              return this.parseParenAndDistinguishExpression(e);

            case c.bracketBarL:
            case c.bracketHashL:
              return this.parseArrayLike(this.state.type === c.bracketBarL ? c.bracketBarR : c.bracketR, !1, !0, t);

            case c.bracketL:
              return this.parseArrayLike(c.bracketR, !0, !1, t);

            case c.braceBarL:
            case c.braceHashL:
              return this.parseObjectLike(this.state.type === c.braceBarL ? c.braceBarR : c.braceR, !1, !0, t);

            case c.braceL:
              return this.parseObjectLike(c.braceR, !1, !1, t);

            case c._function:
              return this.parseFunctionOrFunctionSent();

            case c.at:
              this.parseDecorators();

            case c._class:
              return s = this.startNode(), this.takeDecorators(s), this.parseClass(s, !1);

            case c._new:
              return this.parseNewOrNewTarget();

            case c.backQuote:
              return this.parseTemplate(!1);

            case c.doubleColon:
              {
                s = this.startNode(), this.next(), s.object = null;

                var _t92 = s.callee = this.parseNoCallExpr();

                if ("MemberExpression" === _t92.type) return this.finishNode(s, "BindExpression");
                throw this.raise(_t92.start, g.UnsupportedBind);
              }

            case c.hash:
              {
                if (this.state.inPipeline) return s = this.startNode(), "smart" !== this.getPluginOption("pipelineOperator", "proposal") && this.raise(s.start, g.PrimaryTopicRequiresSmartPipeline), this.next(), this.primaryTopicReferenceIsAllowedInCurrentTopicContext() || this.raise(s.start, g.PrimaryTopicNotAllowed), this.registerTopicReference(), this.finishNode(s, "PipelinePrimaryTopicReference");

                var _t93 = this.input.codePointAt(this.state.end);

                if (L(_t93) || 92 === _t93) {
                  var _t94 = this.state.start;
                  if (s = this.parseMaybePrivateName(!0), this.match(c._in)) this.expectPlugin("privateIn"), this.classScope.usePrivateName(s.id.name, s.start);else {
                    if (!this.hasPlugin("privateIn")) throw this.unexpected(_t94);
                    this.raise(this.state.start, g.PrivateInExpectedIn, s.id.name);
                  }
                  return s;
                }
              }

            case c.relational:
              if ("<" === this.state.value) {
                var _t95 = this.input.codePointAt(this.nextTokenStart());

                (L(_t95) || 62 === _t95) && this.expectOnePlugin(["jsx", "flow", "typescript"]);
              }

            default:
              throw this.unexpected();
          }
        }
      }, {
        key: "parseAsyncArrowUnaryFunction",
        value: function parseAsyncArrowUnaryFunction(t) {
          var e = this.startNodeAtNode(t);
          this.prodParam.enter(ct(!0, this.prodParam.hasYield));
          var s = [this.parseIdentifier()];
          return this.prodParam.exit(), this.hasPrecedingLineBreak() && this.raise(this.state.pos, g.LineTerminatorBeforeArrow), this.expect(c.arrow), this.parseArrowExpression(e, s, !0), e;
        }
      }, {
        key: "parseDo",
        value: function parseDo() {
          this.expectPlugin("doExpressions");
          var t = this.startNode();
          this.next();
          var e = this.state.labels;
          return this.state.labels = [], t.body = this.parseBlock(), this.state.labels = e, this.finishNode(t, "DoExpression");
        }
      }, {
        key: "parseSuper",
        value: function parseSuper() {
          var t = this.startNode();
          return this.next(), !this.match(c.parenL) || this.scope.allowDirectSuper || this.options.allowSuperOutsideMethod ? this.scope.allowSuper || this.options.allowSuperOutsideMethod || this.raise(t.start, g.UnexpectedSuper) : this.raise(t.start, g.SuperNotAllowed), this.match(c.parenL) || this.match(c.bracketL) || this.match(c.dot) || this.raise(t.start, g.UnsupportedSuper), this.finishNode(t, "Super");
        }
      }, {
        key: "parseBooleanLiteral",
        value: function parseBooleanLiteral() {
          var t = this.startNode();
          return t.value = this.match(c._true), this.next(), this.finishNode(t, "BooleanLiteral");
        }
      }, {
        key: "parseMaybePrivateName",
        value: function parseMaybePrivateName(t) {
          if (this.match(c.hash)) {
            this.expectOnePlugin(["classPrivateProperties", "classPrivateMethods"]), t || this.raise(this.state.pos, g.UnexpectedPrivateField);

            var _e84 = this.startNode();

            return this.next(), this.assertNoSpace("Unexpected space between # and identifier"), _e84.id = this.parseIdentifier(!0), this.finishNode(_e84, "PrivateName");
          }

          return this.parseIdentifier(!0);
        }
      }, {
        key: "parseFunctionOrFunctionSent",
        value: function parseFunctionOrFunctionSent() {
          var t = this.startNode();

          if (this.next(), this.prodParam.hasYield && this.match(c.dot)) {
            var _e85 = this.createIdentifier(this.startNodeAtNode(t), "function");

            return this.next(), this.parseMetaProperty(t, _e85, "sent");
          }

          return this.parseFunction(t);
        }
      }, {
        key: "parseMetaProperty",
        value: function parseMetaProperty(t, e, s) {
          t.meta = e, "function" === e.name && "sent" === s && (this.isContextual(s) ? this.expectPlugin("functionSent") : this.hasPlugin("functionSent") || this.unexpected());
          var r = this.state.containsEsc;
          return t.property = this.parseIdentifier(!0), (t.property.name !== s || r) && this.raise(t.property.start, g.UnsupportedMetaProperty, e.name, s), this.finishNode(t, "MetaProperty");
        }
      }, {
        key: "parseImportMetaProperty",
        value: function parseImportMetaProperty(t) {
          var e = this.createIdentifier(this.startNodeAtNode(t), "import");
          return this.next(), this.isContextual("meta") && (this.inModule || this.raiseWithData(e.start, {
            code: "BABEL_PARSER_SOURCETYPE_MODULE_REQUIRED"
          }, g.ImportMetaOutsideModule), this.sawUnambiguousESM = !0), this.parseMetaProperty(t, e, "meta");
        }
      }, {
        key: "parseLiteral",
        value: function parseLiteral(t, e, s, r) {
          s = s || this.state.start, r = r || this.state.startLoc;
          var i = this.startNodeAt(s, r);
          return this.addExtra(i, "rawValue", t), this.addExtra(i, "raw", this.input.slice(s, this.state.end)), i.value = t, this.next(), this.finishNode(i, e);
        }
      }, {
        key: "parseParenAndDistinguishExpression",
        value: function parseParenAndDistinguishExpression(t) {
          var e = this.state.start,
              s = this.state.startLoc;
          var r;
          this.next(), this.expressionScope.enter(new It(1));
          var i = this.state.maybeInArrowParameters,
              n = this.state.inFSharpPipelineDirectBody;
          this.state.maybeInArrowParameters = !0, this.state.inFSharpPipelineDirectBody = !1;
          var a = this.state.start,
              o = this.state.startLoc,
              u = [],
              h = new wt(),
              p = {
            start: 0
          };
          var l,
              d,
              D = !0;

          for (; !this.match(c.parenR);) {
            if (D) D = !1;else if (this.expect(c.comma, p.start || null), this.match(c.parenR)) {
              d = this.state.start;
              break;
            }

            if (this.match(c.ellipsis)) {
              var _t96 = this.state.start,
                  _e86 = this.state.startLoc;
              l = this.state.start, u.push(this.parseParenItem(this.parseRestBinding(), _t96, _e86)), this.checkCommaAfterRest(41);
              break;
            }

            u.push(this.parseMaybeAssignAllowIn(h, this.parseParenItem, p));
          }

          var m = this.state.lastTokEnd,
              f = this.state.lastTokEndLoc;
          this.expect(c.parenR), this.state.maybeInArrowParameters = i, this.state.inFSharpPipelineDirectBody = n;
          var y = this.startNodeAt(e, s);

          if (t && this.shouldParseArrow() && (y = this.parseArrow(y))) {
            this.expressionScope.validateAsPattern(), this.expressionScope.exit();

            for (var _t97 = 0; _t97 < u.length; _t97++) {
              var _e87 = u[_t97];
              _e87.extra && _e87.extra.parenthesized && this.unexpected(_e87.extra.parenStart);
            }

            return this.parseArrowExpression(y, u, !1), y;
          }

          if (this.expressionScope.exit(), u.length || this.unexpected(this.state.lastTokStart), d && this.unexpected(d), l && this.unexpected(l), this.checkExpressionErrors(h, !0), p.start && this.unexpected(p.start), this.toReferencedListDeep(u, !0), u.length > 1 ? (r = this.startNodeAt(a, o), r.expressions = u, this.finishNodeAt(r, "SequenceExpression", m, f)) : r = u[0], !this.options.createParenthesizedExpressions) return this.addExtra(r, "parenthesized", !0), this.addExtra(r, "parenStart", e), r;
          var E = this.startNodeAt(e, s);
          return E.expression = r, this.finishNode(E, "ParenthesizedExpression"), E;
        }
      }, {
        key: "shouldParseArrow",
        value: function shouldParseArrow() {
          return !this.canInsertSemicolon();
        }
      }, {
        key: "parseArrow",
        value: function parseArrow(t) {
          if (this.eat(c.arrow)) return t;
        }
      }, {
        key: "parseParenItem",
        value: function parseParenItem(t, e, s) {
          return t;
        }
      }, {
        key: "parseNewOrNewTarget",
        value: function parseNewOrNewTarget() {
          var t = this.startNode();

          if (this.next(), this.match(c.dot)) {
            var _e88 = this.createIdentifier(this.startNodeAtNode(t), "new");

            this.next();

            var _s52 = this.parseMetaProperty(t, _e88, "target");

            if (!this.scope.inNonArrowFunction && !this.scope.inClass) {
              var _t98 = g.UnexpectedNewTarget;
              this.hasPlugin("classProperties") && (_t98 += " or class properties"), this.raise(_s52.start, _t98);
            }

            return _s52;
          }

          return this.parseNew(t);
        }
      }, {
        key: "parseNew",
        value: function parseNew(t) {
          return t.callee = this.parseNoCallExpr(), "Import" === t.callee.type ? this.raise(t.callee.start, g.ImportCallNotNewExpression) : "OptionalMemberExpression" === t.callee.type || "OptionalCallExpression" === t.callee.type ? this.raise(this.state.lastTokEnd, g.OptionalChainingNoNew) : this.eat(c.questionDot) && this.raise(this.state.start, g.OptionalChainingNoNew), this.parseNewArguments(t), this.finishNode(t, "NewExpression");
        }
      }, {
        key: "parseNewArguments",
        value: function parseNewArguments(t) {
          if (this.eat(c.parenL)) {
            var _e89 = this.parseExprList(c.parenR);

            this.toReferencedList(_e89), t.arguments = _e89;
          } else t.arguments = [];
        }
      }, {
        key: "parseTemplateElement",
        value: function parseTemplateElement(t) {
          var e = this.startNode();
          return null === this.state.value && (t || this.raise(this.state.start + 1, g.InvalidEscapeSequenceTemplate)), e.value = {
            raw: this.input.slice(this.state.start, this.state.end).replace(/\r\n?/g, "\n"),
            cooked: this.state.value
          }, this.next(), e.tail = this.match(c.backQuote), this.finishNode(e, "TemplateElement");
        }
      }, {
        key: "parseTemplate",
        value: function parseTemplate(t) {
          var e = this.startNode();
          this.next(), e.expressions = [];
          var s = this.parseTemplateElement(t);

          for (e.quasis = [s]; !s.tail;) {
            this.expect(c.dollarBraceL), e.expressions.push(this.parseTemplateSubstitution()), this.expect(c.braceR), e.quasis.push(s = this.parseTemplateElement(t));
          }

          return this.next(), this.finishNode(e, "TemplateLiteral");
        }
      }, {
        key: "parseTemplateSubstitution",
        value: function parseTemplateSubstitution() {
          return this.parseExpression();
        }
      }, {
        key: "parseObjectLike",
        value: function parseObjectLike(t, e, s, r) {
          s && this.expectPlugin("recordAndTuple");
          var i = this.state.inFSharpPipelineDirectBody;
          this.state.inFSharpPipelineDirectBody = !1;
          var n = Object.create(null);
          var a = !0;
          var o = this.startNode();

          for (o.properties = [], this.next(); !this.match(t);) {
            if (a) a = !1;else if (this.expect(c.comma), this.match(t)) {
              this.addExtra(o, "trailingComma", this.state.lastTokStart);
              break;
            }

            var _i27 = this.parsePropertyDefinition(e, r);

            e || this.checkProto(_i27, s, n, r), s && "ObjectProperty" !== _i27.type && "SpreadElement" !== _i27.type && this.raise(_i27.start, g.InvalidRecordProperty), _i27.shorthand && this.addExtra(_i27, "shorthand", !0), o.properties.push(_i27);
          }

          this.state.exprAllowed = !1, this.next(), this.state.inFSharpPipelineDirectBody = i;
          var u = "ObjectExpression";
          return e ? u = "ObjectPattern" : s && (u = "RecordExpression"), this.finishNode(o, u);
        }
      }, {
        key: "maybeAsyncOrAccessorProp",
        value: function maybeAsyncOrAccessorProp(t) {
          return !t.computed && "Identifier" === t.key.type && (this.isLiteralPropertyName() || this.match(c.bracketL) || this.match(c.star));
        }
      }, {
        key: "parsePropertyDefinition",
        value: function parsePropertyDefinition(t, e) {
          var s = [];
          if (this.match(c.at)) for (this.hasPlugin("decorators") && this.raise(this.state.start, g.UnsupportedPropertyDecorator); this.match(c.at);) {
            s.push(this.parseDecorator());
          }
          var r = this.startNode();
          var i,
              n,
              a = !1,
              o = !1,
              u = !1;
          if (this.match(c.ellipsis)) return s.length && this.unexpected(), t ? (this.next(), r.argument = this.parseIdentifier(), this.checkCommaAfterRest(125), this.finishNode(r, "RestElement")) : this.parseSpread();
          s.length && (r.decorators = s, s = []), r.method = !1, (t || e) && (i = this.state.start, n = this.state.startLoc), t || (a = this.eat(c.star));
          var h = this.state.containsEsc,
              p = this.parsePropertyName(r, !1);

          if (!t && !a && !h && this.maybeAsyncOrAccessorProp(r)) {
            var _t99 = p.name;
            "async" !== _t99 || this.hasPrecedingLineBreak() || (o = !0, a = this.eat(c.star), this.parsePropertyName(r, !1)), "get" !== _t99 && "set" !== _t99 || (u = !0, r.kind = _t99, this.match(c.star) && (a = !0, this.raise(this.state.pos, g.AccessorIsGenerator, _t99), this.next()), this.parsePropertyName(r, !1));
          }

          return this.parseObjPropValue(r, i, n, a, o, t, u, e), r;
        }
      }, {
        key: "getGetterSetterExpectedParamCount",
        value: function getGetterSetterExpectedParamCount(t) {
          return "get" === t.kind ? 0 : 1;
        }
      }, {
        key: "getObjectOrClassMethodParams",
        value: function getObjectOrClassMethodParams(t) {
          return t.params;
        }
      }, {
        key: "checkGetterSetterParams",
        value: function checkGetterSetterParams(t) {
          var e;
          var s = this.getGetterSetterExpectedParamCount(t),
              r = this.getObjectOrClassMethodParams(t),
              i = t.start;
          r.length !== s && ("get" === t.kind ? this.raise(i, g.BadGetterArity) : this.raise(i, g.BadSetterArity)), "set" === t.kind && "RestElement" === (null == (e = r[r.length - 1]) ? void 0 : e.type) && this.raise(i, g.BadSetterRestParameter);
        }
      }, {
        key: "parseObjectMethod",
        value: function parseObjectMethod(t, e, s, r, i) {
          return i ? (this.parseMethod(t, e, !1, !1, !1, "ObjectMethod"), this.checkGetterSetterParams(t), t) : s || e || this.match(c.parenL) ? (r && this.unexpected(), t.kind = "method", t.method = !0, this.parseMethod(t, e, s, !1, !1, "ObjectMethod")) : void 0;
        }
      }, {
        key: "parseObjectProperty",
        value: function parseObjectProperty(t, e, s, r, i) {
          return t.shorthand = !1, this.eat(c.colon) ? (t.value = r ? this.parseMaybeDefault(this.state.start, this.state.startLoc) : this.parseMaybeAssignAllowIn(i), this.finishNode(t, "ObjectProperty")) : t.computed || "Identifier" !== t.key.type ? void 0 : (this.checkReservedWord(t.key.name, t.key.start, !0, !1), r ? t.value = this.parseMaybeDefault(e, s, t.key.__clone()) : this.match(c.eq) && i ? (-1 === i.shorthandAssign && (i.shorthandAssign = this.state.start), t.value = this.parseMaybeDefault(e, s, t.key.__clone())) : t.value = t.key.__clone(), t.shorthand = !0, this.finishNode(t, "ObjectProperty"));
        }
      }, {
        key: "parseObjPropValue",
        value: function parseObjPropValue(t, e, s, r, i, n, a, o) {
          var u = this.parseObjectMethod(t, r, i, n, a) || this.parseObjectProperty(t, e, s, n, o);
          return u || this.unexpected(), u;
        }
      }, {
        key: "parsePropertyName",
        value: function parsePropertyName(t, e) {
          if (this.eat(c.bracketL)) t.computed = !0, t.key = this.parseMaybeAssignAllowIn(), this.expect(c.bracketR);else {
            var _s53 = this.state.inPropertyName;
            this.state.inPropertyName = !0, t.key = this.match(c.num) || this.match(c.string) || this.match(c.bigint) || this.match(c.decimal) ? this.parseExprAtom() : this.parseMaybePrivateName(e), "PrivateName" !== t.key.type && (t.computed = !1), this.state.inPropertyName = _s53;
          }
          return t.key;
        }
      }, {
        key: "initFunction",
        value: function initFunction(t, e) {
          t.id = null, t.generator = !1, t.async = !!e;
        }
      }, {
        key: "parseMethod",
        value: function parseMethod(t, e, s, r, i, n) {
          var a = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : !1;
          this.initFunction(t, s), t.generator = !!e;
          var o = r;
          return this.scope.enter(18 | (a ? 64 : 0) | (i ? 32 : 0)), this.prodParam.enter(ct(s, t.generator)), this.parseFunctionParams(t, o), this.parseFunctionBodyAndFinish(t, n, !0), this.prodParam.exit(), this.scope.exit(), t;
        }
      }, {
        key: "parseArrayLike",
        value: function parseArrayLike(t, e, s, r) {
          s && this.expectPlugin("recordAndTuple");
          var i = this.state.inFSharpPipelineDirectBody;
          this.state.inFSharpPipelineDirectBody = !1;
          var n = this.startNode();
          return this.next(), n.elements = this.parseExprList(t, !s, r, n), this.state.inFSharpPipelineDirectBody = i, this.finishNode(n, s ? "TupleExpression" : "ArrayExpression");
        }
      }, {
        key: "parseArrowExpression",
        value: function parseArrowExpression(t, e, s, r) {
          this.scope.enter(6);
          var i = ct(s, !1);
          !this.match(c.bracketL) && this.prodParam.hasIn && (i |= 8), this.prodParam.enter(i), this.initFunction(t, s);
          var n = this.state.maybeInArrowParameters;
          return e && (this.state.maybeInArrowParameters = !0, this.setArrowFunctionParameters(t, e, r)), this.state.maybeInArrowParameters = !1, this.parseFunctionBody(t, !0), this.prodParam.exit(), this.scope.exit(), this.state.maybeInArrowParameters = n, this.finishNode(t, "ArrowFunctionExpression");
        }
      }, {
        key: "setArrowFunctionParameters",
        value: function setArrowFunctionParameters(t, e, s) {
          t.params = this.toAssignableList(e, s);
        }
      }, {
        key: "parseFunctionBodyAndFinish",
        value: function parseFunctionBodyAndFinish(t, e) {
          var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
          this.parseFunctionBody(t, !1, s), this.finishNode(t, e);
        }
      }, {
        key: "parseFunctionBody",
        value: function parseFunctionBody(t, e) {
          var _this53 = this;

          var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
          var r = e && !this.match(c.braceL);
          if (this.expressionScope.enter(kt()), r) t.body = this.parseMaybeAssign(), this.checkParams(t, !1, e, !1);else {
            var _r48 = this.state.strict,
                _i28 = this.state.labels;
            this.state.labels = [], this.prodParam.enter(4 | this.prodParam.currentFlags()), t.body = this.parseBlock(!0, !1, function (i) {
              var n = !_this53.isSimpleParamList(t.params);

              if (i && n) {
                var _e90 = "method" !== t.kind && "constructor" !== t.kind || !t.key ? t.start : t.key.end;

                _this53.raise(_e90, g.IllegalLanguageModeDirective);
              }

              var a = !_r48 && _this53.state.strict;
              _this53.checkParams(t, !(_this53.state.strict || e || s || n), e, a), _this53.state.strict && t.id && _this53.checkLVal(t.id, 65, void 0, "function name", void 0, a);
            }), this.prodParam.exit(), this.expressionScope.exit(), this.state.labels = _i28;
          }
        }
      }, {
        key: "isSimpleParamList",
        value: function isSimpleParamList(t) {
          for (var _e91 = 0, _s54 = t.length; _e91 < _s54; _e91++) {
            if ("Identifier" !== t[_e91].type) return !1;
          }

          return !0;
        }
      }, {
        key: "checkParams",
        value: function checkParams(t, e, s) {
          var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
          var i = Object.create(null);

          for (var _s55 = 0; _s55 < t.params.length; _s55++) {
            this.checkLVal(t.params[_s55], 5, e ? null : i, "function parameter list", void 0, r);
          }
        }
      }, {
        key: "parseExprList",
        value: function parseExprList(t, e, s, r) {
          var i = [];
          var n = !0;

          for (; !this.eat(t);) {
            if (n) n = !1;else if (this.expect(c.comma), this.match(t)) {
              r && this.addExtra(r, "trailingComma", this.state.lastTokStart), this.next();
              break;
            }
            i.push(this.parseExprListItem(e, s));
          }

          return i;
        }
      }, {
        key: "parseExprListItem",
        value: function parseExprListItem(t, e, s, r) {
          var i;
          if (this.match(c.comma)) t || this.raise(this.state.pos, g.UnexpectedToken, ","), i = null;else if (this.match(c.ellipsis)) {
            var _t100 = this.state.start,
                _r49 = this.state.startLoc;
            i = this.parseParenItem(this.parseSpread(e, s), _t100, _r49);
          } else if (this.match(c.question)) {
            this.expectPlugin("partialApplication"), r || this.raise(this.state.start, g.UnexpectedArgumentPlaceholder);

            var _t101 = this.startNode();

            this.next(), i = this.finishNode(_t101, "ArgumentPlaceholder");
          } else i = this.parseMaybeAssignAllowIn(e, this.parseParenItem, s);
          return i;
        }
      }, {
        key: "parseIdentifier",
        value: function parseIdentifier(t) {
          var e = this.startNode(),
              s = this.parseIdentifierName(e.start, t);
          return this.createIdentifier(e, s);
        }
      }, {
        key: "createIdentifier",
        value: function createIdentifier(t, e) {
          return t.name = e, t.loc.identifierName = e, this.finishNode(t, "Identifier");
        }
      }, {
        key: "parseIdentifierName",
        value: function parseIdentifierName(t, e) {
          var s;
          var _this$state2 = this.state,
              r = _this$state2.start,
              i = _this$state2.type;
          if (i === c.name) s = this.state.value;else {
            if (!i.keyword) throw this.unexpected();
            {
              s = i.keyword;

              var _t102 = this.curContext();

              i !== c._class && i !== c._function || _t102 !== T.functionStatement && _t102 !== T.functionExpression || this.state.context.pop();
            }
          }
          return e ? this.state.type = c.name : this.checkReservedWord(s, r, !!i.keyword, !1), this.next(), s;
        }
      }, {
        key: "checkReservedWord",
        value: function checkReservedWord(t, e, s, r) {
          if (this.prodParam.hasYield && "yield" === t) return void this.raise(e, g.YieldBindingIdentifier);

          if ("await" === t) {
            if (this.prodParam.hasAwait) return void this.raise(e, g.AwaitBindingIdentifier);
            this.expressionScope.recordAsyncArrowParametersError(e, g.AwaitBindingIdentifier);
          }

          if (this.scope.inClass && !this.scope.inNonArrowFunction && "arguments" === t) return void this.raise(e, g.ArgumentsInClass);
          if (s && W(t)) return void this.raise(e, g.UnexpectedKeyword, t);
          (this.state.strict ? r ? H : V : q)(t, this.inModule) && (this.prodParam.hasAwait || "await" !== t ? this.raise(e, g.UnexpectedReservedWord, t) : this.raise(e, this.hasPlugin("topLevelAwait") ? g.AwaitNotInAsyncContext : g.AwaitNotInAsyncFunction));
        }
      }, {
        key: "isAwaitAllowed",
        value: function isAwaitAllowed() {
          return this.scope.inFunction ? this.prodParam.hasAwait : !!this.options.allowAwaitOutsideFunction || !!this.hasPlugin("topLevelAwait") && this.inModule && this.prodParam.hasAwait;
        }
      }, {
        key: "parseAwait",
        value: function parseAwait() {
          var t = this.startNode();
          return this.next(), this.expressionScope.recordParameterInitializerError(t.start, g.AwaitExpressionFormalParameter), this.eat(c.star) && this.raise(t.start, g.ObsoleteAwaitStar), this.scope.inFunction || this.options.allowAwaitOutsideFunction || (this.hasPrecedingLineBreak() || this.match(c.plusMin) || this.match(c.parenL) || this.match(c.bracketL) || this.match(c.backQuote) || this.match(c.regexp) || this.match(c.slash) || this.hasPlugin("v8intrinsic") && this.match(c.modulo) ? this.ambiguousScriptDifferentAst = !0 : this.sawUnambiguousESM = !0), this.state.soloAwait || (t.argument = this.parseMaybeUnary()), this.finishNode(t, "AwaitExpression");
        }
      }, {
        key: "parseYield",
        value: function parseYield() {
          var t = this.startNode();
          return this.expressionScope.recordParameterInitializerError(t.start, g.YieldInParameter), this.next(), this.match(c.semi) || !this.match(c.star) && !this.state.type.startsExpr || this.hasPrecedingLineBreak() ? (t.delegate = !1, t.argument = null) : (t.delegate = this.eat(c.star), t.argument = this.parseMaybeAssign()), this.finishNode(t, "YieldExpression");
        }
      }, {
        key: "checkPipelineAtInfixOperator",
        value: function checkPipelineAtInfixOperator(t, e) {
          "smart" === this.getPluginOption("pipelineOperator", "proposal") && "SequenceExpression" === t.type && this.raise(e, g.PipelineHeadSequenceExpression);
        }
      }, {
        key: "parseSmartPipelineBody",
        value: function parseSmartPipelineBody(t, e, s) {
          return this.checkSmartPipelineBodyEarlyErrors(t, e), this.parseSmartPipelineBodyInStyle(t, e, s);
        }
      }, {
        key: "checkSmartPipelineBodyEarlyErrors",
        value: function checkSmartPipelineBodyEarlyErrors(t, e) {
          if (this.match(c.arrow)) throw this.raise(this.state.start, g.PipelineBodyNoArrow);
          "SequenceExpression" === t.type && this.raise(e, g.PipelineBodySequenceExpression);
        }
      }, {
        key: "parseSmartPipelineBodyInStyle",
        value: function parseSmartPipelineBodyInStyle(t, e, s) {
          var r = this.startNodeAt(e, s),
              i = this.isSimpleReference(t);
          return i ? r.callee = t : (this.topicReferenceWasUsedInCurrentTopicContext() || this.raise(e, g.PipelineTopicUnused), r.expression = t), this.finishNode(r, i ? "PipelineBareFunction" : "PipelineTopicExpression");
        }
      }, {
        key: "isSimpleReference",
        value: function isSimpleReference(t) {
          switch (t.type) {
            case "MemberExpression":
              return !t.computed && this.isSimpleReference(t.object);

            case "Identifier":
              return !0;

            default:
              return !1;
          }
        }
      }, {
        key: "withTopicPermittingContext",
        value: function withTopicPermittingContext(t) {
          var e = this.state.topicContext;
          this.state.topicContext = {
            maxNumOfResolvableTopics: 1,
            maxTopicIndex: null
          };

          try {
            return t();
          } finally {
            this.state.topicContext = e;
          }
        }
      }, {
        key: "withTopicForbiddingContext",
        value: function withTopicForbiddingContext(t) {
          var e = this.state.topicContext;
          this.state.topicContext = {
            maxNumOfResolvableTopics: 0,
            maxTopicIndex: null
          };

          try {
            return t();
          } finally {
            this.state.topicContext = e;
          }
        }
      }, {
        key: "withSoloAwaitPermittingContext",
        value: function withSoloAwaitPermittingContext(t) {
          var e = this.state.soloAwait;
          this.state.soloAwait = !0;

          try {
            return t();
          } finally {
            this.state.soloAwait = e;
          }
        }
      }, {
        key: "allowInAnd",
        value: function allowInAnd(t) {
          var e = this.prodParam.currentFlags();

          if (8 & ~e) {
            this.prodParam.enter(8 | e);

            try {
              return t();
            } finally {
              this.prodParam.exit();
            }
          }

          return t();
        }
      }, {
        key: "disallowInAnd",
        value: function disallowInAnd(t) {
          var e = this.prodParam.currentFlags();

          if (8 & e) {
            this.prodParam.enter(-9 & e);

            try {
              return t();
            } finally {
              this.prodParam.exit();
            }
          }

          return t();
        }
      }, {
        key: "registerTopicReference",
        value: function registerTopicReference() {
          this.state.topicContext.maxTopicIndex = 0;
        }
      }, {
        key: "primaryTopicReferenceIsAllowedInCurrentTopicContext",
        value: function primaryTopicReferenceIsAllowedInCurrentTopicContext() {
          return this.state.topicContext.maxNumOfResolvableTopics >= 1;
        }
      }, {
        key: "topicReferenceWasUsedInCurrentTopicContext",
        value: function topicReferenceWasUsedInCurrentTopicContext() {
          return null != this.state.topicContext.maxTopicIndex && this.state.topicContext.maxTopicIndex >= 0;
        }
      }, {
        key: "parseFSharpPipelineBody",
        value: function parseFSharpPipelineBody(t) {
          var e = this.state.start,
              s = this.state.startLoc;
          this.state.potentialArrowAt = this.state.start;
          var r = this.state.inFSharpPipelineDirectBody;
          this.state.inFSharpPipelineDirectBody = !0;
          var i = this.parseExprOp(this.parseMaybeUnary(), e, s, t);
          return this.state.inFSharpPipelineDirectBody = r, i;
        }
      }]);

      return _class8;
    }( /*#__PURE__*/function (_ref31) {
      _inherits(_class9, _ref31);

      var _super13 = _createSuper(_class9);

      function _class9() {
        _classCallCheck(this, _class9);

        return _super13.apply(this, arguments);
      }

      _createClass(_class9, [{
        key: "toAssignable",
        value: function toAssignable(t) {
          var e, s;
          var r = void 0;

          switch (("ParenthesizedExpression" === t.type || (null == (e = t.extra) ? void 0 : e.parenthesized)) && (r = St(t), "Identifier" !== r.type && "MemberExpression" !== r.type && this.raise(t.start, g.InvalidParenthesizedAssignment)), t.type) {
            case "Identifier":
            case "ObjectPattern":
            case "ArrayPattern":
            case "AssignmentPattern":
              break;

            case "ObjectExpression":
              t.type = "ObjectPattern";

              for (var _e92 = 0, _s56 = t.properties.length, _r50 = _s56 - 1; _e92 < _s56; _e92++) {
                var i;

                var _s57 = t.properties[_e92],
                    _n17 = _e92 === _r50;

                this.toAssignableObjectExpressionProp(_s57, _n17), _n17 && "RestElement" === _s57.type && (null == (i = t.extra) ? void 0 : i.trailingComma) && this.raiseRestNotLast(t.extra.trailingComma);
              }

              break;

            case "ObjectProperty":
              this.toAssignable(t.value);
              break;

            case "SpreadElement":
              {
                this.checkToRestConversion(t), t.type = "RestElement";
                var _e93 = t.argument;
                this.toAssignable(_e93);
                break;
              }

            case "ArrayExpression":
              t.type = "ArrayPattern", this.toAssignableList(t.elements, null == (s = t.extra) ? void 0 : s.trailingComma);
              break;

            case "AssignmentExpression":
              "=" !== t.operator && this.raise(t.left.end, g.MissingEqInAssignment), t.type = "AssignmentPattern", delete t.operator, this.toAssignable(t.left);
              break;

            case "ParenthesizedExpression":
              this.toAssignable(r);
          }

          return t;
        }
      }, {
        key: "toAssignableObjectExpressionProp",
        value: function toAssignableObjectExpressionProp(t, e) {
          if ("ObjectMethod" === t.type) {
            var _e94 = "get" === t.kind || "set" === t.kind ? g.PatternHasAccessor : g.PatternHasMethod;

            this.raise(t.key.start, _e94);
          } else "SpreadElement" !== t.type || e ? this.toAssignable(t) : this.raiseRestNotLast(t.start);
        }
      }, {
        key: "toAssignableList",
        value: function toAssignableList(t, e) {
          var s = t.length;

          if (s) {
            var _r51 = t[s - 1];
            if ("RestElement" === (null == _r51 ? void 0 : _r51.type)) --s;else if ("SpreadElement" === (null == _r51 ? void 0 : _r51.type)) {
              _r51.type = "RestElement";
              var _t103 = _r51.argument;
              this.toAssignable(_t103), "Identifier" !== _t103.type && "MemberExpression" !== _t103.type && "ArrayPattern" !== _t103.type && "ObjectPattern" !== _t103.type && this.unexpected(_t103.start), e && this.raiseTrailingCommaAfterRest(e), --s;
            }
          }

          for (var _e95 = 0; _e95 < s; _e95++) {
            var _s58 = t[_e95];
            _s58 && (this.toAssignable(_s58), "RestElement" === _s58.type && this.raiseRestNotLast(_s58.start));
          }

          return t;
        }
      }, {
        key: "toReferencedList",
        value: function toReferencedList(t, e) {
          return t;
        }
      }, {
        key: "toReferencedListDeep",
        value: function toReferencedListDeep(t, e) {
          this.toReferencedList(t, e);

          for (var _e96 = 0; _e96 < t.length; _e96++) {
            var _s59 = t[_e96];
            "ArrayExpression" === (null == _s59 ? void 0 : _s59.type) && this.toReferencedListDeep(_s59.elements);
          }
        }
      }, {
        key: "parseSpread",
        value: function parseSpread(t, e) {
          var s = this.startNode();
          return this.next(), s.argument = this.parseMaybeAssignAllowIn(t, void 0, e), this.finishNode(s, "SpreadElement");
        }
      }, {
        key: "parseRestBinding",
        value: function parseRestBinding() {
          var t = this.startNode();
          return this.next(), t.argument = this.parseBindingAtom(), this.finishNode(t, "RestElement");
        }
      }, {
        key: "parseBindingAtom",
        value: function parseBindingAtom() {
          switch (this.state.type) {
            case c.bracketL:
              {
                var _t104 = this.startNode();

                return this.next(), _t104.elements = this.parseBindingList(c.bracketR, 93, !0), this.finishNode(_t104, "ArrayPattern");
              }

            case c.braceL:
              return this.parseObjectLike(c.braceR, !0);
          }

          return this.parseIdentifier();
        }
      }, {
        key: "parseBindingList",
        value: function parseBindingList(t, e, s, r) {
          var i = [];
          var n = !0;

          for (; !this.eat(t);) {
            if (n ? n = !1 : this.expect(c.comma), s && this.match(c.comma)) i.push(null);else {
              if (this.eat(t)) break;

              if (this.match(c.ellipsis)) {
                i.push(this.parseAssignableListItemTypes(this.parseRestBinding())), this.checkCommaAfterRest(e), this.expect(t);
                break;
              }

              {
                var _t105 = [];

                for (this.match(c.at) && this.hasPlugin("decorators") && this.raise(this.state.start, g.UnsupportedParameterDecorator); this.match(c.at);) {
                  _t105.push(this.parseDecorator());
                }

                i.push(this.parseAssignableListItem(r, _t105));
              }
            }
          }

          return i;
        }
      }, {
        key: "parseAssignableListItem",
        value: function parseAssignableListItem(t, e) {
          var s = this.parseMaybeDefault();
          this.parseAssignableListItemTypes(s);
          var r = this.parseMaybeDefault(s.start, s.loc.start, s);
          return e.length && (s.decorators = e), r;
        }
      }, {
        key: "parseAssignableListItemTypes",
        value: function parseAssignableListItemTypes(t) {
          return t;
        }
      }, {
        key: "parseMaybeDefault",
        value: function parseMaybeDefault(t, e, s) {
          var r, i, n;
          if (e = null != (r = e) ? r : this.state.startLoc, t = null != (i = t) ? i : this.state.start, s = null != (n = s) ? n : this.parseBindingAtom(), !this.eat(c.eq)) return s;
          var a = this.startNodeAt(t, e);
          return a.left = s, a.right = this.parseMaybeAssignAllowIn(), this.finishNode(a, "AssignmentPattern");
        }
      }, {
        key: "checkLVal",
        value: function checkLVal(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 64;
          var s = arguments.length > 2 ? arguments[2] : undefined;
          var r = arguments.length > 3 ? arguments[3] : undefined;
          var i = arguments.length > 4 ? arguments[4] : undefined;
          var n = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : !1;

          switch (t.type) {
            case "Identifier":
              if (this.state.strict && (n ? H(t.name, this.inModule) : z(t.name)) && this.raise(t.start, e === D ? g.StrictEvalArguments : g.StrictEvalArgumentsBinding, t.name), s) {
                var _e97 = "_".concat(t.name);

                s[_e97] ? this.raise(t.start, g.ParamDupe) : s[_e97] = !0;
              }

              i && "let" === t.name && this.raise(t.start, g.LetInLexicalBinding), e & D || this.scope.declareName(t.name, e, t.start);
              break;

            case "MemberExpression":
              e !== D && this.raise(t.start, g.InvalidPropertyBindingPattern);
              break;

            case "ObjectPattern":
              for (var _r52 = 0, _n18 = t.properties; _r52 < _n18.length; _r52++) {
                var _t106 = _n18[_r52];
                if ("ObjectProperty" === _t106.type) _t106 = _t106.value;else if ("ObjectMethod" === _t106.type) continue;
                this.checkLVal(_t106, e, s, "object destructuring pattern", i);
              }

              break;

            case "ArrayPattern":
              for (var _r53 = 0, _n19 = t.elements; _r53 < _n19.length; _r53++) {
                var _t107 = _n19[_r53];
                _t107 && this.checkLVal(_t107, e, s, "array destructuring pattern", i);
              }

              break;

            case "AssignmentPattern":
              this.checkLVal(t.left, e, s, "assignment pattern");
              break;

            case "RestElement":
              this.checkLVal(t.argument, e, s, "rest element");
              break;

            case "ParenthesizedExpression":
              this.checkLVal(t.expression, e, s, "parenthesized expression");
              break;

            default:
              this.raise(t.start, e === D ? g.InvalidLhs : g.InvalidLhsBinding, r);
          }
        }
      }, {
        key: "checkToRestConversion",
        value: function checkToRestConversion(t) {
          "Identifier" !== t.argument.type && "MemberExpression" !== t.argument.type && this.raise(t.argument.start, g.InvalidRestAssignmentPattern);
        }
      }, {
        key: "checkCommaAfterRest",
        value: function checkCommaAfterRest(t) {
          this.match(c.comma) && (this.lookaheadCharCode() === t ? this.raiseTrailingCommaAfterRest(this.state.start) : this.raiseRestNotLast(this.state.start));
        }
      }, {
        key: "raiseRestNotLast",
        value: function raiseRestNotLast(t) {
          throw this.raise(t, g.ElementAfterRest);
        }
      }, {
        key: "raiseTrailingCommaAfterRest",
        value: function raiseTrailingCommaAfterRest(t) {
          this.raise(t, g.RestTrailingComma);
        }
      }]);

      return _class9;
    }( /*#__PURE__*/function (_ref32) {
      _inherits(_class10, _ref32);

      var _super14 = _createSuper(_class10);

      function _class10() {
        _classCallCheck(this, _class10);

        return _super14.apply(this, arguments);
      }

      _createClass(_class10, [{
        key: "startNode",
        value: function startNode() {
          return new Bt(this, this.state.start, this.state.startLoc);
        }
      }, {
        key: "startNodeAt",
        value: function startNodeAt(t, e) {
          return new Bt(this, t, e);
        }
      }, {
        key: "startNodeAtNode",
        value: function startNodeAtNode(t) {
          return this.startNodeAt(t.start, t.loc.start);
        }
      }, {
        key: "finishNode",
        value: function finishNode(t, e) {
          return this.finishNodeAt(t, e, this.state.lastTokEnd, this.state.lastTokEndLoc);
        }
      }, {
        key: "finishNodeAt",
        value: function finishNodeAt(t, e, s, r) {
          return t.type = e, t.end = s, t.loc.end = r, this.options.ranges && (t.range[1] = s), this.processComment(t), t;
        }
      }, {
        key: "resetStartLocation",
        value: function resetStartLocation(t, e, s) {
          t.start = e, t.loc.start = s, this.options.ranges && (t.range[0] = e);
        }
      }, {
        key: "resetEndLocation",
        value: function resetEndLocation(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state.lastTokEnd;
          var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.state.lastTokEndLoc;
          t.end = e, t.loc.end = s, this.options.ranges && (t.range[1] = e);
        }
      }, {
        key: "resetStartLocationFromNode",
        value: function resetStartLocationFromNode(t, e) {
          this.resetStartLocation(t, e.start, e.loc.start);
        }
      }]);

      return _class10;
    }( /*#__PURE__*/function (_ref33) {
      _inherits(_class11, _ref33);

      var _super15 = _createSuper(_class11);

      function _class11() {
        _classCallCheck(this, _class11);

        return _super15.apply(this, arguments);
      }

      _createClass(_class11, [{
        key: "addExtra",
        value: function addExtra(t, e, s) {
          if (!t) return;
          (t.extra = t.extra || {})[e] = s;
        }
      }, {
        key: "isRelational",
        value: function isRelational(t) {
          return this.match(c.relational) && this.state.value === t;
        }
      }, {
        key: "expectRelational",
        value: function expectRelational(t) {
          this.isRelational(t) ? this.next() : this.unexpected(null, c.relational);
        }
      }, {
        key: "isContextual",
        value: function isContextual(t) {
          return this.match(c.name) && this.state.value === t && !this.state.containsEsc;
        }
      }, {
        key: "isUnparsedContextual",
        value: function isUnparsedContextual(t, e) {
          var s = t + e.length;
          return this.input.slice(t, s) === e && (s === this.input.length || !O(this.input.charCodeAt(s)));
        }
      }, {
        key: "isLookaheadContextual",
        value: function isLookaheadContextual(t) {
          var e = this.nextTokenStart();
          return this.isUnparsedContextual(e, t);
        }
      }, {
        key: "eatContextual",
        value: function eatContextual(t) {
          return this.isContextual(t) && this.eat(c.name);
        }
      }, {
        key: "expectContextual",
        value: function expectContextual(t, e) {
          this.eatContextual(t) || this.unexpected(null, e);
        }
      }, {
        key: "canInsertSemicolon",
        value: function canInsertSemicolon() {
          return this.match(c.eof) || this.match(c.braceR) || this.hasPrecedingLineBreak();
        }
      }, {
        key: "hasPrecedingLineBreak",
        value: function hasPrecedingLineBreak() {
          return m.test(this.input.slice(this.state.lastTokEnd, this.state.start));
        }
      }, {
        key: "isLineTerminator",
        value: function isLineTerminator() {
          return this.eat(c.semi) || this.canInsertSemicolon();
        }
      }, {
        key: "semicolon",
        value: function semicolon() {
          this.isLineTerminator() || this.unexpected(null, c.semi);
        }
      }, {
        key: "expect",
        value: function expect(t, e) {
          this.eat(t) || this.unexpected(e, t);
        }
      }, {
        key: "assertNoSpace",
        value: function assertNoSpace() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Unexpected space.";
          this.state.start > this.state.lastTokEnd && this.raise(this.state.lastTokEnd, t);
        }
      }, {
        key: "unexpected",
        value: function unexpected(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Unexpected token";
          throw "string" != typeof e && (e = 'Unexpected token, expected "'.concat(e.label, '"')), this.raise(null != t ? t : this.state.start, e);
        }
      }, {
        key: "expectPlugin",
        value: function expectPlugin(t, e) {
          if (!this.hasPlugin(t)) throw this.raiseWithData(null != e ? e : this.state.start, {
            missingPlugin: [t]
          }, "This experimental syntax requires enabling the parser plugin: '".concat(t, "'"));
          return !0;
        }
      }, {
        key: "expectOnePlugin",
        value: function expectOnePlugin(t, e) {
          var _this54 = this;

          if (!t.some(function (t) {
            return _this54.hasPlugin(t);
          })) throw this.raiseWithData(null != e ? e : this.state.start, {
            missingPlugin: t
          }, "This experimental syntax requires enabling one of the following parser plugin(s): '".concat(t.join(", "), "'"));
        }
      }, {
        key: "tryParse",
        value: function tryParse(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state.clone();
          var s = {
            node: null
          };

          try {
            var _r54 = t(function () {
              var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
              throw s.node = t, s;
            });

            if (this.state.errors.length > e.errors.length) {
              var _t108 = this.state;
              return this.state = e, {
                node: _r54,
                error: _t108.errors[e.errors.length],
                thrown: !1,
                aborted: !1,
                failState: _t108
              };
            }

            return {
              node: _r54,
              error: null,
              thrown: !1,
              aborted: !1,
              failState: null
            };
          } catch (t) {
            var _r55 = this.state;
            if (this.state = e, t instanceof SyntaxError) return {
              node: null,
              error: t,
              thrown: !0,
              aborted: !1,
              failState: _r55
            };
            if (t === s) return {
              node: s.node,
              error: null,
              thrown: !1,
              aborted: !0,
              failState: _r55
            };
            throw t;
          }
        }
      }, {
        key: "checkExpressionErrors",
        value: function checkExpressionErrors(t, e) {
          if (!t) return !1;
          var s = t.shorthandAssign,
              r = t.doubleProto;
          if (!e) return s >= 0 || r >= 0;
          s >= 0 && this.unexpected(s), r >= 0 && this.raise(r, g.DuplicateProto);
        }
      }, {
        key: "isLiteralPropertyName",
        value: function isLiteralPropertyName() {
          return this.match(c.name) || !!this.state.type.keyword || this.match(c.string) || this.match(c.num) || this.match(c.bigint) || this.match(c.decimal);
        }
      }]);

      return _class11;
    }( /*#__PURE__*/function (_ref34) {
      _inherits(_class12, _ref34);

      var _super16 = _createSuper(_class12);

      function _class12(t, e) {
        var _this55;

        _classCallCheck(this, _class12);

        _this55 = _super16.call(this), _this55.isLookahead = void 0, _this55.tokens = [], _this55.state = new xt(), _this55.state.init(t), _this55.input = e, _this55.length = e.length, _this55.isLookahead = !1;
        return _this55;
      }

      _createClass(_class12, [{
        key: "pushToken",
        value: function pushToken(t) {
          this.tokens.length = this.state.tokensLength, this.tokens.push(t), ++this.state.tokensLength;
        }
      }, {
        key: "next",
        value: function next() {
          this.isLookahead || (this.checkKeywordEscapes(), this.options.tokens && this.pushToken(new Tt(this.state))), this.state.lastTokEnd = this.state.end, this.state.lastTokStart = this.state.start, this.state.lastTokEndLoc = this.state.endLoc, this.state.lastTokStartLoc = this.state.startLoc, this.nextToken();
        }
      }, {
        key: "eat",
        value: function eat(t) {
          return !!this.match(t) && (this.next(), !0);
        }
      }, {
        key: "match",
        value: function match(t) {
          return this.state.type === t;
        }
      }, {
        key: "lookahead",
        value: function lookahead() {
          var t = this.state;
          this.state = t.clone(!0), this.isLookahead = !0, this.next(), this.isLookahead = !1;
          var e = this.state;
          return this.state = t, e;
        }
      }, {
        key: "nextTokenStart",
        value: function nextTokenStart() {
          return this.nextTokenStartSince(this.state.pos);
        }
      }, {
        key: "nextTokenStartSince",
        value: function nextTokenStartSince(t) {
          E.lastIndex = t;
          return t + E.exec(this.input)[0].length;
        }
      }, {
        key: "lookaheadCharCode",
        value: function lookaheadCharCode() {
          return this.input.charCodeAt(this.nextTokenStart());
        }
      }, {
        key: "setStrict",
        value: function setStrict(t) {
          if (this.state.strict = t, this.match(c.num) || this.match(c.string)) {
            for (this.state.pos = this.state.start; this.state.pos < this.state.lineStart;) {
              this.state.lineStart = this.input.lastIndexOf("\n", this.state.lineStart - 2) + 1, --this.state.curLine;
            }

            this.nextToken();
          }
        }
      }, {
        key: "curContext",
        value: function curContext() {
          return this.state.context[this.state.context.length - 1];
        }
      }, {
        key: "nextToken",
        value: function nextToken() {
          var t = this.curContext();
          if ((null == t ? void 0 : t.preserveSpace) || this.skipSpace(), this.state.octalPositions = [], this.state.start = this.state.pos, this.state.startLoc = this.state.curPosition(), this.state.pos >= this.length) return void this.finishToken(c.eof);
          var e = null == t ? void 0 : t.override;
          e ? e(this) : this.getTokenFromCode(this.input.codePointAt(this.state.pos));
        }
      }, {
        key: "pushComment",
        value: function pushComment(t, e, s, r, i, n) {
          var a = {
            type: t ? "CommentBlock" : "CommentLine",
            value: e,
            start: s,
            end: r,
            loc: new x(i, n)
          };
          this.options.tokens && this.pushToken(a), this.state.comments.push(a), this.addComment(a);
        }
      }, {
        key: "skipBlockComment",
        value: function skipBlockComment() {
          var t = this.state.curPosition(),
              e = this.state.pos,
              s = this.input.indexOf("*/", this.state.pos + 2);
          if (-1 === s) throw this.raise(e, g.UnterminatedComment);
          var r;

          for (this.state.pos = s + 2, f.lastIndex = e; (r = f.exec(this.input)) && r.index < this.state.pos;) {
            ++this.state.curLine, this.state.lineStart = r.index + r[0].length;
          }

          this.isLookahead || this.pushComment(!0, this.input.slice(e + 2, s), e, this.state.pos, t, this.state.curPosition());
        }
      }, {
        key: "skipLineComment",
        value: function skipLineComment(t) {
          var e = this.state.pos,
              s = this.state.curPosition();
          var r = this.input.charCodeAt(this.state.pos += t);
          if (this.state.pos < this.length) for (; !y(r) && ++this.state.pos < this.length;) {
            r = this.input.charCodeAt(this.state.pos);
          }
          this.isLookahead || this.pushComment(!1, this.input.slice(e + t, this.state.pos), e, this.state.pos, s, this.state.curPosition());
        }
      }, {
        key: "skipSpace",
        value: function skipSpace() {
          t: for (; this.state.pos < this.length;) {
            var _t109 = this.input.charCodeAt(this.state.pos);

            switch (_t109) {
              case 32:
              case 160:
              case 9:
                ++this.state.pos;
                break;

              case 13:
                10 === this.input.charCodeAt(this.state.pos + 1) && ++this.state.pos;

              case 10:
              case 8232:
              case 8233:
                ++this.state.pos, ++this.state.curLine, this.state.lineStart = this.state.pos;
                break;

              case 47:
                switch (this.input.charCodeAt(this.state.pos + 1)) {
                  case 42:
                    this.skipBlockComment();
                    break;

                  case 47:
                    this.skipLineComment(2);
                    break;

                  default:
                    break t;
                }

                break;

              default:
                if (!A(_t109)) break t;
                ++this.state.pos;
            }
          }
        }
      }, {
        key: "finishToken",
        value: function finishToken(t, e) {
          this.state.end = this.state.pos, this.state.endLoc = this.state.curPosition();
          var s = this.state.type;
          this.state.type = t, this.state.value = e, this.isLookahead || this.updateContext(s);
        }
      }, {
        key: "readToken_numberSign",
        value: function readToken_numberSign() {
          if (0 === this.state.pos && this.readToken_interpreter()) return;
          var t = this.state.pos + 1,
              e = this.input.charCodeAt(t);
          if (e >= 48 && e <= 57) throw this.raise(this.state.pos, g.UnexpectedDigitAfterHash);

          if (123 === e || 91 === e && this.hasPlugin("recordAndTuple")) {
            if (this.expectPlugin("recordAndTuple"), "hash" !== this.getPluginOption("recordAndTuple", "syntaxType")) throw this.raise(this.state.pos, 123 === e ? g.RecordExpressionHashIncorrectStartSyntaxType : g.TupleExpressionHashIncorrectStartSyntaxType);
            123 === e ? this.finishToken(c.braceHashL) : this.finishToken(c.bracketHashL), this.state.pos += 2;
          } else this.finishOp(c.hash, 1);
        }
      }, {
        key: "readToken_dot",
        value: function readToken_dot() {
          var t = this.input.charCodeAt(this.state.pos + 1);
          t >= 48 && t <= 57 ? this.readNumber(!0) : 46 === t && 46 === this.input.charCodeAt(this.state.pos + 2) ? (this.state.pos += 3, this.finishToken(c.ellipsis)) : (++this.state.pos, this.finishToken(c.dot));
        }
      }, {
        key: "readToken_slash",
        value: function readToken_slash() {
          if (this.state.exprAllowed && !this.state.inType) return ++this.state.pos, void this.readRegexp();
          61 === this.input.charCodeAt(this.state.pos + 1) ? this.finishOp(c.assign, 2) : this.finishOp(c.slash, 1);
        }
      }, {
        key: "readToken_interpreter",
        value: function readToken_interpreter() {
          if (0 !== this.state.pos || this.length < 2) return !1;
          var t = this.input.charCodeAt(this.state.pos + 1);
          if (33 !== t) return !1;
          var e = this.state.pos;

          for (this.state.pos += 1; !y(t) && ++this.state.pos < this.length;) {
            t = this.input.charCodeAt(this.state.pos);
          }

          var s = this.input.slice(e + 2, this.state.pos);
          return this.finishToken(c.interpreterDirective, s), !0;
        }
      }, {
        key: "readToken_mult_modulo",
        value: function readToken_mult_modulo(t) {
          var e = 42 === t ? c.star : c.modulo,
              s = 1,
              r = this.input.charCodeAt(this.state.pos + 1);
          var i = this.state.exprAllowed;
          42 === t && 42 === r && (s++, r = this.input.charCodeAt(this.state.pos + 2), e = c.exponent), 61 !== r || i || (s++, e = c.assign), this.finishOp(e, s);
        }
      }, {
        key: "readToken_pipe_amp",
        value: function readToken_pipe_amp(t) {
          var e = this.input.charCodeAt(this.state.pos + 1);

          if (e !== t) {
            if (124 === t) {
              if (62 === e) return void this.finishOp(c.pipeline, 2);

              if (this.hasPlugin("recordAndTuple") && 125 === e) {
                if ("bar" !== this.getPluginOption("recordAndTuple", "syntaxType")) throw this.raise(this.state.pos, g.RecordExpressionBarIncorrectEndSyntaxType);
                return void this.finishOp(c.braceBarR, 2);
              }

              if (this.hasPlugin("recordAndTuple") && 93 === e) {
                if ("bar" !== this.getPluginOption("recordAndTuple", "syntaxType")) throw this.raise(this.state.pos, g.TupleExpressionBarIncorrectEndSyntaxType);
                return void this.finishOp(c.bracketBarR, 2);
              }
            }

            61 !== e ? this.finishOp(124 === t ? c.bitwiseOR : c.bitwiseAND, 1) : this.finishOp(c.assign, 2);
          } else 61 === this.input.charCodeAt(this.state.pos + 2) ? this.finishOp(c.assign, 3) : this.finishOp(124 === t ? c.logicalOR : c.logicalAND, 2);
        }
      }, {
        key: "readToken_caret",
        value: function readToken_caret() {
          61 === this.input.charCodeAt(this.state.pos + 1) ? this.finishOp(c.assign, 2) : this.finishOp(c.bitwiseXOR, 1);
        }
      }, {
        key: "readToken_plus_min",
        value: function readToken_plus_min(t) {
          var e = this.input.charCodeAt(this.state.pos + 1);
          if (e === t) return 45 !== e || this.inModule || 62 !== this.input.charCodeAt(this.state.pos + 2) || 0 !== this.state.lastTokEnd && !this.hasPrecedingLineBreak() ? void this.finishOp(c.incDec, 2) : (this.skipLineComment(3), this.skipSpace(), void this.nextToken());
          61 === e ? this.finishOp(c.assign, 2) : this.finishOp(c.plusMin, 1);
        }
      }, {
        key: "readToken_lt_gt",
        value: function readToken_lt_gt(t) {
          var e = this.input.charCodeAt(this.state.pos + 1);
          var s = 1;
          return e === t ? (s = 62 === t && 62 === this.input.charCodeAt(this.state.pos + 2) ? 3 : 2, 61 === this.input.charCodeAt(this.state.pos + s) ? void this.finishOp(c.assign, s + 1) : void this.finishOp(c.bitShift, s)) : 33 !== e || 60 !== t || this.inModule || 45 !== this.input.charCodeAt(this.state.pos + 2) || 45 !== this.input.charCodeAt(this.state.pos + 3) ? (61 === e && (s = 2), void this.finishOp(c.relational, s)) : (this.skipLineComment(4), this.skipSpace(), void this.nextToken());
        }
      }, {
        key: "readToken_eq_excl",
        value: function readToken_eq_excl(t) {
          var e = this.input.charCodeAt(this.state.pos + 1);
          if (61 !== e) return 61 === t && 62 === e ? (this.state.pos += 2, void this.finishToken(c.arrow)) : void this.finishOp(61 === t ? c.eq : c.bang, 1);
          this.finishOp(c.equality, 61 === this.input.charCodeAt(this.state.pos + 2) ? 3 : 2);
        }
      }, {
        key: "readToken_question",
        value: function readToken_question() {
          var t = this.input.charCodeAt(this.state.pos + 1),
              e = this.input.charCodeAt(this.state.pos + 2);
          63 === t ? 61 === e ? this.finishOp(c.assign, 3) : this.finishOp(c.nullishCoalescing, 2) : 46 !== t || e >= 48 && e <= 57 ? (++this.state.pos, this.finishToken(c.question)) : (this.state.pos += 2, this.finishToken(c.questionDot));
        }
      }, {
        key: "getTokenFromCode",
        value: function getTokenFromCode(t) {
          switch (t) {
            case 46:
              return void this.readToken_dot();

            case 40:
              return ++this.state.pos, void this.finishToken(c.parenL);

            case 41:
              return ++this.state.pos, void this.finishToken(c.parenR);

            case 59:
              return ++this.state.pos, void this.finishToken(c.semi);

            case 44:
              return ++this.state.pos, void this.finishToken(c.comma);

            case 91:
              if (this.hasPlugin("recordAndTuple") && 124 === this.input.charCodeAt(this.state.pos + 1)) {
                if ("bar" !== this.getPluginOption("recordAndTuple", "syntaxType")) throw this.raise(this.state.pos, g.TupleExpressionBarIncorrectStartSyntaxType);
                this.finishToken(c.bracketBarL), this.state.pos += 2;
              } else ++this.state.pos, this.finishToken(c.bracketL);

              return;

            case 93:
              return ++this.state.pos, void this.finishToken(c.bracketR);

            case 123:
              if (this.hasPlugin("recordAndTuple") && 124 === this.input.charCodeAt(this.state.pos + 1)) {
                if ("bar" !== this.getPluginOption("recordAndTuple", "syntaxType")) throw this.raise(this.state.pos, g.RecordExpressionBarIncorrectStartSyntaxType);
                this.finishToken(c.braceBarL), this.state.pos += 2;
              } else ++this.state.pos, this.finishToken(c.braceL);

              return;

            case 125:
              return ++this.state.pos, void this.finishToken(c.braceR);

            case 58:
              return void (this.hasPlugin("functionBind") && 58 === this.input.charCodeAt(this.state.pos + 1) ? this.finishOp(c.doubleColon, 2) : (++this.state.pos, this.finishToken(c.colon)));

            case 63:
              return void this.readToken_question();

            case 96:
              return ++this.state.pos, void this.finishToken(c.backQuote);

            case 48:
              {
                var _t110 = this.input.charCodeAt(this.state.pos + 1);

                if (120 === _t110 || 88 === _t110) return void this.readRadixNumber(16);
                if (111 === _t110 || 79 === _t110) return void this.readRadixNumber(8);
                if (98 === _t110 || 66 === _t110) return void this.readRadixNumber(2);
              }

            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
              return void this.readNumber(!1);

            case 34:
            case 39:
              return void this.readString(t);

            case 47:
              return void this.readToken_slash();

            case 37:
            case 42:
              return void this.readToken_mult_modulo(t);

            case 124:
            case 38:
              return void this.readToken_pipe_amp(t);

            case 94:
              return void this.readToken_caret();

            case 43:
            case 45:
              return void this.readToken_plus_min(t);

            case 60:
            case 62:
              return void this.readToken_lt_gt(t);

            case 61:
            case 33:
              return void this.readToken_eq_excl(t);

            case 126:
              return void this.finishOp(c.tilde, 1);

            case 64:
              return ++this.state.pos, void this.finishToken(c.at);

            case 35:
              return void this.readToken_numberSign();

            case 92:
              return void this.readWord();

            default:
              if (L(t)) return void this.readWord();
          }

          throw this.raise(this.state.pos, g.InvalidOrUnexpectedToken, String.fromCodePoint(t));
        }
      }, {
        key: "finishOp",
        value: function finishOp(t, e) {
          var s = this.input.slice(this.state.pos, this.state.pos + e);
          this.state.pos += e, this.finishToken(t, s);
        }
      }, {
        key: "readRegexp",
        value: function readRegexp() {
          var t = this.state.pos;
          var e, s;

          for (;;) {
            if (this.state.pos >= this.length) throw this.raise(t, g.UnterminatedRegExp);

            var _r56 = this.input.charAt(this.state.pos);

            if (m.test(_r56)) throw this.raise(t, g.UnterminatedRegExp);
            if (e) e = !1;else {
              if ("[" === _r56) s = !0;else if ("]" === _r56 && s) s = !1;else if ("/" === _r56 && !s) break;
              e = "\\" === _r56;
            }
            ++this.state.pos;
          }

          var r = this.input.slice(t, this.state.pos);
          ++this.state.pos;
          var i = "";

          for (; this.state.pos < this.length;) {
            var _t111 = this.input[this.state.pos],
                _e98 = this.input.codePointAt(this.state.pos);

            if (gt.has(_t111)) i.indexOf(_t111) > -1 && this.raise(this.state.pos + 1, g.DuplicateRegExpFlags);else {
              if (!O(_e98) && 92 !== _e98) break;
              this.raise(this.state.pos + 1, g.MalformedRegExpFlags);
            }
            ++this.state.pos, i += _t111;
          }

          this.finishToken(c.regexp, {
            pattern: r,
            flags: i
          });
        }
      }, {
        key: "readInt",
        value: function readInt(t, e, s) {
          var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
          var i = this.state.pos,
              n = 16 === t ? bt.hex : bt.decBinOct,
              a = 16 === t ? Pt.hex : 10 === t ? Pt.dec : 8 === t ? Pt.oct : Pt.bin;
          var o = !1,
              u = 0;

          for (var _i29 = 0, _h3 = null == e ? 1 / 0 : e; _i29 < _h3; ++_i29) {
            var _e99 = this.input.charCodeAt(this.state.pos);

            var _h4 = void 0;

            if (95 !== _e99) {
              if (_h4 = _e99 >= 97 ? _e99 - 97 + 10 : _e99 >= 65 ? _e99 - 65 + 10 : Ft(_e99) ? _e99 - 48 : 1 / 0, _h4 >= t) if (this.options.errorRecovery && _h4 <= 9) _h4 = 0, this.raise(this.state.start + _i29 + 2, g.InvalidDigit, t);else {
                if (!s) break;
                _h4 = 0, o = !0;
              }
              ++this.state.pos, u = u * t + _h4;
            } else {
              var _t112 = this.input.charCodeAt(this.state.pos - 1),
                  _e100 = this.input.charCodeAt(this.state.pos + 1);

              (-1 === a.indexOf(_e100) || n.indexOf(_t112) > -1 || n.indexOf(_e100) > -1 || Number.isNaN(_e100)) && this.raise(this.state.pos, g.UnexpectedNumericSeparator), r || this.raise(this.state.pos, g.NumericSeparatorInEscapeSequence), ++this.state.pos;
            }
          }

          return this.state.pos === i || null != e && this.state.pos - i !== e || o ? null : u;
        }
      }, {
        key: "readRadixNumber",
        value: function readRadixNumber(t) {
          var e = this.state.pos;
          var s = !1;
          this.state.pos += 2;
          var r = this.readInt(t);
          null == r && this.raise(this.state.start + 2, g.InvalidDigit, t);
          var i = this.input.charCodeAt(this.state.pos);
          if (110 === i) ++this.state.pos, s = !0;else if (109 === i) throw this.raise(e, g.InvalidDecimal);
          if (L(this.input.codePointAt(this.state.pos))) throw this.raise(this.state.pos, g.NumberIdentifier);

          if (s) {
            var _t113 = this.input.slice(e, this.state.pos).replace(/[_n]/g, "");

            this.finishToken(c.bigint, _t113);
          } else this.finishToken(c.num, r);
        }
      }, {
        key: "readNumber",
        value: function readNumber(t) {
          var e = this.state.pos;
          var s = !1,
              r = !1,
              i = !1,
              n = !1,
              a = !1;
          t || null !== this.readInt(10) || this.raise(e, g.InvalidNumber);
          var o = this.state.pos - e >= 2 && 48 === this.input.charCodeAt(e);

          if (o) {
            var _t114 = this.input.slice(e, this.state.pos);

            if (this.state.strict) this.raise(e, g.StrictOctalLiteral);else {
              var _s60 = _t114.indexOf("_");

              _s60 > 0 && this.raise(_s60 + e, g.ZeroDigitNumericSeparator);
            }
            a = o && !/[89]/.test(_t114);
          }

          var u = this.input.charCodeAt(this.state.pos);
          if (46 !== u || a || (++this.state.pos, this.readInt(10), s = !0, u = this.input.charCodeAt(this.state.pos)), 69 !== u && 101 !== u || a || (u = this.input.charCodeAt(++this.state.pos), 43 !== u && 45 !== u || ++this.state.pos, null === this.readInt(10) && this.raise(e, g.InvalidOrMissingExponent), s = !0, n = !0, u = this.input.charCodeAt(this.state.pos)), 110 === u && ((s || o) && this.raise(e, g.InvalidBigIntLiteral), ++this.state.pos, r = !0), 109 === u && (this.expectPlugin("decimal", this.state.pos), (n || o) && this.raise(e, g.InvalidDecimal), ++this.state.pos, i = !0), L(this.input.codePointAt(this.state.pos))) throw this.raise(this.state.pos, g.NumberIdentifier);
          var h = this.input.slice(e, this.state.pos).replace(/[_mn]/g, "");
          if (r) return void this.finishToken(c.bigint, h);
          if (i) return void this.finishToken(c.decimal, h);
          var p = a ? parseInt(h, 8) : parseFloat(h);
          this.finishToken(c.num, p);
        }
      }, {
        key: "readCodePoint",
        value: function readCodePoint(t) {
          var e;

          if (123 === this.input.charCodeAt(this.state.pos)) {
            var _s61 = ++this.state.pos;

            if (e = this.readHexChar(this.input.indexOf("}", this.state.pos) - this.state.pos, !0, t), ++this.state.pos, null !== e && e > 1114111) {
              if (!t) return null;
              this.raise(_s61, g.InvalidCodePoint);
            }
          } else e = this.readHexChar(4, !1, t);

          return e;
        }
      }, {
        key: "readString",
        value: function readString(t) {
          var e = "",
              s = ++this.state.pos;

          for (;;) {
            if (this.state.pos >= this.length) throw this.raise(this.state.start, g.UnterminatedString);

            var _r57 = this.input.charCodeAt(this.state.pos);

            if (_r57 === t) break;
            if (92 === _r57) e += this.input.slice(s, this.state.pos), e += this.readEscapedChar(!1), s = this.state.pos;else if (8232 === _r57 || 8233 === _r57) ++this.state.pos, ++this.state.curLine, this.state.lineStart = this.state.pos;else {
              if (y(_r57)) throw this.raise(this.state.start, g.UnterminatedString);
              ++this.state.pos;
            }
          }

          e += this.input.slice(s, this.state.pos++), this.finishToken(c.string, e);
        }
      }, {
        key: "readTmplToken",
        value: function readTmplToken() {
          var t = "",
              e = this.state.pos,
              s = !1;

          for (;;) {
            if (this.state.pos >= this.length) throw this.raise(this.state.start, g.UnterminatedTemplate);

            var _r58 = this.input.charCodeAt(this.state.pos);

            if (96 === _r58 || 36 === _r58 && 123 === this.input.charCodeAt(this.state.pos + 1)) return this.state.pos === this.state.start && this.match(c.template) ? 36 === _r58 ? (this.state.pos += 2, void this.finishToken(c.dollarBraceL)) : (++this.state.pos, void this.finishToken(c.backQuote)) : (t += this.input.slice(e, this.state.pos), void this.finishToken(c.template, s ? null : t));

            if (92 === _r58) {
              t += this.input.slice(e, this.state.pos);

              var _r59 = this.readEscapedChar(!0);

              null === _r59 ? s = !0 : t += _r59, e = this.state.pos;
            } else if (y(_r58)) {
              switch (t += this.input.slice(e, this.state.pos), ++this.state.pos, _r58) {
                case 13:
                  10 === this.input.charCodeAt(this.state.pos) && ++this.state.pos;

                case 10:
                  t += "\n";
                  break;

                default:
                  t += String.fromCharCode(_r58);
              }

              ++this.state.curLine, this.state.lineStart = this.state.pos, e = this.state.pos;
            } else ++this.state.pos;
          }
        }
      }, {
        key: "readEscapedChar",
        value: function readEscapedChar(t) {
          var e = !t,
              s = this.input.charCodeAt(++this.state.pos);

          switch (++this.state.pos, s) {
            case 110:
              return "\n";

            case 114:
              return "\r";

            case 120:
              {
                var _t115 = this.readHexChar(2, !1, e);

                return null === _t115 ? null : String.fromCharCode(_t115);
              }

            case 117:
              {
                var _t116 = this.readCodePoint(e);

                return null === _t116 ? null : String.fromCodePoint(_t116);
              }

            case 116:
              return "\t";

            case 98:
              return "\b";

            case 118:
              return "\v";

            case 102:
              return "\f";

            case 13:
              10 === this.input.charCodeAt(this.state.pos) && ++this.state.pos;

            case 10:
              this.state.lineStart = this.state.pos, ++this.state.curLine;

            case 8232:
            case 8233:
              return "";

            case 56:
            case 57:
              if (t) return null;
              this.state.strict && this.raise(this.state.pos - 1, g.StrictNumericEscape);

            default:
              if (s >= 48 && s <= 55) {
                var _e101 = this.state.pos - 1;

                var _s62 = this.input.substr(this.state.pos - 1, 3).match(/^[0-7]+/)[0],
                    _r60 = parseInt(_s62, 8);

                _r60 > 255 && (_s62 = _s62.slice(0, -1), _r60 = parseInt(_s62, 8)), this.state.pos += _s62.length - 1;

                var _i30 = this.input.charCodeAt(this.state.pos);

                if ("0" !== _s62 || 56 === _i30 || 57 === _i30) {
                  if (t) return null;
                  this.state.strict ? this.raise(_e101, g.StrictNumericEscape) : this.state.octalPositions.push(_e101);
                }

                return String.fromCharCode(_r60);
              }

              return String.fromCharCode(s);
          }
        }
      }, {
        key: "readHexChar",
        value: function readHexChar(t, e, s) {
          var r = this.state.pos,
              i = this.readInt(16, t, e, !1);
          return null === i && (s ? this.raise(r, g.InvalidEscapeSequence) : this.state.pos = r - 1), i;
        }
      }, {
        key: "readWord1",
        value: function readWord1() {
          var t = "";
          this.state.containsEsc = !1;
          var e = this.state.pos;
          var s = this.state.pos;

          for (; this.state.pos < this.length;) {
            var _r61 = this.input.codePointAt(this.state.pos);

            if (O(_r61)) this.state.pos += _r61 <= 65535 ? 1 : 2;else if (this.state.isIterator && 64 === _r61) ++this.state.pos;else {
              if (92 !== _r61) break;
              {
                this.state.containsEsc = !0, t += this.input.slice(s, this.state.pos);

                var _r62 = this.state.pos,
                    _i31 = this.state.pos === e ? L : O;

                if (117 !== this.input.charCodeAt(++this.state.pos)) {
                  this.raise(this.state.pos, g.MissingUnicodeEscape);
                  continue;
                }

                ++this.state.pos;

                var _n20 = this.readCodePoint(!0);

                null !== _n20 && (_i31(_n20) || this.raise(_r62, g.EscapedCharNotAnIdentifier), t += String.fromCodePoint(_n20)), s = this.state.pos;
              }
            }
          }

          return t + this.input.slice(s, this.state.pos);
        }
      }, {
        key: "isIterator",
        value: function isIterator(t) {
          return "@@iterator" === t || "@@asyncIterator" === t;
        }
      }, {
        key: "readWord",
        value: function readWord() {
          var t = this.readWord1(),
              e = o.get(t) || c.name;
          !this.state.isIterator || this.isIterator(t) && this.state.inType || this.raise(this.state.pos, g.InvalidIdentifier, t), this.finishToken(e, t);
        }
      }, {
        key: "checkKeywordEscapes",
        value: function checkKeywordEscapes() {
          var t = this.state.type.keyword;
          t && this.state.containsEsc && this.raise(this.state.start, g.InvalidEscapedReservedWord, t);
        }
      }, {
        key: "braceIsBlock",
        value: function braceIsBlock(t) {
          var e = this.curContext();
          return e === T.functionExpression || e === T.functionStatement || (t !== c.colon || e !== T.braceStatement && e !== T.braceExpression ? t === c._return || t === c.name && this.state.exprAllowed ? this.hasPrecedingLineBreak() : t === c._else || t === c.semi || t === c.eof || t === c.parenR || t === c.arrow || (t === c.braceL ? e === T.braceStatement : t !== c._var && t !== c._const && t !== c.name && (t === c.relational || !this.state.exprAllowed)) : !e.isExpr);
        }
      }, {
        key: "updateContext",
        value: function updateContext(t) {
          var e = this.state.type;
          var s;
          !e.keyword || t !== c.dot && t !== c.questionDot ? (s = e.updateContext) ? s.call(this, t) : this.state.exprAllowed = e.beforeExpr : this.state.exprAllowed = !1;
        }
      }]);

      return _class12;
    }( /*#__PURE__*/function (_ref35) {
      _inherits(_class13, _ref35);

      var _super17 = _createSuper(_class13);

      function _class13() {
        _classCallCheck(this, _class13);

        return _super17.apply(this, arguments);
      }

      _createClass(_class13, [{
        key: "getLocationForPosition",
        value: function getLocationForPosition(t) {
          var e;
          return e = t === this.state.start ? this.state.startLoc : t === this.state.lastTokStart ? this.state.lastTokStartLoc : t === this.state.end ? this.state.endLoc : t === this.state.lastTokEnd ? this.state.lastTokEndLoc : function (t, e) {
            var s,
                r = 1,
                i = 0;

            for (f.lastIndex = 0; (s = f.exec(t)) && s.index < e;) {
              r++, i = f.lastIndex;
            }

            return new C(r, e - i);
          }(this.input, t), e;
        }
      }, {
        key: "raise",
        value: function raise(t, e) {
          for (var _len7 = arguments.length, s = new Array(_len7 > 2 ? _len7 - 2 : 0), _key7 = 2; _key7 < _len7; _key7++) {
            s[_key7 - 2] = arguments[_key7];
          }

          return this.raiseWithData.apply(this, [t, void 0, e].concat(s));
        }
      }, {
        key: "raiseWithData",
        value: function raiseWithData(t, e, s) {
          for (var _len8 = arguments.length, r = new Array(_len8 > 3 ? _len8 - 3 : 0), _key8 = 3; _key8 < _len8; _key8++) {
            r[_key8 - 3] = arguments[_key8];
          }

          var i = this.getLocationForPosition(t),
              n = s.replace(/%(\d+)/g, function (t, e) {
            return r[e];
          }) + " (".concat(i.line, ":").concat(i.column, ")");
          return this._raise(Object.assign({
            loc: i,
            pos: t
          }, e), n);
        }
      }, {
        key: "_raise",
        value: function _raise(t, e) {
          var s = new SyntaxError(e);
          if (Object.assign(s, t), this.options.errorRecovery) return this.isLookahead || this.state.errors.push(s), s;
          throw s;
        }
      }]);

      return _class13;
    }( /*#__PURE__*/function (_ref36) {
      _inherits(_class14, _ref36);

      var _super18 = _createSuper(_class14);

      function _class14() {
        _classCallCheck(this, _class14);

        return _super18.apply(this, arguments);
      }

      _createClass(_class14, [{
        key: "addComment",
        value: function addComment(t) {
          this.filename && (t.loc.filename = this.filename), this.state.trailingComments.push(t), this.state.leadingComments.push(t);
        }
      }, {
        key: "adjustCommentsAfterTrailingComma",
        value: function adjustCommentsAfterTrailingComma(t, e, s) {
          if (0 === this.state.leadingComments.length) return;
          var r = null,
              i = e.length;

          for (; null === r && i > 0;) {
            r = e[--i];
          }

          if (null === r) return;

          for (var _t117 = 0; _t117 < this.state.leadingComments.length; _t117++) {
            this.state.leadingComments[_t117].end < this.state.commentPreviousNode.end && (this.state.leadingComments.splice(_t117, 1), _t117--);
          }

          var n = [];

          for (var _e102 = 0; _e102 < this.state.leadingComments.length; _e102++) {
            var _r63 = this.state.leadingComments[_e102];
            _r63.end < t.end ? (n.push(_r63), s || (this.state.leadingComments.splice(_e102, 1), _e102--)) : (void 0 === t.trailingComments && (t.trailingComments = []), t.trailingComments.push(_r63));
          }

          s && (this.state.leadingComments = []), n.length > 0 ? r.trailingComments = n : void 0 !== r.trailingComments && (r.trailingComments = []);
        }
      }, {
        key: "processComment",
        value: function processComment(t) {
          if ("Program" === t.type && t.body.length > 0) return;
          var e = this.state.commentStack;
          var s, r, i, n, a;
          if (this.state.trailingComments.length > 0) this.state.trailingComments[0].start >= t.end ? (i = this.state.trailingComments, this.state.trailingComments = []) : this.state.trailingComments.length = 0;else if (e.length > 0) {
            var _s63 = F(e);

            _s63.trailingComments && _s63.trailingComments[0].start >= t.end && (i = _s63.trailingComments, delete _s63.trailingComments);
          }

          for (e.length > 0 && F(e).start >= t.start && (s = e.pop()); e.length > 0 && F(e).start >= t.start;) {
            r = e.pop();
          }

          if (!r && s && (r = s), s) switch (t.type) {
            case "ObjectExpression":
              this.adjustCommentsAfterTrailingComma(t, t.properties);
              break;

            case "ObjectPattern":
              this.adjustCommentsAfterTrailingComma(t, t.properties, !0);
              break;

            case "CallExpression":
              this.adjustCommentsAfterTrailingComma(t, t.arguments);
              break;

            case "ArrayExpression":
              this.adjustCommentsAfterTrailingComma(t, t.elements);
              break;

            case "ArrayPattern":
              this.adjustCommentsAfterTrailingComma(t, t.elements, !0);
          } else this.state.commentPreviousNode && ("ImportSpecifier" === this.state.commentPreviousNode.type && "ImportSpecifier" !== t.type || "ExportSpecifier" === this.state.commentPreviousNode.type && "ExportSpecifier" !== t.type) && this.adjustCommentsAfterTrailingComma(t, [this.state.commentPreviousNode]);

          if (r) {
            if (r.leadingComments) if (r !== t && r.leadingComments.length > 0 && F(r.leadingComments).end <= t.start) t.leadingComments = r.leadingComments, delete r.leadingComments;else for (n = r.leadingComments.length - 2; n >= 0; --n) {
              if (r.leadingComments[n].end <= t.start) {
                t.leadingComments = r.leadingComments.splice(0, n + 1);
                break;
              }
            }
          } else if (this.state.leadingComments.length > 0) if (F(this.state.leadingComments).end <= t.start) {
            if (this.state.commentPreviousNode) for (a = 0; a < this.state.leadingComments.length; a++) {
              this.state.leadingComments[a].end < this.state.commentPreviousNode.end && (this.state.leadingComments.splice(a, 1), a--);
            }
            this.state.leadingComments.length > 0 && (t.leadingComments = this.state.leadingComments, this.state.leadingComments = []);
          } else {
            for (n = 0; n < this.state.leadingComments.length && !(this.state.leadingComments[n].end > t.start); n++) {
              ;
            }

            var _e103 = this.state.leadingComments.slice(0, n);

            _e103.length && (t.leadingComments = _e103), i = this.state.leadingComments.slice(n), 0 === i.length && (i = null);
          }

          if (this.state.commentPreviousNode = t, i) if (i.length && i[0].start >= t.start && F(i).end <= t.end) t.innerComments = i;else {
            var _e104 = i.findIndex(function (e) {
              return e.end >= t.end;
            });

            _e104 > 0 ? (t.innerComments = i.slice(0, _e104), t.trailingComments = i.slice(_e104)) : t.trailingComments = i;
          }
          e.push(t);
        }
      }]);

      return _class14;
    }( /*#__PURE__*/function () {
      function _class15() {
        _classCallCheck(this, _class15);

        this.sawUnambiguousESM = !1, this.ambiguousScriptDifferentAst = !1;
      }

      _createClass(_class15, [{
        key: "hasPlugin",
        value: function hasPlugin(t) {
          return this.plugins.has(t);
        }
      }, {
        key: "getPluginOption",
        value: function getPluginOption(t, e) {
          if (this.hasPlugin(t)) return this.plugins.get(t)[e];
        }
      }]);

      return _class15;
    }())))))))));

    function Ut(t, e) {
      var s = jt;
      return (null == t ? void 0 : t.plugins) && (!function (t) {
        if (Dt(t, "decorators")) {
          if (Dt(t, "decorators-legacy")) throw new Error("Cannot use the decorators and decorators-legacy plugin together");

          var _e105 = mt(t, "decorators", "decoratorsBeforeExport");

          if (null == _e105) throw new Error("The 'decorators' plugin requires a 'decoratorsBeforeExport' option, whose value must be a boolean. If you are migrating from Babylon/Babel 6 or want to use the old decorators proposal, you should use the 'decorators-legacy' plugin instead of 'decorators'.");
          if ("boolean" != typeof _e105) throw new Error("'decoratorsBeforeExport' must be a boolean.");
        }

        if (Dt(t, "flow") && Dt(t, "typescript")) throw new Error("Cannot combine flow and typescript plugins.");
        if (Dt(t, "placeholders") && Dt(t, "v8intrinsic")) throw new Error("Cannot combine placeholders and v8intrinsic plugins.");
        if (Dt(t, "pipelineOperator") && !ft.includes(mt(t, "pipelineOperator", "proposal"))) throw new Error("'pipelineOperator' requires 'proposal' option whose value should be one of: " + ft.map(function (t) {
          return "'".concat(t, "'");
        }).join(", "));

        if (Dt(t, "moduleAttributes")) {
          if (Dt(t, "importAssertions")) throw new Error("Cannot combine importAssertions and moduleAttributes plugins.");
          if ("may-2020" !== mt(t, "moduleAttributes", "version")) throw new Error("The 'moduleAttributes' plugin requires a 'version' option, representing the last proposal update. Currently, the only supported value is 'may-2020'.");
        }

        if (Dt(t, "recordAndTuple") && !yt.includes(mt(t, "recordAndTuple", "syntaxType"))) throw new Error("'recordAndTuple' requires 'syntaxType' option whose value should be one of: " + yt.map(function (t) {
          return "'".concat(t, "'");
        }).join(", "));
      }(t.plugins), s = function (t) {
        var e = At.filter(function (e) {
          return Dt(t, e);
        }),
            s = e.join("/");
        var r = qt[s];

        if (!r) {
          r = jt;

          for (var _t118 = 0; _t118 < e.length; _t118++) {
            var _s64 = e[_t118];
            r = Et[_s64](r);
          }

          qt[s] = r;
        }

        return r;
      }(t.plugins)), new s(t, e);
    }

    var qt = {};
    e.parse = function (t, e) {
      var s;
      if ("unambiguous" !== (null == (s = e) ? void 0 : s.sourceType)) return Ut(e, t).parse();
      e = Object.assign({}, e);

      try {
        e.sourceType = "module";

        var _s65 = Ut(e, t),
            _r64 = _s65.parse();

        if (_s65.sawUnambiguousESM) return _r64;
        if (_s65.ambiguousScriptDifferentAst) try {
          return e.sourceType = "script", Ut(e, t).parse();
        } catch (t) {} else _r64.program.sourceType = "script";
        return _r64;
      } catch (s) {
        try {
          return e.sourceType = "script", Ut(e, t).parse();
        } catch (t) {}

        throw s;
      }
    }, e.parseExpression = function (t, e) {
      var s = Ut(e, t);
      return s.options.strictMode && (s.state.strict = !0), s.getExpression();
    }, e.tokTypes = c;
  });

  var zs = Mt.getNextNonSpaceNonCommentCharacterIndexWithStartIndex,
      Hs = Mt.getShebang,
      Ws = $t.hasPragma,
      Xs = te.locStart,
      Gs = te.locEnd;
  var Ks = /@(?:no)?flow\b/;

  function Js(e) {
    for (var _len9 = arguments.length, s = new Array(_len9 > 1 ? _len9 - 1 : 0), _key9 = 1; _key9 < _len9; _key9++) {
      s[_key9 - 1] = arguments[_key9];
    }

    return function (r, i) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if ("babel" === n.parser && function (t, e) {
        if (e.filepath && e.filepath.endsWith(".js.flow")) return !0;
        var s = Hs(t);
        s && (t = t.slice(s.length));
        var r = zs(t, 0);
        return !1 !== r && (t = t.slice(0, r)), Ks.test(t);
      }(r, n)) return n.parser = "babel-flow", Ys(r, i, n);
      var a = Vs,
          o = "script" === n.__babelSourceType ? "script" : "module";
      var u;

      try {
        u = function (t, e) {
          var s;

          for (var _r65 = 0; _r65 < e.length; _r65++) {
            try {
              return er(t(e[_r65]));
            } catch (t) {
              s || (s = t);
            }
          }

          throw s;
        }(function (t) {
          return a[e](r, t);
        }, function (t, e, s) {
          if (!t) return e;
          var r = [];

          var _iterator8 = _createForOfIteratorHelper(e),
              _step8;

          try {
            for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
              var _t119 = _step8.value;

              var _iterator9 = _createForOfIteratorHelper(s),
                  _step9;

              try {
                for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                  var _e106 = _step9.value;
                  r.push([].concat(_toConsumableArray(_t119), [_e106]));
                }
              } catch (err) {
                _iterator9.e(err);
              } finally {
                _iterator9.f();
              }
            }
          } catch (err) {
            _iterator8.e(err);
          } finally {
            _iterator8.f();
          }

          return r;
        }(r.includes("|>"), s, [["pipelineOperator", {
          proposal: "smart"
        }], ["pipelineOperator", {
          proposal: "minimal"
        }], ["pipelineOperator", {
          proposal: "fsharp"
        }]]).map(function (t) {
          return function (_ref37) {
            var t = _ref37.sourceType,
                _ref37$extraPlugins = _ref37.extraPlugins,
                e = _ref37$extraPlugins === void 0 ? [] : _ref37$extraPlugins;
            return {
              sourceType: t,
              allowAwaitOutsideFunction: !0,
              allowImportExportEverywhere: !0,
              allowReturnOutsideFunction: !0,
              allowSuperOutsideMethod: !0,
              allowUndeclaredExports: !0,
              errorRecovery: !0,
              createParenthesizedExpressions: !0,
              plugins: ["doExpressions", "classProperties", "exportDefaultFrom", "functionBind", "functionSent", "classPrivateProperties", "throwExpressions", "classPrivateMethods", "v8intrinsic", "partialApplication", ["decorators", {
                decoratorsBeforeExport: !1
              }], "privateIn", "importAssertions", ["recordAndTuple", {
                syntaxType: "hash"
              }], "decimal", "moduleStringNames", "classStaticBlock"].concat(_toConsumableArray(e)),
              tokens: !0,
              ranges: !0
            };
          }({
            sourceType: o,
            extraPlugins: t
          });
        }));
      } catch (e) {
        var _s66 = e.message,
            _r66 = e.loc;
        throw t(_s66.replace(/ \(.*\)/, ""), {
          start: {
            line: _r66 ? _r66.line : 0,
            column: _r66 ? _r66.column + 1 : 0
          }
        });
      }

      return qs(u, Object.assign({}, n, {
        originalText: r
      }));
    };
  }

  var $s = Js("parse", ["jsx", "flow"]),
      Ys = Js("parse", ["jsx", ["flow", {
    all: !0,
    enums: !0
  }]]),
      Qs = Js("parse", ["jsx", "typescript"], ["typescript"]),
      Zs = Js("parseExpression", ["jsx"]);
  var tr = new Set(["Did not expect a type annotation here.", "The only accepted module attribute is `type`", "Type parameters must come after the async keyword, e.g. instead of `<T> async () => {}`, use `async <T>() => {}`"]);

  function er(t) {
    var e = t.errors.find(function (t) {
      return function (t) {
        var _t$message$match = t.message.match(/(.*?)\s*\(\d+:\d+\)/),
            _t$message$match2 = _slicedToArray(_t$message$match, 2),
            e = _t$message$match2[1];

        return tr.has(e);
      }(t);
    });
    if (e) throw e;
    return t;
  }

  function sr(e, s) {
    switch (e.type) {
      case "ArrayExpression":
        return e.elements.forEach(r);

      case "ObjectExpression":
        return e.properties.forEach(r);

      case "ObjectProperty":
        if (e.computed) throw i("computed");
        if (e.shorthand) throw i("shorthand");
        return [e.key, e.value].forEach(r);

      case "UnaryExpression":
        switch (e.operator) {
          case "+":
          case "-":
            return r(e.argument);

          default:
            throw i("operator");
        }

      case "Identifier":
        if (s && "ObjectProperty" === s.type && s.key === e) return;
        throw i();

      case "NullLiteral":
      case "BooleanLiteral":
      case "NumericLiteral":
      case "StringLiteral":
        return;

      default:
        throw i();
    }

    function r(t) {
      return sr(t, e);
    }

    function i(s) {
      var r = s ? "".concat(e.type, " with ").concat(s, "=").concat(JSON.stringify(e[s])) : e.type;
      return t("".concat(r, " is not allowed in JSON."), {
        start: {
          line: e.loc.start.line,
          column: e.loc.start.column + 1
        }
      });
    }
  }

  var rr = {
    parse: $s,
    astFormat: "estree",
    hasPragma: Ws,
    locStart: Xs,
    locEnd: Gs
  },
      ir = Object.assign({}, rr, {
    parse: Ys
  }),
      nr = Object.assign({}, rr, {
    parse: Qs
  }),
      ar = Object.assign({}, rr, {
    parse: Zs
  });
  return {
    parsers: {
      babel: rr,
      "babel-flow": ir,
      "babel-ts": nr,
      json: Object.assign({}, ar, {
        hasPragma: function hasPragma() {
          return !0;
        }
      }),
      json5: ar,
      "json-stringify": {
        parse: function parse(t, e, s) {
          var r = Zs(t, e, s);
          return r.comments.forEach(sr), sr(r), r;
        },
        astFormat: "estree-json",
        locStart: Xs,
        locEnd: Gs
      },
      __js_expression: ar,
      __vue_expression: ar,
      __vue_event_binding: rr
    }
  };
});